var CalcDefaultStyles = [
    {
        name: "Gray theme",
        value: "gray",
        allowSlags: ['all'],
        styles: {
            large: {
                topPane: "background: linear-gradient(#fff 20%, #f5f5f5 45%); color: black; border: solid 1px #aaa; border-bottom: none; ",
                bottomPane: "background: #f3f3f3; border: solid 1px #aaa; color: black;",
                buttonStyle: "background: #343540; color: white; border-radius: 20px;",
                titleStyle: "text-align: left; font-size: 40px; font-weight: 500;",
                textboxStyle: "background-color: white; color: black; border: solid 1px #aaaaaa",
                highlightColor: "#ffff00",
                containerWidth: "665"
            },
            small: {
                topPane: "background: linear-gradient(#fff 20%, #f5f5f5 45%); color: black; border: solid 1px #aaa; border-bottom: none; ",
                bottomPane: "background: #f3f3f3; border: solid 1px #aaa; color: black;",
                buttonStyle: "background: #343540; color: white; border-radius: 20px;",
                titleStyle: "text-align: left; font-size: 16px; font-weight: 500;",
                textboxStyle: "background-color: white; color: black; border: solid 1px #aaaaaa",
                highlightColor: "#ffff00",
                containerWidth: "250"
            }

        }
    },
    {
        name: "Dark theme",
        value: "dark",
        allowSlags: ['all'],
        styles: {
            large: {
                topPane: "background: linear-gradient(#343540 0%, #242831 100%); color: white; border-bottom: none;",
                bottomPane: "background: #15181d; border: solid 0px #2a2e39; color: #9194a1;",
                buttonStyle: "background: #343540; color: white; border-radius: 20px;",
                titleStyle: "text-align: left; font-size: 40px; font-weight: 500;",
                textboxStyle: "background: #15181d; color: #9194a1; border: solid 0px #9194a1;",
                highlightColor: "rgba(0,0,0,1.0)",
                containerWidth: "665"
            },
            small: {
                topPane: "background: linear-gradient(#343540 0%, #242831 100%); color: white; border-bottom: none;",
                bottomPane: "background: #15181d; border: solid 0px #2a2e39; color: #9194a1;",
                buttonStyle: "background: #343540; color: white; border-radius: 20px;",
                titleStyle: "text-align: left; font-size: 40px; font-weight: 500;",
                textboxStyle: "background: #15181d; color: #9194a1; border: solid 0px #9194a1;",
                highlightColor: "rgba(0,0,0,1.0)",
                containerWidth: "250"
            },
        }
    },
    {
        name: "Blue Green theme",
        value: "bluegreen",
        allowSlags: ['all'],
        styles: {
            large: {
                topPane: "background: linear-gradient(#1ba1c4 20%, #49b9ad 45%); border: solid 0px; border-bottom: none; color: white;",
                bottomPane: "background: white; border: solid 1px #7a7a7a; border-top: none; color: black;",
                buttonStyle: "background: #1ba1c4; color: white; border-radius: 20px;",
                titleStyle: "text-align: left; font-size: 40px; font-weight: 500;",
                textboxStyle: "background-color: white; color: black; border: solid 1px #aaaaaa",
                highlightColor: "#ffff00",
                containerWidth: "665"
            },
            small: {
                topPane: "background: linear-gradient(#1ba1c4 20%, #49b9ad 45%); border: solid 0px; border-bottom: none; color: white;",
                bottomPane: "background: white; border: solid 1px #7a7a7a; border-top: none;color: black;",
                buttonStyle: "background: #1ba1c4; color: white; border-radius: 20px;",
                titleStyle: "text-align: left; font-size: 16px; font-weight: 500;",
                textboxStyle: "background-color: white; color: black; border: solid 1px #aaaaaa",
                highlightColor: "#ffff00",
                containerWidth: "250"
            }

        }
    },

    {
        name: "Plain theme",
        value: "plain",
        allowSlags: ['all'],
        styles: {
            large: {
                topPane: "background: white; color: black; border: solid 1px black; border-bottom: none; ",
                bottomPane: "background: white; border: solid 1px black; color: black;",
                buttonStyle: "background: black; color: white; border-radius: 20px;",
                titleStyle: "text-align: left; font-size: 40px; font-weight: 500;",
                textboxStyle: "background-color: white; color: black; border: solid 1px #aaaaaa",
                highlightColor: "#ffff00",
                containerWidth: "665"
            },
            small: {
                topPane: "background: white; color: black; border: solid 1px black; border-bottom: none; ",
                bottomPane: "background: white; border: solid 1px black; color: black;",
                buttonStyle: "background: black; color: white; border-radius: 20px;",
                titleStyle: "text-align: left; font-size: 16px; font-weight: 500;",
                textboxStyle: "background-color: white; color: black; border: solid 1px #aaaaaa",
                highlightColor: "#ffff00",
                containerWidth: "250"
            }

        }
    },
]
var CCCalcDefaultStyles = [
    {
        name: "Minimalist",
        allowSlags: ['currency-converter'],
        value: "minimalist",
        styles: {
            large: {
                topPane: "background: transparent; color: #aaa; border: none;",
                bottomPane: "display: none !important;",
                buttonStyle: "background: black; color: white; border-radius: 20px;",
                titleStyle: "text-align: left; font-size: 40px; font-weight: 500;",
                textboxStyle: "background-color: white; color: black; border: solid 1px #aaaaaa;",
                highlightColor: "#ffff00",
                containerWidth: "350"
            },
            small: {
                topPane: "background: transparent; color: #aaa; border: none;",
                bottomPane: "display: none !important;",
                buttonStyle: "background: black; color: white; border-radius: 20px;",
                titleStyle: "text-align: left; font-size: 16px; font-weight: 500;",
                textboxStyle: "background-color: white; color: black; border: solid 1px #aaaaaa;",
                highlightColor: "#ffff00",
                containerWidth: "250"
            }

        }
    },
    {
        name: "MinimalistDark",
        allowSlags: ['currency-converter'],
        value: "minimalist-dark",
        styles: {
            large: {
                topPane: "background: linear-gradient(#343540 0%, #242831 100%); color: #777; border-bottom: none;",
                bottomPane: "display: none !important;",
                buttonStyle: "background: black; color: white; border-radius: 20px;",
                titleStyle: "text-align: left; font-size: 40px; font-weight: 500;",
                textboxStyle: "background: #15181d; color: #9194a1; border: solid 0px #9194a1;",
                highlightColor: "#ffff00",
                containerWidth: "350"
            },
            small: {
                topPane: "background: linear-gradient(#343540 0%, #242831 100%); color: #777; border-bottom: none;",
                bottomPane: "display: none !important;",
                buttonStyle: "background: black; color: white; border-radius: 20px;",
                titleStyle: "text-align: left; font-size: 16px; font-weight: 500;",
                textboxStyle: "background: #15181d; color: #9194a1; border: solid 0px #9194a1;",
                highlightColor: "#ffff00",
                containerWidth: "250"
            }

        }
    },
]
const containerMinMaxWidth = 150;
const defaultStyleValue = 'gray';
const currency_converter_slug = 'currency-converter';

document.addEventListener('DOMContentLoaded', function (evt) {
    var element = document.querySelector('.widget-content-wrapper');
    var topOffsetElement = document.getElementById('fix-wrap');
    var top = 0; 
    if (topOffsetElement !== null) {
        top = topOffsetElement.offsetHeight;
        
    }
   

    if (element !== null) {
        element.style.position = "sticky";
        element.style.top = top + "px";
    }


})

function InitializeCalcWidgetMaker() {
    if ($('#calc-embed-script-overlay').length == 0)
        return;
    
    var theme = atob(window.CalcWidgetStyle.GetWidgetStyleTheme());
    if (window.CalcSlug === currency_converter_slug) {
        theme = atob(window.CalcWidgetStyle.GetCCWidgetStyleTheme());
    }
    if (theme === '') {
        theme = CalcDefaultStyles[0].value;
    }
    SetStyleThemeSelectValue(theme, true);
    currentStyleTheme = theme;
    GenerateCalculatorWidgetRemoteScript();

    var compactSelect = document.getElementById('widget-compact-type-select');
    if (compactSelect) {
        var cmpValue = compactSelect.options[compactSelect.selectedIndex].value;
        ChangeCompactType(cmpValue);
    }

    if (window.CalcSlug == currency_converter_slug) {
        $("#maker-currency-converter-from-select").infiniteselect({
            types: [
                { option: 'all', text: 'All' },
                { option: 'forex', text: 'Forex' },
                { option: 'crypto', text: 'Crypto' }],
            url: '/api/widgets/currencies',
            placeholder: 'Select',
            default: 'EUR',
            showDescription: true,
            culture: window.CURRENT_LANG,
            btnClass: 'widget-input-override frn-override'
        });
        $("#maker-currency-converter-to-select").infiniteselect({
            types: [
                { option: 'all', text: 'All' },
                { option: 'forex', text: 'Forex' },
                { option: 'crypto', text: 'Crypto' }],
            url: '/api/widgets/currencies',
            placeholder: 'Select',
            default: 'USD',
            showDescription: true,
            culture: window.CURRENT_LANG,
            btnClass: 'widget-input-override frn-override'
        });
        document.getElementById('maker-currency-converter-from-select').addEventListener('change', OnChangedFromCurrency);
        document.getElementById('maker-currency-converter-to-select').addEventListener('change', OnChangedToCurrency);
    }

    if ($("#maker-symbol-select-control").length > 0) {
        window.calcMakerSymbolSelectControl = $("#maker-symbol-select-control").chartSymbolSearch('init', '/api/live-chart/datafeed', {
            onChange: function (ticker, symbolData) {
                window.calcMakerDefaultSymbol = symbolData.symbol;
                window.calcMakerDefaultTicker = ticker;

                if (window.CalcSlug == "pip-value-calculator" && window.pipValueCalculator) {
                    window.pipValueCalculator.UpdateCalculatorSymbol(ticker, symbolData.symbol);
                } else if (window.CalcSlug == "margin-calculator" && window.marginCalculator) {
                    window.marginCalculator.UpdateCalculatorSymbol(ticker, symbolData.symbol);
                } else if (window.CalcSlug == "position-size-calculator" && window.positionSizeCalculator) {
                    window.positionSizeCalculator.UpdateCalculatorSymbol(ticker, symbolData.symbol);
                } else if (window.CalcSlug == "profit-calculator" && window.profitCalculator) {
                    window.profitCalculator.UpdateCalculatorSymbol(ticker, symbolData.symbol);
                } else if (window.CalcSlug == "forex-rebate-calculator" && window.rebateCalculator) {
                    window.rebateCalculator.UpdateCalculatorSymbol(ticker, symbolData.symbol);
                }
                GenerateCalculatorWidgetRemoteScript();
            }
        });
    }

    if (window.CalcSlug === "compounding-calculator") {
        var cookieStartBalance = window.CalcWidgetStyle.GetCalcCookieValue('comc-balance');
        if (cookieStartBalance === "") {
            cookieStartBalance = 2000;
        }
        $('#default-starting-balance-input').val(parseInt(cookieStartBalance));

        var cookiePeriods = window.CalcWidgetStyle.GetCalcCookieValue('comc-periods');
        if (cookiePeriods === "") {
            cookiePeriods = 12;
        }
        $('#default-number-input').val(parseInt(cookiePeriods));

        var cookieGain = window.CalcWidgetStyle.GetCalcCookieValue('comc-gain');
        if (cookieGain === '') {
            cookieGain = 5;

        }
        $('#default-percent-input').val(parseInt(cookieGain));


    } else if (window.CalcSlug === "drawdown-calculator") {

        var cookieStartBalance = window.CalcWidgetStyle.GetCalcCookieValue('dc-balance');
        if (cookieStartBalance === "") {
            cookieStartBalance = 2000;
        }
        $('#default-starting-balance-input').val(parseInt(cookieStartBalance));

        var cookiePeriods = window.CalcWidgetStyle.GetCalcCookieValue('dc-periods');
        if (cookiePeriods === "") {
            cookiePeriods = 12;
        }
        $('#default-number-input').val(parseInt(cookiePeriods));

        var cookieGain = window.CalcWidgetStyle.GetCalcCookieValue('dc-gain');
        if (cookieGain === "") {
            cookieGain = 2;
        }
        $('#default-percent-input').val(parseInt(cookieGain));
    }


    if (window.CalcSlug == "exchange-fees-calculator") {
        $("#widget-default-exchange-select").selectpicker();
        $("#widget-default-exchange-select").selectpicker('val', 'bitstamp');
    }

    var resetLink = document.getElementById('widget-default-style-reset');
    if (resetLink) {
        if (currentStyleTheme === 'custom') {
            resetLink.style.setProperty('display', 'flex', 'important');
        } else {
            resetLink.style.setProperty('display', 'none', 'important');
        }
    }

    var calcContent = document.querySelector('.calc-widget-content');
    if (calcContent) {
        const calcContentReseizeObserver = new ResizeObserver(function (entries) {
            OnChangedSizeCalcContent();
        });
        calcContentReseizeObserver.observe(calcContent);
    }

    ChangeBodyContent();
}

function UpdateWidgetMakerCurrencyPairData() {
    if ($('#calc-embed-script-overlay').length == 0)
        return;
    GenerateCalculatorWidgetRemoteScript();
}
function OnSetStyleValues(value, compactType) {
    var allDefaultStyles = [].concat(CalcDefaultStyles);
    if (window.CalcSlug === currency_converter_slug) {
        allDefaultStyles = allDefaultStyles.concat(CCCalcDefaultStyles);
    }    
    for (var i = 0; i < allDefaultStyles.length; i++) {
        var style = allDefaultStyles[i];
        if (style.value === value) {
            $("[cbf-widget-style-input-id='top-pane-style-input']").val(style.styles[compactType]['topPane']);
            $("[cbf-widget-style-input-id='bottom-pane-style-input']").val(style.styles[compactType]['bottomPane']);
            $("[cbf-widget-style-input-id='button-style-input']").val(style.styles[compactType]['buttonStyle']);
            $("[cbf-widget-style-input-id='title-style-input']").val(style.styles[compactType]['titleStyle']);
            $("[cbf-widget-style-input-id='textbox-style-input']").val(style.styles[compactType]['textboxStyle']);
            $("[cbf-widget-style-input-id='container-width-input']").val(style.styles[compactType]['containerWidth']);
            $("[cbf-widget-style-input-id='highlight-color-input']").val(style.styles[compactType]['highlightColor']);            
        }

    }
}
function OnChangedCalcDefaultStyles() {
    var el = document.getElementById('widget-default-style-select');
    var value = el.options[el.selectedIndex].value;
    currentStyleTheme = value;
    if (window.CalcSlug === currency_converter_slug) {        
        window.CalcWidgetStyle.SetCCWidgetStyleTheme(value);
    } else {        
        window.CalcWidgetStyle.SetWidgetStyleCookie('WidgetTheme', value);
    }
    
    if (value === 'custom') {
        GetAllStylesFromCookie();
    } else {
        var compactType = "large";
        var compactTypeSelect = document.getElementById('widget-compact-type-select');
        if (compactTypeSelect) {
            compactType = compactTypeSelect.options[compactTypeSelect.selectedIndex].value;
        }
        OnSetStyleValues(value, compactType);
    }
    ChangeBodyContent();
}

function SetStyleThemeSelectValue(value, dispatchEvent) {
    var themeSelectEl = document.getElementById('widget-default-style-select');
    currentStyleTheme = value;
    if (themeSelectEl) {
        themeSelectEl.value = value;
    }
    if (dispatchEvent && themeSelectEl) {
        themeSelectEl.dispatchEvent(new Event('change'));
    }
}


function ChangeBodyContent() {

    var topStyleValue = $('[cbf-widget-style-input-id=top-pane-style-input]').val();
    var bottomStyleValue = $('[cbf-widget-style-input-id=bottom-pane-style-input]').val();
    var buttonStyleValue = $('[cbf-widget-style-input-id=button-style-input]').val();
    var titleStyleValue = $('[cbf-widget-style-input-id=title-style-input]').val();
    var textboxStyleValue = $('[cbf-widget-style-input-id=textbox-style-input]').val();
    var containerWidth = $('[cbf-widget-style-input-id=container-width-input]').val();
    var highlightColor = $('[cbf-widget-style-input-id=highlight-color-input]').val();

    $('.widget-top-pane').attr('style', topStyleValue);
    $('.widget-bottom-pane').attr('style', bottomStyleValue);
    $('.calculate-button').attr('style', buttonStyleValue);
    $('.widget-title').attr('style', titleStyleValue);
    $('.calc-widget-content').attr('style', 'max-width: ' + containerWidth + 'px !important');
    OnChangedSizeCalcContent();
    $('.converter-main-result-span').attr('style', 'background: ' + highlightColor);

    $('.widget-top-pane button.widget-input-override').attr('style', textboxStyleValue);
    $('.widget-top-pane input.widget-input-override').attr('style', textboxStyleValue);

    var topBackColor = '';
    var topSplits = topStyleValue.split(';');
    for (var i = 0; i < topSplits.length; i++) {
        var topSplit = topSplits[i];
        if (topSplit !== undefined && split !== '') {
            var stylesSplits = topSplit.split(':');
            if (stylesSplits.length > 0) {
                var trimKey = stylesSplits[0].trim();
                if (trimKey === 'background' || trimKey === 'background-color') {
                    topBackColor = stylesSplits[1];
                    topBackColor = topBackColor.replace('!important', '');
                    topBackColor = topBackColor.replace(' ', '');
                    topBackColor = topBackColor.trim()
                }
            }
        }
    }

    var splits = textboxStyleValue.split(';');
    var arrowColor = '';
    var backColor = '';
    var newTextboxStyle = '';
    for (var i = 0; i < splits.length; i++) {
        var split = splits[i];
        if (split !== undefined && split !== '') {
            var colors = split.split(':');
            if (colors.length > 0) {
                var trimKey = colors[0].trim();
                if (trimKey === 'color') {
                    arrowColor = colors[1];
                    arrowColor = arrowColor.replace('!important', '');
                    arrowColor = arrowColor.replace(' ', '');
                    arrowColor = arrowColor.trim();
                }
                if (!colors[1].includes('!important')) {
                    newTextboxStyle += colors[0] + ':' + colors[1] + ' !important;';
                } else {
                    newTextboxStyle += colors[0] + ':' + colors[1] + ';';
                }


                if (trimKey === 'background' || trimKey === 'background-color') {
                    backColor = colors[1];
                    backColor = backColor.replace('!important', '');
                    backColor = backColor.replace(' ', '');
                    backColor = backColor.trim()
                }
            }

            
        }
    }
    var result1 = window.ParseGradientFromString(topBackColor);
    
    if (result1 !== false) {
        topBackColor = window.ExtractColor(0, result1);
    }    
    var result2 = window.ParseGradientFromString(backColor);
    if (result2 !== false) {
        backColor = window.ExtractColor(0, result2);
    }    
    var mixedColor = window.CalculateDropdownArrowColor(topBackColor, backColor);
    var mixedColorStr = 'rgb(' + mixedColor.r + ', ' + mixedColor.g + ', ' + mixedColor.b + ')';
    var mixedColorOpStr = 'rgb(' + mixedColor.r + ', ' + mixedColor.g + ', ' + mixedColor.b + ', 0)';
    var style = document.querySelector('head style[id="calc_textbox_style"]');
    var css = '.widget-top-pane button.widget-input-override:after, .widget-top-pane div.widget-symbol-select:after { background-color: ' + arrowColor + ' !important; } .widget-top-pane button.widget-input-override:before, .widget-top-pane div.widget-symbol-select:before { background: linear-gradient(90deg, ' + mixedColorOpStr + ' -6.25%, ' + mixedColorStr + ' 27.46%); } html[dir=rtl] .widget-top-pane button.widget-input-override:before, html[dir=rtl] .widget-top-pane div.widget-symbol-select:before {background: linear-gradient(-90deg, ' + mixedColorOpStr + ' -6.25%, ' + mixedColorStr + ' 27.46%); } .widget-top-pane button.widget-input-override, .widget-top-pane input.widget-input-override, .widget-top-pane div.widget-symbol-select {' + newTextboxStyle + '} .widget-top-pane div.selectdiv, .widget-top-pane select.widget-input-override {' + newTextboxStyle + '} .widget-top-pane div.selectdiv:after, .widget-top-pane select.widget-input-override:after { border-top-color: ' + arrowColor + ' !important; }';

    if (style === null) {
        head = document.head || document.getElementsByTagName('head')[0];
        style = document.createElement('style');
        head.appendChild(style);
        style.type = 'text/css';
        style.id = 'calc_textbox_style';
    }
    if (style.styleSheet) {
        style.styleSheet.style = css;
    } else {
        style.innerHTML = '';
        style.appendChild(document.createTextNode(css));
    }

    var regex = /([\w-]*)\s*:\s*([^;]*)/g;
    var match, bottomStyles = {};
    while (match = regex.exec(bottomStyleValue)) bottomStyles[match[1]] = match[2].trim();
    if (bottomStyles['color']) {
        var btColor = bottomStyles['color'];
        var els = document.querySelectorAll('.calc-live-chart-links a');
        for (var i = 0; i < els.length; i++) {
            var el = els[i];
            el.style.setProperty('color', btColor, 'important');
        }
    }

    AddRemoveFormgroupWidthStyle(containerWidth);

    var topStyles = topStyleValue.split(";");
    for (var i = 0; i < topStyles.length; i++) {
        var style = topStyles[i];
        if (style.includes("color")) {
            $('.widget-top-pane .calc-popup-icon i').attr('style', style);
            break;
        }
    }

    var isDisplayTitle = $('#display-tool-title-input').prop("checked");
    var isShowChartLinks = $('#show-chart-links-input').prop("checked");
    var isShowEmbedButton = $('#show-embed-button').prop("checked");
    var isShowBuyCryptoButton = $("#show-buy-crypto-button").prop("checked");

    if (isDisplayTitle) {
        $('.widget-title').show();
    } else {
        $('.widget-title').hide();
    }
    if (isShowChartLinks) {
        $('.calc-live-chart-links').attr('style', 'display: flex !important');
    } else {
        $('.calc-live-chart-links').attr('style', 'display: none !important');
    }

    if (isShowEmbedButton) {
        $('.embed-button').show();
    } else {
        $('.embed-button').hide();
    }
    if (isShowBuyCryptoButton) {
        $("#buy-crypto-button-area").attr('style', 'display:flex');
    } else {
        $("#buy-crypto-button-area").attr('style', 'display: none !important');
    }
    if (window.CalcSlug === 'compounding-calculator') {
        var defaultBalace = $('#default-starting-balance-input').val();
        var defaultNumber = $('#default-number-input').val();
        var defaultPercent = $('#default-percent-input').val();
        $('#cc-starting-balance').val(parseInt(defaultBalace));
        $('#cc-periods').val(parseInt(defaultNumber));
        $('#cc-gain-percent').val(parseInt(defaultPercent));

    } else if (window.CalcSlug === 'drawdown-calculator') {
        var defaultBalace = $('#default-starting-balance-input').val();
        var defaultNumber = $('#default-number-input').val();
        var defaultPercent = $('#default-percent-input').val();
        $('#dc-starting-balance').val(parseInt(defaultBalace));
        $('#dc-periods').val(parseInt(defaultNumber));
        $('#dc-gain-percent').val(parseInt(defaultPercent));
    }

}
function ChangeCompactType(type) {
    var widgetContents = document.getElementsByClassName('calc-widget-content');
    var calcConverterIcon = document.getElementById('calc-converter-icon');
    if (type === "small") {
        if (widgetContents.length > 0) {
            var widgetContent = widgetContents[0];
            widgetContent.classList.add('widget-content-compact-small');
            document.body.classList.add('body-widget-content-small');
            if (calcConverterIcon) {
                calcConverterIcon.classList.remove('mdi-swap-horizontal');
                calcConverterIcon.classList.add('mdi-swap-vertical');
            }
        }
    } else {
        if (widgetContents.length > 0) {
            var widgetContent = widgetContents[0];
            widgetContent.classList.remove('widget-content-compact-small');
            document.body.classList.remove('body-widget-content-small');
            if (calcConverterIcon) {
                calcConverterIcon.classList.add('mdi-swap-horizontal');
                calcConverterIcon.classList.remove('mdi-swap-vertical');
            }
        }
    }
}

function GenerateCalculatorWidgetModel() {
    CalcWidgetConfig = new Object();
    CalcWidgetConfig.TopPaneStyle = btoa($('[cbf-widget-style-input-id="top-pane-style-input"]').val());
    CalcWidgetConfig.BottomPaneStyle = btoa($('[cbf-widget-style-input-id="bottom-pane-style-input"]').val());
    var buttonStyleValue = $('[cbf-widget-style-input-id="button-style-input"]').val();
    if (buttonStyleValue) {
        CalcWidgetConfig.ButtonStyle = btoa(buttonStyleValue);
    }

    CalcWidgetConfig.TitleStyle = btoa($('[cbf-widget-style-input-id="title-style-input"]').val());
    CalcWidgetConfig.TextboxStyle = btoa($('[cbf-widget-style-input-id="textbox-style-input"]').val());
    CalcWidgetConfig.ContainerWidth = $('[cbf-widget-style-input-id="container-width-input"]').val();
    CalcWidgetConfig.HighlightColor = $('[cbf-widget-style-input-id="highlight-color-input"]').val();

    CalcWidgetConfig.IsDisplayTitle = $('#display-tool-title-input').prop('checked');
    CalcWidgetConfig.IsShowChartLinks = $('#show-chart-links-input').prop('checked');
    CalcWidgetConfig.IsShowEmbedButton = $('#show-embed-button').prop('checked');    

    var language = document.getElementById('widget-language-select').value;
    if (language != "browser") {
        CalcWidgetConfig.Lang = language;
    }

    var hostUrl = window.location.protocol + "//" + window.location.hostname;
    if (window.location.port !== "")
        hostUrl += ":" + window.location.port;

    CalcWidgetConfig.Url = hostUrl;
    CalcWidgetConfig.Calculator = window.CalcSlug;

    var compactSelect = document.getElementById('widget-compact-type-select');
    if (compactSelect) {
        var compactValue = compactSelect.options[compactSelect.selectedIndex].value;
        CalcWidgetConfig.CompactType = compactValue;
    }

    const symbol = window.calcMakerDefaultSymbol;
    const ticker = window.calcMakerDefaultTicker;
    if (symbol && ticker) {
        var exchange = '';
        if (ticker.includes(':')) exchange = ticker.split(":")[0];
        CalcWidgetConfig.DefaultInstrument = window.CalculatorHelper.GetToolSymbolSlugFromTicker(exchange, symbol);
    }

    if (window.CalcSlug === "currency-converter") {
        var from = $('#maker-currency-converter-from-select').val();
        var to = $('#maker-currency-converter-to-select').val();
        CalcWidgetConfig.DefaultCurrencyFrom = from;
        CalcWidgetConfig.DefaultCurrencyTo = to;
    }

    CalcWidgetConfig.DefaultBalance = $('#default-starting-balance-input').val();
    CalcWidgetConfig.DefaultPeriod = $('#default-number-input').val();
    CalcWidgetConfig.DefaultGain = $('#default-percent-input').val();

    if (window.CalcSlug == "exchange-fees-calculator") {
        CalcWidgetConfig.DefaultExchange = $("#widget-default-exchange-select").val();
        CalcWidgetConfig.IsShowBuyCryptoButton = $("#show-buy-crypto-button").prop("checked");
    }

    return CalcWidgetConfig;
}
function GenerateCalculatorWidgetRemoteScript() {

    var CalcWidgetConfig = GenerateCalculatorWidgetModel();
    document.getElementById('embed-script-preview-output').value = GenerateCalcWidgetScript(CalcWidgetConfig);
}

function GetCurrencyPairForUrl(cpair) {
    var lastCurrency = window.CalculatorHelper.GetQuoteCurrency(cpair);
    if (lastCurrency && lastCurrency !== '') {
        var index = cpair.indexOf(lastCurrency);
        if (index === -1) {
            return cpair
        }
        return cpair.substring(0, index) + '-' + lastCurrency;
    } else {
        return cpair;
    }

}

function OnChangeCalcDisplayTitle(e) {
    ChangeBodyContent();
    GenerateCalculatorWidgetRemoteScript();
}

function OnChangeCalcShowChartLinks(e) {
    ChangeBodyContent();
    GenerateCalculatorWidgetRemoteScript();
}

function OnChangeShowEmbedButton(e) {
    ChangeBodyContent();
    GenerateCalculatorWidgetRemoteScript();
}
function OnChangeShowBuyCryptoButton(e) {
    ChangeBodyContent();
    GenerateCalculatorWidgetRemoteScript();
}
function OnChangePointAffiliateLinksButton(e) {

    var clientId = $("#client-profile-id").val();

    if (!clientId || clientId == "0") {
        e.checked = false;
        window.Access.LoginWithPurpose('OnChangePointAffiliateLinksButton', '', 'signup', '', '');
    } else {
        GenerateCalculatorWidgetRemoteScript();
    }
}

function OnCopyCalcEmbedScript() {
    var previewOutput = document.getElementById('embed-script-preview-output');
    if (previewOutput) {
        var scriptVal = previewOutput.value;
        var dummy = document.createElement("textarea");
        document.body.appendChild(dummy);
        dummy.value = scriptVal;
        dummy.select();
        document.execCommand("copy");
        document.body.removeChild(dummy);

        document.execCommand("copy");
        var notificationEl = document.getElementById('embed-copy-notification-panel');
        if (notificationEl) {
            notificationEl.style.display = 'block';
            setTimeout(function () {
                notificationEl.style.display = 'none';
            }, 3000);
        }
    }

    GenerateCalculatorWidgetRemoteScript();
}


function OnCalcStyleUpdated(e, styleType) {
    var resetLink = document.getElementById('widget-default-style-reset');
    if (currentStyleTheme !== 'custom') {
        SetStyleThemeSelectValue('custom', false);
        if (window.CalcSlug === currency_converter_slug) {
            window.CalcWidgetStyle.SetCCWidgetStyleTheme('custom');
        } else {
            window.CalcWidgetStyle.SetWidgetStyleCookie('WidgetTheme', 'custom');
        }
        
        if (resetLink) {
            resetLink.style.setProperty('display', 'flex', 'important');
        }
    }
    SaveAllStylesToCookie();

    GenerateCalculatorWidgetRemoteScript();
    ChangeBodyContent();

}

function SaveAllStylesToCookie() {
    var topPaneStyle = $('[cbf-widget-style-input-id="top-pane-style-input"]').val();
    if (window.CalcSlug === currency_converter_slug) {
        window.CalcWidgetStyle.SetCCTopPaneStyle(topPaneStyle);
    } else {
        window.CalcWidgetStyle.SetWidgetStyleCookie('TopPaneStyle', topPaneStyle);
    }
    var bottomPaneStyle = $('[cbf-widget-style-input-id="bottom-pane-style-input"]').val();
    if (window.CalcSlug === currency_converter_slug) {
        window.CalcWidgetStyle.SetCCBottomPaneStyle(bottomPaneStyle);
    } else {
        window.CalcWidgetStyle.SetWidgetStyleCookie('BottomPaneStyle', bottomPaneStyle);
    }    
    var buttonStyle = $('[cbf-widget-style-input-id="button-style-input"]').val();
    window.CalcWidgetStyle.SetWidgetStyleCookie('ButtonStyle', buttonStyle);
    var titleStyle = $('[cbf-widget-style-input-id="title-style-input"]').val();
    window.CalcWidgetStyle.SetWidgetStyleCookie('TitleStyle', titleStyle);
    var textboxStyle = $('[cbf-widget-style-input-id="textbox-style-input"]').val();
    window.CalcWidgetStyle.SetWidgetStyleCookie('TextboxStyle', textboxStyle);
    var containerWidth = $('[cbf-widget-style-input-id="container-width-input"]').val();

    var compactSelect = document.querySelector('#widget-compact-type-select');
    if (compactSelect) {
        var cmpValue = compactSelect.options[compactSelect.selectedIndex].value;
        if (cmpValue === 'small') {
            if (window.CalcSlug === currency_converter_slug) {
                window.CalcWidgetStyle.SetCCSmallContainerWidth(containerWidth);
            } else {
                window.CalcWidgetStyle.SetWidgetStyleCookie('SmallContainerWidth', containerWidth);
            }            
        } else {
            if (window.CalcSlug === currency_converter_slug) {
                window.CalcWidgetStyle.SetCCContainerWidth(containerWidth);
            } else {
                window.CalcWidgetStyle.SetWidgetStyleCookie('ContainerWidth', containerWidth);
            }           
        }
    }
    
    var highlightColor = $('[cbf-widget-style-input-id="highlight-color-input"]').val();
    if (highlightColor !== undefined) {
        window.CalcWidgetStyle.SetWidgetStyleCookie('HighlightColor', highlightColor);
    }
}

function GetAllStylesFromCookie() {
    var topPaneStyle = window.CalcWidgetStyle.GetTopPaneStyle();
    if (window.CalcSlug === currency_converter_slug) {
        topPaneStyle = window.CalcWidgetStyle.GetCCTopPaneStyle();
    }
    if (!!topPaneStyle) {        
        $('[cbf-widget-style-input-id="top-pane-style-input"]').val(atob(topPaneStyle));
    }
    var bottomPaneStyle = window.CalcWidgetStyle.GetBottomPaneStyle();
    if (window.CalcSlug === currency_converter_slug) {
        bottomPaneStyle = window.CalcWidgetStyle.GetCCBottomPaneStyle();        
    }

    if (!!bottomPaneStyle) {
        $('[cbf-widget-style-input-id="bottom-pane-style-input"]').val(atob(bottomPaneStyle));
    }
    var buttonPaneStyle = window.CalcWidgetStyle.GetButtonStyle();
    if (!!buttonPaneStyle) {
        $('[cbf-widget-style-input-id="button-style-input"]').val(atob(buttonPaneStyle));
    }
    var titlePaneStyle = window.CalcWidgetStyle.GetTitleStyle();
    if (!!titlePaneStyle) {
        $('[cbf-widget-style-input-id="title-style-input"]').val(atob(titlePaneStyle));
    }

    var textboxStyle = window.CalcWidgetStyle.GetTextboxStyle();
    if (!!textboxStyle) {
        $('[cbf-widget-style-input-id="textbox-style-input"]').val(atob(textboxStyle));
    }

    var containerWidth = containerMinMaxWidth;
    var compactSelect = document.querySelector('#widget-compact-type-select');
    if (compactSelect) {
        var cmpValue = compactSelect.options[compactSelect.selectedIndex].value;
        if (cmpValue === 'small') {
            if (window.CalcSlug === currency_converter_slug) {
                containerWidth = window.CalcWidgetStyle.GetCCSmallContainerWidth();
            } else {
                containerWidth = window.CalcWidgetStyle.GetSmallContainerWidth();
            }            
        } else {
            if (window.CalcSlug === currency_converter_slug) {
                containerWidth = window.CalcWidgetStyle.GetCCContainerWidth();
            } else {
                containerWidth = window.CalcWidgetStyle.GetContainerWidth();
            }
            
        }
    }

    if (!!containerWidth) {
        $('[cbf-widget-style-input-id="container-width-input"]').val(atob(containerWidth));
    }
    var highlightColor = window.CalcWidgetStyle.GetHighlightColor();
    var decodedHighlightColor = atob(highlightColor);

    if (!!highlightColor && decodedHighlightColor !== undefined) {
        $('[cbf-widget-style-input-id="highlight-color-input"]').val(decodedHighlightColor);
    }
}
function AddRemoveFormgroupWidthStyle(width) {
    if (width <= 500) {
        $('.form-group').addClass('form-group-less-500');
    } else {
        $('.form-group').removeClass('form-group-less-500');
    }
}
function OnCalcChangedDefaultStyles(e) {
    currentStyleTheme = e.value;
    var resetLink = document.getElementById('widget-default-style-reset');
    if (resetLink) {
        if (currentStyleTheme === 'custom') {
            resetLink.style.setProperty('display', 'flex', 'important');
        } else {
            resetLink.style.setProperty('display', 'none', 'important');
        }
    }

    OnChangedCalcDefaultStyles();
    GenerateCalculatorWidgetRemoteScript();
}

function OnChangeCalcCompactType(e) {
    ChangeCompactType(e.value);
    OnChangedCalcDefaultStyles();
    GenerateCalculatorWidgetRemoteScript();
}


function OnChangedFromCurrency() {
    var val = $('#maker-currency-converter-from-select').val();
    $('#currency-converter-from-select').infiniteselect('val', val);
    document.getElementById('currency-converter-from-select').dispatchEvent(new CustomEvent('change'));
    GenerateCalculatorWidgetRemoteScript();
}

function OnChangedToCurrency() {
    var val = $('#maker-currency-converter-to-select').val();
    $('#currency-converter-to-select').infiniteselect('val', val);
    document.getElementById('currency-converter-to-select').dispatchEvent(new CustomEvent('change'));
    GenerateCalculatorWidgetRemoteScript();
}
function GenerateContentCalcModel() {

}
function setInnerHTML(elm, html) {
    elm.innerHTML = html;

    Array.from(elm.querySelectorAll("script"))
        .forEach(function (oldScriptEl) {
            const newScriptEl = document.createElement("script");

            Array.from(oldScriptEl.attributes).forEach(function (attr) {
                newScriptEl.setAttribute(attr.name, attr.value)
            });

            const scriptText = document.createTextNode(oldScriptEl.innerHTML);
            newScriptEl.appendChild(scriptText);

            oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl);
        });
}
function FetchLocalizedContent(lang) {
    var url = '/widgets/' + window.CalcSlug + '-content';
    if (lang !== '') {
        url = '/' + lang + url;
    }
    var CalcWidgetConfig = GenerateCalculatorWidgetModel();

    $.ajax({
        type: "POST",
        url: url,
        data: {
            bodyFileName: window.CalcWidgetPartialFileName,
            lang: lang,
            model: JSON.stringify(CalcWidgetConfig)
        },
        success: function (data) {
            var widgetContainers = document.getElementsByClassName('widget-content-container');
            if (widgetContainers.length > 0) {
                var widgetContainer = widgetContainers[0];
                setInnerHTML(widgetContainer, data.content);
                // widgetContainer.innerHTML = data.content;
                window.InitializeCalcWidget();
                InitializeGlobalCalcContent();
                ChangeBodyContent();
            }
        },
        error: function () {

        }
    })
}

function OnChangedWidgetLanguage(e) {
    GenerateCalculatorWidgetRemoteScript();
    var value = e.value;
    if (value === "browser") {
        value = '';
    } else if (value === "page") {
        value = window.CurrentLang;
    }
    var compactType = 'large';
    var compactTypeSelect = document.getElementById('widget-compact-type-select');
    if (compactTypeSelect) {
        compactType = compactTypeSelect.options[compactTypeSelect.selectedIndex].value;
    }

    FetchLocalizedContent(value, compactType);
}

function ResetDefaultStyles() {
    SetStyleThemeSelectValue(defaultStyleValue, true);
    ResetCustomStyles();
    var resetLink = document.getElementById('widget-default-style-reset');
    if (resetLink) {
        resetLink.style.setProperty('display', 'none', 'important');
    }


}

function ResetCustomStyles() {
    var defaultCustomTheme = 'plain';
    var defaultStyleObj;
    for (var i = 0; i < CalcDefaultStyles.length; i++) {
        if (CalcDefaultStyles[i].value === defaultCustomTheme) {
            defaultStyleObj = CalcDefaultStyles[i];
        }
    }
    if (defaultStyleObj) {
        window.CalcWidgetStyle.SetWidgetStyleCookie('TopPaneStyle', defaultStyleObj.styles['large']['topPane']);
        window.CalcWidgetStyle.SetWidgetStyleCookie('BottomPaneStyle', defaultStyleObj.styles['large']['bottomPane']);
        window.CalcWidgetStyle.SetWidgetStyleCookie('ButtonStyle', defaultStyleObj.styles['large']['buttonStyle']);
        window.CalcWidgetStyle.SetWidgetStyleCookie('TitleStyle', defaultStyleObj.styles['large']['titleStyle']);
        window.CalcWidgetStyle.SetWidgetStyleCookie('TextboxStyle', defaultStyleObj.styles['large']['textboxStyle']);
        window.CalcWidgetStyle.SetWidgetStyleCookie('HighlightColor', defaultStyleObj.styles['large']['highlightColor']);
        window.CalcWidgetStyle.SetWidgetStyleCookie('SmallContainerWidth', defaultStyleObj.styles['small']['containerWidth']);
        window.CalcWidgetStyle.SetWidgetStyleCookie('ContainerWidth', defaultStyleObj.styles['large']['containerWidth']);
    }
}
function OnChangeDefaultExchange(e) {

    var defaultExchangeVal = $('#widget-default-exchange-select').selectpicker('val');
    $('#exfee-exchange-select').selectpicker('val', defaultExchangeVal);

    $('span.result-span').html('--');
    UpdateExchangeInfo();

    GenerateCalculatorWidgetRemoteScript();
}


function OnChangeDefaultStatingBalance(e) {
    GenerateCalculatorWidgetRemoteScript();
    ChangeBodyContent();
}


function OnChangeDefaultNumber(e) {
    GenerateCalculatorWidgetRemoteScript();
    ChangeBodyContent();
}


function OnChangeDefaultPercent(e) {
    GenerateCalculatorWidgetRemoteScript();
    ChangeBodyContent();
}


function InitializeCompoundingCalcParamsFromCookie() {
    if (window.DefaultBalance !== '-1' && window.DefaultBalance !== '' && window.DefaultBalance !== undefined) {
        $("#cc-starting-balance").val(parseInt(window.DefaultBalance));
    } else {
        var cookieStartBalance = window.CalcWidgetStyle.GetCalcCookieValue('comc-balance');
        if (cookieStartBalance != "") {
            $("#cc-starting-balance").val(parseInt(cookieStartBalance));
        }
    }

    if (window.DefaultPeriod !== '-1' && window.DefaultPeriod !== '' && window.DefaultPeriod !== undefined) {
        $("#cc-periods").val(parseInt(window.DefaultPeriod));
    } else {
        var cookiePeriods = window.CalcWidgetStyle.GetCalcCookieValue('comc-periods');
        if (cookiePeriods != "") {
            $("#cc-periods").val(parseInt(cookiePeriods));
        }
    }

    if (window.DefaultGain !== '-1' && window.DefaultGain !== '' && window.DefaultGain !== undefined) {
        $("#cc-gain-percent").val(parseInt(window.DefaultGain));
    } else {
        var cookieGain = window.CalcWidgetStyle.GetCalcCookieValue('comc-gain');
        if (cookieGain != "") {
            $("#cc-gain-percent").val(parseInt(cookieGain));
        }
    }
    
}

function InitCompoundingCalcWidget() {

    if ($("#cc-starting-balance").length <= 0)
        return;
    InitializeCompoundingCalcParamsFromCookie();

    CalculateCompounding();

    document.getElementById('cc-starting-balance').addEventListener('change', OnCCChangeInput);
    document.getElementById('cc-periods').addEventListener('change', OnCCChangeInput);
    document.getElementById('cc-gain-percent').addEventListener('change', OnCCChangeInput);
}

function OnCCStyleUpdated(e, styleType) {

    window.CalcWidgetStyle.SetWidgetStyleCookie(styleType, e.value);

    GenerateCompoundingCalculatorRemoteScript();
}

function OpenCCEmbedOverlay() {
    var prefix = 'compounding-calculator';
    var currentLocation = window.location.pathname;
    if (currentLocation.includes('/widgets/' + prefix + '-widget')) {
        var url = '/widgets/' + prefix + '-widget-maker';
        if (window.CurrentLang !== '') {
            url = '/' + window.CurrentLang + url;
            var width = 398;
            window.open(url, "", "width=" + width);
        }
    } else if (currentLocation.includes('/widgets/' + prefix)) {
        var url = '/widgets/' + prefix + '-widget';
        if (window.CurrentLang !== '') {
            url = '/' + window.CurrentLang + url;
        }
        window.open(url, '_blank').focus();
    } else if (currentLocation.includes('/tools/' + prefix)) {
        var url = '/tools/' + prefix + '-widget';
        if (window.CurrentLang !== '') {
            url = '/' + window.CurrentLang + url;
        }
        window.location.href = url;
    }
}


function ClearCompoundingCalcWdigetStyles() {

    window.CalcWidgetStyle.ResetCalcWidgetsStyles();

    GenerateCompoundingCalculatorRemoteScript();
}

function OnCopyCCEmbedScript() {
    document.getElementById('cc-embed-script-preview-output').select();
    document.execCommand("copy");

    GenerateCompoundingCalculatorRemoteScript();
}

function GenerateCompoundingCalculatorRemoteScript() {

    CompoundingWidgetConfig = new Object();

    CompoundingWidgetConfig.TopPaneStyle = window.CalcWidgetStyle.GetTopPaneStyle();
    CompoundingWidgetConfig.BottomPaneStyle = window.CalcWidgetStyle.GetBottomPaneStyle();
    CompoundingWidgetConfig.ButtonStyle = window.CalcWidgetStyle.GetButtonStyle();

    CompoundingWidgetConfig.IsDisplayTitle = document.getElementById('cc-display-tool-title-input').checked;

    var language = document.getElementById('cc-widget-language-select').value;
    if (language != "browser") {
        CompoundingWidgetConfig.Lang = language;
    }

    var hostUrl = window.location.protocol + "//" + window.location.hostname;
    if (window.location.port !== "")
        hostUrl += ":" + window.location.port;

    CompoundingWidgetConfig.Url = hostUrl;
    CompoundingWidgetConfig.Calculator = "compounding-calculator";

    document.getElementById('cc-embed-script-preview-output').value = GenerateCalcWidgetScript(CompoundingWidgetConfig);

    document.getElementById('compounding-preview-link').href = window.CalculatorHelper.GenerateCalcPreviewLink(CompoundingWidgetConfig, "compounding-calculator");
}

function OnCCChangeInput() {
    document.getElementById('compounding-ending-balance-result').innerHTML = "--";
    document.getElementById('compounding-total-gain-result').innerHTML = "--";
    var tableResultHtml = '<table class="calc-table compounding-table" style="width: 100% !important;"><tr><th></th><th>' + window.StartingBalanceLabel + '</th>' + '<th>' + window.TotalGainLabel + '</th>' + '<th>' + window.EndingBalanceLabel + '</th></tr>';
    tableResultHtml += '<tr>';

    tableResultHtml += "<td>--</td>";
    tableResultHtml += "<td>--</td>";
    tableResultHtml += "<td>--</td>";
    tableResultHtml += "<td>--</td>";

    tableResultHtml += '</tr>';

    document.getElementById('compounding-table-result').innerHTML = tableResultHtml;
}

function CCResultLoading() {

    $("#compounding-calc-form span.result-span").html('<img class="result-loading-img" src="/Content/dist/images/PageElements/ajax-loader.svg" />');

    var tableResultHtml = '<table class="calc-table compounding-table" style="width: 100% !important;"><tr><th></th><th>' + window.StartingBalanceLabel + '</th>' + '<th>' + window.TotalGainLabel + '</th>' + '<th>' + window.EndingBalanceLabel + '</th></tr>';
    tableResultHtml += '<tr>';

    tableResultHtml += '<td></td>';
    tableResultHtml += '<td><img class="result-loading-img" src="/Content/dist/images/PageElements/ajax-loader.svg" /></td>';
    tableResultHtml += '<td><img class="result-loading-img" src="/Content/dist/images/PageElements/ajax-loader.svg" /></td>';
    tableResultHtml += '<td><img class="result-loading-img" src="/Content/dist/images/PageElements/ajax-loader.svg" /></td>';

    tableResultHtml += '</tr>';

    document.getElementById('compounding-table-result').innerHTML = tableResultHtml;
}

function CalculateCompounding() {

    var form = document.getElementById('compounding-calc-form');
    if (form.checkValidity() == false) {
        form.reportValidity();
        //form.classList.add('was-validated');
        return;
    }
    
    var startingBalance = window.CalculatorHelper.ParseLocaleNumber(document.getElementById('cc-starting-balance').value);
    var numberOfPeriods = window.CalculatorHelper.ParseLocaleNumber(document.getElementById('cc-periods').value);
    var gainPerPeriod = window.CalculatorHelper.ParseLocaleNumber(document.getElementById('cc-gain-percent').value);

    window.CalcWidgetStyle.SetCalcCookieValue('comc-balance', startingBalance);
    window.CalcWidgetStyle.SetCalcCookieValue('comc-periods', numberOfPeriods);
    window.CalcWidgetStyle.SetCalcCookieValue('comc-gain', gainPerPeriod);
    
    CCResultLoading();

    $.ajax({
        type: "POST",
        cache: false,
        dataType: "json",
        url: "/widgets/calculation/compounding",
        data: { startingBalance: startingBalance, numberOfPeriods: numberOfPeriods, gainPerPeriod: gainPerPeriod },
        success: function (data) {
            if (data.success === true) {
                document.getElementById('compounding-ending-balance-result').innerHTML = window.CalculatorHelper.ToLocaleNumberForResult(data.endingBalance, "", 2, "");
                document.getElementById('compounding-total-gain-result').innerHTML = window.CalculatorHelper.ToLocaleNumberForResult(data.totalGain, 'percent', 1, "");

                var tableResultHtml = '<table class="calc-table compounding-table" style="width: 100% !important;"><tr><th></th><th>' + window.StartingBalanceLabel + '</th>' + '<th>' + window.TotalGainLabel + '</th>' + '<th>' + window.EndingBalanceLabel + '</th></tr>';
                for (var i = 0; i < numberOfPeriods; i++) {
                    if (data.tableResult[i] != undefined) {
                        tableResultHtml += '<tr>';

                        tableResultHtml += "<td>" + window.CalculatorHelper.ToLocaleNumberForResult((i + 1), "", 0, "") + "</td>";
                        tableResultHtml += "<td>" + window.CalculatorHelper.ToLocaleNumberForResult(data.tableResult[i].startingBalance, "", 2, "") + "</td>";
                        tableResultHtml += "<td>" + window.CalculatorHelper.ToLocaleNumberForResult(data.tableResult[i].totalGain, "percent", 2, "") + "</td>";
                        tableResultHtml += "<td>" + window.CalculatorHelper.ToLocaleNumberForResult(data.tableResult[i].endingBalance, "", 2, "") + "</td>";

                        tableResultHtml += '</tr>';
                    }
                }

                document.getElementById('compounding-table-result').innerHTML = tableResultHtml;
              
            } else {
                document.getElementById('compounding-ending-balance-result').innerHTML = "NaN";
                document.getElementById('compounding-total-gain-result').innerHTML = "NaN";
            }
        },
        error: function () {
            document.getElementById('compounding-ending-balance-result').innerHTML = "NaN";
            document.getElementById('compounding-total-gain-result').innerHTML = "NaN";
        }
    });
}


function InitializeCurrencyConverterParams() {

    var pathName = window.location.pathname;
    if (pathName.endsWith("/")) pathName = pathName.substring(0, pathName.length - 1);

    var defaultFrom = 'EUR';
    var defaultTo = 'USD';


    if (pathName.endsWith("currency-converter")) {
        var queryParams = new URLSearchParams(window.location.search);
        if (queryParams.get('s')) {
            var sParam = queryParams.get('s');
            if (sParam.length >= 6 && sParam.includes('-')) {
                defaultFrom = sParam.split('-')[0];
                defaultTo = sParam.split('-')[1];
            }

            var amount = 1;
            if (queryParams.get('v')) {

                amount = parseFloat(queryParams.get('v'));

                if (amount === NaN) {
                    amount = 1;
                }

                document.getElementById("currency-converter-from-amount").value = window.CalculatorHelper.ToLongDecimalNumberForInput(amount);
            }

        }
        else if (window.DefaultCurrencyFrom && window.DefaultCurrencyFrom !== '' && window.DefaultCurrencyTo && window.DefaultCurrencyTo !== '') {
            defaultFrom = window.DefaultCurrencyFrom;
            defaultTo = window.DefaultCurrencyTo;
        } else {
            var cookieFrom = window.CalcWidgetStyle.GetCalcCookieValue('cc-from');
            var cookieTo = window.CalcWidgetStyle.GetCalcCookieValue('cc-to');
            if (cookieFrom != "" && cookieTo != "") {
                defaultFrom = cookieFrom;
                defaultTo = cookieTo;
            }
            var cookieAmount = window.CalcWidgetStyle.GetCalcCookieValue('cc-amount');
            if (cookieAmount != '') {
                $("#currency-converter-from-amount").val(window.CalculatorHelper.ToLongDecimalNumberForInput(cookieAmount));
            }
        }
    } else if (pathName.includes("tools/currency-converter/")) {
        var urlParams = window.location.pathname.split("/tools/currency-converter/")[1].split("/");
        if (urlParams[0].length >= 6 && urlParams[0].includes('-')) {
            defaultFrom = urlParams[0].split('-')[0];
            defaultTo = urlParams[0].split('-')[1];
        }

        var amount = 1;
        if (urlParams.length == 2) {
            amount = parseFloat(urlParams[1]);

            if (amount === NaN) {
                amount = 1;
            }

            document.getElementById("currency-converter-from-amount").value = window.CalculatorHelper.ToLongDecimalNumberForInput(amount);
        }
    }

    if (location.pathname.includes("/tools/")) {
        // update the cannonical
        var pathAndQueryString = location.pathname + location.search;
        $("link[rel='canonical']").attr('href', window.location.protocol + "//" + window.location.host + pathAndQueryString);
    }

    $("#currency-converter-from-select").infiniteselect({
        types: [
            { option: 'all', text: 'All' },
            { option: 'forex', text: 'Forex' },
            { option: 'crypto', text: 'Crypto' }],
        url: '/api/widgets/currencies',
        placeholder: 'Select',
        default: defaultFrom,
        showDescription: true,
        culture: window.CURRENT_LANG,
        btnClass: 'widget-input-override frn-override'
    });
    $("#currency-converter-to-select").infiniteselect({
        types: [
            { option: 'all', text: 'All' },
            { option: 'forex', text: 'Forex' },
            { option: 'crypto', text: 'Crypto' }],
        url: '/api/widgets/currencies',
        placeholder: 'Select',
        default: defaultTo,
        showDescription: true,
        culture: window.CURRENT_LANG,
        btnClass: 'widget-input-override frn-override'
    });
}

function InitCurrencyConverterWidget() {

    if ($("#currency-converter-form").length <= 0)
        return;

    InitializeCurrencyConverterParams();

   
    PrepareCurrencyConverterCalculation(ConvertCurrency);
    

    var from = $('#currency-converter-from-select').infiniteselect('val');
    var to = $('#currency-converter-to-select').infiniteselect('val');
    AdjustPageTitleAndUrl(from, to);

    
    document.getElementById('currency-converter-from-select').addEventListener('change', OnCurrencyChanged);    
    document.getElementById('currency-converter-to-select').addEventListener('change', OnCurrencyChanged);

    var timerid;

    $("#currency-converter-from-amount").on('input', function () {
        UpdateCurrencyConverterHrefAndTitle();
        ConvertCurrency();
        var value = $(this).val();
        if ($(this).data("lastval") != value) {

            $(this).data("lastval", value);
            clearTimeout(timerid);

            timerid = setTimeout(function () {
                //your change action goes here
                SaveConvertHistory();
            }, 3000);
        };
    });
    $("#currency-converter-to-amount").on('input', function () {
        UpdateCurrencyConverterHrefAndTitle();
        ConvertCurrency(true);

        var value = $(this).val();
        if ($(this).data("lastval") != value) {

            $(this).data("lastval", value);
            clearTimeout(timerid);

            timerid = setTimeout(function () {
                //your change action goes here
                SaveConvertHistory();
            }, 3000);
        };
    });
    
    $("#currency-converter-from-amount").on('click', function () {
        $(this).select();
    });
    $("#currency-converter-to-amount").on('click', function () {
        $(this).select();
    });
    /*    
    UpdateCurrenyConverterPageTitle(from, to, from, to);
    */
    
}

function AdjustPageTitleAndUrl(from, to) {

    $.ajax({
        type: 'GET',
        cache: 'true',
        dataType: 'json',
        url: "/" + window.CURRENT_LANG + "/api/widgets/converter-currencies-adjust",
        data: { from: from, to: to },
        success: function (res) {

            $('#currency-converter-from-select').infiniteselect('val', res.from.Code, res.from.Name);
            $('#currency-converter-to-select').infiniteselect('val', res.to.Code, res.to.Name);

            if (res.backToDefault) {

                PrepareCurrencyConverterCalculation(ConvertCurrency);
            }
            
            UpdateCurrenyConverterPageTitle(res.from.Code, res.to.Code, res.from.Name, res.to.Name);
            ConvertCurrency();
            UpdateRecentSymbols();
        }
    });
    

}

function UpdateRecentSymbols() {
    if ($("#cc-recent-symbols").length == 0 || !window.location.pathname.includes("tools/currency-converter"))
        return;
    var symbol = '';
    var queryParms = new URLSearchParams(window.location.search);
    if (queryParms.get('s'))
        symbol = $('#currency-converter-from-select').val() + '-' + $('#currency-converter-to-select').val();

    $.ajax({
        type: "GET",
        cache: false,
        dataType: "json",
        url: "/api/widgets/recent-convert-symbols",
        data: { symbol: symbol },
        success: function (res) {

            if (res.length > 0) {
                var html = '';
                if (!symbol) {
                    if (!window.RecentConversionsLabel) window.RecentConversionsLabel = "Recent Conversions";
                    html += '<h3 class="recent-conversions-title">' + window.RecentConversionsLabel + '</h2>';
                } else {
                   
                    var fromCurrencyName = $("#currency-converter-from-select").infiniteselect('description');
                    var toCurrencyName = $("#currency-converter-to-select").infiniteselect('description');

                    if (!window.RecentSymbolConversionsLabel) window.RecentSymbolConversionsLabel = "Recent {0} to {1} Conversions"; 
                    var title = window.RecentSymbolConversionsLabel.replaceAll("{0}", fromCurrencyName).replaceAll("{1}", toCurrencyName);
                    html += '<h3 class="recent-conversions-title">' + title + '</h2>';
                }
                
                html += '<div class="recent-conversions">';
                for (var i = 0; i < res.length; i++) {
                    html += '<a href="/tools/currency-converter?s=' + res[i].Symbol;
                    var adjustedAmount = window.CalculatorHelper.ToLongDecimalNumberForResult(res[i].Amount, true);
                    if (res[i].Amount != 1)
                        html += '&v=' + window.CalculatorHelper.ToLongDecimalNumberForInput(res[i].Amount);
                    if (res[i].Symbol.includes('-')) {
                        html += '" class="recent-conversion-item">' + adjustedAmount + ' ' + res[i].Symbol.split('-')[0] + " to " + res[i].Symbol.split('-')[1] + '</a>';
                    } else {
                        html += '" class="recent-conversion-item">' + adjustedAmount + ' ' + res[i].Symbol.substring(0, 3) + " to " + res[i].Symbol.substring(3, 6) + '</a>';
                    }
                }
                html += "</div>";
                $("#cc-recent-symbols").html(html);
            } else {
                $("#cc-recent-symbols").html("");
            }
        }
    });
}


function OnCurrencyConverterStyleUpdated(e, styleType) {

    window.CalcWidgetStyle.SetWidgetStyleCookie(styleType, e.value);

    GenerateCurrencyConverterulatorRemoteScript();
}

function OpenCurrencyConverterEmbedOverlay() {
    var prefix = 'currency-converter';
    var currentLocation = window.location.pathname;
    if (currentLocation.includes('/widgets/' + prefix + '-widget')) {
        var url = '/widgets/' + prefix + '-widget-maker';
        if (window.CurrentLang !== '') {
            url = '/' + window.CurrentLang + url;
            var width = 398;
            window.open(url, "", "width=" + width);
        }
    } else if (currentLocation.includes('/widgets/' + prefix)) {
        var url = '/widgets/' + prefix + '-widget';
        if (window.CurrentLang !== '') {
            url = '/' + window.CurrentLang + url;
        }
        window.open(url, '_blank').focus();
    } else if (currentLocation.includes('/tools/' + prefix)) {
        var url = '/tools/' + prefix + '-widget';
        if (window.CurrentLang !== '') {
            url = '/' + window.CurrentLang + url;
        }
        window.location.href = url;
    }
}

function CloseCurrencyConverterEmbedOverlay() {
    $("#currency-converter-embed-script-overlay").css("display", "none");
}

function ClearCurrencyConverterWdigetStyles() {

    window.CalcWidgetStyle.ResetCalcWidgetsStyles();

    GenerateCurrencyConverterulatorRemoteScript();
}

function OnCopyCurrencyConverterEmbedScript() {
    document.getElementById('currency-converter-embed-script-preview-output').select();
    document.execCommand("copy");

    GenerateCurrencyConverterulatorRemoteScript();
}

function GenerateCurrencyConverterulatorRemoteScript() {

    CurrencyConverterWidgetConfig = new Object();

    CurrencyConverterWidgetConfig.TopPaneStyle = window.CalcWidgetStyle.GetTopPaneStyle();
    CurrencyConverterWidgetConfig.BottomPaneStyle = window.CalcWidgetStyle.GetBottomPaneStyle();
    CurrencyConverterWidgetConfig.ButtonStyle = window.CalcWidgetStyle.GetButtonStyle();

    CurrencyConverterWidgetConfig.IsDisplayTitle = document.getElementById('currency-converter-display-tool-title-input').checked;

    var language = document.getElementById('currency-converter-widget-language-select').value;
    if (language != "browser") {
        CurrencyConverterWidgetConfig.Lang = language;
    }

    var hostUrl = window.location.protocol + "//" + window.location.hostname;
    if (window.location.port !== "")
        hostUrl += ":" + window.location.port;

    CurrencyConverterWidgetConfig.Url = hostUrl;

    CurrencyConverterWidgetConfig.Calculator = "currency-converter";

    document.getElementById('currency-converter-embed-script-preview-output').value = GenerateCalcWidgetScript(CurrencyConverterWidgetConfig);

    document.getElementById('currency-converter-preview-link').href = window.CalculatorHelper.GenerateCalcPreviewLink(CurrencyConverterWidgetConfig, "currency-converter");
}

function UpdateLiveChart() {

    if ($("#cc-tv-chart-pane").length == 0 || !window.location.pathname.includes("tools/currency-converter")) return;

    var fromCurrency = $("#currency-converter-from-select").val();
    var toCurrency = $("#currency-converter-to-select").val();

    var symbol = fromCurrency + toCurrency;

    var hideToolBar = false;
    if (screen.width <= 767) {
        hideToolBar = true;
    }
    var tvSymbol = window.CalculatorHelper.GetTVSymbol(symbol);
    if (tvSymbol === "") {
        $("#cc-tv-chart-pane").hide();
    } else {
        $("#cc-tv-chart-pane").show();

        
        var fromCurrencyName = $("#currency-converter-from-select").infiniteselect('description');
        var toCurrencyName = $("#currency-converter-to-select").infiniteselect('description');

        if (!fromCurrencyName) fromCurrencyName = fromCurrency;
        if (!toCurrencyName) toCurrencyName = toCurrency;

        if (!window.ExchangeRateHistoryLabel) window.ExchangeRateHistoryLabel = "{0} to {1} Exchange Rate History";
        var chartTitle = window.ExchangeRateHistoryLabel.replaceAll("{0}", fromCurrencyName).replaceAll("{1}", toCurrencyName);

        $("#cc-tv-chart-title").html(chartTitle);

        if (!window.TradingViewChart) {
            window.TradingViewChart = new TradingView.widget(
                {
                    "autosize": true,
                    "symbol": tvSymbol,
                    "interval": "60",
                    "timezone": "Atlantic/Reykjavik",
                    "theme": "light",
                    "style": "1",
                    "locale": window.tvLang[window.DEFAULT_LANG],
                    "toolbar_bg": "#f1f3f6",
                    "enable_publishing": false,
                    "hide_side_toolbar": hideToolBar,
                    "container_id": "cc-tv-chart-container"
                }
            );
        } else {

            window.TradingViewChart.options["symbol"] = tvSymbol;
            window.TradingViewChart.reload();
        }
    }
    
}

function PrepareCurrencyConverterCalculation(callback) {

    var e = document.getElementById('currency-converter-from-select');
    var fromCurrency = e.value;
  
    var e = document.getElementById('currency-converter-to-select');
    var toCurrency = e.value;

    if (fromCurrency == toCurrency) {
        if (!window.PrevCCFromCurrency || window.PrevCCFromCurrency == window.PrevCCToCurrency) {
            toCurrency = "USD";
        } else {
            toCurrency = window.PrevCCFromCurrency;
        }
        if (!window.PrevCCToCurrency || window.PrevCCFromCurrency == window.PrevCCToCurrency) {
            fromCurrency = "EUR";
        } else {
            fromCurrency = window.PrevCCToCurrency;
        }

        $("#currency-converter-from-select").infiniteselect('val', fromCurrency);
        $("#currency-converter-to-select").infiniteselect('val', toCurrency);
        
        e = document.getElementById('currency-converter-to-select')
        localizedToCurrency = e.value;

        e = document.getElementById('currency-converter-from-select');
        localizedFromCurrency = e.value;
    }

    window.PrevCCFromCurrency = fromCurrency;
    window.PrevCCToCurrency = toCurrency;
    
    /*
    $("#currency-converter-to-select option").removeAttr('disabled');
    $("#currency-converter-to-select option[value='" + fromCurrency + "']").attr('disabled', true);

    $("#currency-converter-from-select option").removeAttr('disabled');
    $("#currency-converter-from-select option[value='" + toCurrency + "']").attr('disabled', true);
    

    $("#currency-converter-to-select").selectpicker('refresh');
    $("#currency-converter-from-select").selectpicker('refresh');
    */
    UpdateLiveChart();

    window.CalculatorHelper.GetExchangeRateAsync(fromCurrency, toCurrency)
        .then(function (res) {
            
            if (res.rate < 0)
                res.rate = "NaN";

            $("#cc-current-exchange-rate").val(res.rate);
            if (res.mins == 0) {
                $("#converter-updated-desc").html(window.RatesSecondsUpdatedLabel.replaceAll("{0}", 1));
            } else {
                $("#converter-updated-desc").html(window.RatesUpdatedLabel.replaceAll("{0}", res.mins));
            }
            
            /*
            document.getElementById("currency-converter-CurrentPrice").value = window.CalculatorHelper.ToLocaleNumberForInput(currentPrice, { minimumFractionDigits: 5 });
            if (!window.PriceLabel) window.PriceLabel = "1 {0} to {1}";
            document.getElementById("currency-converter-CurrentPriceLabel").innerHTML = window.PriceLabel.replaceAll("{0}", localizedFromCurrency).replaceAll("{1}", localizedToCurrency);

            if (currentPrice == 1) {

                $("#currency-converter-current-price-form-group").css("display", "none");

            } else {

                $("#currency-converter-current-price-form-group").css("display", "block");
            }
            */
            if (!!callback && typeof callback === "function")
                callback();
        });
}
function OnCurrencyChanged() {

    //update title, page and all href
    UpdateCurrencyConverterHrefAndTitle();

    PrepareCurrencyConverterCalculation(ConvertCurrency);
    
    //update ParamLinks
    //UpdateCurrencyConvertParamLinks();
    UpdateRecentSymbols();

    TriggerGoogleAnalytics();
}

function CurrencyConverterCalculate() {

    var queryParams = new URLSearchParams(window.location.search);

    if (window.UpdateCurrenyConverterPageTitle != undefined && queryParams.get('s') != null) {

        var fromCurrency = document.getElementById('currency-converter-from-select').value;
        var amount = window.CalculatorHelper.ParseLocaleNumber(document.getElementById('currency-converter-from-amount').value);
        var toCurrency = document.getElementById('currency-converter-to-select').value;

        var newUrl = GenerateCurrencyConverterNewLink(window.location.href, fromCurrency + toCurrency, amount);
        if (newUrl != window.location.href) {
            window.history.replaceState({ path: newUrl }, '', newUrl);
        }
        UpdateCurrencyConverterHrefAndTitle();
    }

    ConvertCurrency();
}

function ConvertCurrency(isTo) {

    var form = document.getElementById('currency-converter-form');
    if (form.checkValidity() == false) {
        form.reportValidity();
        //form.classList.add('was-validated');
        return;
    }

    var fromCurrency = document.getElementById('currency-converter-from-select').value;
    var fromAmount = window.CalculatorHelper.ParseLocaleNumber(document.getElementById('currency-converter-from-amount').value);
    var toCurrency = document.getElementById('currency-converter-to-select').value;
    var toAmount = window.CalculatorHelper.ParseLocaleNumber(document.getElementById('currency-converter-to-amount').value);

    window.CalcWidgetStyle.SetCalcCookieValue('cc-from', fromCurrency);
    window.CalcWidgetStyle.SetCalcCookieValue('cc-amount', fromAmount);
    window.CalcWidgetStyle.SetCalcCookieValue('cc-to', toCurrency);
    
    //var rate = window.CalculatorHelper.GetCalculatedExchangeRate(fromCurrency, toCurrency);
    var rate = document.getElementById("cc-current-exchange-rate").value;
    if (rate == "NaN") {
        return;
    }
    if (isTo) {
        fromAmount = toAmount / rate;
        $('#currency-converter-from-amount').val(window.CalculatorHelper.ToLongDecimalNumberForInput(fromAmount));
    } else {
        toAmount = fromAmount * rate;
        $('#currency-converter-to-amount').val(window.CalculatorHelper.ToLongDecimalNumberForInput(toAmount));
    }

    var fromCurrencyName = $("#currency-converter-from-select").infiniteselect('description');
    var toCurrencyName = $("#currency-converter-to-select").infiniteselect('description');
    $("#currency-converter-result").html(window.CalculatorHelper.ToLongDecimalNumberForResult(fromAmount) + ' ' + fromCurrencyName + ' = ' + window.CalculatorHelper.ToLongDecimalNumberForResult(toAmount) + ' ' + toCurrencyName);
    if (fromAmount == 1) {
        $("#currency-converter-one-result").html('1 ' + toCurrencyName + ' = ' + window.CalculatorHelper.ToLongDecimalNumberForResult(1 / rate) + ' ' + fromCurrencyName);
    } else {
        $("#currency-converter-one-result").html('1 ' + fromCurrencyName + ' = ' + window.CalculatorHelper.ToLongDecimalNumberForResult(rate) + ' ' + toCurrencyName);
    }

    var queryParams = new URLSearchParams(window.location.search);
    if (queryParams.get('s') != null) {
        $("title").html($("title").html().replaceAll("{4}", window.CalculatorHelper.ToLongDecimalNumberForInput(toAmount) + " " + toCurrency));
        $("title").html($("title").html().replaceAll("{5}", window.CalculatorHelper.ToLongDecimalNumberForInput(toAmount)));
    }
}

function SaveConvertHistory() {

    var fromCurrency = document.getElementById('currency-converter-from-select').value;
    var fromAmount = window.CalculatorHelper.ParseLocaleNumber(document.getElementById('currency-converter-from-amount').value);
    var toCurrency = document.getElementById('currency-converter-to-select').value;    

    $.ajax({
        type: "POST",
        cache: false,
        dataType: "json",
        url: "/api/widgets/recent-convert-symbol",
        data: { symbol: fromCurrency + '-' + toCurrency, amount: fromAmount },
        success: function (res) {

        }
    });
}

function UpdateCurrencyConverterSymbol(symbol) {

    if (symbol.length != 6)
        return;
    var from = symbol.substring(0, 3);
    var to = symbol.substring(3, 6);

    $("#currency-converter-from-select").infiniteselect('val', from);
    $("#currency-converter-to-select").infiniteselect('val', to);

    OnCurrencyChanged();

}

function GenerateCurrencyConverterNewLink(oldUrl, newSymbol, amount) {

    var urlPart = "/tools/currency-converter";
    var baseUrl = oldUrl.substring(0, oldUrl.toLowerCase().indexOf(urlPart) + urlPart.length);
    var link = baseUrl + GenerateCurrencyConverterQueryString(newSymbol, amount);
    return link;
}

function GenerateCurrencyConverterQueryString(newSymbol, amount) {
    var queryString = "";
    if (newSymbol) {
        queryString = "?s=" + newSymbol;
        if (amount != undefined && amount != 1)
            queryString += "&v=" + window.CalculatorHelper.ToLongDecimalNumberForInput(amount);
    }

    return queryString;
}

function UpdateCurrenyConverterPageTitle(defaultFrom, defaultTo, defaultFromName, defaultToName) {

    var queryParams = new URLSearchParams(window.location.search);
    if (queryParams.get('s') != null && window.location.hash != '#popout') {

        var amount = 1;
        if (queryParams.get('v')) {
            amount = parseFloat(queryParams.get('v'));
        }
        if (amount != 1) {
            title = window.CurrencyConverterPageTitle
                .replaceAll("{0}", window.CalculatorHelper.ToLongDecimalNumberForResult(amount))
                .replaceAll("{1}", defaultFrom)
                .replaceAll("{2}", defaultTo)
                .replaceAll("{3}", defaultFromName)
                .replaceAll("{4}", defaultToName);
        } else {
            title = window.CurrencyConverterOnePageTitle
                .replaceAll("{0}", defaultFrom)
                .replaceAll("{1}", defaultTo)
                .replaceAll("{2}", defaultFromName)
                .replaceAll("{3}", defaultToName);
        }

        document.getElementsByTagName("title")[0].innerHTML = title;

        var h1Title = window.CurrencyConverterH1Title
            .replaceAll("{0}", window.CalculatorHelper.ToLongDecimalNumberForResult(amount))
            .replaceAll("{1}", defaultFromName)
            .replaceAll("{2}", defaultToName);

        document.querySelector("h1.article-title").innerHTML = h1Title;
    }
}

function UpdateCurrencyConverterHrefAndTitle() {

    var urlPart = "/tools/currency-converter";

    if (!window.location.pathname.includes(urlPart) || window.location.hash == '#popout' || window.location.pathname.includes('-widget'))
        return;

    var symbol = $("#currency-converter-from-select").val() + "-" + $("#currency-converter-to-select").val();

    //var newH1Title = symbol + " " + window.originArticleH1Title;
    var newPageTitle = symbol + " " + window.originArticlePageTitle;
    var newSEODesc = symbol + ": " + window.originArticleSEODescription;

    /*
    if (window.originArticleH1Title != "")
        $("h1.article-title").html(newH1Title);
        */
    /*
    if (window.originArticlePageTitle != "")
        $("title").html(newPageTitle);
        */
    if (window.originArticleSEODescription != "")
        $('meta[name="description"]').attr("content", newSEODesc);


    // update current page link
    var amount = window.CalculatorHelper.ParseLocaleNumber(document.getElementById('currency-converter-from-amount').value);


    var newUrl = "";
    if (window.CURRENT_LANG != "en") newUrl += "/" + window.CURRENT_LANG;

    newUrl += urlPart;

    var queryString = GenerateCurrencyConverterQueryString(symbol, amount);

    newUrl += queryString;

    // update current page url
    
    window.history.replaceState({ path: newUrl }, '', newUrl);

    // update canonical links
    $("link[rel='canonical']").attr('href', window.location.protocol + "//" + window.location.host + newUrl);
    
    // update href links
    var hreflangs = $("link[hreflang]");
    for (var i = 0; i < hreflangs.length; i++) {
        hreflangs[i].href = GenerateCurrencyConverterNewLink(hreflangs[i].href, symbol, amount);
    }

    //update language switch links
    var langSelectors = $("#lang-select li a")
    for (var i = 0; i < langSelectors.length; i++) {

        var newLink = GenerateCurrencyConverterNewLink(langSelectors[i].href, symbol, amount);

        var langCode = $("#lang-select li a i")[i].getAttribute("data-id").split('-')[0];

        langSelectors[i].href = newLink;
        var langSlug = "";
        if (langCode != 'en') langSlug += "/" + langCode;

        if (amount != 1) {
            $(langSelectors[i]).attr("onclick", "return window.Language.Select('" + langSlug + urlPart + "?s=" + symbol + "&v=" + window.CalculatorHelper.ToLongDecimalNumberForResult(amount, true) + "','" + langCode + "')");
        } else {
            $(langSelectors[i]).attr("onclick", "return window.Language.Select('" + langSlug + urlPart + "?s=" + symbol + "','" + langCode + "')");
        }
        
    }

    if (window.UpdateCurrenyConverterPageTitle != undefined) {

        var fromCurrency = document.getElementById('currency-converter-from-select').value;
        var toCurrency = document.getElementById('currency-converter-to-select').value;

        var defaultFromName = $("#currency-converter-from-select").infiniteselect('description');
        var defaultToName = $("#currency-converter-to-select").infiniteselect('description');

        UpdateCurrenyConverterPageTitle(fromCurrency, toCurrency, defaultFromName, defaultToName);        
    }
}

function UpdateCurrencyConvertParamLinks() {

    var urlPart = "/tools/currency-converter";

    if (!window.location.pathname.includes(urlPart) || window.location.hash == '#popout' || window.location.pathname.includes('-widget'))
        return;

    var fromSymbol = $("#currency-converter-from-select").val();
    var toSymbol = $("#currency-converter-to-select").val();

    if ($('#currency-converter-from-select-group .dropdown-menu a[role="option"]').length == 0)
        $("#currency-converter-from-select").selectpicker("refresh");
    var fromSymbolLinks = $('#currency-converter-from-select-group .dropdown-menu a[role="option"]');

    for (var i = 0; i < fromSymbolLinks.length; i++) {

        var curSymbol = document.getElementById("currency-converter-from-select").options[i].getAttribute("value");
        if (curSymbol != toSymbol) {
            fromSymbolLinks[i].href = GenerateCurrencyConverterNewLink(window.location.pathname, curSymbol + toSymbol);
        } else {
            fromSymbolLinks[i].href = '#';
        }
    }

    if ($('#currency-converter-to-select-group .dropdown-menu a[role="option"]').length == 0)
        $("#currency-converter-to-select").selectpicker("refresh");
    var toSymbolLinks = $('#currency-converter-to-select-group .dropdown-menu a[role="option"]');

    for (var i = 0; i < toSymbolLinks.length; i++) {

        var curSymbol = document.getElementById("currency-converter-to-select").options[i].getAttribute("value");
        if (fromSymbol != curSymbol) {
            toSymbolLinks[i].href = GenerateCurrencyConverterNewLink(window.location.pathname, fromSymbol + curSymbol);
        } else {
            toSymbolLinks[i].href = '#';
        }
    }
}

function SwapCurrencyConverter() {
    var fromCur = $("#currency-converter-from-select").val();
    var toCur = $("#currency-converter-to-select").val();
    var fromCurDesc = $("#currency-converter-from-select").infiniteselect('description');
    var toCurDesc = $("#currency-converter-to-select").infiniteselect('description');

    var rate = window.CalculatorHelper.ParseLocaleNumber(document.getElementById('cc-current-exchange-rate').value);

    rate = 1.0 / rate;

    document.getElementById('cc-current-exchange-rate').value = rate;

    $("#currency-converter-from-select").infiniteselect('val', toCur, toCurDesc);
    $("#currency-converter-to-select").infiniteselect('val', fromCur, fromCurDesc);

    //update title, page and all href
    UpdateCurrencyConverterHrefAndTitle();
    //update ParamLinks
    //UpdateCurrencyConvertParamLinks();
    UpdateLiveChart();

    ConvertCurrency();
    UpdateRecentSymbols();
}
function InitializeDrawdownCalcParamsFromCookie() {
    if (window.DefaultBalance !== '-1' && window.DefaultBalance !== '' && window.DefaultBalance !== undefined) {
        $("#dc-starting-balance").val(parseInt(window.DefaultBalance));
    } else {
        var cookieStartBalance = window.CalcWidgetStyle.GetCalcCookieValue('dc-balance');
        if (cookieStartBalance != "") {
            $("#dc-starting-balance").val(parseInt(cookieStartBalance));
        }
    }
    if (window.DefaultPeriod !== '-1' && window.DefaultPeriod !== '' && window.DefaultPeriod !== undefined) {
        $("#dc-periods").val(parseInt(window.DefaultPeriod));
    } else {
        var cookiePeriods = window.CalcWidgetStyle.GetCalcCookieValue('dc-periods');
        if (cookiePeriods != "") {
            $("#dc-periods").val(parseInt(cookiePeriods));
        }
    }

    if (window.DefaultGain !== '-1' && window.DefaultGain !== '' && window.DefaultGain !== undefined) {
        $("#dc-gain-percent").val(parseInt(window.DefaultGain));
    } else {
        var cookieGain = window.CalcWidgetStyle.GetCalcCookieValue('dc-gain');
        if (cookieGain != "") {
            $("#dc-gain-percent").val(parseInt(cookieGain));
        }
    }


}

function InitDrawdownCalcWidget() {

    if ($('#dc-starting-balance').length <= 0)
        return;   
    InitializeDrawdownCalcParamsFromCookie();

    CalculateDrawdown();

    document.getElementById('dc-starting-balance').addEventListener('change', OnDCChangeInput);
    document.getElementById('dc-periods').addEventListener('change', OnDCChangeInput);
    document.getElementById('dc-gain-percent').addEventListener('change', OnDCChangeInput);

}

function OnDCStyleUpdated(e, styleType) {

    window.CalcWidgetStyle.SetWidgetStyleCookie(styleType, e.value);

    GenerateDrawdownCalculatorRemoteScript();
}

function OpenDCEmbedOverlay() {
    var prefix = 'drawdown-calculator';
    var currentLocation = window.location.pathname;
    if (currentLocation.includes('/widgets/' + prefix + '-widget')) {
        var url = '/widgets/' + prefix + '-widget-maker';
        if (window.CurrentLang !== '') {
            url = '/' + window.CurrentLang + url;
            var width = 398;
            window.open(url, "", "width=" + width);
        }
    } else if (currentLocation.includes('/widgets/' + prefix)) {
        var url = '/widgets/' + prefix + '-widget';
        if (window.CurrentLang !== '') {
            url = '/' + window.CurrentLang + url;
        }
        window.open(url, '_blank').focus();
    } else if (currentLocation.includes('/tools/' + prefix)) {
        var url = '/tools/' + prefix + '-widget';
        if (window.CurrentLang !== '') {
            url = '/' + window.CurrentLang + url;
        }
        window.location.href = url;
    }
}

function CloseDCEmbedOverlay() {
    $("#dc-embed-script-overlay").css("display", "none");
}

function ClearDrawdownCalcWdigetStyles() {

    window.CalcWidgetStyle.ResetCalcWidgetsStyles();

    GenerateDrawdownCalculatorRemoteScript();
}

function OnCopyDCEmbedScript() {
    document.getElementById('dc-embed-script-preview-output').select();
    document.execCommand("copy");

    GenerateDrawdownCalculatorRemoteScript();
}

function GenerateDrawdownCalculatorRemoteScript() {

    DrawdownWidgetConfig = new Object();

    DrawdownWidgetConfig.TopPaneStyle = window.CalcWidgetStyle.GetTopPaneStyle();
    DrawdownWidgetConfig.BottomPaneStyle = window.CalcWidgetStyle.GetBottomPaneStyle();
    DrawdownWidgetConfig.ButtonStyle = window.CalcWidgetStyle.GetButtonStyle();

    DrawdownWidgetConfig.IsDisplayTitle = document.getElementById('dc-display-tool-title-input').checked;

    var language = document.getElementById('dc-widget-language-select').value;
    if (language != "browser") {
        DrawdownWidgetConfig.Lang = language;
    }

    var hostUrl = window.location.protocol + "//" + window.location.hostname;
    if (window.location.port !== "")
        hostUrl += ":" + window.location.port;

    DrawdownWidgetConfig.Url = hostUrl;
    DrawdownWidgetConfig.Calculator = "drawdown-calculator";
    
    document.getElementById('dc-embed-script-preview-output').value = GenerateCalcWidgetScript(DrawdownWidgetConfig);

    document.getElementById('drawdown-preview-link').href = window.CalculatorHelper.GenerateCalcPreviewLink(DrawdownWidgetConfig, "drawdown-calculator");
}

function OnDCChangeInput() {
    document.getElementById('drawdown-ending-balance-result').innerHTML = "--";
    document.getElementById('drawdown-total-gain-result').innerHTML = "--";
    var tableResultHtml = '<table class="calc-table compounding-table" style="width: 100% !important;"><tr><th></th><th>' + window.StartingBalanceLabel + '</th>' + '<th>' + window.TotalGainLabel + '</th>' + '<th>' + window.EndingBalanceLabel + '</th></tr>';
    tableResultHtml += '<tr>';

    tableResultHtml += "<td>--</td>";
    tableResultHtml += "<td>--</td>";
    tableResultHtml += "<td>--</td>";
    tableResultHtml += "<td>--</td>";

    tableResultHtml += '</tr>';

    document.getElementById('drawdown-table-result').innerHTML = tableResultHtml;
}

function DCResultLoading() {

    $("#drawdown-calc-form span.result-span").html('<img class="result-loading-img" src="/Content/dist/images/PageElements/ajax-loader.svg" />');

    
    var tableResultHtml = '<table class="calc-table compounding-table" style="width: 100% !important;"><tr><th></th><th>' + window.StartingBalanceLabel + '</th>' + '<th>' + window.TotalGainLabel + '</th>' + '<th>' + window.EndingBalanceLabel + '</th></tr>';
    tableResultHtml += '<tr>';

    tableResultHtml += '<td></td>';
    tableResultHtml += '<td><img class="result-loading-img" src="/Content/dist/images/PageElements/ajax-loader.svg" /></td>';
    tableResultHtml += '<td><img class="result-loading-img" src="/Content/dist/images/PageElements/ajax-loader.svg" /></td>';
    tableResultHtml += '<td><img class="result-loading-img" src="/Content/dist/images/PageElements/ajax-loader.svg" /></td>';

    tableResultHtml += '</tr>';

    document.getElementById('drawdown-table-result').innerHTML = tableResultHtml;
}

function CalculateDrawdown() {

    var form = document.getElementById('drawdown-calc-form');
    if (form.checkValidity() == false) {
        form.reportValidity();
        //form.classList.add('was-validated');
        return;
    }

    var startingBalance = window.CalculatorHelper.ParseLocaleNumber(document.getElementById('dc-starting-balance').value);
    var numberOfPeriods = window.CalculatorHelper.ParseLocaleNumber(document.getElementById('dc-periods').value);
    var lossPerPeriod = window.CalculatorHelper.ParseLocaleNumber(document.getElementById('dc-gain-percent').value);

    window.CalcWidgetStyle.SetCalcCookieValue('dc-balance', startingBalance);
    window.CalcWidgetStyle.SetCalcCookieValue('dc-periods', numberOfPeriods);
    window.CalcWidgetStyle.SetCalcCookieValue('dc-gain', lossPerPeriod);
    
    DCResultLoading();

    $.ajax({
        type: "POST",
        cache: false,
        dataType: "json",
        url: "/widgets/calculation/drawdown",
        data: { startingBalance: startingBalance, numberOfPeriods: numberOfPeriods, lossPerPeriod: lossPerPeriod },
        success: function (data) {
            if (data.success === true) {
                document.getElementById('drawdown-ending-balance-result').innerHTML = window.CalculatorHelper.ToLocaleNumberForResult(data.endingBalance, "", 2, "");
                document.getElementById('drawdown-total-gain-result').innerHTML = window.CalculatorHelper.ToLocaleNumberForResult(data.totalLoss, "percent", 1, "");

                var tableResultHtml = '<table class="calc-table compounding-table" style="width: 100% !important;"><tr><th></th><th>' + window.StartingBalanceLabel + '</th>' + '<th>' + window.TotalGainLabel + '</th>' + '<th>' + window.EndingBalanceLabel + '</th></tr>';
                for (var i = 0; i < numberOfPeriods; i++) {
                    if (data.tableResult[i] != undefined) {
                        tableResultHtml += '<tr>';

                        tableResultHtml += "<td>" + window.CalculatorHelper.ToLocaleNumberForResult((i + 1), "", 0, "") + "</td>";
                        tableResultHtml += "<td>" + window.CalculatorHelper.ToLocaleNumberForResult(data.tableResult[i].startingBalance, "", 2, "") + "</td>";
                        tableResultHtml += "<td>" + window.CalculatorHelper.ToLocaleNumberForResult(data.tableResult[i].totalLoss, 'percent', 2, "") + "</td>";
                        tableResultHtml += "<td>" + window.CalculatorHelper.ToLocaleNumberForResult(data.tableResult[i].endingBalance, "", 2, "") + "</td>";

                        tableResultHtml += '</tr>';
                    }
                }

                document.getElementById('drawdown-table-result').innerHTML = tableResultHtml;

            } else {
                document.getElementById('drawdown-ending-balance-result').innerHTML = "NaN";
                document.getElementById('drawdown-total-gain-result').innerHTML = "NaN";
            }
        },
        error: function () {
            document.getElementById('drawdown-ending-balance-result').innerHTML = "NaN";
            document.getElementById('drawdown-total-gain-result').innerHTML = "NaN";
        }
    });
}

function InitializeExchangeFeeCalcParams() {

    var defaultFee = "";
    var defaultBuy = "";
    var defaultPay = "";
    var defaultAmount = "";
    var defaultExchange = "";

    var pathname = document.location.pathname;

    if (!pathname.includes("/widgets/")) {

        defaultBuy = window.CalcWidgetStyle.GetCalcCookieValue('exfee-buy-currency');
        defaultFee = window.CalcWidgetStyle.GetCalcCookieValue('exfee-fee-currency');
        defaultPay = window.CalcWidgetStyle.GetCalcCookieValue('exfee-pay-currency');
        defaultAmount = window.CalcWidgetStyle.GetCalcCookieValue('exfee-buy-amount');

        if (pathname.endsWith("tools/exchange-fees-calculator")) {
            var queryParams = new URLSearchParams(window.location.search);
            if (queryParams.get('s')) defaultExchange = queryParams.get('s');
            else defaultExchange = window.CalcWidgetStyle.GetCalcCookieValue('exfee-exchange');
        } else if (pathname.includes("tools/exchange-fees-calculator/")) {
            parts = pathname.split('/');
            defaultExchange = parts[parts.length - 1].split('?')[0];
        }

        if (defaultExchange != "" && $("#exfee-exchange-select option[value='" + defaultExchange + "']").length > 0) {
            $("#exfee-exchange-select").selectpicker('val', defaultExchange);
        }
    }

    if (defaultBuy == "")
        defaultBuy = "BTC";
    if (defaultFee == "")
        defaultFee = "USD";
    if (defaultPay == "")
        defaultPay = "USD";
    if (defaultAmount == "")
        defaultAmount = "1";

    $("#exfee-fee-currency-select").infiniteselect({
        types: [
            { option: 'all', text: 'All' },
            { option: 'forex', text: 'Forex' },
            { option: 'crypto', text: 'Crypto' }],
        url: '/api/widgets/currencies',
        placeholder: 'Select',
        default: defaultFee,
        showDescription: true,
        culture: window.CURRENT_LANG,
        btnClass: 'widget-input-override frn-override'
    });
    $("#exfee-buy-currency-select").infiniteselect({
        types: [
            { option: 'all', text: 'All' },
            { option: 'forex', text: 'Forex' },
            { option: 'crypto', text: 'Crypto' }],
        url: '/api/widgets/currencies',
        placeholder: 'Select',
        default: defaultBuy,
        showDescription: true,
        culture: window.CURRENT_LANG,
        btnClass: 'widget-input-override frn-override'
    });
    $("#exfee-pay-currency-select").infiniteselect({
        types: [
            { option: 'all', text: 'All' },
            { option: 'forex', text: 'Forex' },
            { option: 'crypto', text: 'Crypto' }],
        url: '/api/widgets/currencies',
        placeholder: 'Select',
        default: defaultPay,
        showDescription: true,
        culture: window.CURRENT_LANG,
        btnClass: 'widget-input-override frn-override'
    });
    $("#exfee-buy-amount").val(defaultAmount);

    if (pathname.includes("/tools/")) {
        var pathAndQuery = pathname + location.search;
        $("link[rel='canonical']").attr('href', window.location.protocol + "//" + window.location.host + pathAndQuery);

    }
}

function IsOnToolsExFeeCalculatorPage() {
    if (window.location.pathname.endsWith("/tools/exchange-fees-calculator") || window.location.pathname.includes("/tools/exchange-fees-calculator/"))
        return true;
    return false;

}
function InitExchangeFeeCalcWidget() {

    if ($("#exfee-current-exchange-rate").length == 0)
        return;

    InitializeExchangeFeeCalcParams();

    UpdateExFeeParamLinks();

    var queryParams = new URLSearchParams(window.location.search);

    if (queryParams.get('s')) {
        UpdateExFeePageTitleAndHref();
    }

    InitAmountInputLabels();
    setTimeout(InitAmountInputLabels, 1000);

    UpdateExchangeInfo(InitializeExchangeRate(function () {
        ExFeesUpdateAmounts();
        CalculateExchangeFee();
    }));

    $("#exfee-buy-amount").on('input', function () {
        ExFeesUpdateAmounts();
    });
    $("#exfee-pay-amount").on('input', function () {        
        ExFeesUpdateAmounts(true);
    });

    document.getElementById('exfee-buy-currency-select').addEventListener('change', OnExFeeCurrencyChanged);
    document.getElementById('exfee-pay-currency-select').addEventListener('change', OnExFeeCurrencyChanged);
    document.getElementById('exfee-fee-currency-select').addEventListener('change', function () {
        window.CalcWidgetStyle.SetCalcCookieValue('exfee-fee-currency', $("#exfee-fee-currency-select").val());
        $('span.result-span').html('--');
    });
}

function ExFeesUpdateAmounts(isTo) {

    var buyElem = document.getElementById('exfee-buy-amount');
    if (buyElem.checkValidity() == false) {
        buyElem.reportValidity();
        return;
    }
    var payElem = document.getElementById('exfee-pay-amount');
    if (payElem.checkValidity() == false) {
        payElem.reportValidity();
        return;
    }

    var fromCurrency = document.getElementById('exfee-buy-currency-select').value;
    var fromAmount = window.CalculatorHelper.ParseLocaleNumber(document.getElementById('exfee-buy-amount').value);
    var toCurrency = document.getElementById('exfee-pay-currency-select').value;
    var toAmount = window.CalculatorHelper.ParseLocaleNumber(document.getElementById('exfee-pay-amount').value);

    window.CalcWidgetStyle.SetCalcCookieValue('exfee-buy-currency', fromCurrency);
    window.CalcWidgetStyle.SetCalcCookieValue('exfee-buy-amount', fromAmount);
    window.CalcWidgetStyle.SetCalcCookieValue('exfee-pay-currency', toCurrency);

    //var rate = window.CalculatorHelper.GetCalculatedExchangeRate(fromCurrency, toCurrency);
    var rate = document.getElementById("exfee-current-exchange-rate").value;
    if (rate == "NaN") {
        return;
    }
    if (isTo) {
        fromAmount = toAmount / rate;
        $('#exfee-buy-amount').val(window.CalculatorHelper.ToLongDecimalNumberForInput(fromAmount));
    } else {
        toAmount = fromAmount * rate;
        $('#exfee-pay-amount').val(window.CalculatorHelper.ToLongDecimalNumberForInput(toAmount));
    }
}

function InitializeExchangeRate(callback) {

    var e = document.getElementById('exfee-buy-currency-select');
    var fromCurrency = e.value;

    var e = document.getElementById('exfee-pay-currency-select');
    var toCurrency = e.value;

    window.CalculatorHelper.GetExchangeRateAsync(fromCurrency, toCurrency)
        .then(function (res) {

            if (res.rate < 0)
                res.rate = "NaN";

            $("#exfee-current-exchange-rate").val(res.rate);
         
            if (!!callback && typeof callback === "function")
                callback();
        });
}


function OnExFeeCurrencyChanged() {

    $('span.result-span').html('--');

    var name = $(this).infiniteselect('description');
    if ($(this).attr('id').includes("-buy-")) {
        
        $("label[for=exfee-buy-amount]").html(window.ExFeeCalcResxStrings["_0Amount"].replace("{0}", name));
    }
    if ($(this).attr('id').includes("-pay-")) {
        $("label[for=exfee-pay-amount]").html(window.ExFeeCalcResxStrings["_0Amount"].replace("{0}", name));
    }
    InitializeExchangeRate(ExFeesUpdateAmounts);
}

function InitAmountInputLabels() {

    var buyCurrency = $("#exfee-buy-currency-select").infiniteselect('description');
    $("label[for=exfee-buy-amount]").html(window.ExFeeCalcResxStrings["_0Amount"].replace("{0}", buyCurrency));

    var payCurrency = $("#exfee-pay-currency-select").infiniteselect('description');
    $("label[for=exfee-pay-amount]").html(window.ExFeeCalcResxStrings["_0Amount"].replace("{0}", payCurrency));
}

function OnExFeeExchangeChanged() {

    $('span.result-span').html('--');

    UpdateExFeePageTitleAndHref();
    window.CalcWidgetStyle.SetCalcCookieValue('exfee-exchange', $("#exfee-exchange-select").val());
    UpdateExchangeInfo();
}

function UpdateExFeePageTitleAndHref() {

    var urlPart = "/tools/exchange-fees-calculator";
    
    if (!IsOnToolsExFeeCalculatorPage() || window.location.hash == '#popout')
        return;

    var exchange = $('#exfee-exchange-select').val();
    var exchangeName = $($("#exfee-exchange-select option")[document.getElementById('exfee-exchange-select').selectedIndex]).text();
    var title = window.ExFeeCalcResxStrings["_0FeesCalculator"].replace("{0}", exchangeName);
    var seoDesc = window.ExFeeCalcResxStrings["ExchangeFeesCalculatorSEODescription"].replace("{0}", exchangeName);


    $("h1.article-title").html(title);
    $("title").html(title);
    $('meta[name="description"]').attr('content', seoDesc);

    var queryString = "?s=" + exchange;
    var newUrl = location.pathname + queryString;

    // update current page link
    window.history.replaceState({ path: newUrl }, '', newUrl);

    // update canonical links
    $("link[rel='canonical']").attr('href', window.location.protocol + "//" + window.location.host + newUrl);

    // update href links
    var hreflangs = $("link[hreflang]");
    for (var i = 0; i < hreflangs.length; i++) {
        hreflangs[i].href = GenerateExFeeNewLink(hreflangs[i].href, exchange);
    }

    //update language switch links
    var langSelectors = $("#lang-select li a")
    for (var i = 0; i < langSelectors.length; i++) {

        var newLink = GenerateExFeeNewLink(langSelectors[i].href, exchange);

        var langCode = $("#lang-select li a i")[i].getAttribute("data-id").split('-')[0];

        langSelectors[i].href = newLink;
        if (langCode == "en")
            $(langSelectors[i]).attr("onclick", "return window.Language.Select('" + urlPart + "/" + exchange + "','" + langCode + "')");
        else
            $(langSelectors[i]).attr("onclick", "return window.Language.Select('/" + langCode + urlPart + "/" + exchange + "','" + langCode + "')");
    }
}

function GenerateExFeeNewLink(oldUrl, newExchange) {

    var urlPart = "tools/exchange-fees-calculator";
    var baseUrl = oldUrl.substring(0, oldUrl.toLowerCase().indexOf(urlPart) + urlPart.length);
    return baseUrl + "?s=" + newExchange;
}

function UpdateExFeeParamLinks() {

    if (!IsOnToolsExFeeCalculatorPage())
        return;

    if ($('#exfee-exchange-select-group .dropdown-menu a[role="option"]').length == 0)
        $("#exfee-exchange-select").selectpicker("refresh");
    var exchangeLinks = $('#exfee-exchange-select-group .dropdown-menu a[role="option"]');

    for (var i = 0; i < exchangeLinks.length; i++) {

        var curExchange = document.getElementById("exfee-exchange-select").options[i].getAttribute("value");

        exchangeLinks[i].href = GenerateExFeeNewLink(window.location.pathname, curExchange);
    }
}

function OnExFeeSetCustomRate() {

    $('span.result-span').html('--');
    $("#exfee-custom-fee").val('');

    $('#exfee-custom-fee-group').show();

    $("#exfee-fee-result-group").hide();
    $("#exfee-custom-fee-result-group").show();
    $("#custom-fees-link").replaceWith('<span style="padding: 0 15px;" onclick="OnExFeeSetCustomRate();" id="custom-fees-link">' + window.ExFeeCalcResxStrings["CustomFeesRate"] + '</span>');
    
}

function UpdateExchangeInfo(callback) {

    var code = $('#exfee-exchange-select').val();
    var name = $($("#exfee-exchange-select option")[document.getElementById('exfee-exchange-select').selectedIndex]).text();
        
    $("#exfee-maker-fee").val(-1);
    $("#exfee-taker-fee").val(-1);

    $.ajax({
        url: '/api/widgets/exchange-fees/exchange-info',
        data: { code: code },
        success: function (res) {

            if (res.data.ReferralLink !== undefined && res.data.ReferralLink !== null) {
                $("#exchange-link").attr('href', res.data.ReferralLink);
            } else {
                $("#exchange-link").attr('href', res.data.WebsiteLink);
            }

            if (!!res.data.FeeDiscount) {
                $("#exfee-off-fee-desc").html(window.ExFeeCalcResxStrings["ExchangeOffFeePromoteMsg"]
                    .replace("{0}", name)
                    .replace("{1}", window.CalculatorHelper.ToLocaleNumberForResult(res.data.FeeDiscount / 100, "percent", 2)));
                $("#exfee-off-fee-desc").show();

                $("#exchange-link div").html(window.ExFeeCalcResxStrings["_0OffFees"].replace("{0}", window.CalculatorHelper.ToLocaleNumberForResult(res.data.FeeDiscount / 100, "percent", 2)) + " - " + window.ExFeeCalcResxStrings["BuySellCryptoAt0"].replace("{0}", name));
            } else {
                $("#exfee-off-fee-desc").hide();
                $("#exchange-link div").html(window.ExFeeCalcResxStrings["BuySellCryptoAt0"].replace("{0}", name));
            }

            if (!!res.data.MakerFee && !!res.data.TakerFee) {
                $('#exfee-custom-fee-group').hide();
                $("#exfee-maker-fee").val(res.data.MakerFee);
                $("#exfee-taker-fee").val(res.data.TakerFee);

                $("#exfee-maker-fee-desc").html(window.ExFeeCalcResxStrings["_0MakerFees"].replace("{0}", window.CalculatorHelper.ToLocaleNumberForResult(res.data.MakerFee / 100, "percent", 2)));
                $("#exfee-taker-fee-desc").html(window.ExFeeCalcResxStrings["_0TakerFees"].replace("{0}", window.CalculatorHelper.ToLocaleNumberForResult(res.data.TakerFee / 100, "percent", 2)));
                $("#exfee-fee-result-group").show();
                $("#exfee-custom-fee-result-group").hide();

                $("#custom-fees-link").replaceWith('<a style="padding: 0 15px;" href="javascript:void(0);" onclick="OnExFeeSetCustomRate();" id="custom-fees-link">' + window.ExFeeCalcResxStrings["ClickToSetACustomFeesRate"] + '</a>');
            } else {
                OnExFeeSetCustomRate();
            }

            if (!!res.data.FeeLink) {
                $("#exfee-exchange-fee-link").html(window.ExFeeCalcResxStrings["ClickFor0FeesSchedule"].replace("{0}", name));
                $("#exfee-exchange-fee-link").attr('href', res.data.FeeLink);
                $("#exfee-exchange-fee-link").show();
            } else {
                $("#exfee-exchange-fee-link").hide();
            }

            if (callback != undefined)
                callback();
        },
    });
}

function CalculateExchangeFee() {
    
    if ($("#exfee-custom-fee-group").is(":visible")) {
        var form = document.getElementById("exfee-form");
        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }
    }

    var payAmount = window.CalculatorHelper.ParseLocaleNumber($("#exfee-pay-amount").val());

    var payCurrency = $("#exfee-pay-currency-select").val();
    var feeCurrency = $("#exfee-fee-currency-select").val();

    $("#exfee-form span.result-span").html('<img class="result-loading-img" src="/Content/dist/images/PageElements/ajax-loader.svg" />');

    window.CalculatorHelper.GetExchangeRateAsync(payCurrency, feeCurrency)
        .then(function (res) {
            if ($("#exfee-custom-fee-group").is(":visible")) {
                var customFee = $("#exfee-custom-fee").val();
                var feeAmount = payAmount * customFee / 100;

                $("#exfee-custom-fee-result").html(window.CalculatorHelper.ToLocaleNumberForResult(feeAmount * res.rate, "currency", 2, feeCurrency));

            } else {
                var makerFee = $("#exfee-maker-fee").val();
                var takerFee = $("#exfee-taker-fee").val();
                var makerFeeAmount = payAmount * makerFee / 100;
                var takerFeeAmount = payAmount * takerFee / 100;


                $("#exfee-maker-fee-result").html(window.CalculatorHelper.ToLocaleNumberForResult(makerFeeAmount * res.rate, "currency", 2, feeCurrency));
                $("#exfee-taker-fee-result").html(window.CalculatorHelper.ToLocaleNumberForResult(takerFeeAmount * res.rate, "currency", 2, feeCurrency));
            }
        }, function () {
            $("#exfee-form span.result-span").html('NaN');
        })
}

function InitializeFibonacciCalcParamsFromCookie() {

    var cookieTrendDirrection = window.CalcWidgetStyle.GetCalcCookieValue('fc-trend-direction');
    if (cookieTrendDirrection != "") {
        $("#fc-type-select").selectpicker('val', cookieTrendDirrection);
    }

    var cookieType = window.CalcWidgetStyle.GetCalcCookieValue('fc-type');
    
    if (cookieType !== "") {
        if (cookieType == true) {
            document.getElementById("fc-retracement").checked = true;
        } else {
            document.getElementById("fc-projection").checked = true;
        }
    }
    var cookieLowPrice = window.CalcWidgetStyle.GetCalcCookieValue('fc-lowprice');
    if (cookieLowPrice != "") {
        $("#fc-low-price").val(cookieLowPrice);
    }

    var cookieHighPrice = window.CalcWidgetStyle.GetCalcCookieValue('fc-high-price');
    if (cookieHighPrice != "") {
        $("#fc-high-price").val(cookieHighPrice);
    }

    var cookieEndPrice = window.CalcWidgetStyle.GetCalcCookieValue('fc-end-price');
    if (cookieEndPrice != "") {
        $("#fc-end-price").val(cookieEndPrice);
    }
    OnFCTypeChanged();
}

function InitFibonacciCalcWidget() {

    if ($("#fc-low-price").length <= 0)
        return;
    InitializeFibonacciCalcParamsFromCookie();

    CalculateFibonacci();

    document.getElementById('fc-type-select').addEventListener('change', OnFCChangeInput);
    document.getElementById('fc-retracement').addEventListener('change', OnFCChangeInput);
    document.getElementById('fc-projection').addEventListener('change', OnFCChangeInput);
    document.getElementById('fc-low-price').addEventListener('change', OnFCChangeInput);
    document.getElementById('fc-high-price').addEventListener('change', OnFCChangeInput);
    document.getElementById('fc-end-price').addEventListener('change', OnFCChangeInput);

}

function OnFCStyleUpdated(e, styleType) {

    window.CalcWidgetStyle.SetWidgetStyleCookie(styleType, e.value);

    GenerateFibonacciCalculatorRemoteScript();
}
function OnFCTypeChanged() {

    var dir = document.getElementById('fc-type-select').value;
    var isRetracement = document.getElementById('fc-retracement').checked;

    if (isRetracement != true) {
        $('#fc-end-price-group').css("display", "block");
        $('#fc-end-price').attr("required", true);
    } else {
        $('#fc-end-price-group').css("display", "none");
        $('#fc-end-price').removeAttr("required");
    }
    var img = document.getElementById('fc-type-logo');
    if (dir == 'up') {
        if (isRetracement == true) {
            img.src = "/Content/dist/images/PageElements/uptrend-retracement.png";
        } else {
            img.src = "/Content/dist/images/PageElements/uptrend-projection.png";
        }
    } else {
        if (isRetracement == true) {
            img.src = "/Content/dist/images/PageElements/downtrend-retracement.png";
        } else {
            img.src = "/Content/dist/images/PageElements/downtrend-projection.png";
        }
    }
}
function OpenFCEmbedOverlay() {
    var prefix = 'fibonacci-calculator';
    var currentLocation = window.location.pathname;
    if (currentLocation.includes('/widgets/' + prefix + '-widget')) {
        var url = '/widgets/' + prefix + '-widget-maker';
        if (window.CurrentLang !== '') {
            url = '/' + window.CurrentLang + url;
            var width = 398;
            window.open(url, "", "width=" + width);
        }
    } else if (currentLocation.includes('/widgets/' + prefix)) {
        var url = '/widgets/' + prefix + '-widget';
        if (window.CurrentLang !== '') {
            url = '/' + window.CurrentLang + url;
        }
        window.open(url, '_blank').focus();
    } else if (currentLocation.includes('/tools/' + prefix)) {
        var url = '/tools/' + prefix + '-widget';
        if (window.CurrentLang !== '') {
            url = '/' + window.CurrentLang + url;
        }
        window.location.href = url;
    }
}

function CloseFCEmbedOverlay() {
    $("#fc-embed-script-overlay").css("display", "none");
}

function ClearFibonacciCalcWdigetStyles() {

    window.CalcWidgetStyle.ResetCalcWidgetsStyles();

    GenerateFibonacciCalculatorRemoteScript();
}

function OnCopyFCEmbedScript() {
    document.getElementById('fc-embed-script-preview-output').select();
    document.execCommand("copy");

    GenerateFibonacciCalculatorRemoteScript();
}

function GenerateFibonacciCalculatorRemoteScript() {

    FibonacciWidgetConfig = new Object();

    FibonacciWidgetConfig.TopPaneStyle = window.CalcWidgetStyle.GetTopPaneStyle();
    FibonacciWidgetConfig.BottomPaneStyle = window.CalcWidgetStyle.GetBottomPaneStyle();
    FibonacciWidgetConfig.ButtonStyle = window.CalcWidgetStyle.GetButtonStyle();

    FibonacciWidgetConfig.IsDisplayTitle = document.getElementById('fc-display-tool-title-input').checked;

    var language = document.getElementById('fc-widget-language-select').value;
    if (language != "browser") {
        FibonacciWidgetConfig.Lang = language;
    }

    var hostUrl = window.location.protocol + "//" + window.location.hostname;
    if (window.location.port !== "")
        hostUrl += ":" + window.location.port;

    FibonacciWidgetConfig.Url = hostUrl;
    FibonacciWidgetConfig.Calculator = "fibonacci-calculator";

    document.getElementById('fc-embed-script-preview-output').value = GenerateCalcWidgetScript(FibonacciWidgetConfig);

    document.getElementById('fibonacci-preview-link').href = window.CalculatorHelper.GenerateCalcPreviewLink(FibonacciWidgetConfig, "fibonacci-calculator");
}

function OnFCChangeInput() {
    var tableResultHtml = '<table class="calc-table fibonacci-table"><thead><tr><th>' + window.LevelLabel + '</th>' + '<th>' + window.PriceLabel + '</th></tr></thead>';
    tableResultHtml += '<tr>';

    tableResultHtml += "<td>--</td>";
    tableResultHtml += "<td>--</td>";

    tableResultHtml += '</tr>';
   
    document.getElementById('fibonacci-table-result').innerHTML = tableResultHtml;
}

function FCResultLoading() {
    var tableResultHtml = '<table class="calc-table fibonacci-table"><thead><tr><th>' + window.LevelLabel + '</th>' + '<th>' + window.PriceLabel + '</th></tr></thead>';
    tableResultHtml += '<tr>';

    tableResultHtml += '<td><img class="result-loading-img" src="/Content/dist/images/PageElements/ajax-loader.svg" /></td>';
    tableResultHtml += '<td><img class="result-loading-img" src="/Content/dist/images/PageElements/ajax-loader.svg" /></td>';

    tableResultHtml += '</tr>';

    document.getElementById('fibonacci-table-result').innerHTML = tableResultHtml;
}

function CalculateFibonacci() {

    var form = document.getElementById('fibonacci-calc-form');
    if (form.checkValidity() == false) {
        form.reportValidity();
        //form.classList.add('was-validated');
        return;
    }

    var dir = document.getElementById('fc-type-select').value;
    var isRetracement = document.getElementById('fc-retracement').checked;
    var highPrice = window.CalculatorHelper.ParseLocaleNumber(document.getElementById('fc-high-price').value);
    var lowPrice = window.CalculatorHelper.ParseLocaleNumber(document.getElementById('fc-low-price').value);

    var endPrice = 0;
    if (isRetracement != true) {
        endPrice = window.CalculatorHelper.ParseLocaleNumber(document.getElementById('fc-end-price').value);
        window.CalcWidgetStyle.SetCalcCookieValue('fc-end-price', endPrice);
    }

    window.CalcWidgetStyle.SetCalcCookieValue('fc-trend-direction', dir);
    window.CalcWidgetStyle.SetCalcCookieValue('fc-type', isRetracement);
    window.CalcWidgetStyle.SetCalcCookieValue('fc-lowprice', lowPrice);
    window.CalcWidgetStyle.SetCalcCookieValue('fc-high-price', highPrice);
    
    
    var isValid = true;
    if (highPrice < lowPrice) {
        $("#invalid-high-low-price").css("display", "block");
        return;
    } else {
        $("#invalid-high-low-price").css("display", "none");
    }
    
    FCResultLoading();

    $.ajax({
        type: "POST",
        cache: false,
        dataType: "json",
        url: "/widgets/calculation/fibonacci",
        data: { dir: dir, isRetracement: isRetracement, lowPrice: lowPrice, highPrice: highPrice, endPrice: endPrice },
        success: function (data) {
            if (data.success === true) {                

                var tableResultHtml = '<table class="calc-table fibonacci-table"><thead><tr><th>' + window.LevelLabel + '</th>' + '<th>' + window.PriceLabel + '</th></tr></thead>';
                for (var i = 0; i < data.tableResult.length; i++) {
                    if (data.tableResult[i] != undefined) {
                        tableResultHtml += '<tr>';

                        tableResultHtml += "<td>" + window.CalculatorHelper.ToLocaleNumberForResult(data.tableResult[i].Level, 'percent', 1, "") + "</td>";
                        tableResultHtml += "<td>" + window.CalculatorHelper.ToLocaleNumberForResult(data.tableResult[i].Price, "", 4, "") + "</td>";                       

                        tableResultHtml += '</tr>';
                    }
                }

                document.getElementById('fibonacci-table-result').innerHTML = tableResultHtml;

            } else {
                
            }
        },
        error: function () {            
        }
    });
}

function ResizeCalcWidgetFrame(selector, reviewsVerifiedByFXVerifyText) {

    if (!selector) selector = '#calculator-body';

    var top, height, bottom, left, width, right;

    var element = $(selector);
    if (element.length <= 0)
        return;

    var targetContainerId = element.attr("container-id");

    top = element.offset().top; // Vert offset of element
    height = element.outerHeight(true); // Height of element

    left = element.offset().left;
    width = element.outerWidth(true);

    // Offset to bottom of element
    // + 16 px for luck
    bottom = top + height + 16;

    right = left + width + 16;

    if (selector == '#review-widget') {
        bottom = bottom - 16;
        right = right - 16;
    }

    var title = $('title').html();

    window.parent.postMessage({
        'func': 'resizeCBFCalcWidget',
        'targetHeight': bottom,
        'targetWidth': right,
        'containerId': targetContainerId,
        'title': title,
        'reviewsVerifiedByFXVerifyText': reviewsVerifiedByFXVerifyText,
    }, "*");

    // console.log('resize cbf embed widget height', targetContainerId, bottom);
}

function SetPopoutLink() {

    var element = document.getElementById('calculator-body');
    if (element === null)
        return;

    var targetContainerId = element.getAttribute("container-id");

    var topPane = element.querySelector('.calc-widgit-top-pane');
    if (topPane === null) return;

    var title = document.querySelector('title').innerText;
    var canonicalLink = document.querySelector('head > link[rel=canonical]');
    var link = window.location.href;
    if (canonicalLink) {
        link = document.querySelector('head > link[rel=canonical]').getAttribute('href');
    }

    if ($("input[name='embed-widget-affiliate-id']").length > 0) {
        var affiliateId = $("input[name='embed-widget-affiliate-id']").val();
        if (!!affiliateId && affiliateId != "0")
            link += "?aid=" + affiliateId;
    }
    var elementRect = element.getBoundingClientRect();
    var topPaneRect = topPane.getBoundingClientRect();
    var top = topPaneRect.top + 7;
    var right = elementRect.right - topPaneRect.right + 7;
    var popoutColorEl = document.getElementById('popout-color-value');
    if (popoutColorEl) {
        colorValue = popoutColorEl.getAttribute('value');
    }
    window.parent.postMessage({
        'func': 'popoutPositionCalcWidget',
        'containerId': targetContainerId,
        'top': top,
        'right': right,
        'title': title,
        'link': link,
        'color': colorValue
    }, "*");
}

function GenerateCalcWidgetScript(WidgetConfig) {
    var containerId = WidgetConfig.Calculator + "-" + Math.ceil(Math.random() * 1000000);

    var affiliateId = "";
    if ($("#client-profile-id").length > 0) {
        if ($("#point-affailiate-links").length > 0 && $("#point-affailiate-links")[0].checked == true)
            affiliateId = $("#client-profile-id").val();
    }
    else if ($("input[name='embed-widget-affiliate-id']").length > 0) {
        affiliateId = $("input[name='embed-widget-affiliate-id']").val();
    }

    var previewScript = "<div id=\"" + containerId + "\">";

    previewScript += "<script type=\"text/javascript\" src=\"" + WidgetConfig.Url + RemoteScriptJsLink + "\"><\/script>";

    previewScript += "<script type=\"text/javascript\"> RemoteCalc({";
    previewScript += "\"Url\":\"" + WidgetConfig.Url + "\", ";

    if (WidgetConfig.TopPaneStyle && WidgetConfig.TopPaneStyle !== "") {
        previewScript += "\"TopPaneStyle\":\"" + WidgetConfig.TopPaneStyle + "\",";
    }
    if (WidgetConfig.BottomPaneStyle && WidgetConfig.BottomPaneStyle !== "") {
        previewScript += "\"BottomPaneStyle\":\"" + WidgetConfig.BottomPaneStyle + "\",";
    }
    if (WidgetConfig.ButtonStyle && WidgetConfig.ButtonStyle !== "") {
        previewScript += "\"ButtonStyle\":\"" + WidgetConfig.ButtonStyle + "\",";
    }
    if (WidgetConfig.TitleStyle && WidgetConfig.TitleStyle !== "") {
        previewScript += "\"TitleStyle\":\"" + WidgetConfig.TitleStyle + "\",";
    }
    if (WidgetConfig.TextboxStyle && WidgetConfig.TextboxStyle !== "") {
        previewScript += "\"TextboxStyle\":\"" + WidgetConfig.TextboxStyle + "\",";
    }
    if (WidgetConfig.ContainerWidth && WidgetConfig.ContainerWidth !== "") {
        previewScript += "\"ContainerWidth\":\"" + WidgetConfig.ContainerWidth + "\",";
    }
    if (WidgetConfig.DefaultInstrument && WidgetConfig.DefaultInstrument !== '') {
        previewScript += "\"DefaultInstrument\":\"" + WidgetConfig.DefaultInstrument + "\",";
    }
    if (WidgetConfig.HighlightColor && WidgetConfig.HighlightColor !== "") {
        previewScript += "\"HighlightColor\":\"" + WidgetConfig.HighlightColor + "\",";
    }
    if (WidgetConfig.IsDisplayTitle !== undefined) {
        previewScript += "\"IsDisplayTitle\":" + WidgetConfig.IsDisplayTitle + ",";
    }
    if (WidgetConfig.IsShowChartLinks !== undefined) {
        previewScript += "\"IsShowChartLinks\":" + WidgetConfig.IsShowChartLinks + ",";
    }
    if (WidgetConfig.IsShowEmbedButton !== undefined) {
        previewScript += "\"IsShowEmbedButton\":" + WidgetConfig.IsShowEmbedButton + ",";
    }
    if (WidgetConfig.Lang) {
        previewScript += "\"Lang\":\"" + WidgetConfig.Lang + "\",";
    }
    if (affiliateId != "" && affiliateId != "0")
        previewScript += "\"AffiliateId\":\"" + affiliateId + "\",";

    if (WidgetConfig.CompactType) {
        previewScript += "\"CompactType\":\"" + WidgetConfig.CompactType + "\",";
    }
    if (WidgetConfig.DefaultCurrencyFrom) {
        previewScript += "\"DefaultCurrencyFrom\":\"" + WidgetConfig.DefaultCurrencyFrom + "\",";
    }
    if (WidgetConfig.DefaultCurrencyTo) {
        previewScript += "\"DefaultCurrencyTo\":\"" + WidgetConfig.DefaultCurrencyTo + "\",";
    }

    if (WidgetConfig.DefaultBalance) {
        previewScript += "\"DefaultBalance\":\"" + WidgetConfig.DefaultBalance + "\",";
    }

    if (WidgetConfig.DefaultPeriod) {
        previewScript += "\"DefaultPeriod\":\"" + WidgetConfig.DefaultPeriod + "\",";
    }

    if (WidgetConfig.DefaultGain) {
        previewScript += "\"DefaultGain\":\"" + WidgetConfig.DefaultGain + "\",";
    }

    if (WidgetConfig.DefaultExchange) {
        previewScript += "\"DefaultExchange\":\"" + WidgetConfig.DefaultExchange + "\",";
    }

    if (WidgetConfig.IsShowBuyCryptoButton != undefined) {
        previewScript += "\"IsShowBuyCryptoButton\":\"" + WidgetConfig.IsShowBuyCryptoButton + "\",";
    }

    if (WidgetConfig.SAID != undefined) {
        previewScript += "\"SAID\":\"" + WidgetConfig.SAID + "\",";
    }

    previewScript += "\"Calculator\":\"" + WidgetConfig.Calculator + "\",";
    previewScript += "\"ContainerId\":\"" + containerId + "\"";
    previewScript += "});<\/script><\/div>";

    return previewScript;
}


function OpenCalcPopup(e) {
    if (window.CalcWidgetType === 'ArticleMaker' || window.CalcWidgetType === 'WidgetMaker') {
        return false;
    }
    var link = e.href;

    var height = e.parentNode.parentNode.offsetHeight + 5;
    window.open(link, "", "width=640, height=" + height);

    return false;
}

function OpenLiveChartPopupFromCalc(e) {

    var link = e.href;
    if (link.includes("widgets/live-chart")) {
        window.open(link, "", "width=800, height=600");
    }

    return false;
}
function UpdateCalcLiveChartPopoutLink(id, symbol, chartSymbol) {

    if (!chartSymbol) {
        $('#' + id).attr('style', 'display:none !important');
        $('#' + id + ' a').attr('href', '#');
    } else {


        $('#' + id).removeAttr('style');

        $('#' + id + ' a:nth-child(1)').html(window.Live1HChartLinkText.replaceAll("{0}", symbol));
        $('#' + id + ' a:nth-child(2)').html(window.LiveHistoricalChartLinkText.replaceAll("{0}", symbol));

        if (window.location.pathname.includes("widgets/") || window.location.hash == "#popout") {

            var liveChartUrl = "";
            if (window.CURRENT_LANG != 'en')
                liveChartUrl += "/" + window.CURRENT_LANG;
            liveChartUrl += "/widgets/live-chart";

            var affiliateId = "";
            if ($("input[name='embed-widget-affiliate-id']").length > 0)
                affiliateId = $("input[name='embed-widget-affiliate-id']").val();
            if (affiliateId != "" && affiliateId != "0") {
                $('#' + id + ' a:nth-child(1)').attr('href', liveChartUrl + "/" + chartSymbol + "?aid=" + affiliateId);
                $('#' + id + ' a:nth-child(2)').attr('href', liveChartUrl + "/" + chartSymbol + "-historical" + "?aid=" + affiliateId);
            } else {
                $('#' + id + ' a:nth-child(1)').attr('href', liveChartUrl + "/" + chartSymbol);
                $('#' + id + ' a:nth-child(2)').attr('href', liveChartUrl + "/" + chartSymbol + "-historical");
            }
        } else {

            var liveChartUrl = "";
            if (window.CURRENT_LANG != 'en')
                liveChartUrl += "/" + window.CURRENT_LANG;
            liveChartUrl += "/chart";

            $('#' + id + ' a:nth-child(1)').attr('href', liveChartUrl + "?s=" + chartSymbol);
            $('#' + id + ' a:nth-child(2)').attr('href', liveChartUrl + "?s=" + chartSymbol + "-historical");
        }
    }
}

function TriggerGoogleAnalytics() {

    if (window.googletag !== undefined) {
        var slots = [];
        if (window.Promotion.SlotWallpaper != '') {
            slots.push(window.Promotion.SlotWallpaper);
            
        }
        if (window.Promotion.SlotMobileFooter != '') {
            slots.push(window.Promotion.SlotMobileFooter);

        }
        googletag.cmd.push(function () {
            if (slots.length)
                googletag.pubads().refresh(slots);
            else
                googletag.pubads().refresh();
        })
    }

    if (window.dataLayer === undefined)
        return;

    var gtaCode = "";
    for (var i = 0; i < window.dataLayer.length; i++) {

        if (window.dataLayer[i].length != undefined && window.dataLayer[i].length >= 2 && window.dataLayer[i][0] == 'config') {
            gtaCode = window.dataLayer[i][1];
            break;
        }

    }
    if (gtaCode != "") {
        gtag('config', gtaCode, { 'page_path': window.location.pathname, 'send_page_view': true, 'debug_mode': true });
    }

}


function OnClickedEmbedButton() {

    var currentLocation = window.location.pathname;
    if (window.CalcWidgetType === 'Article') {
        window.location.href = currentLocation + '-widget';
    } else if (window.CalcWidgetType === 'Widget') {
        var url = currentLocation + '-widget';
        window.open(url, '_blank').focus();
    } else if (window.CalcWidgetType === 'WidgetMaker' || window.CalcWidgetType === 'ArticleMaker') {
        // var width = 800;
        // window.open(currentLocation, '', 'width=' + width);
    }
}


document.addEventListener('DOMContentLoaded', function (event) {
    OnChangedSizeCalcContent();
    AddHrefToEmbedButtonToCalc();
});


window.addEventListener('resize', function () {
    OnChangedSizeCalcContent();
}, true);

function AddHrefToElement(embedContent) {
    var embedSlug = embedContent.querySelector('#widget-slug');
    var slug = '';
    if (embedSlug) {
        slug = embedSlug.getAttribute('value');
    }
    var embedBtn = embedContent.querySelector('.embed-button');
    if (embedBtn) {
        var href = '';
        if (window.CalcWidgetType === 'Article') {
            var en = '';
            if (window.CURRENT_LANG != 'en') {
                en = window.CURRENT_LANG + '/';
            }
            var url = window.location.protocol + "//" + window.location.hostname;
            if (window.location.port !== "")
                url += ":" + window.location.port;
            url += '/' + en + 'tools/' + slug + '-widget';
            embedBtn.setAttribute('href', url);
        } else if (window.CalcWidgetType === 'Widget') {
            var canonical = document.querySelector('link[rel="canonical"]');
            if (canonical) {
                var url = canonical.getAttribute('href');
                href = url;

                if ($("input[name='embed-widget-affiliate-id']").length > 0) {
                    var affiliateId = $("input[name='embed-widget-affiliate-id']").val();
                    if (!!affiliateId && affiliateId != "0")
                        href += "?aid=" + affiliateId;
                }

                embedBtn.setAttribute('target', '_blank');
                embedBtn.setAttribute('href', href);
            }

        } else if (window.CalcWidgetType === 'ArticleMaker' || window.CalcWidgetType === 'WidgetMaker') {

        }
    }
}
function AddHrefToEmbedButtonToCalc() {
    var embedWidgetContents = document.getElementsByClassName('calc-widget-content');
    for (var i = 0; i < embedWidgetContents.length; i++) {
        AddHrefToElement(embedWidgetContents[i]);
    }

}

function OnChangedSizeCalcContent() {

    var limitWidth = 560;
    var limitCCWidth = 560;
    var calcBodies = document.getElementsByClassName('calc-widget-content');
    if (calcBodies.length > 0) {
        for (var i = 0; i < calcBodies.length; i++) {
            var calcBody = calcBodies[i];
            if (calcBody !== null) {
                var width = calcBody.offsetWidth;
                var formGroups = calcBody.getElementsByClassName('form-group');
                var formInputContainers = calcBody.getElementsByClassName('form-input-container');
                var calcInputLines = calcBody.getElementsByClassName('calculator-input-line');

                if (width <= limitWidth) {
                    for (var j = 0; j < formGroups.length; j++) {
                        var formgroup = formGroups[j];
                        formgroup.classList.add('form-group-less-500');
                    }
                    for (var j = 0; j < formInputContainers.length; j++) {
                        var formInputContainer = formInputContainers[j];
                        formInputContainer.classList.add('form-input-container-less-500');
                    }
                    for (var j = 0; j < calcInputLines.length; j++) {
                        var calcInputLine = calcInputLines[j];
                        calcInputLine.classList.add('calculator-input-line-less-500');
                    }
                } else {
                    for (var k = 0; k < formGroups.length; k++) {
                        var formgroup = formGroups[k];
                        formgroup.classList.remove('form-group-less-500');
                    }
                    for (var k = 0; k < formInputContainers.length; k++) {
                        var formInputContainer = formInputContainers[k];
                        formInputContainer.classList.remove('form-input-container-less-500');
                    }
                    for (var k = 0; k < calcInputLines.length; k++) {
                        var calcInputLine = calcInputLines[k];
                        calcInputLine.classList.remove('calculator-input-line-less-500');
                    }
                }

                var convertlayout = document.querySelector('.converter-layout');
                if (convertlayout) {
                    if (width <= limitCCWidth) {
                        convertlayout.style.setProperty('flex-direction', 'column', 'important');
                        var formgroups = convertlayout.getElementsByClassName('form-group');
                        for (var l = 0; l < formgroups.length; l++) {
                            var formgroup = formgroups[l];
                            formgroup.style.setProperty('width', 'unset', 'important');
                            formgroup.style.setProperty('margin', '3px 0', 'important');
                        }
                    } else {
                        convertlayout.style.removeProperty('flex-direction');
                        var formgroups = convertlayout.getElementsByClassName('form-group');
                        for (var m = 0; m < formgroups.length; m++) {
                            var formgroup = formgroups[m];
                            formgroup.style.removeProperty('width');
                            formgroup.style.removeProperty('margin');
                        }
                    }
                    var swapWrapper = convertlayout.querySelector('.cc-swap-wrapper');
                    if (swapWrapper) {
                        if (width <= limitWidth) {
                            swapWrapper.style.setProperty('margin', 'auto');
                        } else {
                            swapWrapper.style.removeProperty('margin');
                        }

                        var icon = swapWrapper.querySelector('i.mdi-swap-horizontal');
                        if (icon) {
                            if (width <= limitWidth) {
                                icon.classList.add('swap-horizontal-icon');
                            } else {
                                icon.classList.remove('swap-horizontal-icon');
                            }
                        }
                    }


                }
                var dropdownMenus = calcBody.querySelectorAll('div.dropdown-menu');
                for (var n = 0; n < dropdownMenus.length; n++) {
                    dropdownMenus[n].style.setProperty('max-width', (width - 20) + 'px', 'important');
                }
            }

        }
    }
}
function InitializeGlobalCalcContent() {
    var bootstrapSelectors = document.querySelectorAll('.calc-widget-content .bootstrap-select div.dropdown-menu');
    for (var i = 0; i < bootstrapSelectors.length; i++) {
        var selector = bootstrapSelectors[i];
        selector.classList.add('dropdown-menu-right');
    }
    if (window.CalcCompactType === 'small') {
        document.body.classList.add('body-widget-content-small');
    }
    if (window.CalcIsShowEmbedButton === 'True') {
        $('.embed-button').show();
    } else if (window.CalcIsShowEmbedButton === 'False') {
        $('.embed-button').hide();
    }
}


(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

var _CalcWidgetsStyle = _interopRequireDefault(require("../../includes/CalcWidgetsStyle.js"));
var _CalculatorHelper = _interopRequireDefault(require("../../includes/CalculatorHelper.js"));
var _PositionSizeCalculator = _interopRequireDefault(require("../../includes/PositionSizeCalculator.js"));
var _TwelveDatafeed = _interopRequireDefault(require("../../includes/TwelveDatafeed.js"));
var _ProfitCalculator = _interopRequireDefault(require("../../includes/ProfitCalculator.js"));
var _PipValueCalculator = _interopRequireDefault(require("../../includes/PipValueCalculator.js"));
var _MarginCalculator = _interopRequireDefault(require("../../includes/MarginCalculator.js"));
var _RebateCalculator = _interopRequireDefault(require("../../includes/RebateCalculator.js"));
var _LiveChartSaveLoadAdapter = _interopRequireDefault(require("../../includes/LiveChartSaveLoadAdapter.js"));
var _APIHelper = _interopRequireDefault(require("../../includes/APIHelper.js"));
var _AISHelper = _interopRequireDefault(require("../../includes/AISHelper.js"));
var _Watchlist = _interopRequireDefault(require("../../includes/Watchlist.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
require('../../includes/InfiniteScrollSelectPlugin');
require('../../includes/CustomChartSymbolSelectPlugin');
window.AISHelper = _AISHelper["default"];
window.TwelveDatafeed = _TwelveDatafeed["default"];
window.LiveChartSaveLoadAdapter = _LiveChartSaveLoadAdapter["default"];
window.CalculatorHelperClass = _CalculatorHelper["default"];
window.CalcWidgetStyleClass = _CalcWidgetsStyle["default"];
window.PositionSizeCalculator = _PositionSizeCalculator["default"];
window.ProfitCalculator = _ProfitCalculator["default"];
window.PipValueCalculator = _PipValueCalculator["default"];
window.MarginCalculator = _MarginCalculator["default"];
window.RebateCalculator = _RebateCalculator["default"];
if (!window.APIHelper) window.APIHelper = new _APIHelper["default"]();
$(function () {
  window.CalcWidgetStyle = new _CalcWidgetsStyle["default"]();
  window.CalculatorHelper = new _CalculatorHelper["default"]();
  window.WatchlistInstance = new _Watchlist["default"]();
  window.WatchlistInstance.InitializeWatchList();
  $(document).on('input', 'input[data-trigger="watchlist-filter"]', function () {
    var that = this;
    var value = $(this).val().toLowerCase();
    if ($(this).data("lastval") != value) {
      $(this).data("lastval", value);
      if (window.tid != undefined) clearTimeout(window.tid);
      window.tid = setTimeout(function () {
        //your change action goes here
        var targetId = $(that).data('target');
        $('#' + targetId + ' [data-text]').each(function (index, elem) {
          if (!value || $(elem).data('text').includes(value)) {
            $(elem).show();
          } else {
            $(elem).hide();
          }
        });
      }, 200);
    }
    ;
  });
  window.RGBAtoRGB = function (r, g, b, a, r2, g2, b2) {
    var r3 = Math.round((1 - a) * r2 + a * r);
    var g3 = Math.round((1 - a) * g2 + a * g);
    var b3 = Math.round((1 - a) * b2 + a * b);
    return {
      r: r3,
      g: g3,
      b: b3
    };
  };
  window.ParseColor = function (color) {
    var ctx = document.createElement("canvas").getContext("2d");
    ctx.fillStyle = color;
    return ctx.fillStyle;
  };
  window.ColorToRGBA = function (color) {
    var cvs, ctx;
    cvs = document.createElement('canvas');
    cvs.height = 1;
    cvs.width = 1;
    ctx = cvs.getContext('2d');
    ctx.fillStyle = 'white';
    ctx.fillStyle = color;
    ctx.fillRect(0, 0, 1, 1);
    var data = ctx.getImageData(0, 0, 1, 1).data;
    return {
      r: data[0],
      g: data[1],
      b: data[2],
      a: data[3] / 255
    };
  };
  window.CalculateDropdownArrowColor = function (backColor, txtBackColor) {
    if (backColor && backColor !== '' && txtBackColor && txtBackColor !== '') {
      var topPaneColor = window.ColorToRGBA(backColor);
      if (topPaneColor.r === 0 && topPaneColor.g === 0 && topPaneColor.b === 0 && topPaneColor.a === 0) {
        topPaneColor.r = 255;
        topPaneColor.g = 255;
        topPaneColor.b = 255;
        topPaneColor.a = 1;
      }
      var textBoxColor = window.ColorToRGBA(txtBackColor);
      if (textBoxColor.a < 1) {
        var mixedColor = window.RGBAtoRGB(textBoxColor.r, textBoxColor.g, textBoxColor.b, textBoxColor.a, topPaneColor.r, topPaneColor.g, topPaneColor.b);
        return mixedColor;
      } else {
        return textBoxColor;
      }
    } else if (txtBackColor && txtBackColor !== '') {
      var textBoxColor = window.ColorToRGBA(txtBackColor);
      return textBoxColor;
    } else {
      return {
        r: 255,
        g: 255,
        b: 255
      };
    }
  };
  window.ExtractColor = function (index, result) {
    /// index = -1 last color
    var colors = result.colorStopList;
    if (index === -1) {
      var last = colors[colors.length - 1];
      return last.color;
    } else {
      var colors = result.colorStopList;
      var last = colors[index];
      return last.color;
    }
  };
  window.UpdateCalcDropdownArrowStyle = function () {
    if (window.DropDownArrowBackFormat && window.DropDownArrowBackFormat !== '' && window.RtlDropDownArrowBackFormat && window.RtlDropDownArrowBackFormat !== '') {
      window.TopPaneBackgroundColor = window.TopPaneBackgroundColor.replace("!important", "");
      window.TopPaneBackgroundColor = window.TopPaneBackgroundColor.trim();
      window.TextBoxBackgroundColor = window.TextBoxBackgroundColor.replace("!important", "");
      window.TextBoxBackgroundColor = window.TextBoxBackgroundColor.trim();
      var result1 = window.ParseGradientFromString(window.TopPaneBackgroundColor);
      if (result1 !== false) {
        window.TopPaneBackgroundColor = window.ExtractColor(0, result1);
      }
      var result2 = window.ParseGradientFromString(window.TextBoxBackgroundColor);
      if (result2 !== false) {
        window.TextBoxBackgroundColor = window.ExtractColor(0, result2);
      }
      var mixedColor = window.CalculateDropdownArrowColor(window.TopPaneBackgroundColor, window.TextBoxBackgroundColor);
      var mixedColorStr = 'rgb(' + mixedColor.r + ',' + mixedColor.g + ',' + mixedColor.b + ')';
      var mixedColorOpStr = 'rgb(' + mixedColor.r + ',' + mixedColor.g + ',' + mixedColor.b + ', 0)';
      var result = window.DropDownArrowBackFormat.replace('{0}', mixedColorStr);
      var rtlResult = window.RtlDropDownArrowBackFormat.replace('{0}', mixedColorStr);
      var result = window.DropDownArrowBackFormat.replace('{1}', mixedColorOpStr);
      var rtlResult = window.RtlDropDownArrowBackFormat.replace('{1}', mixedColorOpStr);
      var css = '.widget-top-pane button.widget-input-override:before {' + result + '} html[dir=rtl] .widget-top-pane button.widget-input-override:before { ' + rtlResult + ' } ';
      var head = document.head || document.getElementsByTagName('head')[0];
      var style = document.createElement('style');
      head.appendChild(style);
      style.type = 'text/css';
      style.id = 'calc_textbox_style';
      if (style.styleSheet) {
        style.styleSheet.style = css;
      } else {
        style.innerHTML = '';
        style.appendChild(document.createTextNode(css));
      }
    }
  };
  /// Parse Gradient Color Start
  window.CombineRegExp = function (regexpList, flags) {
    var i,
      source = '';
    for (i = 0; i < regexpList.length; i++) {
      if (typeof regexpList[i] === 'string') {
        source += regexpList[i];
      } else {
        source += regexpList[i].source;
      }
    }
    return new RegExp(source, flags);
  };
  window.GenerateRegExp = function () {
    // Note any variables with "Capture" in name include capturing bracket set(s).
    var searchFlags = 'gi',
      // ignore case for angles, "rgb" etc
      rAngle = /(?:[+-]?\d*\.?\d+)(?:deg|grad|rad|turn)/,
      // Angle +ive, -ive and angle types
      rSideCornerCapture = /to\s+((?:(?:left|right)(?:\s+(?:top|bottom))?))/,
      // optional 2nd part
      rComma = /\s*,\s*/,
      // Allow space around comma.
      rColorHex = /\#(?:[a-f0-9]{6}|[a-f0-9]{3})/,
      // 3 or 6 character form
      rDigits3 = /\(\s*(?:\d{1,3}\s*,\s*){2}\d{1,3}\s*\)/,
      // "(1, 2, 3)"
      rDigits4 = /\(\s*(?:\d{1,3}\s*,\s*){2}\d{1,3}\s*,\s*\d*\.?\d+\)/,
      // "(1, 2, 3, 4)"
      rValue = /(?:[+-]?\d*\.?\d+)(?:%|[a-z]+)?/,
      // ".9", "-5px", "100%".
      rKeyword = /[_a-z-][_a-z0-9-]*/,
      // "red", "transparent", "border-collapse".
      rColor = window.CombineRegExp(['(?:', rColorHex, '|', '(?:rgb|hsl)', rDigits3, '|', '(?:rgba|hsla)', rDigits4, '|', rKeyword, ')'], ''),
      rColorStop = window.CombineRegExp([rColor, '(?:\\s+', rValue, '(?:\\s+', rValue, ')?)?'], ''),
      // Single Color Stop, optional %, optional length.
      rColorStopList = window.CombineRegExp(['(?:', rColorStop, rComma, ')*', rColorStop], ''),
      // List of color stops min 1.
      rLineCapture = window.CombineRegExp(['(?:(', rAngle, ')|', rSideCornerCapture, ')'], ''),
      // Angle or SideCorner
      rGradientSearch = window.CombineRegExp(['(?:(', rLineCapture, ')', rComma, ')?(', rColorStopList, ')'], searchFlags),
      // Capture 1:"line", 2:"angle" (optional), 3:"side corner" (optional) and 4:"stop list".
      rColorStopSearch = window.CombineRegExp(['\\s*(', rColor, ')', '(?:\\s+', '(', rValue, '))?', '(?:', rComma, '\\s*)?'], searchFlags); // Capture 1:"color" and 2:"position" (optional).

    return {
      gradientSearch: rGradientSearch,
      colorStopSearch: rColorStopSearch
    };
  };
  window.ParseGradient = function (regExpLib, input) {
    var result, matchGradient, matchColorStop, stopResult;

    // reset search position, because we reuse regex.
    regExpLib.gradientSearch.lastIndex = 0;
    matchGradient = regExpLib.gradientSearch.exec(input);
    if (matchGradient !== null) {
      result = {
        original: matchGradient[0],
        colorStopList: []
      };

      // Line (Angle or Side-Corner).
      if (!!matchGradient[1]) {
        result.line = matchGradient[1];
      }
      // Angle or undefined if side-corner.
      if (!!matchGradient[2]) {
        result.angle = matchGradient[2];
      }
      // Side-corner or undefined if angle.
      if (!!matchGradient[3]) {
        result.sideCorner = matchGradient[3];
      }

      // reset search position, because we reuse regex.
      regExpLib.colorStopSearch.lastIndex = 0;

      // Loop though all the color-stops.
      matchColorStop = regExpLib.colorStopSearch.exec(matchGradient[4]);
      while (matchColorStop !== null) {
        stopResult = {
          color: matchColorStop[1]
        };

        // Position (optional).
        if (!!matchColorStop[2]) {
          stopResult.position = matchColorStop[2];
        }
        result.colorStopList.push(stopResult);

        // Continue searching from previous position.
        matchColorStop = regExpLib.colorStopSearch.exec(matchGradient[4]);
      }
    }

    // Can be undefined if match not found.
    return result;
  };
  window.ParseGradientFromCss = function (regExpLib, input) {
    var result,
      rGradientEnclosedInBrackets = /.*gradient\s*\(((?:\([^\)]*\)|[^\)\(]*)*)\)/,
      // Captures inside brackets - max one additional inner set.
      match = rGradientEnclosedInBrackets.exec(input);
    if (match !== null) {
      // Get the parameters for the gradient
      result = window.ParseGradient(regExpLib, match[1]);
      if (result.original.trim() !== match[1].trim()) {
        // Did not match the input exactly - possible parsing error.
        result.parseWarning = true;
      }
    } else {
      result = false;
    }
    return result;
  };
  window.ParseGradientFromString = function (str) {
    var regExpLib = window.GenerateRegExp();
    var result = window.ParseGradientFromCss(regExpLib, str);
    return result;
  };
  /// 
  window.InitializeCalcWidget = function () {
    $.fn.selectpicker.Constructor.BootstrapVersion = '4';
    $('.calc-widget-content .selectpicker').selectpicker({
      style: "frn-override widget-input-override",
      styleBase: "form-control",
      noneSelectedText: ""
    });
    var pickers = $('.calc-widget-content .selectpicker');
    for (var i = 0; i < pickers.length; i++) {
      var initVal = $(pickers[i]).attr("value");
      for (var j = 0; j < pickers[i].options.length; j++) {
        if (pickers[i].options[j].value == initVal) {
          $(pickers[i]).selectpicker("val", initVal);
          break;
        }
      }
    }
    $('[data-toggle="tooltip"]').tooltip('dispose').tooltip({
      boundary: 'window'
    });
    $('[data-toggle = "trade-size-popover"]').popover('dispose');
    $('[data-toggle="trade-size-popover"]').popover({
      html: true,
      trigger: "manual",
      template: '<div class="popover widget-trade-size-popover-wrapper" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
      content: function content() {
        var id = $(this).data('target-id');
        var out = $('#' + id).html();
        return out;
      }
    }).on("mouseenter", function () {
      var _this = this;
      $(this).popover("show");
      if (window.location.hash != "#popout" && !window.location.pathname.includes("/widgets/")) {
        setTimeout(function () {
          $('[data-toggle="lightbox-image"]').on('click', function (e) {
            $(_this).popover('hide');
            e.preventDefault();
            var id = $(e.target).data("target-id");
            ;
            var srclink = $(e.target).attr('href');
            $('#' + id + " img.lightbox-image").attr('src', srclink);
            $('#' + id).modal('show');
            return false;
          });
        }, 100);
      }
      $(".popover").on("mouseleave", function () {
        $(_this).popover('hide');
      });
    }).on("mouseleave", function () {
      var _this = this;
      setTimeout(function () {
        if (!$(".popover:hover").length) {
          $(_this).popover("hide");
        }
      }, 100);
    });
    InitCompoundingCalcWidget();
    InitFibonacciCalcWidget();
    InitPivotPointCalcWidget();
    InitRiskOfRuinCalcWidget();
    InitDrawdownCalcWidget();
    InitCurrencyConverterWidget();
    InitExchangeFeeCalcWidget();
    var remoteWidget = document.getElementById('calculator-body');
    if (remoteWidget) {
      ResizeCalcWidgetFrame();
      SetPopoutLink();
      var ro = new ResizeObserver(function (entries) {
        ResizeCalcWidgetFrame();
        SetPopoutLink();
      });
      ro.observe(document.getElementById('calculator-body'));
    }
    window.UpdateCalcDropdownArrowStyle();
  };
  window.InitializeCalcWidget();
  InitializeCalcWidgetMaker();
  InitializeGlobalCalcContent();
  if ($.fn.isInViewport === undefined) {
    $.fn.isInViewport = function (isFully) {
      if ($(this).length == 0) return false;
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      if (isFully === true) return viewportTop <= elementTop && elementBottom <= viewportBottom;
      return elementBottom > viewportTop && elementTop < viewportBottom;
    };
  }
  var event = new Event('ReadyToInitWidget');
  window.dispatchEvent(event);
  window.document.dispatchEvent(event);
});

},{"../../includes/AISHelper.js":2,"../../includes/APIHelper.js":3,"../../includes/CalcWidgetsStyle.js":4,"../../includes/CalculatorHelper.js":5,"../../includes/CustomChartSymbolSelectPlugin":7,"../../includes/InfiniteScrollSelectPlugin":8,"../../includes/LiveChartSaveLoadAdapter.js":9,"../../includes/MarginCalculator.js":10,"../../includes/PipValueCalculator.js":11,"../../includes/PositionSizeCalculator.js":12,"../../includes/ProfitCalculator.js":13,"../../includes/RebateCalculator.js":14,"../../includes/TwelveDatafeed.js":15,"../../includes/Watchlist.js":16}],15:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TwelveDatafeed = exports["default"] = /*#__PURE__*/function () {
  function TwelveDatafeed(options) {
    _classCallCheck(this, TwelveDatafeed);
    this.twelveDataHost = options.host || 'https://cashbackforex.com/api/live-chart/datafeed';
    this.debug = options.debug || false;
    this.symbols = [];
    this.exchanges = [];
    this.current_exchange_timezone = 'UTC';
    this.subscribers = {};
    this.requestsPending = 0;
    this.lastSearchCallAbortController = null;
    this.liveChartConnection = options.liveChartConnection || null;
    this.streamCallback = options.streamCallback || null;
    this.customSymbolResolvedCallback = options.symbolResolvedCallback || null;
    var myThis = this;
    setInterval(function () {
      myThis.updateBars();
    }, 20000);
    this.initializeSignalR();
    document.addEventListener("visibilitychange", function () {
      // when change visiblity
      if (!document.hidden) {
        var _loop = function _loop() {
          var subscriptionRecord = myThis.subscribers[listenerGuid];
          window.tvLivechartWidgetPrevVisibleRange = window.tvLivechartWidget.activeChart().getVisibleRange();
          subscriptionRecord.resetCallback();
          window.tvLivechartWidget.activeChart().resetData();
          if (myThis.liveChartConnection != null) {
            if (myThis.liveChartConnection.state == "Connected") {
              try {
                myThis.liveChartConnection.invoke('Subscribe', myThis.getStreamSymbolInfo(subscriptionRecord.symbolInfo));
              } catch (err) {
                console.error(err);
              }
            } else if (myThis.liveChartConnection.state == "Disconnected") {
              myThis.liveChartConnection.start();
              setTimeout(function () {
                try {
                  myThis.liveChartConnection.invoke('Subscribe', myThis.getStreamSymbolInfo(subscriptionRecord.symbolInfo));
                } catch (err) {
                  console.error(err);
                }
              }, 3000);
            } else {
              setTimeout(function () {
                try {
                  myThis.liveChartConnection.invoke('Subscribe', myThis.getStreamSymbolInfo(subscriptionRecord.symbolInfo));
                } catch (err) {
                  console.error(err);
                }
              }, 3000);
            }
          }
        };
        for (var listenerGuid in myThis.subscribers) {
          _loop();
        }
      }
    });
  }
  return _createClass(TwelveDatafeed, [{
    key: "initializeSignalR",
    value: function initializeSignalR() {
      var _this = this;
      var myThis = this;
      if (myThis.liveChartConnection == null) return;
      myThis.liveChartConnection.on('ReceiveMessage', function (msg, body) {
        myThis.debug && console.log('Real time message arrived', msg, body);
        try {
          if (msg == 'Bar') {
            var msgData = JSON.parse(body);
            for (var listenerGuid in myThis.subscribers) {
              var subscriptionRecord = myThis.subscribers[listenerGuid];
              var symbolExt = window.tvLivechartWidget.activeChart().symbolExt();
              var msgSymbol = msgData['symbol'];
              if (msgSymbol.includes(":")) msgSymbol = msgSymbol.split(":")[1];
              if (!symbolExt || !symbolExt.pro_name || !symbolExt.symbol || symbolExt.pro_name.toLowerCase() != msgData['symbol'].toLowerCase() && symbolExt.symbol.toLowerCase() != msgSymbol.toLowerCase()) continue;
              var subscribedRecordTicker = myThis.getStreamTickerName(subscriptionRecord.symbolInfo);
              var subscribedRecordSymbol = subscribedRecordTicker;
              if (subscribedRecordSymbol.includes(":")) subscribedRecordSymbol = subscribedRecordSymbol.split(":")[1];
              if (subscribedRecordTicker.toLowerCase() == msgData['symbol'].toLowerCase() || subscribedRecordSymbol.toLowerCase() == msgSymbol.toLowerCase()) {
                if (!subscriptionRecord.feeds.includes(msgData.source)) subscriptionRecord.feeds.push(msgData.source);
                if (myThis.streamCallback && typeof myThis.streamCallback === 'function') {
                  if (subscriptionRecord.feeds.includes('FEED4')) {
                    if (msgData.source == 'FEED4') myThis.streamCallback(msgData);
                  } else {
                    myThis.streamCallback(msgData);
                  }
                }
                if (!msgData.price && msgData.bid) msgData.price = msgData.bid;
                var data = {
                  symbol: msgData.symbol,
                  time: new Date(),
                  high: msgData.price,
                  low: msgData.price,
                  open: msgData.price,
                  close: msgData.price,
                  volume: msgData.volume
                };
                var lastBar = window.tvLivechartWidget.activeChart().getSeries().data().bars().last();
                var lastBarTime = lastBar.value[6];
                if (subscriptionRecord.resolution == 'D' || subscriptionRecord.resolution == '1D' || subscriptionRecord.resolution == 'W' || subscriptionRecord.resolution == '1W' || subscriptionRecord.resolution == 'M' || subscriptionRecord.resolution == '1M') {
                  lastBarTime = new Date();
                }
                lastBarTime = myThis.getAdjustedTime(lastBarTime, subscriptionRecord.resolution);
                if (lastBarTime == myThis.getAdjustedTime(new Date(), subscriptionRecord.resolution)) {
                  // within same timeframe
                  // update current candle

                  data.open = lastBar.value[1];
                  if (data.high < lastBar.value[2]) data.high = lastBar.value[2];
                  if (data.low > lastBar.value[3]) data.low = lastBar.value[3];
                  if (data.volume) data.volume = lastBar.value[5] + data.volume;
                  data.time = lastBarTime;
                  if (data.time < lastBar.value[6]) {
                    data.time = lastBar.value[6];
                  }
                  if (subscriptionRecord.resolution == 'W' || subscriptionRecord.resolution == '1W') {
                    data.time += 12 * 60 * 60 * 1000;
                  }
                  // console.log('updating- realtime time, last bar time', new Date(data.time).toISOString(), new Date(lastBar.value[6]).toISOString(), data.close);
                } else {
                  data.time = myThis.getAdjustedTime(new Date(), subscriptionRecord.resolution);

                  // console.log('creating- realtime time, last bar time', new Date(data.time).toISOString(), new Date(lastBar.value[6]).toISOString(), data.close);
                }
                myThis.debug && console.log('onRealtimeCallback', new Date(data.time).toISOString(), data);
                try {
                  subscriptionRecord.lastRealTimeUpdated = new Date().getTime() / 1000;
                  subscriptionRecord.listener(data);
                } catch (err) {
                  console.log(err);
                }
              }
            }
          }
        } catch (err) {
          myThis.debug && console.error('error', err, msg);
        }
      });
      myThis.liveChartConnection.onreconnected(function () {
        if (myThis.liveChartConnection.state == "Connected") {
          for (var listenerGuid in myThis.subscribers) {
            var subscriptionRecord = myThis.subscribers[listenerGuid];
            var ticker = myThis.getStreamTickerName(subscriptionRecord.symbolInfo);
            _this.debug && console.log('subscribe again at reconnection:', ticker, listenerGuid);
            try {
              myThis.liveChartConnection.invoke('Subscribe', myThis.getStreamSymbolInfo(subscriptionRecord.symbolInfo));
            } catch (err) {
              console.log(err);
            }
          }
        }
      });
    }
  }, {
    key: "updateBars",
    value: function updateBars() {
      var _this2 = this;
      this.debug && console.log("updateBars called: pending=".concat(this.requestsPending));
      if (this.requestsPending > 0) return;
      this.requestsPending = 0;
      var myThis = this;
      var _loop2 = function _loop2(listenerGuid) {
        var subscriptionRecord = myThis.subscribers[listenerGuid];

        // check if the real time price is updated in recent 30 seconds
        if (subscriptionRecord.lastRealTimeUpdated && subscriptionRecord.lastRealTimeUpdated > new Date().getTime() / 1000 - 30) return 1; // continue
        try {
          // if real time data is not comming, try to subscribe again
          if (myThis.liveChartConnection != null && myThis.liveChartConnection.state == "Connected") {
            myThis.liveChartConnection.invoke('Subscribe', myThis.getStreamSymbolInfo(subscriptionRecord.symbolInfo));
          }
        } catch (err) {
          console.log(err);
        }
        _this2.requestsPending += 1;
        _this2.updateDataForSubscriber(listenerGuid).then(function () {
          _this2.requestsPending -= 1;
          _this2.debug && console.log("updateBars: data for #".concat(listenerGuid, " updated successfully, pending=").concat(_this2.requestsPending));
        })["catch"](function (err) {
          _this2.requestsPending -= 1;
          _this2.debug && console.log("updateBars: data for #".concat(listenerGuid, " updated with error=").concat(err, ", pending=").concat(_this2.requestsPending));
        });
      };
      for (var listenerGuid in myThis.subscribers) {
        if (_loop2(listenerGuid)) continue;
      }
    }
  }, {
    key: "updateDataForSubscriber",
    value: function updateDataForSubscriber(subscriberUID) {
      var subscriptionRecord = this.subscribers[subscriberUID];
      var rangeEndTime = parseInt((Date.now() / 1000).toString());
      var myThis = this;
      return this.timeSeries(subscriptionRecord.symbolInfo.ticker, subscriptionRecord.resolution, 0, rangeEndTime, 2).then(function (bars) {
        // means the subscription was cancelled while waiting for data
        if (!myThis.subscribers.hasOwnProperty(subscriberUID)) {
          myThis.debug && console.log("updateDataForSubscriber: Data comes for already unsubscribed subscription #".concat(subscriberUID));
          return;
        }
        myThis.debug && console.log("updateDataForSubscriber: ".concat(bars.length, " data comes for subscription #").concat(subscriberUID));
        if (bars.length === 0) {
          return;
        }
        for (var i = 0; i < bars.length; i++) {
          var bar = bars[i];
          bar.time = myThis.getAdjustedTime(bar.time, subscriptionRecord.resolution);
          myThis.debug && console.log("updateDataForSubscriber: bar time adjusted ".concat(bar.time));
        }
        var lastBar = bars[bars.length - 1];
        if (subscriptionRecord.lastBarTime !== null && lastBar.time < subscriptionRecord.lastBarTime) {
          myThis.debug && console.log("updateDataForSubscriber: no new bar record found for subscription #".concat(subscriberUID));
          return;
        }
        var isNewBar = subscriptionRecord.lastBarTime !== null && lastBar.time > subscriptionRecord.lastBarTime;

        // Pulse updating may miss some trades data (ie, if pulse period = 10 secods and new bar is started 5 seconds later after the last update, the
        // old bar's last 5 seconds trades will be lost). Thus, at fist we should broadcast old bar updates when it's ready.
        if (isNewBar) {
          if (bars.length < 2) {
            throw new Error('Not enough bars in history for proper pulse update. Need at least 2.');
          }
          var previousBar = bars[bars.length - 2];
          try {
            subscriptionRecord.listener(previousBar);
          } catch (err) {
            myThis.debug && console.error(err);
          }
        }
        subscriptionRecord.lastBarTime = lastBar.time;
        try {
          subscriptionRecord.listener(lastBar);
        } catch (err) {
          myThis.debug && console.error(err);
        }
        myThis.debug && console.log("updateDataForSubscriber: bar data updated for subscription #".concat(subscriberUID));
      });
    }
  }, {
    key: "timeSeries",
    value: function timeSeries(symbol, resolution, from, to, countback) {
      this.debug && console.log('pull time series', symbol, resolution, from, to, countback);
      var url = this.twelveDataHost + '/bars' + "?symbol=".concat(symbol) + "&resolution=".concat(resolution) + "&from=".concat(from) + "&to=".concat(to) + "&countback=".concat(countback);
      return fetch(url).then(function (res) {
        return res.json();
      }).then(function (json) {
        return json || {};
      });
    }
  }, {
    key: "twelveDataSymbolSearch",
    value: function twelveDataSymbolSearch(query, exchange, type, abortController) {
      var url = this.twelveDataHost + "/search" + "?query=".concat(query) + "&exchange=".concat(exchange) + "&type=".concat(type) + "&lang=".concat(window.CURRENT_LANG);
      return fetch(url, {
        signal: abortController.signal
      }).then(function (res) {
        return res.json();
      }).then(function (json) {
        return json;
      });
    }
  }, {
    key: "onReady",
    value: function onReady(callback) {
      this.debug && console.log("onReady");
      var url = this.twelveDataHost + '/config';
      return fetch(url).then(function (res) {
        return res.json();
      }).then(function (json) {
        callback(json);
      });
    }
  }, {
    key: "searchSymbols",
    value: function searchSymbols(userInput, exchange, symbolType, onResultReadyCallback) {
      userInput = userInput.toUpperCase();
      if (userInput.includes(":")) userInput = userInput.split(":")[1];
      var myThis = this;
      if (myThis.lastSearchCallAbortController && _typeof(myThis.lastSearchCallAbortController) === 'object') {
        myThis.lastSearchCallAbortController.abort();
      }
      myThis.lastSearchCallAbortController = new AbortController();
      this.twelveDataSymbolSearch(userInput, exchange, symbolType, myThis.lastSearchCallAbortController).then(function (json) {
        myThis.debug && console.log('search symbol: ', userInput, exchange, symbolType, json);
        myThis.symbols = json;
        myThis.lastSearchCallAbortController = null;
        onResultReadyCallback(myThis.symbols);
      });
    }
  }, {
    key: "resolveSymbol",
    value: function resolveSymbol(symbolName, onSymbolResolvedCallback, onResolveErrorCallback) {
      var myThis = this;
      this.debug && console.log('👉 resolveSymbol:', symbolName);
      var url = this.twelveDataHost + "/symbols" + "?symbol=".concat(symbolName) + "&lang=".concat(window.CURRENT_LANG);
      fetch(url).then(function (res) {
        return res.json();
      }).then(function (json) {
        myThis.debug && console.log('👉 resolved symbol:', symbolName, json);
        try {
          if (myThis.customSymbolResolvedCallback && typeof myThis.customSymbolResolvedCallback === 'function') {
            myThis.customSymbolResolvedCallback(json);
          }
        } catch (e) {
          console.log(e);
        }
        onSymbolResolvedCallback(json);
      })["catch"](function (err) {
        onResolveErrorCallback("not found");
      });
    }
  }, {
    key: "getBars",
    value: function getBars(symbolInfo, resolution, periodParams, onHistoryCallback, onErrorCallback) {
      var from = periodParams.from;
      var to = periodParams.to;
      var firstDataRequest = periodParams.firstDataRequest;
      var myThis = this;
      if (this.debug) {
        console.log('👉 getBars:', symbolInfo.name, resolution);
        console.log('First:', firstDataRequest);
        console.log('From:', from, '(' + new Date(from * 1000).toString() + ')');
        console.log('To:  ', to, '(' + new Date(to * 1000).toString() + ')');
        console.log('Resolution', resolution);
      }
      this.timeSeries(symbolInfo.ticker, resolution, periodParams.from, periodParams.to, periodParams.countBack).then(function (res) {
        if (res.length > 0) {
          onHistoryCallback(res, {
            noData: false
          });
        } else onHistoryCallback([], {
          noData: true
        });
      });
    }
  }, {
    key: "getStreamTickerName",
    value: function getStreamTickerName(symbolInfo) {
      return symbolInfo.ticker;
    }
  }, {
    key: "getStreamSymbolInfo",
    value: function getStreamSymbolInfo(symbolInfo) {
      return {
        name: symbolInfo.name,
        ticker: symbolInfo.ticker,
        exchange: symbolInfo.exchange,
        source: symbolInfo.source,
        type: symbolInfo.type
      };
    }
  }, {
    key: "subscribeBars",
    value: function subscribeBars(symbolInfo, resolution, onRealtimeCallback, subscriberUID, onResetCacheNeededCallback) {
      this.debug && console.log('👉 subscribeBars:', symbolInfo, subscriberUID);
      var ticker = this.getStreamTickerName(symbolInfo);
      var hasSymbol = false;
      for (var listenrId in this.subscribers) {
        if (this.getStreamTickerName(this.subscribers[listenrId].symbolInfo) == ticker) {
          hasSymbol = true;
          break;
        }
      }
      if (!this.subscribers.hasOwnProperty(subscriberUID)) {
        this.subscribers[subscriberUID] = {
          symbolInfo: symbolInfo,
          resolution: resolution,
          listener: onRealtimeCallback,
          resetCallback: onResetCacheNeededCallback,
          lastBarTime: null,
          lastRealTimeRecord: {},
          lastRealTimeUpdated: null,
          feeds: []
        };
        this.debug && console.log('http request subscribed:', symbolInfo, subscriberUID);
      }
      var myThis = this;
      if (hasSymbol === false && myThis.liveChartConnection != null) {
        if (myThis.liveChartConnection.state == "Connected") {
          try {
            this.debug && console.log('subscribing for realtime:', ticker, subscriberUID);
            myThis.liveChartConnection.invoke('Subscribe', myThis.getStreamSymbolInfo(symbolInfo));
          } catch (err) {
            console.error(err);
          }
        } else if (myThis.liveChartConnection.state == "Disconnected") {
          myThis.liveChartConnection.start();
        } else {
          setTimeout(function () {
            try {
              this.debug && console.log('subscribing for realtime:', ticker, subscriberUID);
              myThis.liveChartConnection.invoke('Subscribe', myThis.getStreamSymbolInfo(symbolInfo));
            } catch (err) {
              console.error(err);
            }
          }, 3000);
        }
      }
    }
  }, {
    key: "unsubscribeBars",
    value: function unsubscribeBars(subscriberUID) {
      if (this.subscribers.hasOwnProperty(subscriberUID)) {
        var ticker = this.getStreamTickerName(this.subscribers[subscriberUID].symbolInfo);
        delete this.subscribers[subscriberUID];
        var hasSymbol = false;
        for (var listenrId in this.subscribers) {
          if (this.getStreamTickerName(this.subscribers[listenrId].symbolInfo) == ticker) {
            hasSymbol = true;
            break;
          }
        }
        if (hasSymbol == false && this.liveChartConnection != null) {
          this.liveChartConnection.invoke('Unsubscribe', ticker);
        }
      }
      this.debug && console.log('👉 unsubscribeBars:', subscriberUID);
    }
  }, {
    key: "getServerTime",
    value: function getServerTime(callback) {
      var _this3 = this;
      var url = this.twelveDataHost + "/time";
      fetch(url).then(function (res) {
        return res.text();
      }).then(function (text) {
        _this3.debug && console.log('get server time:', text, '(' + new Date(text * 1000).toString() + ')');
        callback(text);
      });
    }
  }, {
    key: "getAdjustedTime",
    value: function getAdjustedTime(time, resolution) {
      if (resolution === 'D' || resolution === '1D') {
        var t = new Date(time);
        t.setUTCHours(0);
        t.setUTCMinutes(0);
        t.setUTCSeconds(0);
        t.setUTCMilliseconds(0);
        return t.getTime();
      } else if (resolution === 'M' || resolution === '1M') {
        var _t = new Date(time);
        _t.setUTCDate(1);
        _t.setUTCHours(0);
        _t.setUTCMinutes(0);
        _t.setUTCSeconds(0);
        _t.setUTCMilliseconds(0);
        return _t.getTime();
      } else if (resolution === 'W' || resolution === '1W') {
        var _t2 = new Date(time);
        _t2.setUTCHours(0);
        _t2.setUTCMinutes(0);
        _t2.setUTCSeconds(0);
        _t2.setUTCMilliseconds(0);
        var offset = _t2.getUTCDay() * 24 * 60 * 60 * 1000;
        return _t2.getTime() - offset;
      } else {
        var milliseconds = parseInt(resolution) * 60 * 1000;
        return parseInt(Math.floor(time / milliseconds) * milliseconds);
      }
    }
  }, {
    key: "getNextAdjustedTime",
    value: function getNextAdjustedTime(time, resolution, next) {
      var adjustedTime = this.getAdjustedTime(time, resolution);
      var adding = 0;
      if (resolution === 'D' || resolution === '1D') {
        adding = 24 * 60 * 60 * 1000;
        return adjustedTime + next * adding;
      } else if (resolution === 'M' || resolution === '1M') {
        var time = new Date(adjustedTime);
        return new Date(time.setMonth(time.getMonth() + next)).getTime();
      } else if (resolution === 'W' || resolution === '1W') {
        adding = 7 * 24 * 60 * 60 * 1000;
        return adjustedTime + next * adding;
      } else {
        adding = parseInt(resolution) * 60 * 1000;
        return adjustedTime + next * adding;
      }
    }
  }]);
}();

},{}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LiveChartSaveLoadAdapter = exports["default"] = /*#__PURE__*/function () {
  function LiveChartSaveLoadAdapter(options) {
    _classCallCheck(this, LiveChartSaveLoadAdapter);
    this.options = {
      baseUrl: (options === null || options === void 0 ? void 0 : options.storageUrl) || '/api/live-chart/saveload',
      debug: (options === null || options === void 0 ? void 0 : options.debug) || false
    };
    this.studyTemplates = [];
    this.drawingTemplates = [];
    this.chartTemplates = [];
  }
  return _createClass(LiveChartSaveLoadAdapter, [{
    key: "getAllCharts",
    value: function getAllCharts() {
      var myThis = this;
      myThis.options.debug && console.log('getAllCharts');
      return fetch(myThis.options.baseUrl + "/charts").then(function (res) {
        return res.json();
      }).then(function (json) {
        myThis.options.debug && console.log('getAllCharts return', json);
        return json;
      })["catch"](function (err) {
        myThis.options.debug && console.log('getAllCharts error', err);
        return Promise.reject(err);
      });
      ;
    }
  }, {
    key: "removeChart",
    value: function removeChart(id) {
      var myThis = this;
      myThis.options.debug && console.log('removeChart', id);
      var request = new Request(myThis.options.baseUrl + "/charts/" + id + "/delete", {
        method: 'POST'
      });
      return fetch(request)["catch"](function (err) {
        myThis.options.debug && console.log('removeChart error', err);
        return Promise.reject(err);
      });
      ;
    }
  }, {
    key: "saveChart",
    value: function saveChart(chartData) {
      var myThis = this;
      myThis.options.debug && console.log('saveChart', chartData);
      var formData = new FormData();
      formData.append('name', chartData.name);
      formData.append('resolution', chartData.resolution);
      formData.append('symbol', chartData.symbol);
      formData.append('content', chartData.content);
      var request = null;
      if (!chartData.id) {
        request = new Request(myThis.options.baseUrl + "/charts", {
          method: 'POST',
          body: formData
        });
      } else {
        formData.append('id', chartData.id);
        request = new Request(myThis.options.baseUrl + "/charts/" + chartData.id + "/update", {
          method: 'POST',
          body: formData
        });
      }
      return fetch(request).then(function (res) {
        return res.json();
      }).then(function (json) {
        myThis.options.debug && console.log('saveChart return', json.id);
        return json.id;
      })["catch"](function (err) {
        myThis.options.debug && console.log('saveChart error', err);
        return Promise.reject(err);
      });
    }
  }, {
    key: "getChartContent",
    value: function getChartContent(id) {
      var myThis = this;
      myThis.options.debug && console.log('getChartContent', id);
      return fetch(myThis.options.baseUrl + "/charts/" + id).then(function (res) {
        return res.json();
      }).then(function (json) {
        myThis.options.debug && console.log('getChartContent return', json.content);
        return json.content;
      })["catch"](function (err) {
        myThis.options.debug && console.log('getChartContent error', err);
        return Promise.reject(err);
      });
    }
  }, {
    key: "removeStudyTemplate",
    value: function removeStudyTemplate(studyTemplateData) {
      var myThis = this;
      myThis.options.debug && console.log('removeStudyTemplate', studyTemplateData);
      var request = new Request(myThis.options.baseUrl + "/delete-study_templates?name=" + studyTemplateData.name, {
        method: 'POST'
      });
      return fetch(request)["catch"](function (err) {
        myThis.options.debug && console.log('removeStudyTemplate error', err);
        return Promise.reject(err);
      });
      ;
      for (var i = 0; i < myThis.studyTemplates.length; ++i) {
        if (myThis.studyTemplates[i].name === studyTemplateData.name) {
          myThis.studyTemplates.splice(i, 1);
          return Promise.resolve();
        }
      }
      return Promise.reject();
    }
  }, {
    key: "getStudyTemplateContent",
    value: function getStudyTemplateContent(studyTemplateData) {
      var myThis = this;
      myThis.options.debug && console.log('getStudyTemplateContent', studyTemplateData);
      return fetch(myThis.options.baseUrl + "/study_template-content?name=" + studyTemplateData.name).then(function (res) {
        return res.json();
      }).then(function (json) {
        myThis.options.debug && console.log('getStudyTemplateContent return', json.content);
        return json.content;
      })["catch"](function (err) {
        myThis.options.debug && console.log('getStudyTemplateContent error', err);
        return Promise.reject(err);
      });
      for (var i = 0; i < myThis.studyTemplates.length; ++i) {
        if (myThis.studyTemplates[i].name === studyTemplateData.name) {
          return Promise.resolve(myThis.studyTemplates[i].content);
        }
      }
      console.error('st: error');
      return Promise.reject();
    }
  }, {
    key: "saveStudyTemplate",
    value: function saveStudyTemplate(studyTemplateData) {
      var myThis = this;
      myThis.options.debug && console.log('saveStudyTemplate', studyTemplateData);
      var formData = new FormData();
      formData.append('name', studyTemplateData.name);
      formData.append('content', studyTemplateData.content);
      var request = new Request(myThis.options.baseUrl + "/study_templates", {
        method: 'POST',
        body: formData
      });
      return fetch(request).then(function (res) {
        return res.json();
      }).then(function (json) {
        myThis.options.debug && console.log('saveStudyTemplate return', json.name);
        return json.name;
      })["catch"](function (err) {
        myThis.options.debug && console.log('saveStudyTemplate error', err);
        return Promise.reject(err);
      });
      for (var i = 0; i < myThis.studyTemplates.length; ++i) {
        if (myThis.studyTemplates[i].name === studyTemplateData.name) {
          myThis.studyTemplates.splice(i, 1);
          break;
        }
      }
      myThis.studyTemplates.push(studyTemplateData);
      return Promise.resolve();
    }
  }, {
    key: "getAllStudyTemplates",
    value: function getAllStudyTemplates() {
      var myThis = this;
      myThis.options.debug && console.log('getAllStudyTemplates');
      return fetch(myThis.options.baseUrl + "/study_templates").then(function (res) {
        return res.json();
      }).then(function (json) {
        myThis.options.debug && console.log('getAllStudyTemplates return', json);
        return json;
      })["catch"](function (err) {
        myThis.options.debug && console.log('getAllStudyTemplates error', err);
        return Promise.reject(err);
      });
      ;
      return Promise.resolve(myThis.studyTemplates);
    }
  }, {
    key: "removeDrawingTemplate",
    value: function removeDrawingTemplate(toolName, templateName) {
      var myThis = this;
      myThis.options.debug && console.log('removeDrawingTemplate', toolName, templateName);
      for (var i = 0; i < myThis.drawingTemplates.length; ++i) {
        if (myThis.drawingTemplates[i].name === templateName) {
          myThis.drawingTemplates.splice(i, 1);
          return Promise.resolve();
        }
      }
      return Promise.reject();
    }
  }, {
    key: "loadDrawingTemplate",
    value: function loadDrawingTemplate(toolName, templateName) {
      var myThis = this;
      myThis.options.debug && console.log('loadDrawingTemplate', toolName, templateName);
      for (var i = 0; i < myThis.drawingTemplates.length; ++i) {
        if (myThis.drawingTemplates[i].name === templateName) {
          return Promise.resolve(myThis.drawingTemplates[i].content);
        }
      }
      console.error('drawing: error');
      return Promise.reject();
    }
  }, {
    key: "saveDrawingTemplate",
    value: function saveDrawingTemplate(toolName, templateName, content) {
      var myThis = this;
      myThis.options.debug && console.log('saveDrawingTemplate', toolName, templateName, content);
      for (var i = 0; i < myThis.drawingTemplates.length; ++i) {
        if (myThis.drawingTemplates[i].name === templateName) {
          myThis.drawingTemplates.splice(i, 1);
          break;
        }
      }
      myThis.drawingTemplates.push({
        name: templateName,
        content: content
      });
      return Promise.resolve();
    }
  }, {
    key: "getDrawingTemplates",
    value: function getDrawingTemplates() {
      var myThis = this;
      myThis.options.debug && console.log('getDrawingTemplates');
      return Promise.resolve(myThis.drawingTemplates.map(function (template) {
        return template.name;
      }));
    }
  }, {
    key: "getAllChartTemplates",
    value: function getAllChartTemplates() {
      var myThis = this;
      myThis.options.debug && console.log('getAllChartTemplates');
      return Promise.resolve(myThis.chartTemplates.map(function (x) {
        return x.name;
      }));
    }
  }, {
    key: "saveChartTemplate",
    value: function saveChartTemplate(templateName, content) {
      var myThis = this;
      myThis.options.debug && console.log('saveChartTemplate', templateName, content);
      var theme = myThis.chartTemplates.find(function (x) {
        return x.name === templateName;
      });
      if (theme) {
        theme.content = content;
      } else {
        myThis.chartTemplates.push({
          name: templateName,
          content: content
        });
      }
      return Promise.resolve();
    }
  }, {
    key: "removeChartTemplate",
    value: function removeChartTemplate(templateName) {
      var myThis = this;
      myThis.options.debug && console.log('removeChartTemplate', templateName);
      myThis.chartTemplates = myThis.chartTemplates.filter(function (x) {
        return x.name !== templateName;
      });
      return Promise.resolve();
    }
  }, {
    key: "getChartTemplateContent",
    value: function getChartTemplateContent(templateName) {
      var _myThis$chartTemplate;
      var myThis = this;
      myThis.options.debug && console.log('getChartTemplateContent', templateName);
      var theme = {};
      var content = (_myThis$chartTemplate = myThis.chartTemplates.find(function (x) {
        return x.name === templateName;
      })) === null || _myThis$chartTemplate === void 0 ? void 0 : _myThis$chartTemplate.content;
      if (content) {
        theme.content = structuredClone(content);
      }
      return Promise.resolve(theme);
    }
  }]);
}();

},{}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var APIHelper = /*#__PURE__*/function () {
  function APIHelper() {
    _classCallCheck(this, APIHelper);
    this.isFetchingToken = false;
    this.tokenPromiseQueue = [];
  }
  return _createClass(APIHelper, [{
    key: "GetAccessTokenAsync",
    value: function GetAccessTokenAsync() {
      var myThis = this;
      return new Promise(function (resolve) {
        var token = localStorage.getItem('cbf-access-token');
        if (!token) {
          myThis.QueueTokenRequest(resolve);
        } else {
          try {
            var body = token.split('.')[1];
            var jsonStr = atob(body);
            var json = JSON.parse(jsonStr);
            var date = new Date((json.exp - 200) * 1000);
            if (date <= new Date()) {
              localStorage.removeItem('cbf-access-token');
              myThis.QueueTokenRequest(resolve);
            } else {
              resolve(token);
            }
          } catch (error) {
            myThis.QueueTokenRequest(resolve);
            console.error("Error retrieving token", error);
          }
        }
      });
    }
  }, {
    key: "QueueTokenRequest",
    value: function QueueTokenRequest(resolve) {
      var myThis = this;
      if (myThis.isFetchingToken) {
        myThis.tokenPromiseQueue.push(resolve);
      } else {
        this.isFetchingToken = true;
        myThis.RetrieveTokenAsync().then(function (res) {
          localStorage.setItem('cbf-access-token', res.token);
          myThis.isFetchingToken = false;
          resolve(res.token);
          while (myThis.tokenPromiseQueue.length > 0) {
            var nextResolve = myThis.tokenPromiseQueue.shift();
            nextResolve(res.token);
          }
        })["catch"](function (error) {
          myThis.isFetchingToken = false;
          console.error('Error retrieving token:', error);
        });
      }
    }
  }, {
    key: "RetrieveTokenAsync",
    value: function RetrieveTokenAsync() {
      return $.ajax({
        url: '/api/account/generate-token',
        type: "POST"
      });
    }
  }, {
    key: "SafeServiceAPICall",
    value: function SafeServiceAPICall(ajaxRequest) {
      var myThis = this;
      return new Promise(function (resolve, reject) {
        myThis.GetAccessTokenAsync().then(function (token) {
          if (!ajaxRequest.headers) {
            ajaxRequest.headers = {};
          }
          ajaxRequest.headers.Authorization = 'Bearer ' + token;
          $.ajax(ajaxRequest).then(function (res) {
            resolve(res);
          })["catch"](function (error) {
            reject(error);
          });
        })["catch"](function (error) {
          reject(error);
        });
      });
    }
  }]);
}();
var _default = exports["default"] = APIHelper;

},{}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AISHelper = /*#__PURE__*/function () {
  function AISHelper() {
    _classCallCheck(this, AISHelper);
  }
  return _createClass(AISHelper, [{
    key: "ToPercent",
    value: function ToPercent(val, hasStyle, strWhenZero) {
      if (val == null) return '-';
      val = parseFloat(val);
      if (Number.isNaN(val)) return '<i class="mdi mdi-lock"/>';
      if (!!strWhenZero && val == 0) return strWhenZero;
      var localeCode = window.CURRENT_CULTURE;
      if (!localeCode || localeCode.includes("ar") || localeCode.includes("fa")) localeCode = window.DEFAULT_CULTURE;
      if (!localeCode) localeCode = "en-GB";
      var str = val.toLocaleString(localeCode, {
        style: 'percent',
        maximumFractionDigits: 2
      });
      if (hasStyle === true) {
        if (val >= 0) return '<span class="stats-positive">' + str + '</span>';else return '<span class="stats-negative">' + str + '</span>';
      }
      return str;
    }
  }, {
    key: "ToCurrency",
    value: function ToCurrency(val, hasStyle) {
      if (val == null) return '-';
      val = parseFloat(val);
      if (Number.isNaN(val)) return '<i class="mdi mdi-lock"/>';
      var localeCode = window.CURRENT_CULTURE;
      if (!localeCode || localeCode.includes("ar") || localeCode.includes("fa")) localeCode = window.DEFAULT_CULTURE;
      if (!localeCode) localeCode = "en-GB";
      var str = val.toLocaleString(localeCode, {
        style: 'currency',
        maximumFractionDigits: 2,
        currency: 'USD'
      });
      if (hasStyle === true) {
        if (val >= 0) return '<span class="stats-positive">' + str + '</span>';else return '<span class="stats-negative">' + str + '</span>';
      }
      return str;
    }
  }, {
    key: "ToDecimal",
    value: function ToDecimal(val, hasStyle) {
      if (val == null) return '-';
      val = parseFloat(val);
      if (Number.isNaN(val)) return '<i class="mdi mdi-lock"/>';
      var localeCode = window.CURRENT_CULTURE;
      if (!localeCode || localeCode.includes("ar") || localeCode.includes("fa")) localeCode = window.DEFAULT_CULTURE;
      if (!localeCode) localeCode = "en-GB";
      var str = val.toLocaleString(localeCode, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      if (hasStyle === true) {
        if (val >= 0) return '<span class="stats-positive">' + str + '</span>';else return '<span class="stats-negative">' + str + '</span>';
      }
      return str;
    }
  }, {
    key: "ToDigitsDecimal",
    value: function ToDigitsDecimal(val, digits) {
      if (val == null) return '-';
      val = parseFloat(val);
      if (Number.isNaN(val)) return '-';
      var localeCode = window.CURRENT_CULTURE;
      if (!localeCode || localeCode.includes("ar") || localeCode.includes("fa")) localeCode = window.DEFAULT_CULTURE;
      if (!localeCode) localeCode = "en-GB";
      var str = '';
      if (digits == null || digits == undefined) str = val.toLocaleString(localeCode);else str = val.toLocaleString(localeCode, {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
      });
      return str;
    }
  }, {
    key: "ToIntNumber",
    value: function ToIntNumber(val, hasStyle) {
      if (val == null) return '-';
      val = parseFloat(val);
      if (Number.isNaN(val)) return '<i class="mdi mdi-lock"/>';
      var localeCode = window.CURRENT_CULTURE;
      if (!localeCode || localeCode.includes("ar") || localeCode.includes("fa")) localeCode = window.DEFAULT_CULTURE;
      if (!localeCode) localeCode = "en-GB";
      var str = val.toLocaleString(localeCode, {
        maximumFractionDigits: 0
      });
      if (hasStyle === true) {
        if (val >= 0) return '<span class="stats-positive">' + str + '</span>';else return '<span class="stats-negative">' + str + '</span>';
      }
      return str;
    }
  }, {
    key: "ToTimeSpan",
    value: function ToTimeSpan(val) {
      var res = '';
      if (val.days > 0) res += val.days + 'd';
      if (val.hours > 0) res += ' ' + val.hours + 'h';
      if (val.minutes > 0) res += ' ' + val.minutes + 'm';
      return res;
    }
  }, {
    key: "GetDuraction",
    value: function GetDuraction(t1, t2) {
      t1 = new Date(t1);
      t2 = new Date(t2);
      var res = '';
      var span = (t2 - t1) / 1000;
      if (span > 24 * 3600) {
        res += parseInt(span / (24 * 3600)) + "d";
        span = span % (24 * 3600);
      }
      if (span > 3600) {
        res += ' ' + parseInt(span / 3600) + 'h';
        span = span % 3600;
      }
      if (span > 60) {
        res += ' ' + parseInt(span / 60) + 'm';
        span = span % 60;
      }
      if (res == '') res = parseInt(span) + 's';
      return res;
    }
  }, {
    key: "ToShortDate",
    value: function ToShortDate(val, type, timezone) {
      var date = new Date(val);
      var yearType = 'numeric';
      if (date.getFullYear() == new Date().getFullYear()) yearType = undefined;
      var localeCode = window.CURRENT_CULTURE;
      if (!localeCode || localeCode.includes("ar") || localeCode.includes("fa")) localeCode = window.DEFAULT_CULTURE;
      if (!localeCode) localeCode = "en-GB";
      if (!type) type = "short";
      return date.toLocaleDateString(localeCode, {
        weekday: undefined,
        year: yearType,
        month: type,
        day: 'numeric',
        timeZone: timezone
      });
    }
  }, {
    key: "ToShortDateTime",
    value: function ToShortDateTime(val, type, timezone) {
      var date = new Date(val);
      var yearType = 'numeric';
      if (date.getFullYear() == new Date().getFullYear()) yearType = undefined;
      var localeCode = window.CURRENT_CULTURE;
      if (!localeCode || localeCode.includes("ar") || localeCode.includes("fa")) localeCode = window.DEFAULT_CULTURE;
      if (!localeCode) localeCode = "en-GB";
      if (!type) type = "short";
      return date.toLocaleDateString(localeCode, {
        weekday: undefined,
        year: yearType,
        month: type,
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: timezone
      });
    }
  }, {
    key: "ToLongDate",
    value: function ToLongDate(val, timezone) {
      var date = new Date(val);
      var localeCode = window.CURRENT_CULTURE;
      if (!localeCode || localeCode.includes("ar") || localeCode.includes("fa")) localeCode = window.DEFAULT_CULTURE;
      if (!localeCode) localeCode = "en-GB";
      return date.toLocaleString(localeCode, {
        weekday: undefined,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: timezone
      });
    }
  }, {
    key: "ToStatus",
    value: function ToStatus(lastUpdated, hasError) {
      var desc = '';
      if (new Date(lastUpdated).getTime() < 0) {
        desc = 'never';
      } else {
        desc = this.GetDuraction(lastUpdated, new Date()) + ' ago';
      }
      var res = '';
      if (hasError == false) {
        res += '<span data-toggle="tooltip" title="Connection Succeeded"><i class="mdi mdi-sync"/> <span class="dotted-border-bottom">(' + desc + ')</span></span>';
      } else {
        res += '<span data-toggle="tooltip" title="Connection Failed"><i class="mdi mdi-sync-off"/> <span class="dotted-border-bottom">(' + desc + ')</span></span>';
      }
      return res;
    }
  }, {
    key: "ToChartMoney",
    value: function ToChartMoney(value) {
      if (Math.abs(value) >= 1000000) {
        return (value / 1000000).toFixed(1) + "M";
      } else if (Math.abs(value) >= 1000) {
        return (value / 1000).toFixed(1) + "K";
      } else return value.toFixed(2);
    }
  }, {
    key: "InitializeRankingTableTooltips",
    value: function InitializeRankingTableTooltips() {
      this.InitializeCountryCodeTooltip();
      $("[data-action=drawdown-disqualified-tooltip]").each(function (i, ele) {
        $(ele).data('toggle', 'tooltip');
        if ($(ele).data('reason') == 'manual') {
          var _window$contestString;
          $(ele).data('title', (_window$contestString = window.contestStrings["DisqualifiedDueToAViolation"]) !== null && _window$contestString !== void 0 ? _window$contestString : "Disqualified due to a violation");
        } else {
          var _window$contestString2;
          $(ele).data('title', (_window$contestString2 = window.contestStrings["DisqualfiedDueToDrawdown"]) !== null && _window$contestString2 !== void 0 ? _window$contestString2 : "Disqualified due to drawdown");
        }
        $(ele).tooltip('dispose').tooltip({
          boundary: 'window'
        });
      });
      $("[data-toggle='drawdown-popover']").popover();
    }
  }, {
    key: "InitializeCountryCodeTooltip",
    value: function InitializeCountryCodeTooltip() {
      var displayNames = new Intl.DisplayNames(window.CURRENT_LANG, {
        type: 'region'
      });
      $("[data-action=country]").each(function (i, ele) {
        try {
          var countryCode = $(ele).data('country');
          $(ele).data('toggle', 'tooltip');
          $(ele).data('title', displayNames.of(countryCode));
          $(ele).tooltip('dispose').tooltip({
            boundary: 'window'
          });
        } catch (err) {}
      });
    }
  }, {
    key: "GetLocalizedCurrencyName",
    value: function GetLocalizedCurrencyName(currencyCode) {
      var currencyNames = new Intl.DisplayNames(window.CURRENT_LANG, {
        type: 'currency'
      });
      // Get currency names
      return currencyNames.of(currencyCode);
    }
  }, {
    key: "GetLocalizedLanguageName",
    value: function GetLocalizedLanguageName(langCode) {
      var languageNames = new Intl.DisplayNames(window.CURRENT_LANG, {
        type: 'language'
      });
      return languageNames.of(langCode);
    }
  }, {
    key: "GetLocalizedRegionName",
    value: function GetLocalizedRegionName(regionCode) {
      var regionNames = new Intl.DisplayNames(window.CURRENT_LANG, {
        type: 'region'
      });
      return regionNames.of(regionCode);
    }
  }]);
}();
var _default = exports["default"] = AISHelper;

},{}],16:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Watchlist = exports["default"] = /*#__PURE__*/function () {
  /*
  * watchlist object schema
  [
      {
          Id: 2,
          IsDefault: true,
          Name: "My Favorites",
          Order: 1,
          CreatedAt: 1746196140,   // unix time seconds
          Symbols: [
              {
                  "Ticker": "IC Markets:EURUSD",
                  "Symbol": "EUR/USD",
                  "Exchange": "IC Markets",
                  "CreatedAt": "1746196140",   // unix time seconds
                  "LastViewedAt": "1746196140",   // unix time seconds
                  "Order": 0
              },
              {
                  "Ticker": "IC Markets:EURUSD",
                  "Symbol": "EUR/USD",
                  "Exchange": "IC Markets",
                  "CreatedAt": "1746196140",   // unix time seconds
                  "LastViewedAt": "1746196140",   // unix time seconds
                  "Order": 1
              }
              ...
          ]
      },
      ...
  ]
  */
  function Watchlist() {
    _classCallCheck(this, Watchlist);
    this._oldCacheKeyName = "ntvc-watchlist";
    this._cacheKeyName = "ntvc-watchlists";
    this._recentSymbolsCacheKey = "ntvc-recent-symbols";
    this._recentSymbols = [];
    this._watchlists = [];
    this._activeWatchlistName = null;
    this._watchlistSymbolSelectBoxControl = null;
    this._isRecentSymbolsMode = false;
    this._currentManagingWatchlistId = null;
    this._currentSelectedSymbol = {
      ticker: '',
      symbol: 'EUR/USD'
    };
    this._sortOption = 'recent';
    this._watchlistsSortableControl = null;
    this._defaultSymbols = [{
      Ticker: 'IC Markets:EURUSD',
      Symbol: 'EUR/USD',
      Exchange: 'IC Markets'
    }, {
      Ticker: 'IC Markets:GBPUSD',
      Symbol: 'GBP/USD',
      Exchange: 'IC Markets'
    }, {
      Ticker: 'IC Markets:USDJPY',
      Symbol: 'USD/JPY',
      Exchange: 'IC Markets'
    }, {
      Ticker: 'IC Markets:USDCAD',
      Symbol: 'USD/CAD',
      Exchange: 'IC Markets'
    }, {
      Ticker: 'IC Markets:USDCHF',
      Symbol: 'USD/CHF',
      Exchange: 'IC Markets'
    }, {
      Ticker: 'IC Markets:NZDUSD',
      Symbol: 'NZD/USD',
      Exchange: 'IC Markets'
    }, {
      Ticker: 'IC Markets:AUDUSD',
      Symbol: 'AUD/USD',
      Exchange: 'IC Markets'
    }, {
      Ticker: 'IC Markets:USTEC',
      Symbol: 'USTEC',
      Exchange: 'IC Markets'
    }, {
      Ticker: 'IC Markets:US500',
      Symbol: 'US500',
      Exchange: 'IC Markets'
    }, {
      Ticker: 'IC Markets:US30',
      Symbol: 'US30',
      Exchange: 'IC Markets'
    }, {
      Ticker: 'IC Markets:JP225',
      Symbol: 'JP225',
      Exchange: 'IC Markets'
    }, {
      Ticker: 'IC Markets:STOXX50',
      Symbol: 'STOXX50',
      Exchange: 'IC Markets'
    }, {
      Ticker: 'IC Markets:DE40',
      Symbol: 'DE40',
      Exchange: 'IC Markets'
    }, {
      Ticker: 'IC Markets:UK100',
      Symbol: 'UK100',
      Exchange: 'IC Markets'
    }, {
      Ticker: 'IC Markets:CA60',
      Symbol: 'CA60',
      Exchange: 'IC Markets'
    }, {
      Ticker: 'IC Markets:AUS200',
      Symbol: 'AUS200',
      Exchange: 'IC Markets'
    }, {
      Ticker: 'IC Markets:CHINA50',
      Symbol: 'CHINA50',
      Exchange: 'IC Markets'
    }, {
      Ticker: 'IC Markets:XAUUSD',
      Symbol: 'XAU/USD',
      Exchange: 'IC Markets'
    }, {
      Ticker: 'IC Markets:XAGUSD',
      Symbol: 'XAG/USD',
      Exchange: 'IC Markets'
    }, {
      Ticker: 'IC Markets:XBRUSD',
      Symbol: 'XBR/USD',
      Exchange: 'IC Markets'
    }, {
      Ticker: 'IC Markets:XTIUSD',
      Symbol: 'XTI/USD',
      Exchange: 'IC Markets'
    }, {
      Ticker: 'IC Markets:BTCUSD',
      Symbol: 'BTC/USD',
      Exchange: 'IC Markets'
    }, {
      Ticker: 'IC Markets:ETHUSD',
      Symbol: 'ETH/USD',
      Exchange: 'IC Markets'
    }, {
      Ticker: 'IC Markets:XRPUSD',
      Symbol: 'XRP/USD',
      Exchange: 'IC Markets'
    }, {
      Ticker: 'NYSE:SPY',
      Symbol: 'SPY',
      Exchange: 'NYSE'
    }, {
      Ticker: 'NASDAQ:QQQ',
      Symbol: 'QQQ',
      Exchange: 'NASDAQ'
    }];
  }
  return _createClass(Watchlist, [{
    key: "InitializeWatchList",
    value: function InitializeWatchList() {
      var _this = this;
      if (window.userIsOnline) {
        _this.LoadWatchlistFromCache();
      } else {
        _this._isRecentSymbolsMode = true;
      }
      if (!window.WatchlistResxStrings) {
        return;
      }
      _this.LoadRecentSymbolsFromCache();
      _this.InitWatchListDialog();
      _this.RenderWatchlistComponents();
      _this.InitializeWatchListPopover();
      if (window.userIsOnline) {
        _this.SyncWatchListSymbols();
        _this.SyncRecentSymbols();
      }
    }
  }, {
    key: "InitWatchListDialog",
    value: function InitWatchListDialog() {
      var _this = this;
      this._watchlistSymbolSelectBoxControl = $("#watchlist-mng-dialog-symbol-select").chartSymbolSearch('init', '/api/live-chart/datafeed', {
        onChange: function onChange(ticker, symbolData) {
          _this.AddSymbolToWatchlist(_this._currentManagingWatchlistId, ticker, symbolData.symbol, symbolData.exchange);
        },
        hideStarIcon: true
      });

      // Handle the click event on the star icon
      $(document).on('click', '.watchlist-saveto-dialog [data-action="watchlist-add-or-remove"]', function (e) {
        var item = $(e.target).closest('.item');
        var watchListId = item.data('id');
        var starIcon = item.find('.watchlist-mng-item-star');
        if (starIcon.hasClass('filled')) {
          _this.RemoveSymbolFromWatchList(watchListId, _this._currentSelectedSymbol.ticker);
          starIcon.removeClass('filled');
        } else {
          _this.AddSymbolToWatchlist(watchListId, _this._currentSelectedSymbol.ticker, _this._currentSelectedSymbol.symbol, _this._currentSelectedSymbol.exchange);
          starIcon.addClass('filled');
        }
        _this.AfterWatchListUpdated(watchListId);
      });
      $(document).on('click', '#live-chart-watch-list-popover-payload .watch-list-item a:first-child', function (e) {
        var watchListItem = $(e.target).closest('.watch-list-item');
        var ticker = watchListItem.data('ticker');
        var symbol = watchListItem.data('symbol');
        var exchange = watchListItem.data('exchange');
        $("[data-toggle=top-menu-watchlist-icon-popover]").popover('hide');
        $('.tooltip').remove();
        $("#live-chart-watch-list-popover-payload a[data-toggle=tooltip]").tooltip('dispose');
        _this.OpenAddSymbolToWatchlistsDialog({
          ticker: ticker,
          symbol: symbol,
          exchange: exchange
        });
      });
      $(document).on('click', 'a[data-action="save-to-new-watchlist"]', function (e) {
        $(".watchlist-saveto-dialog").modal('hide');
        _this.NewWatchlist(_this._currentSelectedSymbol);
      });
      $(document).on('click', '.live-chart-watch-list-popover-dropdown .dropdown-item.manage-item[data-action="manage-watchlist"]', function (e) {
        $("[data-toggle=top-menu-watchlist-icon-popover]").popover('hide');
        $('.tooltip').remove();
        $(".tv-symbol-search-dialog").modal('hide');
        if (window.userIsOnline) {
          _this.OpenWatchlistMngAllDialog();
        } else {
          window.Access.Login();
        }
      });
      $(document).on('click', 'a.dropdown-item[data-action="sort-symbols"]', function (e) {
        var sortOption = $(e.target).data('order');
        _this.UpdateWatchlistSortOption(sortOption);
      });
      $(document).on('click', '.watchlist-all-mng-dialog a[data-action="duplicate-watchlist"]', function (e) {
        var watchlistItem = $(e.target).closest('.item');
        var watchlistId = watchlistItem.data('id');
        _this.DuplicateWatchlist(watchlistId);
      });
      $(document).on('click', '.live-chart-watch-list-popover-dropdown .dropdown-item[data-action="recent-symbols"]', function (e) {
        _this._isRecentSymbolsMode = true;
        _this.SaveWatchlistToCache();
        $(".live-chart-content .live-chart-watch-list-popover-dropdown .dropdown-toggle").text(window.WatchlistResxStrings['RecentSymbols']);
        UpdateChartPageRecentWatchlistBar();
        _this.UpdateWatchlistSortOptionDropdownState();
      });
      $(document).on('click', '.live-chart-watch-list-popover-dropdown .dropdown-item:not([data-action])', function (e) {
        if ($(e.target).closest('.tv-symbol-search-dialog').length > 0) {
          return;
        }
        var watchlistName = $(e.target).data('watchlist');
        $(".live-chart-watch-list-popover-dropdown .dropdown-toggle").text(watchlistName);
        _this._isRecentSymbolsMode = false;
        _this.SetActiveWatchlist(watchlistName);
        if ($(e.target).closest('.popover').length > 0) {
          $('[data-toggle="top-menu-watchlist-icon-popover"]').popover('show');
        }
      });
      $(document).on('click', '.watchlist-dlg-watchlist-popover-dropdown .dropdown-item', function (e) {
        var watchlistId = $(e.target).data('watchlistid');
        var watchlistName = $(e.target).data('watchlist');
        $(".watchlist-dlg-watchlist-popover-dropdown .dropdown-toggle").text(watchlistName);
        _this._currentManagingWatchlistId = watchlistId;
        _this.RenderWatchlistMngDialogSymbols(watchlistId);
        _this.UpdateWatchlistMngDialogButtonStates();
      });
      $(document).on('click', 'a[data-action=edit-watchlist]', function (e) {
        var watchlistItem = $(e.target).closest('.item');
        var watchlistId = watchlistItem.data('id');
        $(".watchlist-all-mng-dialog").modal('hide');
        _this.OpenWatchListMngDialog(watchlistId);
      });
      $(document).on('input', '.watchlist-all-mng-dialog .watchlist-mng-search-box input', function (e) {
        var searchTerm = $(this).val().toLowerCase();
        $(".watchlist-all-mng-dialog .watchlist-mng-items-container .item").each(function () {
          var itemText = $(this).text().toLowerCase();
          if (!searchTerm || itemText.includes(searchTerm)) {
            $(this).show();
          } else {
            $(this).hide();
          }
        });
      });
      $(document).on('input', '.watchlist-mng-dialog .watchlist-mng-search-box input', function (e) {
        var searchTerm = $(this).val().toLowerCase();
        $(".watchlist-mng-dialog .watchlist-mng-items-container .item").each(function () {
          var itemText = $(this).text().toLowerCase();
          if (!searchTerm || itemText.includes(searchTerm)) {
            $(this).show();
          } else {
            $(this).hide();
          }
        });
      });
      $(document).on('input', '.watchlist-saveto-dialog .watchlist-mng-search-box input', function (e) {
        var searchTerm = $(this).val().toLowerCase();
        $(".watchlist-saveto-dialog .watchlist-mng-items-container .item").each(function () {
          var itemText = $(this).text().toLowerCase();
          if (!searchTerm || itemText.includes(searchTerm)) {
            $(this).show();
          } else {
            $(this).hide();
          }
        });
      });
    }
  }, {
    key: "EditWatchlistName",
    value: function EditWatchlistName() {
      var _this = this;
      var selectElement = document.getElementById('watchlist-mng-select');
      var selectDropdownToggle = document.querySelector('#watchlist-mng-select .dropdown-toggle');
      var currentValue = selectDropdownToggle.textContent.trim();
      var selectedOption = document.querySelector("#watchlist-mng-select .dropdown-item[data-watchlist=\"".concat(currentValue, "\"]"));

      // Replace the select element with an input field
      var input = document.createElement('input');
      input.type = 'text';
      input.value = currentValue;
      input.className = 'watchlist-mng-select-input';
      input.id = 'edit-watchlist-mng-input';

      // Replace the select element in the DOM
      selectElement.parentNode.replaceChild(input, selectElement);

      // Handle saving the edited value
      input.addEventListener('blur', function () {
        var newValue = input.value.trim();
        var orgName = selectedOption.getAttribute('data-watchlist');
        var watchlistId = selectedOption.getAttribute('data-watchlistid');
        if (orgName == newValue) {
          input.parentNode.replaceChild(selectElement, input);
          return;
        }
        if (!_this.ValidateWatchlistName(watchlistId, newValue)) {
          toastr.error('Invalid name.');
          input.parentNode.replaceChild(selectElement, input);
          return;
        }

        // Update the selected option's text
        selectDropdownToggle.textContent = newValue;
        selectedOption.textContent = newValue;
        selectedOption.setAttribute('data-watchlist', newValue);

        // Replace the input field back with the select element
        input.parentNode.replaceChild(selectElement, input);
        _this.RenameWatchlist(watchlistId, newValue);
      });

      // Focus the input field for editing
      input.focus();
    }
  }, {
    key: "ValidateWatchlistName",
    value: function ValidateWatchlistName(watchlistId, name) {
      if (name.length < 3 || name.length > 60) {
        return false;
      }
      if (this._watchlists.find(function (wl) {
        return wl.Name.toLowerCase() === name.toLowerCase() && watchlistId != wl.Id;
      }) != null) {
        return false;
      }
      return true;
    }
  }, {
    key: "HideDeleteConfirmPopover",
    value: function HideDeleteConfirmPopover() {
      $('a[data-action="delete-watchlist"]').popover('hide');
    }
  }, {
    key: "HideRemoveSymbolConfirmPopover",
    value: function HideRemoveSymbolConfirmPopover() {
      $('a[data-action="remove-symbol-from-watchlist"]').popover('hide');
    }
  }, {
    key: "ConfirmRemoveSymbolFromWatchlist",
    value: function ConfirmRemoveSymbolFromWatchlist(ticker) {
      $('[data-action="remove-symbol-from-watchlist"]').popover('hide');
      this.RemoveSymbolFromWatchList(this._currentManagingWatchlistId, ticker);
      $("[data-id=\"".concat(ticker, "\"]")).remove();
    }
  }, {
    key: "ConfirmDeleteWatchlist",
    value: function ConfirmDeleteWatchlist(watchlistId, isOnManageAllDialog) {
      $('a[data-action="delete-watchlist"]').popover('hide');
      var watchlist = this.GetWatchlistById(watchlistId);
      if (watchlist.IsDefault) {
        toastr.error(window.WatchlistResxStrings['DefaultWatchlistCanNotBeDeleted']);
        return;
      }
      // Delete the selected watchlist
      this.DeleteWatchlist(watchlist.Name);
      if (isOnManageAllDialog) {
        $(".watchlist-mng-items-container .item[data-id=".concat(watchlistId, "]")).remove();
      } else {
        var _watchlist = this.GetActiveWatchlist();
        this._currentManagingWatchlistId = _watchlist.Id;
        this.RenderWatchlistMngDialogSymbols(_watchlist.Id);
        this.RenderWatchlistMngDialogWatchlistDropdown(_watchlist.Id);
        this._watchlistSymbolSelectBoxControl.chartSymbolSearch('updateWatchlistDropdown', this);
      }
    }
  }, {
    key: "DuplicateWatchlist",
    value: function DuplicateWatchlist(watchlistId) {
      var _this = this;
      var watchlist = _this.GetWatchlistById(watchlistId);
      var watchlistName = watchlist.Name;
      if (watchlist) {
        var newWatchlistName = watchlistName + ' (Copy)';
        var cnt = 1;
        while (!_this.ValidateWatchlistName(0, newWatchlistName)) {
          newWatchlistName = watchlistName + ' (Copy) ' + cnt;
          cnt++;
        }
        if (window.userIsOnline) {
          $.ajax({
            url: '/api/live-chart/duplicate-watchlist',
            data: JSON.stringify({
              WatchlistId: watchlistId,
              NewName: newWatchlistName,
              Order: _this._watchlists.length + 1
            }),
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            cache: false,
            type: 'POST',
            success: function success(result) {
              if (!result.success) {
                if (result.message) toastr.error(result.message);else toastr.error(window.WatchlistResxStrings['FailedToSaveWatchlist']);
                return;
              }
              var newWatchlist = {
                Id: result.watchlistId,
                Name: newWatchlistName,
                Order: _this._watchlists.length + 1,
                CreatedAt: Math.floor(Date.now() / 1000),
                // Current timestamp in seconds
                Symbols: []
              };
              newWatchlist.Symbols = watchlist.Symbols.map(function (symbol) {
                return {
                  Ticker: symbol.Ticker,
                  Symbol: symbol.Symbol,
                  Exchange: symbol.Exchange,
                  CreatedAt: symbol.CreatedAt || Math.floor(Date.now() / 1000),
                  // Current timestamp in seconds
                  LastViewedAt: symbol.LastViewedAt || Math.floor(Date.now() / 1000) // Current timestamp in seconds
                };
              });
              _this._watchlists.push(newWatchlist);
              _this.SaveWatchlistToCache();
              _this.RenderTopMenuWatchListDropdown();
              _this._watchlistSymbolSelectBoxControl.chartSymbolSearch('updateWatchlistDropdown', _this);
              _this.OpenWatchListMngDialog(newWatchlist.Id);
            },
            error: function error(_error) {
              toastr.error(window.WatchlistResxStrings['FailedToSaveWatchlist']);
            }
          });
        }
      }
    }
  }, {
    key: "OpenWatchlistMngAllDialog",
    value: function OpenWatchlistMngAllDialog() {
      this.RenderManageAllWatchlistsDialog();
      this.InitWatchlistDeleteButton();
      $(".watchlist-all-mng-dialog").modal('show');
    }
  }, {
    key: "OpenWatchListMngDialog",
    value: function OpenWatchListMngDialog(watchlistId) {
      this.RenderWatchlistMngDialog(watchlistId);

      // Open the watchlist management dialog
      $('.watchlist-mng-dialog').modal('show');
      this.InitWatchlistDeleteButton();
    }
  }, {
    key: "RenderWatchlistMngDialog",
    value: function RenderWatchlistMngDialog(watchlistId) {
      this._currentManagingWatchlistId = watchlistId;
      this.RenderWatchlistMngDialogWatchlistDropdown(watchlistId);
      this.RenderWatchlistMngDialogSymbols(watchlistId);
      this._watchlistSymbolSelectBoxControl.chartSymbolSearch('updateWatchlistDropdown', this);
      this._watchlistSymbolSelectBoxControl.chartSymbolSearch('setSymbol', '', 'SEARCH');
    }
  }, {
    key: "RenderWatchlistMngDialogSymbols",
    value: function RenderWatchlistMngDialogSymbols(watchlistId) {
      var watchlist = this.GetWatchlistById(watchlistId);
      var html = '';
      var _iterator = _createForOfIteratorHelper(watchlist.Symbols),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var symbol = _step.value;
          html += '<div class="item" data-id="' + symbol.Ticker + '">';
          html += '<div class="watchlist-mng-item-star filled" data-action="remove-symbol-from-watchlist"></div>';
          html += '<span data-action="remove-symbol-from-watchlist">' + symbol.Symbol + '</span>';
          html += '</div>';
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      $(".watchlist-mng-dialog .watchlist-mng-items-container").html(html);
      this.InitSymbolRemoveButton();
    }
  }, {
    key: "LoadWatchlistFromCache",
    value: function LoadWatchlistFromCache() {
      var _this2 = this;
      this._sortOption = localStorage.getItem('ntvc-watchlist-sort-option') || 'recent';
      this._activeWatchlistName = localStorage.getItem('ntvc-active-watchlist-name');
      // restore whether the user had the recent-symbols mode enabled
      try {
        var recentMode = localStorage.getItem('ntvc-recent-symbols-mode');
        this._isRecentSymbolsMode = recentMode === '1';
      } catch (e) {
        this._isRecentSymbolsMode = false;
      }
      var watchlistStr = window.localStorage.getItem(this._cacheKeyName);
      if (!watchlistStr && window.localStorage.getItem(this._oldCacheKeyName)) {
        window.localStorage.removeItem(this._oldCacheKeyName);
      }
      try {
        this._watchlists = JSON.parse(watchlistStr);
      } catch (e) {
        console.error("Failed to parse watchlists from cache:", e);
      }
      if (!this._watchlists) this._watchlists = [];
      if (this._watchlists.length == 0) {
        this._watchlists.push({
          Id: 0,
          IsDefault: true,
          Name: "My Favorites",
          Order: 0,
          Symbols: []
        });
      }
      if (this._watchlists.length > 0 && this._watchlists.find(function (wl) {
        return wl.Name === _this2._activeWatchlistName;
      }) == null) {
        this._activeWatchlistName = this._watchlists[0].Name;
      }
    }
  }, {
    key: "LoadRecentSymbolsFromCache",
    value: function LoadRecentSymbolsFromCache() {
      var _this3 = this;
      var recentSymbolsStr = window.localStorage.getItem(this._recentSymbolsCacheKey);
      if (!recentSymbolsStr) {
        this.LoadRecentSymbolsFromOldCache();
      } else {
        this._recentSymbols = JSON.parse(recentSymbolsStr);
      }

      // Ensure recent symbols are unique by ticker
      var uniqueRecentSymbols = [];
      var seenTickers = new Set();
      var _iterator2 = _createForOfIteratorHelper(this._recentSymbols),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var symbol = _step2.value;
          if (!seenTickers.has(symbol.Ticker)) {
            seenTickers.add(symbol.Ticker);
            uniqueRecentSymbols.push(symbol);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this._recentSymbols = uniqueRecentSymbols;

      // append default symbols to recent symbols if length is less than 30
      var _iterator3 = _createForOfIteratorHelper(this._defaultSymbols),
        _step3;
      try {
        var _loop = function _loop() {
          var defaultSymbol = _step3.value;
          if (!_this3._recentSymbols.find(function (item) {
            return item.Symbol === defaultSymbol.Symbol;
          })) {
            _this3._recentSymbols.push({
              Ticker: defaultSymbol.Ticker,
              Symbol: defaultSymbol.Symbol,
              Exchange: defaultSymbol.Exchange
            });
          }
          if (_this3._recentSymbols.length >= 23) return 1; // break
        };
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          if (_loop()) break;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "LoadRecentSymbolsFromOldCache",
    value: function LoadRecentSymbolsFromOldCache() {
      var calcsStr = localStorage.getItem('calcs');
      if (!calcsStr) return;
      var calcConfig = JSON.parse(calcsStr);
      if (calcConfig.tvHistory) {
        this._recentSymbols = calcConfig.tvHistory.filter(function (item) {
          return item.Ticker && item.Symbol;
        }) // Filter out items without Ticker or Symbol
        .map(function (item) {
          return {
            Ticker: item.Ticker,
            Symbol: item.Symbol,
            Exchange: item.Ticker ? item.Ticker.split(':')[0] : '',
            LastViewedAt: Math.floor(Date.now() / 1000) // Current timestamp in seconds
          };
        });
        calcConfig['tvHistory'] = null;
        localStorage.setItem('calcs', JSON.stringify(calcConfig)); // Update the calcs with the new tvHistory

        this._recentSymbols = this._recentSymbols.slice(0, 23);
        localStorage.setItem(this._recentSymbolsCacheKey, JSON.stringify(this._recentSymbols)); // Save the recent symbols to cache
      }
    }
  }, {
    key: "SyncWatchListSymbols",
    value: function SyncWatchListSymbols() {
      var _this = this;
      var langSlug = "";
      if (window.CURRENT_LANG != "en") langSlug = "/" + window.CURRENT_LANG;
      if (window.userIsOnline) {
        $.ajax({
          url: langSlug + '/api/live-chart/sync-watch-list',
          contentType: "application/json; charset=utf-8",
          dataType: 'json',
          cache: false,
          type: 'POST',
          success: function success(result) {
            if (result && result.success) {
              _this._watchlists = result.watchlists;
              if (_this._watchlists.length > 0 && _this._watchlists.find(function (wl) {
                return wl.Name === _this._activeWatchlistName;
              }) == null) {
                _this._activeWatchlistName = _this._watchlists[0].Name;
              }
              _this.SaveWatchlistToCache();
              _this.RenderWatchlistComponents();
            }
          },
          error: function error(_error2) {}
        });
      }
    }
  }, {
    key: "SyncRecentSymbols",
    value: function SyncRecentSymbols() {
      var _this = this;
      if (window.userIsOnline) {
        $.ajax({
          url: '/api/chart-history',
          contentType: "application/json; charset=utf-8",
          dataType: 'json',
          cache: false,
          type: 'GET',
          success: function success(result) {
            if (result && !result.error) {
              var _loop2 = function _loop2() {
                var item = result.list[i];

                // remote existing symbols from recent list
                _this._recentSymbols = _this._recentSymbols.filter(function (x) {
                  return x.Symbol != item.Symbol && x.Ticker != item.Ticker;
                });

                // add to recent symbols at the top of the list
                _this._recentSymbols.unshift({
                  Ticker: item.Ticker,
                  Symbol: item.Symbol,
                  Exchange: item.Exchange,
                  LastViewedAt: item.LastViewedAt
                });
              };
              for (var i = result.list.length - 1; i >= 0; i--) {
                _loop2();
              }
              _this._recentSymbols = _this._recentSymbols.slice(0, 23);
              localStorage.setItem(_this._recentSymbolsCacheKey, JSON.stringify(_this._recentSymbols));
            }
          },
          error: function error(_error3) {}
        });
      }
    }
  }, {
    key: "SaveWatchlistToCache",
    value: function SaveWatchlistToCache() {
      // Save the watchlists to local storage
      localStorage.setItem(this._cacheKeyName, JSON.stringify(this._watchlists));
      localStorage.setItem('ntvc-active-watchlist-name', this._activeWatchlistName);
      // persist the recent symbols mode so the UI can restore it after refresh
      localStorage.setItem('ntvc-recent-symbols-mode', this._isRecentSymbolsMode ? '1' : '0');
    }
  }, {
    key: "GetWatchLists",
    value: function GetWatchLists() {
      return this._watchlists;
    }
  }, {
    key: "GetActiveWatchlistName",
    value: function GetActiveWatchlistName() {
      return this._activeWatchlistName;
    }
  }, {
    key: "GetActiveWatchlistId",
    value: function GetActiveWatchlistId() {
      return this.GetActiveWatchlist().Id;
    }
  }, {
    key: "GetActiveWatchlist",
    value: function GetActiveWatchlist() {
      var _this4 = this;
      return this._watchlists.find(function (wl) {
        return wl.Name === _this4._activeWatchlistName;
      }) || {
        Symbols: []
      };
    }
  }, {
    key: "GetWatchlistByName",
    value: function GetWatchlistByName(watchlistName) {
      return this._watchlists.find(function (wl) {
        return wl.Name === watchlistName;
      }) || {
        Symbols: []
      };
    }
  }, {
    key: "GetWatchlistById",
    value: function GetWatchlistById(watchlistId) {
      return this._watchlists.find(function (wl) {
        return wl.Id === watchlistId;
      }) || {
        Symbols: []
      };
    }
  }, {
    key: "GetRecentSymbols",
    value: function GetRecentSymbols() {
      return this._recentSymbols;
    }
  }, {
    key: "AddSymbolToWatchlist",
    value: function AddSymbolToWatchlist(watchlistId, ticker, symbol, exchange) {
      var _this = this;
      var watchlist = this._watchlists.find(function (wl) {
        return wl.Id === watchlistId;
      });
      if (watchlist) {
        if (!this.IsSymbolInWatchlist(watchlist.Name, ticker, symbol)) {
          watchlist.Symbols.push({
            Ticker: ticker,
            Symbol: symbol,
            Exchange: exchange,
            CreatedAt: Math.floor(Date.now() / 1000),
            // Current timestamp in seconds
            LastViewedAt: Math.floor(Date.now() / 1000) // Current timestamp in seconds
          });
        }
      } else {
        console.error("Watchlist ".concat(watchlistName, " not found"));
      }
      // Save the updated watchlists to local storage
      this.SaveWatchlistToCache();
      this.RenderWatchlistMngDialogSymbols(watchlistId);
      if (window.userIsOnline) {
        $.ajax({
          url: '/api/live-chart/add-symbol-to-watchlist',
          data: JSON.stringify({
            WatchlistId: watchlist.Id,
            Ticker: ticker,
            Symbol: symbol,
            Exchange: exchange
          }),
          contentType: "application/json; charset=utf-8",
          dataType: 'json',
          cache: false,
          type: 'POST',
          success: function success(result) {
            if (!result.success) {
              if (result.message) toastr.error(result.message);else toastr.error(window.WatchlistResxStrings['FailedToSaveWatchlist']);
              return;
            }
            _this.AfterWatchListUpdated(watchlistId);
          },
          error: function error(_error4) {
            toastr.error(window.WatchlistResxStrings['FailedToSaveWatchlist']);
          }
        });
      }
    }
  }, {
    key: "AfterWatchListUpdated",
    value: function AfterWatchListUpdated(watchlistId) {
      var watchlist = this._watchlists.find(function (wl) {
        return wl.Id === watchlistId;
      });
      if (watchlist.Name == this._activeWatchlistName) {
        this.RenderTopMenuWatchListContent();
        if ($(".chart-history-view").length > 0) {
          UpdateChartPageRecentWatchlistBar();
        }
        if ($("#add-watch-list").length > 0) {
          UpdateChartPageWatchlistIcon();
        }
      }
    }
  }, {
    key: "RemoveSymbolFromWatchList",
    value: function RemoveSymbolFromWatchList(watchlistId, ticker) {
      // Perform the logic to remove the symbol from the watchlist

      // Remove the symbol from the watchlist
      var watchlist = this._watchlists.find(function (wl) {
        return wl.Id === watchlistId;
      });
      if (watchlist) {
        var index = watchlist.Symbols.findIndex(function (symbol) {
          return symbol.Ticker === ticker;
        });
        if (index !== -1) {
          watchlist.Symbols.splice(index, 1);
        } else {
          console.error("Symbol ".concat(ticker, " not found in watchlist ").concat(watchlistId));
        }
      } else {
        console.error("Watchlist ".concat(watchlistId, " not found"));
      }

      // Save the updated watchlists to local storage
      this.SaveWatchlistToCache();
      this.AfterWatchListUpdated(watchlistId);
      if (window.userIsOnline) {
        $.ajax({
          url: '/api/live-chart/remove-symbol-from-watchlist',
          data: JSON.stringify({
            WatchlistId: watchlist.Id,
            Ticker: ticker
          }),
          contentType: "application/json; charset=utf-8",
          dataType: 'json',
          cache: false,
          type: 'POST',
          success: function success(result) {
            if (!result.success) {
              if (result.message) toastr.error(result.message);else toastr.error(window.WatchlistResxStrings['FailedToSaveWatchlist']);
            }
          },
          error: function error(_error5) {
            toastr.error(window.WatchlistResxStrings['FailedToSaveWatchlist']);
          }
        });
      }
    }
  }, {
    key: "RenameWatchlist",
    value: function RenameWatchlist(watchlistId, newName) {
      // Perform the logic to rename the watchlist
      // Rename the watchlist
      var watchlist = this._watchlists.find(function (wl) {
        return wl.Id == watchlistId;
      });
      if (!watchlist) {
        console.error("Watchlist ".concat(watchlistId, " not found"));
        return false;
      }
      var orgWatchlistName = watchlist.Name;
      watchlist.Name = newName;
      if (orgWatchlistName == this._activeWatchlistName) {
        this._activeWatchlistName = newName;
      }

      // Save the updated watchlists to local storage
      this.SaveWatchlistToCache();
      this.RenderTopMenuWatchListDropdown();
      this._watchlistSymbolSelectBoxControl.chartSymbolSearch('updateWatchlistDropdown', this);
      if (window.userIsOnline) {
        $.ajax({
          url: '/api/live-chart/rename-watchlist',
          data: JSON.stringify({
            WatchlistId: watchlist.Id,
            NewName: newName
          }),
          contentType: "application/json; charset=utf-8",
          dataType: 'json',
          cache: false,
          type: 'POST',
          success: function success(result) {
            if (!result.success) {
              if (result.message) toastr.error(result.message);else toastr.error(window.WatchlistResxStrings['FailedToSaveWatchlist']);
            }
          },
          error: function error(_error6) {
            toastr.error(window.WatchlistResxStrings['FailedToSaveWatchlist']);
          }
        });
      }
    }
  }, {
    key: "DeleteWatchlist",
    value: function DeleteWatchlist(watchlistName) {
      // Perform the logic to delete the watchlist

      var watchlist = this._watchlists.find(function (wl) {
        return wl.Name === watchlistName;
      });
      if (watchlist.IsDefault) {
        toastr.error(window.WatchlistResxStrings['DefaultWatchlistCanNotBeDeleted']);
        return;
      }

      // Delete the watchlist
      var index = this._watchlists.findIndex(function (wl) {
        return wl.Name === watchlistName;
      });
      if (index !== -1) {
        this._watchlists.splice(index, 1);
      } else {
        console.error("Watchlist ".concat(watchlistName, " not found"));
      }
      if (watchlistName == this._activeWatchlistName) {
        this.SetActiveWatchlist(this._watchlists[0].Name);
      } else {
        // Save the updated watchlists to local storage
        this.SaveWatchlistToCache();
      }
      this.RenderTopMenuWatchListDropdown();
      if (window.userIsOnline) {
        $.ajax({
          url: '/api/live-chart/delete-watchlist',
          data: JSON.stringify({
            WatchlistId: watchlist.Id
          }),
          contentType: "application/json; charset=utf-8",
          dataType: 'json',
          cache: false,
          type: 'POST',
          success: function success(result) {
            if (!result.success) {
              if (result.message) toastr.error(result.message);else toastr.error(window.WatchlistResxStrings['FailedToSaveWatchlist']);
            }
          },
          error: function error(_error7) {
            toastr.error(window.WatchlistResxStrings['FailedToSaveWatchlist']);
          }
        });
      }
    }
  }, {
    key: "SetActiveWatchlist",
    value: function SetActiveWatchlist(watchlistName) {
      this._activeWatchlistName = watchlistName;
      this.SaveWatchlistToCache();
      this.RenderTopMenuWatchListContent();
      UpdateChartPageRecentWatchlistBar();
    }
  }, {
    key: "IsSymbolInWatchlist",
    value: function IsSymbolInWatchlist(watchlistName, ticker, symbol) {
      var watchlist = this._watchlists.find(function (wl) {
        return wl.Name === watchlistName;
      });
      if (watchlist != null && Array.isArray(watchlist.Symbols)) {
        return watchlist.Symbols.find(function (item) {
          return item.Ticker === ticker;
        }) != null;
      }
      return false;
    }
  }, {
    key: "InitializeWatchListPopover",
    value: function InitializeWatchListPopover() {
      $('[data-toggle = "top-menu-watchlist-icon-popover"]').popover('dispose');
      $('[data-toggle="top-menu-watchlist-icon-popover"]').popover({
        html: true,
        trigger: "manual",
        placement: "bottom",
        boundary: "viewport",
        template: '<div class="popover watchlist-popover-wrapper" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
        content: function content() {
          var out = $('#live-chart-watch-list-popover-container').html();
          return out;
        }
      }).on("mouseenter", function () {
        var _this = this;
        $(this).popover("show");
        setTimeout(function () {
          $(".tooltip").remove();
          $("#live-chart-watch-list-popover-payload a").tooltip('dispose').tooltip({
            boundary: 'window'
          });
        }, 300);
        $(".popover").on("mouseleave", function () {
          if (!$(".tooltip:hover").length) {
            $(_this).popover('hide');
          }
        });
      }).on("mouseleave", function () {
        var _this = this;
        setTimeout(function () {
          if (!$(".popover:hover").length) {
            $(_this).popover("hide");
          }
        }, 100);
      });
    }
  }, {
    key: "RenderWatchlistComponents",
    value: function RenderWatchlistComponents() {
      // this.RenderDialogWatchlistSortable();

      this.RenderTopMenuWatchListDropdown();
      this.RenderTopMenuWatchListContent();

      // if user is on chart page, update chart page watchlist bar and icon

      if ($(".chart-history-view").length > 0) {
        UpdateChartPageRecentWatchlistBar();
      }
      if ($("#add-watch-list").length > 0) {
        UpdateChartPageWatchlistIcon();
      }
      this._watchlistSymbolSelectBoxControl.chartSymbolSearch('updateWatchlistDropdown', this);
    }
  }, {
    key: "UpdateWatchlistMngDialogButtonStates",
    value: function UpdateWatchlistMngDialogButtonStates() {
      var watchlist = this.GetWatchlistById(this._currentManagingWatchlistId);
      if (watchlist.IsDefault) {
        // set the edit and delete button disabled
        $('a[data-action="delete-watchlist"]').attr('disabled', 'disabled');
      } else {
        // enable the edit and delete button
        $('a[data-action="delete-watchlist"]').removeAttr('disabled');
      }
    }
  }, {
    key: "RenderWatchlistMngDialogWatchlistDropdown",
    value: function RenderWatchlistMngDialogWatchlistDropdown(watchlistId) {
      var html = '';
      var watchlists = this.GetWatchLists();
      for (var i = 0; i < watchlists.length; i++) {
        var item = watchlists[i];
        html += "<a class=\"dropdown-item\" href=\"javascript:void(0);\" data-watchlist=\"".concat(item.Name, "\" data-watchlistid=\"").concat(item.Id, "\">").concat(item.Name, "</a>");
      }
      var selectedWatchlistName = '';
      if (watchlistId) {
        var watchlist = this.GetWatchlistById(watchlistId);
        selectedWatchlistName = watchlist.Name;
      } else {
        var _watchlist2 = this.GetActiveWatchlist();
        selectedWatchlistName = _watchlist2.Name;
        watchlistId = _watchlist2.Id;
      }
      $(".watchlist-dlg-watchlist-popover-dropdown .dropdown-toggle").text(selectedWatchlistName);
      $(".watchlist-dlg-watchlist-popover-dropdown .dropdown-menu").html(html);
      this.UpdateWatchlistMngDialogButtonStates();
    }
  }, {
    key: "RenderDialogWatchlistSortable",
    value: function RenderDialogWatchlistSortable() {
      var _this = this;
      var html = '';
      for (var i = 0; i < this._watchlists.length; i++) {
        html += '<div class="item" draggable="true" data-id="' + this._watchlists[i].Name + '">';
        if (this.IsSymbolInWatchlist(this._watchlists[i].Name, this._currentSelectedSymbol.ticker, this._currentSelectedSymbol.symbol)) {
          html += '<div class="watchlist-mng-item-star filled" data-action="watchlist-add-or-remove"></div>';
        } else {
          html += '<div class="watchlist-mng-item-star" data-action="watchlist-add-or-remove"></div>';
        }
        html += '<span data-action="watchlist-add-or-remove">' + this._watchlists[i].Name + '</span>';
        html += '<div class="drag-handle"></div>';
        html += '</div>';
      }
      $("#sortable-watchlist-mng-item-container").html(html);
      if (_this._watchlistsSortableControl != null) {
        _this._watchlistsSortableControl.destroy();
      }
      _this._watchlistsSortableControl = new Sortable(document.getElementById('sortable-watchlist-mng-item-container'), {
        animation: 150,
        handle: '.drag-handle',
        onEnd: function onEnd(evt) {
          var items = Array.from(evt.from.children);
          var order = items.map(function (item, index) {
            return item.getAttribute('data-id');
          });
          _this.UpdateWatchlistOrder(order);
        }
      });
    }
  }, {
    key: "RenderManageAllWatchlistsDialog",
    value: function RenderManageAllWatchlistsDialog() {
      var html = '';
      for (var i = 0; i < this._watchlists.length; i++) {
        html += '<div class="item" data-id="' + this._watchlists[i].Id + '">';
        html += '<div class="watchlist-mng-item-star filled"></div>';
        html += '<span>' + this._watchlists[i].Name + '</span>';
        html += "<div class=\"d-flex\" style=\"gap: 8px\">\n                        <a href=\"javascript:void(0);\" class=\"std-btn tertiary icon\" title=\"Edit\" data-action=\"edit-watchlist\" data-dismiss=\"modal\"><img src=\"/content/dist/images/icons/pen.svg\" /></a>\n                        <a href=\"javascript:void(0);\" class=\"std-btn tertiary icon\" title=\"Duplicate\" data-action=\"duplicate-watchlist\" data-dismiss=\"modal\"><img src=\"/content/dist/images/icons/duplicate.svg\" /></a>\n                        <a href=\"javascript:void(0);\" class=\"std-btn tertiary icon\" title=\"Delete\" data-action=\"delete-watchlist\" data-id=\"".concat(this._watchlists[i].Id, "\"><img src=\"/content/dist/images/icons/delete-trash.svg\" /></a>\n                    </div>");
        html += '</div>';
      }
      $(".watchlist-all-mng-dialog .watchlist-mng-items-container").html(html);
      this.UpdateWatchlistSortOptionDropdownState();
    }
  }, {
    key: "UpdateWatchlistSortOptionDropdownState",
    value: function UpdateWatchlistSortOptionDropdownState() {
      if (this._sortOption == 'recent') {
        $(".watchlist-all-mng-dialog .watchlist-symbol-sort-dropdown .dropdown-toggle").html(window.WatchlistResxStrings['MostRecent']);
      } else {
        $(".watchlist-all-mng-dialog .watchlist-symbol-sort-dropdown .dropdown-toggle").html(window.WatchlistResxStrings['Alphabetical']);
      }
    }
  }, {
    key: "NewWatchlist",
    value: function NewWatchlist(symbolInfo) {
      var _this = this;
      var cnt = this._watchlists.length + 1;
      var newWatchlistName = "Watchlist " + cnt;
      while (!this.ValidateWatchlistName(0, newWatchlistName)) {
        newWatchlistName = "Watchlist " + cnt;
        cnt++;
      }
      if (window.userIsOnline) {
        $.ajax({
          url: '/api/live-chart/add-watchlist',
          data: JSON.stringify({
            NewName: newWatchlistName,
            Order: _this._watchlists.length + 1
          }),
          contentType: "application/json; charset=utf-8",
          dataType: 'json',
          cache: false,
          type: 'POST',
          success: function success(result) {
            if (!result.success) {
              if (result.message) toastr.error(result.message);else toastr.error(window.WatchlistResxStrings['FailedToSaveWatchlist']);
            }
            var newWatchlist = {
              Id: result.watchlistId,
              Name: newWatchlistName,
              IsDefault: false,
              Order: _this._watchlists.length + 1,
              CreatedAt: Math.floor(Date.now() / 1000),
              // Current timestamp in seconds
              Symbols: []
            };
            _this._watchlists.push(newWatchlist);
            _this.SaveWatchlistToCache();
            _this.RenderTopMenuWatchListDropdown();
            _this._watchlistSymbolSelectBoxControl.chartSymbolSearch('updateWatchlistDropdown', _this);
            if (symbolInfo) {
              _this.AddSymbolToWatchlist(newWatchlist.Id, symbolInfo.ticker, symbolInfo.symbol, symbolInfo.exchange);
            }
            _this.OpenWatchListMngDialog(newWatchlist.Id);
          },
          error: function error(_error8) {
            toastr.error(window.WatchlistResxStrings['FailedToSaveWatchlist']);
          }
        });
      }
    }
  }, {
    key: "SelectDialogEditableWatchlist",
    value: function SelectDialogEditableWatchlist(watchlistName) {
      // select the watchlist in the dialog watchlist select
      if (this._watchlists.find(function (watchlist) {
        return watchlist.Name === watchlistName;
      }) != null) {
        $("#watchlist-mng-select .dropdown-toggle").text(watchlistName);
      }
    }
  }, {
    key: "RenderTopMenuWatchListDropdown",
    value: function RenderTopMenuWatchListDropdown() {
      var html = '';
      var watchlists = this.GetWatchLists();
      for (var i = 0; i < watchlists.length; i++) {
        var item = watchlists[i];
        html += "<a class=\"dropdown-item\" href=\"javascript:void(0);\" data-watchlist=\"".concat(item.Name, "\">").concat(item.Name, "</a>");
      }
      if (window.userIsOnline) {
        html += "<div class=\"management-items\">";
        html += "<div class=\"dropdown-divider\"></div>";
        html += "<a class=\"dropdown-item manage-item\" href=\"javascript:void(0);\" data-action=\"manage-watchlist\">".concat(window.WatchlistResxStrings['ManageWatchlists'], "</a>");
        if (this._sortOption == 'recent') {
          html += "<a class=\"dropdown-item manage-item\" href=\"javascript:void(0);\" data-action=\"sort-symbols\" data-order=\"alphabetical\">".concat(window.WatchlistResxStrings['SortByAlphabetical'], "</a>");
        } else {
          html += "<a class=\"dropdown-item manage-item\" href=\"javascript:void(0);\" data-action=\"sort-symbols\" data-order=\"recent\">".concat(window.WatchlistResxStrings['SortByRecent'], "</a>");
        }
        html += "</div>";

        // Show recent symbols label on the toggle if recent mode is enabled
        var toggleText = this._isRecentSymbolsMode ? window.WatchlistResxStrings['RecentSymbols'] : this.GetActiveWatchlistName();
        $(".live-chart-watch-list-popover-dropdown .dropdown-toggle").text(toggleText);
        $(".live-chart-watch-list-popover-dropdown .dropdown-menu").html(html);
        $(".live-chart-content .live-chart-watch-list-popover-dropdown .dropdown-menu .management-items").before("<a class=\"dropdown-item\" href=\"javascript:void(0);\" data-action=\"recent-symbols\">".concat(window.WatchlistResxStrings['RecentSymbols'], "</a>"));
      } else {
        $(".live-chart-content .live-chart-watch-list-popover-dropdown .dropdown-toggle").text(window.WatchlistResxStrings['RecentSymbols']);
        $(".live-chart-content .live-chart-watch-list-popover-dropdown .dropdown-menu").html("<a class=\"dropdown-item\" href=\"javascript:void(0);\" data-action=\"recent-symbols\">".concat(window.WatchlistResxStrings['RecentSymbols'], "</a><div class=\"management-items\"><div class=\"dropdown-divider\"></div><a class=\"dropdown-item manage-item\" href=\"javascript:void(0);\" data-action=\"manage-watchlist\">").concat(window.WatchlistResxStrings['ManageWatchlists'], "</a></div>"));
      }
    }
  }, {
    key: "RenderTopMenuWatchListContent",
    value: function RenderTopMenuWatchListContent() {
      if (!window.userIsOnline) return;
      var _this = this;
      var langSlug = "";
      if (window.CURRENT_LANG != "en") langSlug = "/" + window.CURRENT_LANG;
      var activeWatchlist = this.GetActiveWatchlist();
      var watchlistItems = [].concat(activeWatchlist.Symbols);
      watchlistItems.sort(function (a, b) {
        return _this.CompareWatchlistItemBySortMethod(a, b);
      });
      var content = '';
      for (var i = 0; i < watchlistItems.length; i++) {
        var ticker = watchlistItems[i].Ticker;
        if (!ticker) ticker = watchlistItems[i].Symbol;
        var searchText = (watchlistItems[i].Symbol + watchlistItems[i].Symbol.replace("/", "") + watchlistItems[i].Exchange).toLowerCase();
        content += "<div class=\"watch-list-item\" data-ticker=\"".concat(ticker, "\" data-symbol=\"").concat(watchlistItems[i].Symbol, "\" data-exchange=\"").concat(watchlistItems[i].Exchange, "\" data-text=\"").concat(searchText, "\">");
        content += "<a href=\"javascript:void(0);\" data-toggle=\"tooltip\" data-title=\"".concat(window.WatchlistResxStrings['ManageWatchlist'], "\">");
        content += '<img src="/Content/dist/images/icons/star-filled.svg" />';
        content += "</a>";
        var exchange = watchlistItems[i].Exchange;
        var slug = GenerateNewLiveChartUrlParam(exchange, watchlistItems[i].Symbol, '1h');
        content += '<a href="' + langSlug + '/chart' + slug + '" onclick="return NewLiveChartSwitchSymbol(' + "'" + ticker + "', '" + watchlistItems[i].Symbol + "'" + '); ">';
        if (CountWatchListItem(watchlistItems, watchlistItems[i].Symbol) > 1) {
          content += watchlistItems[i].Exchange + "<br/>";
        }
        content += watchlistItems[i].Symbol;
        content += "</a></div>";
      }
      $("#live-chart-watch-list-popover-payload").html(content);
      $(".popover-body #live-chart-watch-list-popover-payload").html(content);
      $("#live-chart-watch-list-icon").show();
    }
  }, {
    key: "VisitSymbol",
    value: function VisitSymbol(symbolInfo) {
      var ticker = symbolInfo.ticker;
      var symbol = symbolInfo.name;
      if (!symbol) symbol = symbolInfo.symbol;
      var exchange = symbolInfo.exchange;
      var hasUpdateOnWatchlist = false;
      var lastViewedAt = Math.floor(Date.now() / 1000); // Current timestamp in seconds
      for (var i = 0; i < this._watchlists.length; i++) {
        var watchlistItems = this._watchlists[i].Symbols;
        for (var j = 0; j < watchlistItems.length; j++) {
          if (watchlistItems[j].Ticker == ticker) {
            watchlistItems[j].LastViewedAt = lastViewedAt;
            hasUpdateOnWatchlist = true;
          }
        }
      }
      if (hasUpdateOnWatchlist) {
        this.SaveWatchlistToCache();
      }
      this.AddRecentSymbol(symbolInfo);
      if (window.userIsOnline) {
        $.ajax({
          url: '/api/live-chart/update-recent-symbols',
          data: JSON.stringify({
            ticker: ticker,
            symbol: symbol,
            exchange: exchange,
            lastViewedAt: lastViewedAt
          }),
          contentType: "application/json; charset=utf-8",
          dataType: 'json',
          cache: false,
          type: 'POST',
          success: function success(result) {
            if (!result.success) {
              if (result.message) toastr.error(result.message);else toastr.error(window.WatchlistResxStrings['FailedToSaveWatchlist']);
            }
          },
          error: function error(_error9) {
            toastr.error(window.WatchlistResxStrings['FailedToSaveWatchlist']);
          }
        });
      }
    }
  }, {
    key: "AddRecentSymbol",
    value: function AddRecentSymbol(symbolInfo) {
      var ticker = symbolInfo.ticker;
      var symbol = symbolInfo.name;
      var exchange = symbolInfo.exchange;
      if (!symbol) symbol = symbolInfo.symbol;

      // remote existing symbols from recent list
      this._recentSymbols = this._recentSymbols.filter(function (item) {
        return item.Symbol != symbol;
      });

      // add to recent symbols at the top of the list
      this._recentSymbols.unshift({
        Ticker: ticker,
        Symbol: symbol,
        Exchange: exchange,
        LastViewedAt: Math.floor(Date.now() / 1000) // Current timestamp in seconds
      });

      // Limit the number of recent symbols to 23
      // If the length exceeds 23, remove the oldest symbol
      this._recentSymbols = this._recentSymbols.slice(0, 23);

      // Save the updated recent symbols to local storage
      localStorage.setItem(this._recentSymbolsCacheKey, JSON.stringify(this._recentSymbols));
    }
  }, {
    key: "UpdateWatchlistOrder",
    value: function UpdateWatchlistOrder(order) {
      for (var i = 0; i < order.length; i++) {
        var watchlist = this._watchlists.find(function (wl) {
          return wl.Id == order[i];
        });
        if (watchlist) {
          watchlist.Order = i;
        } else {
          watchlist.Order = 10000;
        }
      }
      this._watchlists.sort(function (a, b) {
        return a.Order - b.Order;
      });
      this.SaveWatchlistToCache();
      this.RenderTopMenuWatchListDropdown();
      this._watchlistSymbolSelectBoxControl.chartSymbolSearch('updateWatchlistDropdown', this);
      if (window.userIsOnline) {
        var data = [];
        for (var i = 0; i < order.length; i++) {
          data.push({
            WatchlistId: order[i],
            Order: i
          });
        }
        $.ajax({
          url: '/api/live-chart/update-watchlist-orders',
          data: JSON.stringify(data),
          contentType: "application/json; charset=utf-8",
          dataType: 'json',
          cache: false,
          type: 'POST',
          success: function success(result) {
            if (!result.success) {
              if (result.message) toastr.error(result.message);else toastr.error(window.WatchlistResxStrings['FailedToSaveWatchlist']);
            }
          },
          error: function error(_error0) {
            toastr.error(window.WatchlistResxStrings['FailedToSaveWatchlist']);
          }
        });
      }
    }
  }, {
    key: "IsRecentSymbolsMode",
    value: function IsRecentSymbolsMode() {
      return this._isRecentSymbolsMode;
    }
  }, {
    key: "InitWatchlistDeleteButton",
    value: function InitWatchlistDeleteButton() {
      $('a[data-action="delete-watchlist"]').popover('dispose');
      $('a[data-action="delete-watchlist"]').popover({
        html: true,
        trigger: "manual",
        placement: 'bottom',
        content: function content() {
          var watchlistId = $(this).data('id');
          var isOnManageAllDialog = true;
          if (watchlistId === 'current') {
            watchlistId = window.WatchlistInstance._currentManagingWatchlistId;
            isOnManageAllDialog = false;
          }
          var confirmContent = '<div class="d-flex" style="gap: 8px;">';
          confirmContent += "<span>".concat(window.WatchlistResxStrings['AreYouSureYouWantToDeleteThisList'], "</span>");
          confirmContent += "<a href='javascript:void(0);' class='std-btn primary small' onclick='window.WatchlistInstance.ConfirmDeleteWatchlist(".concat(watchlistId, ", ").concat(isOnManageAllDialog, ");'>").concat(window.WatchlistResxStrings['Yes'], "</a>");
          confirmContent += "<a href='javascript:void(0);' class='std-btn secondary small' onclick='window.WatchlistInstance.HideDeleteConfirmPopover();'>".concat(window.WatchlistResxStrings['No'], "</a>");
          confirmContent += '</div>';
          return confirmContent;
        }
      }).off('click').on("click", function (e) {
        e.stopPropagation();
        var _this = this;
        $(this).popover("toggle");

        // Close popover when clicking outside
        $(document).on("click.popover", function () {
          $(_this).popover("hide");
          $(document).off("click.popover"); // Remove the event listener
        });
      });
    }
  }, {
    key: "InitSymbolRemoveButton",
    value: function InitSymbolRemoveButton() {
      $('[data-action="remove-symbol-from-watchlist"]').popover('dispose');
      $('[data-action="remove-symbol-from-watchlist"]').popover({
        html: true,
        trigger: "manual",
        placement: 'bottom',
        content: function content() {
          var item = $(this).closest('.item');
          var ticker = item.data('id');
          var confirmContent = '<div class="d-flex flex-column" style="gap: 8px;">';
          confirmContent += "<span>".concat(window.WatchlistResxStrings['AreYouSureYouWantToRemoveThisSymbol'], "</span>");
          confirmContent += '<div class="d-flex justify-content-end" style="gap: 8px;">';
          confirmContent += "<a href='javascript:void(0);' class='std-btn primary small' onclick='window.WatchlistInstance.ConfirmRemoveSymbolFromWatchlist(\"".concat(ticker, "\");'>").concat(window.WatchlistResxStrings['Yes'], "</a>");
          confirmContent += "<a href='javascript:void(0);' class='std-btn secondary small' onclick='window.WatchlistInstance.HideRemoveSymbolConfirmPopover();'>".concat(window.WatchlistResxStrings['No'], "</a>");
          confirmContent += '</div>';
          confirmContent += '</div>';
          return confirmContent;
        }
      }).off('click').on("click", function (e) {
        e.stopPropagation();
        var _this = this;
        $(this).popover("toggle");

        // Close popover when clicking outside
        $(document).on("click.popover", function () {
          $(_this).popover("hide");
          $(document).off("click.popover"); // Remove the event listener
        });
      });
    }
  }, {
    key: "OpenAddSymbolToWatchlistsDialog",
    value: function OpenAddSymbolToWatchlistsDialog(symbolInfo) {
      this._currentSelectedSymbol = {
        ticker: symbolInfo.ticker,
        symbol: symbolInfo.symbol,
        exchange: symbolInfo.exchange
      };
      this.RenderAddSymbolToWatchlistsDialog();
      $(".watchlist-saveto-dialog").modal('show');
    }
  }, {
    key: "RenderAddSymbolToWatchlistsDialog",
    value: function RenderAddSymbolToWatchlistsDialog() {
      var _this = this;
      var html = '';
      for (var i = 0; i < this._watchlists.length; i++) {
        html += '<div class="item" draggable="true" data-id="' + this._watchlists[i].Id + '">';
        if (this.IsSymbolInWatchlist(this._watchlists[i].Name, this._currentSelectedSymbol.ticker, this._currentSelectedSymbol.symbol)) {
          html += '<div class="watchlist-mng-item-star filled" data-action="watchlist-add-or-remove"></div>';
        } else {
          html += '<div class="watchlist-mng-item-star" data-action="watchlist-add-or-remove"></div>';
        }
        html += '<span data-action="watchlist-add-or-remove">' + this._watchlists[i].Name + '</span>';
        html += '<div class="drag-handle"></div>';
        html += '</div>';
      }
      $(".watchlist-saveto-dialog .watchlist-mng-items-container").html(html);
      if (_this._watchlistsSortableControl != null) {
        _this._watchlistsSortableControl.destroy();
      }
      _this._watchlistsSortableControl = new Sortable(document.querySelector('.watchlist-saveto-dialog .watchlist-mng-items-container'), {
        animation: 150,
        handle: '.drag-handle',
        onEnd: function onEnd(evt) {
          var items = Array.from(evt.from.children);
          var order = items.map(function (item, index) {
            return item.getAttribute('data-id');
          });
          _this.UpdateWatchlistOrder(order);
        }
      });
    }
  }, {
    key: "GetWatchlistSortOption",
    value: function GetWatchlistSortOption() {
      return this._sortOption || 'recent';
    }
  }, {
    key: "CompareWatchlistItemBySortMethod",
    value: function CompareWatchlistItemBySortMethod(a, b) {
      if (this._sortOption === 'recent') {
        return b.LastViewedAt - a.LastViewedAt; // Sort by LastViewedAt ascending
      } else if (this._sortOption === 'alphabetical') {
        return a.Symbol.localeCompare(b.Symbol); // Sort by Symbol alphabetically
      } else if (this._sortOption === 'user') {
        // sort by user definded order and then by alphabetical
        if (a.Order !== b.Order) return a.Order - b.Order;else return a.Symbol.localeCompare(b.Symbol); // If orders are equal, sort by Symbol alphabetically
      }
      return 0; // Default case, no sorting
    }
  }, {
    key: "UpdateWatchlistSortOption",
    value: function UpdateWatchlistSortOption(sortOption) {
      this._sortOption = sortOption;

      // Save the sort option to local storage
      localStorage.setItem('ntvc-watchlist-sort-option', sortOption);

      // Update the watchlist content based on the new sort option
      this.RenderTopMenuWatchListContent();
      UpdateChartPageRecentWatchlistBar();
      this.UpdateWatchlistSortOptionDropdownState();
      this.RenderTopMenuWatchListDropdown();
    }
  }, {
    key: "HasSymbolInWatchlists",
    value: function HasSymbolInWatchlists(ticker) {
      var _iterator4 = _createForOfIteratorHelper(this._watchlists),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var watchlist = _step4.value;
          if (watchlist.Symbols.find(function (symbol) {
            return symbol.Ticker === ticker;
          })) {
            return true;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return false;
    }
  }]);
}();

},{}],8:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function ($) {
  var methods = {
    init: function init(options) {
      var settings = {
        types: [],
        "default": '',
        url: '/api/widgets/currencies',
        placeholder: 'Select',
        btnClass: '',
        showDescription: false,
        culture: '',
        multiSelect: false,
        inputClass: 'form-control frn-override'
      };
      return this.each(function () {
        var _that$variables;
        //plugin goes here

        var $el = $(this);
        var that = this;
        if (!!$el.data('name')) settings.placeholder = $el.data('name');
        if (options) {
          $.extend(settings, options);
        }
        if (settings.multiSelect && !settings["default"]) {
          var cryptos = $el.val();
          var cryptoList = cryptos.split(',');
          var defaultCryptos = [];
          for (var i = 0; i < cryptoList.length; i++) {
            if (!!cryptoList[i]) defaultCryptos.push({
              value: cryptoList[i].toUpperCase(),
              description: ''
            });
          }
          settings["default"] = defaultCryptos;
        }

        // Initialize properties
        that.variables = {
          lastNumber: 10,
          lastPage: 0,
          pageCount: 1,
          isLoading: false,
          url: settings.url,
          showDescription: settings.showDescription,
          culture: settings.culture,
          multiSelect: settings.multiSelect,
          multiValues: [],
          inputClass: settings.inputClass,
          placeholder: settings.placeholder
        };
        that.LoadMore = LoadMore;
        that.Search = Search;
        that.UpdateSelectedValues = UpdateSelectedValues;
        that.RemoveValue = RemoveValue;
        $el.wrap('<div class="infinite-select-wrap">');
        if ((_that$variables = that.variables) !== null && _that$variables !== void 0 && _that$variables.multiSelect) {
          $el.after("<div class=\"infinite-select-dropdown dropdown-menu\"><div class=\"infinite-select-header\"><div class=\"infinite-selected-values\"><input type=\"text\" class=\"".concat(settings.inputClass, "\" autofocus/><span class=\"sizer\"></span></div><div class=\"infinite-select-options\"></div></div><div class=\"dropdown-items\"></div></div>")).after("<button class=\"infinite-select-button ".concat(settings.btnClass, "\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" data-display=\"static\">").concat(that.variables.multiSelect ? settings.placeholder : settings["default"] ? settings["default"] : that.variables.placeholder, "</button>"));
        } else {
          $el.after("<div class=\"infinite-select-dropdown dropdown-menu\"><div class=\"infinite-select-header\"><input type=\"text\" class=\"".concat(settings.inputClass, "\" autofocus/><div class=\"infinite-select-options\"></div></div><div class=\"dropdown-items\"></div></div>")).after("<button class=\"infinite-select-button ".concat(settings.btnClass, "\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" data-display=\"static\">").concat(that.variables.multiSelect ? settings.placeholder : settings["default"] ? settings["default"] : that.variables.placeholder, "</button>"));
        }
        var $parent = $el.parent();
        var $button = $parent.find('.infinite-select-button');
        var $header = $parent.find('.infinite-select-header');
        var $headerInput = $parent.find('.infinite-select-header input');
        var $headerOptions = $parent.find('.infinite-select-header .infinite-select-options');
        var $headerSelectedValues = $parent.find('.infinite-select-header .infinite-selected-values');
        var $dropdownList = $parent.find('.infinite-select-dropdown .dropdown-items');
        var $inputBoxResizer = $header.find('span.sizer');

        // Initialize options
        for (var i = 0; i < (settings.types || []).length; i++) {
          if (i == 0) $headerOptions.append('<button class="infinite-select-type active" data-value="' + settings.types[i].option + '">' + settings.types[i].text + '</button>');else $headerOptions.append('<button class="infinite-select-type" data-value="' + settings.types[i].option + '">' + settings.types[i].text + '</button>');
        }
        if (!!settings["default"]) {
          if (!that.variables.multiSelect) {
            $el.val(settings["default"]);
          } else {
            that.variables.multiValues = settings["default"];
            that.UpdateSelectedValues();
          }
        }

        // load initial data
        that.LoadMore(false, true, settings["default"]);
        $dropdownList.scroll(function () {
          if (this.offsetHeight + this.scrollTop + 5 >= this.scrollHeight) {
            if (that.variables.lastPage < that.variables.pageCount && !that.variables.isLoading) {
              that.LoadMore(false);
            }
          }
        });
        $dropdownList.on('click', '.dropdown-item', function (e) {
          var _that$variables2;
          $dropdownList.find('.dropdown-item').removeClass("active").removeClass("selected");
          var value = $(this).data('value');
          var description = $(this).data('description');
          $(this).addClass("active").addClass("selected");
          $headerInput.val('');
          if ((_that$variables2 = that.variables) !== null && _that$variables2 !== void 0 && _that$variables2.multiSelect) {
            var found = that.variables.multiValues.find(function (x) {
              return x.value == value;
            });
            if (!found) {
              that.variables.multiValues.push({
                value: value,
                description: description
              });
            }
            that.UpdateSelectedValues();
            e.stopPropagation();
            $headerInput.focus();
            that.Search();
          } else {
            var _that$variables3;
            if ((_that$variables3 = that.variables) !== null && _that$variables3 !== void 0 && _that$variables3.showDescription) {
              $button.html(description);
            } else {
              $button.html(value);
            }
            $el.val(value);
            that.dispatchEvent(new CustomEvent('change'));
          }
        });
        $dropdownList.on('click', '.dropdown-sticky-label', function (e) {
          e.stopPropagation();
        });
        $header.on('click', function (e) {
          e.stopPropagation();
        });
        $headerOptions.on('click', 'button', function (e) {
          $headerOptions.find('button').removeClass('active');
          $(this).addClass('active');
          that.Search(true);
        });
        $headerSelectedValues.on('click', 'button.close', function (e) {
          var removedValue = $(this).parent().data("value");
          that.RemoveValue(removedValue);
          $headerInput.focus();
        });
        $headerSelectedValues.on('click', function () {
          $headerInput.focus();
        });
        var timerid;
        $headerInput.on('input', function (e) {
          var value = $(this).val();
          //resize
          $inputBoxResizer.html(value);
          this.style = "width: ".concat($inputBoxResizer.width() + 16, "px !important;");
          if ($(this).data("lastval") != value) {
            $(this).data("lastval", value);
            clearTimeout(timerid);
            timerid = setTimeout(function () {
              //your change action goes here
              that.Search();
            }, 500);
          }
          ;
        });
        $headerInput.on('keyup', function (event) {
          if (event.key == 'Enter') {
            event.stopPropagation();
            $dropdownList.find('.dropdown-item.active').trigger('click');
          }
        });
        $parent.on('shown.bs.dropdown', function () {
          $headerInput.focus();
          $headerInput.select();
        });
        return $el;
      });
    },
    add: function add(value, desc) {
      this.each(function () {
        var that = this;
        if (!that.variables.multiSelect) return;
        if (!!that.variables.find(function (x) {
          return x.value == value;
        })) {
          that.variables.multiValues.push({
            value: value,
            description: desc
          });
          that.UpdateSelectedValues();
        }
      });
    },
    remove: function remove(value) {
      this.each(function () {
        var that = this;
        if (!that.variables.multiSelect) return;
        that.RemoveValue(value);
      });
    },
    val: function val(value, desc) {
      // set value

      if (!!value) {
        this.each(function () {
          var $el = $(this);
          var $button = $el.parent().find('.infinite-select-button');
          var that = this;
          var $dropdownList = $el.parent().find('.infinite-select-dropdown .dropdown-items');
          $dropdownList.find('.dropdown-item').removeClass("selected").removeClass("active");
          var $selected = $dropdownList.find('.dropdown-item[data-value="' + value + '"]');
          if ($selected.length > 0) {
            var _that$variables4;
            $selected.addClass("selected").addClass("active");
            if ((_that$variables4 = that.variables) !== null && _that$variables4 !== void 0 && _that$variables4.showDescription) {
              $button.html($selected.data('description'));
            } else {
              $button.html($selected.data('value'));
            }
          } else {
            var _that$variables5;
            if ((_that$variables5 = that.variables) !== null && _that$variables5 !== void 0 && _that$variables5.showDescription && desc) {
              $button.html(desc);
            } else {
              $button.html(value);
            }
          }
        });
        return this.val(value);
      } else {
        return this.val();
      }
    },
    description: function description() {
      var $el = this;
      var $button = $el.parent().find('.infinite-select-button');
      var $dropdownList = $el.parent().find('.infinite-select-dropdown .dropdown-items');
      var desc = $dropdownList.find('.dropdown-item.selected').data('description');
      if (!desc) {
        return $button.html();
      }
      return desc;
    },
    refresh: function refresh() {
      this.each(function () {
        var $el = $(this);
        var that = this;
        var $parent = $el.parent();
        var $button = $parent.find('.infinite-select-button');
        var $header = $parent.find('.infinite-select-header');
        var $headerInput = $parent.find('.infinite-select-header input');
        var $headerOptions = $parent.find('.infinite-select-header .infinite-select-options');
        var $headerSelectedValues = $parent.find('.infinite-select-header .infinite-selected-values');
        var $dropdownList = $parent.find('.infinite-select-dropdown .dropdown-items');
        var $inputBoxResizer = $header.find('span.sizer');
        $dropdownList.scroll(function () {
          if (this.offsetHeight + this.scrollTop + 5 >= this.scrollHeight) {
            if (that.variables.lastPage < that.variables.pageCount && !that.variables.isLoading) {
              that.LoadMore(false);
            }
          }
        });
        $dropdownList.on('click', '.dropdown-item', function (e) {
          var _that$variables6;
          $dropdownList.find('.dropdown-item').removeClass("active").removeClass("selected");
          var value = $(this).data('value');
          var description = $(this).data('description');
          $(this).addClass("active").addClass("selected");
          $headerInput.val('');
          if ((_that$variables6 = that.variables) !== null && _that$variables6 !== void 0 && _that$variables6.multiSelect) {
            var found = that.variables.multiValues.find(function (x) {
              return x.value == value;
            });
            if (!found) {
              that.variables.multiValues.push({
                value: value,
                description: description
              });
            }
            that.UpdateSelectedValues();
            e.stopPropagation();
            $headerInput.focus();
            that.Search();
          } else {
            var _that$variables7;
            if ((_that$variables7 = that.variables) !== null && _that$variables7 !== void 0 && _that$variables7.showDescription) {
              $button.html(description);
            } else {
              $button.html(value);
            }
            $el.val(value);
            that.dispatchEvent(new CustomEvent('change'));
          }
        });
        $dropdownList.on('click', '.dropdown-sticky-label', function (e) {
          e.stopPropagation();
        });
        $header.on('click', function (e) {
          e.stopPropagation();
        });
        $headerOptions.on('click', 'button', function (e) {
          $headerOptions.find('button').removeClass('active');
          $(this).addClass('active');
          that.Search(true);
        });
        $headerSelectedValues.on('click', 'button.close', function (e) {
          var removedValue = $(this).parent().data("value");
          that.RemoveValue(removedValue);
          $headerInput.focus();
        });
        $headerSelectedValues.on('click', function () {
          $headerInput.focus();
        });
        var timerid;
        $headerInput.on('input', function (e) {
          var value = $(this).val();
          //resize
          $inputBoxResizer.html(value);
          this.style = "width: ".concat($inputBoxResizer.width() + 16, "px !important;");
          if ($(this).data("lastval") != value) {
            $(this).data("lastval", value);
            clearTimeout(timerid);
            timerid = setTimeout(function () {
              //your change action goes here
              that.Search();
            }, 500);
          }
          ;
        });
        $headerInput.on('keyup', function (event) {
          if (event.key == 'Enter') {
            event.stopPropagation();
            $dropdownList.find('.dropdown-item.active').trigger('click');
          }
        });
        $parent.on('shown.bs.dropdown', function () {
          $headerInput.focus();
          $headerInput.select();
        });
      });
    }
  };
  $.fn.infiniteselect = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (_typeof(methodOrOptions) === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      console.log("Method " + methodOrOptions + ' does not exist on jQuery.infiniteselect');
    }
  };
  function LoadMore() {
    var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var first = arguments.length > 1 ? arguments[1] : undefined;
    var defaultCurrency = arguments.length > 2 ? arguments[2] : undefined;
    var noSearchingLabel = arguments.length > 3 ? arguments[3] : undefined;
    var that = this;
    var $parent = $(that).parent();
    var $dropdown = $parent.find('.infinite-select-dropdown .dropdown-items');
    that.variables.isLoading = true;
    if (search && !noSearchingLabel) {
      $dropdown.find('span.loading').remove();
      $dropdown.prepend('<span class="dropdown-item loading">Searching ...</span>');
      $dropdown.scrollTop(0);
    } else {
      $dropdown.append('<span class="dropdown-item loading">Loading more ...</span>');
    }
    var query = $parent.find('.infinite-select-header input').val();
    var type = $parent.find('.infinite-select-header .infinite-select-options button.active').data('value');
    var url = that.variables.url;
    if (that.variables.culture) url = "/" + that.variables.culture + "/" + that.variables.url;
    $.ajax({
      url: url,
      type: 'GET',
      cache: true,
      data: {
        q: query,
        type: type,
        page: that.variables.lastPage + 1
      },
      success: function success(res) {
        var html = '';
        var flag = false;
        for (var i = 0; i < res.data.length; i++) {
          if (res.data[i]['GroupLabel'] == true) {
            if (search || $dropdown.find(".dropdown-sticky-label[data-value=\"".concat(res.data[i]['Code'], "\"]")).length == 0) {
              html += "<span class=\"dropdown-sticky-label\" data-value=\"".concat(res.data[i]['Code'], "\">").concat(res.data[i]['Name'], "</span>");
            }
          } else {
            if (first === true && !!defaultCurrency && res.data[i]["Code"] == defaultCurrency) {
              var _that$variables8;
              html += "<span class=\"dropdown-item active selected\" data-value=\"".concat(res.data[i]['Code'], "\" data-description=\"").concat(res.data[i]['Name'], "\"><span class=\"item-value\">").concat(res.data[i]['Code'], "</span><span class=\"item-description\">").concat(res.data[i]['Name'], "</span></span>");
              $(that).val(res.data[i]['Code']);
              var title = res.data[i]['Code'];
              if ((_that$variables8 = that.variables) !== null && _that$variables8 !== void 0 && _that$variables8.showDescription) title = res.data[i]['Name'];
              $(that).parent().find('.infinite-select-button').html(title);
            } else if (!flag && search) {
              html += "<span class=\"dropdown-item active\" data-value=\"".concat(res.data[i]['Code'], "\" data-description=\"").concat(res.data[i]['Name'], "\"><span class=\"item-value\">").concat(res.data[i]['Code'], "</span><span class=\"item-description\">").concat(res.data[i]['Name'], "</span></span>");
              flag = true;
            } else {
              html += "<span class=\"dropdown-item\" data-value=\"".concat(res.data[i]['Code'], "\" data-description=\"").concat(res.data[i]['Name'], "\"><span class=\"item-value\">").concat(res.data[i]['Code'], "</span><span class=\"item-description\">").concat(res.data[i]['Name'], "</span></span>");
            }
          }
        }
        if (search) {
          $dropdown.html(html);
        } else {
          $dropdown.append(html);
        }
        that.variables.pageCount = res.pageCount;
        that.variables.lastPage++;
      },
      complete: function complete() {
        $dropdown.find('span.loading').remove();
        that.variables.isLoading = false;
      }
    });
  }
  function Search(noSearchingLabel) {
    var that = this;
    that.variables.lastPage = 0;
    that.variables.pageCount = 1;
    that.LoadMore(true, false, "", noSearchingLabel);
  }
  function UpdateSelectedValues() {
    var that = this;
    var $parent = $(that).parent();
    var $selectedValueDiv = $parent.find('.infinite-select-dropdown .infinite-select-header .infinite-selected-values');
    var $button = $parent.find('.infinite-select-button');
    if (!that.variables.multiSelect) return;
    var valueList = that.variables.multiValues.map(function (x) {
      return x.value;
    });
    var descList = that.variables.multiValues.map(function (x) {
      return !x.description ? x.value : x.description;
    });
    var newValue = valueList.join();
    if (that.variables.multiValues.length > 0) {
      var div = '<span class="multi-num">(' + that.variables.multiValues.length + ')</span> ' + that.variables.placeholder;
      $button.html(div);
    } else {
      $button.html(that.variables.placeholder);
    }
    if ($(that).val() != newValue.toLocaleLowerCase()) {
      $(that).val(newValue);
      that.dispatchEvent(new CustomEvent('change'));
    }
    $selectedValueDiv.find('.selected-value').remove();
    var html = '';
    for (var i = 0; i < that.variables.multiValues.length; i++) {
      var name = '';
      if (that.variables.description) name = !that.variables.multiValues[i].description ? that.variables.multiValues[i].value : that.variables.multiValues[i].description;else name = that.variables.multiValues[i].value;
      html += "<div class=\"selected-value\" data-value=\"".concat(that.variables.multiValues[i].value, "\">").concat(name, "<button type=\"button\" class=\"close\" aria-label=\"Close\"><span aria-hidden=\"true\">\xD7</span></button></div>");
    }
    //html += `<input type="text" class="${that.variables.inputClass}" autofocus/>`
    $selectedValueDiv.prepend(html);
  }
  function RemoveValue(removed) {
    var that = this;
    var foundIndex = that.variables.multiValues.findIndex(function (x) {
      return x.value == removed;
    });
    if (foundIndex != -1) {
      that.variables.multiValues.splice(foundIndex, 1);
    }
    that.UpdateSelectedValues();
    that.dispatchEvent(new CustomEvent('change'));
  }
})(jQuery);

},{}],7:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
(function ($) {
  var $dialog = $(".tv-symbol-search-dialog");
  var dialogConfig = {
    baseUri: '/api/live-chart/datafeed',
    curControlSettings: {}
  };
  var methods = {
    init: function init(baseUri, options) {
      if (!window.symbolSearchDialogResxStrings) window.symbolSearchDialogResxStrings = {};
      if (baseUri) dialogConfig.baseUri = baseUri;
      if (options.debug) console.log('initializing symbol search control');
      if (options.searchDialogSelector) $dialog = $(options.searchDialogSelector);
      if (!dialogConfig.symbols_types || dialogConfig.symbols_types.length == 0) {
        var configUrl = dialogConfig.baseUri;
        if (window.CURRENT_LANG && window.CURRENT_LANG != 'en') {
          configUrl = '/' + window.CURRENT_LANG + configUrl;
        }
        configUrl += '/config';
        getConfig(configUrl, function (configData) {
          $.extend(dialogConfig, configData);
          var categoryHtml = '';
          categoryHtml += "<span data-value=\"\">".concat(window.symbolSearchDialogResxStrings['All'], "</span>");
          categoryHtml += "<span data-value=\"Favorite\"></span>";
          categoryHtml += "<span data-value=\"Recent\">".concat(window.symbolSearchDialogResxStrings['Recent'], "</span>");
          var _iterator = _createForOfIteratorHelper(dialogConfig.symbols_types),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var category = _step.value;
              categoryHtml += "<span data-value=\"".concat(category.value, "\">").concat(category.name, "</span>");
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          $dialog.find(".tv-categories").html(categoryHtml);
          var exchangesHtml = '';
          var _iterator2 = _createForOfIteratorHelper(dialogConfig.exchanges),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var exchange = _step2.value;
              exchangesHtml += "<div class=\"exchange-item\" data-value=\"".concat(exchange.value, "\"><span>").concat(exchange.name, "</span><span>").concat(exchange.desc, "</span></div>");
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          $dialog.find('.exchange-selection-container .exchanges').html(exchangesHtml);
        });
      }
      return this.each(function () {
        var $el = $(this);
        var myThis = this;
        var defaultSettings = {
          orgUserInput: '',
          userInput: '',
          ticker: '',
          symbol: 'EUR/USD',
          category: '',
          exchange: '',
          curWatchlist: '',
          pageSize: 120,
          page: 1,
          hasNext: false,
          loadingNextPage: false,
          onChange: function onChange() {},
          debug: false,
          searchDialogSelector: '.tv-symbol-search-dialog',
          retrievedSymbols: [],
          hideStarIcon: false,
          hideFavorites: false,
          onStarIconClicked: null
        };
        if (options) {
          $.extend(defaultSettings, options);
        }
        myThis.settings = defaultSettings;
        myThis.dialogConfig = dialogConfig;
        myThis.settings.onSymbolSelected = function (ticker, symbolData) {
          $el.html(symbolData.symbol);
          myThis.settings.ticker = ticker;
          myThis.settings.symbol = symbolData.symbol;
          if (myThis.settings.debug) console.log('symbol changed', ticker);
          if (typeof myThis.settings.onChange === 'function') {
            myThis.settings.onChange(ticker, symbolData);
          }
        };
        $el.html(myThis.settings.symbol);
        $el.on('click', function () {
          if (myThis.settings.debug) console.log('opening symbol search dialog');
          openModal(myThis.settings);
        });
        if (myThis.settings.debug) console.log('initialized symbol search control', $el);
        return $el;
      });
    },
    setSymbol: function setSymbol(ticker, symbol) {
      return this.each(function () {
        var $el = $(this);
        var myThis = this;
        if (myThis.settings.debug) console.log('set symbol', ticker, symbol);
        myThis.settings.ticker = ticker;
        myThis.settings.symbol = symbol;
        $el.html(myThis.settings.symbol);
      });
    },
    getSelection: function getSelection() {
      return this.each(function () {
        var $el = $(this);
        var myThis = this;
        return {
          ticker: myThis.settings.ticker,
          symbol: myThis.settings.symbol
        };
      });
    },
    updateWatchlistDropdown: function updateWatchlistDropdown(watchlistInstance) {
      return this.each(function () {
        var $el = $(this);
        var myThis = this;
        var watchlists = watchlistInstance.GetWatchLists();
        if (myThis.settings.debug) console.log('update watchlist dropdown', watchlists);
        var watchlistHtml = '';
        for (var i = 0; i < watchlists.length; i++) {
          var item = watchlists[i];
          watchlistHtml += "<a class=\"dropdown-item\" href=\"javascript:void(0);\" data-watchlist=\"".concat(item.Name, "\">").concat(item.Name, "</a>");
        }
        watchlistHtml += "<div class=\"management-items\">";
        watchlistHtml += "<div class=\"dropdown-divider\"></div>";
        watchlistHtml += "<a class=\"dropdown-item manage-item\" href=\"javascript:void(0);\" data-action=\"manage-watchlist\">".concat(window.WatchlistResxStrings['ManageWatchlists'], "</a>");
        watchlistHtml += "</div>";
        $(".tv-watchlist-dropdown-container .dropdown-toggle").text(watchlistInstance.GetActiveWatchlistName());
        $dialog.find('.tv-watchlist-dropdown-container .dropdown-menu').html(watchlistHtml);
      });
    }
  };
  $.fn.chartSymbolSearch = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (_typeof(methodOrOptions) === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      console.log("Method " + methodOrOptions + ' does not exist on jQuery.chartSymbolSearch');
    }
  };
  function openModal(settings) {
    // initialize input box
    settings.userInput = '';
    $dialog.find('.tv-search-box input').val(settings.userInput);
    $dialog.find('.tv-search-box input').data('lastval', settings.userInput);

    // check category
    $dialog.find(".tv-categories span").removeClass('selected');
    $dialog.find(".tv-categories span[data-value=\"".concat(settings.category, "\"]")).addClass('selected');
    if (settings.hideFavorites) {
      $dialog.find(".tv-categories span[data-value=\"Favorite\"]").hide();
    } else {
      $dialog.find(".tv-categories span[data-value=\"Favorite\"]").show();
    }
    if (settings.category == 'Favorite') {
      $(".tv-symbol-search-dialog .tv-watchlist-dropdown-container").show();
    } else {
      $(".tv-symbol-search-dialog .tv-watchlist-dropdown-container").hide();
    }
    if (settings.hideStarIcon) {
      $(".tv-symbol-search-dialog .item-head-row .item-cell:first-child").addClass('no-star');
    } else {
      $(".tv-symbol-search-dialog .item-head-row .item-cell:first-child").removeClass('no-star');
    }

    // check source
    $dialog.find(".exchange-selection-container .exchanges .exchange-item").removeClass('selected');
    $dialog.find(".exchange-selection-container .exchanges .exchange-item[data-value=\"".concat(settings.exchange, "\"]")).addClass('selected');
    updateSymbols(settings, true);
    if (settings.debug) console.log('updating symbols on symbol search dialog');
    dialogConfig.curControlSettings = settings;
    settings.debug && console.log('update current control setting to ', dialogConfig.curControlSettings);
    $dialog.modal();
    if (settings.debug) console.log('open symbol search dialog', $dialog);
    $dialog.find('.tv-search-box input').focus();
  }
  function getConfig(configEndpoint, callback) {
    fetch(configEndpoint).then(function (res) {
      return res.json();
    }).then(function (json) {
      callback(json);
    });
    ;
  }
  function initializeEventHandlers() {
    var timerId;
    $(document).on('input', '.tv-symbol-search-dialog .tv-search-box input', function (e) {
      var value = $(this).val();
      if ($(this).data("lastval") != value) {
        $(this).data("lastval", value);
        clearTimeout(timerId);
        timerId = setTimeout(function () {
          //your change action goes here
          dialogConfig.curControlSettings.userInput = value;
          if (dialogConfig.curControlSettings.category.toLowerCase() == 'recent' || dialogConfig.curControlSettings.category.toLowerCase() == 'favorite') dialogConfig.curControlSettings.orgUserInput = dialogConfig.curControlSettings.userInput;
          updateSymbols(dialogConfig.curControlSettings, true);
        }, 300);
      }
      ;
    });
    $(document).on('click', '.tv-symbol-search-dialog .tv-search-box input', function () {
      $(this).select();
    });
    $(document).on('click', '.tv-symbol-search-dialog .tv-categories span', function (e) {
      if ($(this).hasClass('selected')) return;
      $(".tv-symbol-search-dialog .tv-categories span.selected").removeClass('selected');
      $(this).addClass('selected');
      var newCategory = $(this).data('value');
      if (newCategory.toLowerCase() == 'favorite') {
        $(".tv-symbol-search-dialog .tv-watchlist-dropdown-container").show();
      } else {
        $(".tv-symbol-search-dialog .tv-watchlist-dropdown-container").hide();
      }
      if ((newCategory.toLowerCase() == 'recent' || newCategory.toLowerCase() == 'favorite') && dialogConfig.curControlSettings.category.toLowerCase() != 'recent' && dialogConfig.curControlSettings.category.toLowerCase() != 'favorite') {
        dialogConfig.curControlSettings.orgUserInput = dialogConfig.curControlSettings.userInput;
        dialogConfig.curControlSettings.userInput = '';
        $(".tv-symbol-search-dialog .tv-search-box input").data('lastval', '');
        $(".tv-symbol-search-dialog .tv-search-box input").val('');
      } else if (newCategory.toLowerCase() != 'recent' && newCategory.toLowerCase() != 'favorite' && (dialogConfig.curControlSettings.category.toLowerCase() == 'recent' || dialogConfig.curControlSettings.category.toLowerCase() == 'favorite')) {
        dialogConfig.curControlSettings.userInput = dialogConfig.curControlSettings.orgUserInput;
        dialogConfig.curControlSettings.orgUserInput = '';
        $(".tv-symbol-search-dialog .tv-search-box input").data('lastval', '');
        $(".tv-symbol-search-dialog .tv-search-box input").val(dialogConfig.curControlSettings.userInput);
      }
      dialogConfig.curControlSettings.category = newCategory;
      updateSymbols(dialogConfig.curControlSettings, true);
    });
    $(document).on('click', '.tv-symbol-search-dialog .exchange-selection-cell a', function () {
      $(".tv-symbol-search-dialog .exchange-selection-container").show();
    });
    $(".tv-symbol-search-dialog .scroll-container").scroll(function () {
      if (this.offsetHeight + this.scrollTop + 5 >= this.scrollHeight) {
        if (dialogConfig.curControlSettings.hasNext) {
          updateSymbols(dialogConfig.curControlSettings, false);
        }
      }
    });
    $(document).on('input', '.tv-symbol-search-dialog .exchange-selection-container input', function () {
      var userInput = $(this).val().toLowerCase();
      $dialog.find('.exchange-selection-container .exchange-item').each(function (i, e) {
        if ($(e).data('value').toLowerCase().includes(userInput)) $(e).show();else $(e).hide();
      });
    });
    $(document).on('click', '.tv-symbol-search-dialog .exchange-selection-container .close', function () {
      $('.tv-symbol-search-dialog .exchange-selection-container').hide();
    });
    $(document).on('click', '.tv-symbol-search-dialog .change-selection-cell a', function () {
      $('.tv-symbol-search-dialog .exchange-selection-container').show();
    });
    $(document).on('click', '.tv-symbol-search-dialog .exchanges .exchange-item', function () {
      $dialog.find('.exchanges .exchange-item').removeClass('selected');
      $(this).addClass('selected');
      var exchange = $(this).data('value');
      var name = $(this).find('span:first-child').text();
      dialogConfig.curControlSettings.exchange = exchange;
      $dialog.find('.exchange-selection-cell .exchange').html(name);
      updateSymbols(dialogConfig.curControlSettings, true);
      $('.tv-symbol-search-dialog .exchange-selection-container').hide();
    });
    $(document).on('click', '.tv-symbol-search-dialog .list-container .item-row .item-cell:not(.item-star):not(.item-exchange)', function () {
      var $itemRow = $(this).parent();
      var ticker = $itemRow.data('ticker');
      var symbolData = dialogConfig.curControlSettings.retrievedSymbols.find(function (v, i) {
        return v.ticker === ticker;
      });
      if (!symbolData) symbolData = {
        symbol: $itemRow.data('symbol')
      };
      dialogConfig.curControlSettings.onSymbolSelected(ticker, symbolData);
      $dialog.modal('hide');
    });
    $(document).on('click', '.tv-symbol-search-dialog .list-container .item-row .item-exchange ul.dropdown-menu li a', function () {
      var $itemRow = $(this).closest('.item-row');
      var mainTicker = $itemRow.data('ticker');
      var ticker = $(this).data('ticker');
      var symbolData = dialogConfig.curControlSettings.retrievedSymbols.find(function (v, i) {
        return v.ticker === mainTicker;
      });
      if (!symbolData) symbolData = {
        symbol: $itemRow.data('symbol')
      };
      dialogConfig.curControlSettings.onSymbolSelected(ticker, symbolData);
      $dialog.modal('hide');
    });
    $(document).on('click', '.tv-symbol-search-dialog .list-container .item-row .item-cell.item-star', function () {
      var $itemRow = $(this).parent();
      var ticker = $itemRow.data('ticker');
      var symbolData = dialogConfig.curControlSettings.retrievedSymbols.find(function (v, i) {
        return v.ticker === ticker;
      });
      $dialog.modal('hide');
      if (dialogConfig.curControlSettings.onStarIconClicked) {
        dialogConfig.curControlSettings.onStarIconClicked(ticker, symbolData);
      } else {
        if (window.userIsOnline) {
          window.WatchlistInstance.OpenAddSymbolToWatchlistsDialog({
            ticker: ticker,
            symbol: symbolData.symbol,
            exchange: symbolData.exchange
          });
        } else {
          window.Access.Login();
        }
      }
    });
    $(document).on('click', '.tv-watchlist-dropdown-container .dropdown-item:not([data-action="manage-watchlist"])', function () {
      var watchlistName = $(this).data('watchlist');
      $(".tv-watchlist-dropdown-container .dropdown-toggle").text(watchlistName);
      updateSymbols(dialogConfig.curControlSettings, true);
    });
  }
  function updateSymbols(settings, isFirst) {
    settings.curWatchlist = $(".tv-symbol-search-dialog .tv-watchlist-dropdown-container .dropdown-toggle").text();
    if (!settings.curWatchlist) {
      settings.curWatchlist = window.WatchlistInstance.GetActiveWatchlistName();
      $(".tv-symbol-search-dialog .tv-watchlist-dropdown-container .dropdown-toggle").text(settings.curWatchlist);
    }
    if (!isFirst && settings.loadingNextPage) return;
    if ($dialog.lastSearchCallAbortController && _typeof($dialog.lastSearchCallAbortController) === 'object') {
      $dialog.lastSearchCallAbortController.abort();
    }
    $dialog.lastSearchCallAbortController = new AbortController();
    $dialog.find('.modal-body').addClass('loading');
    if (isFirst) {
      $dialog.find('.modal-body .list-container .item-row').remove();
      $dialog.find('.modal-body .scroll-container').scrollTop(0);
      settings.page = 1;
    } else {
      settings.page = settings.page + 1;
      settings.loadingNextPage = true;
    }
    settings.hasNext = false;
    retrieveSymbolsFromApi(settings.userInput, settings.exchange, settings.category, settings.curWatchlist, settings.page, settings.pageSize, $dialog.lastSearchCallAbortController).then(function (res) {
      $dialog.find('.modal-body').removeClass('loading');
      var rows = '';
      var _iterator3 = _createForOfIteratorHelper(res),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var item = _step3.value;
          rows += "<div class=\"item-row\" data-ticker=\"".concat(item.ticker, "\" data-symbol=\"").concat(item.symbol, "\" data-exchange=\"").concat(item.exchange, "\">");
          if (dialogConfig.curControlSettings.hideStarIcon) {
            rows += "<div></div>";
          } else {
            if (window.WatchlistInstance.HasSymbolInWatchlists(item.ticker)) {
              rows += "<div class=\"item-cell item-star filled\"></div>";
            } else {
              rows += "<div class=\"item-cell item-star\"></div>";
            }
          }
          rows += "<div class=\"item-cell item-wrap-on-mobile\">";
          rows += "<div class=\"item-info\">".concat(item.symbol, "</div>");
          if (!item.popular) {
            rows += "<div class=\"item-description\">".concat(item.description, "</div>");
          } else {
            rows += "<div class=\"item-description\">".concat(item.description, " <span class=\"ml-1 mr-1 badge badge-success\">Popular</span></div>");
          }
          rows += "</div>";
          rows += "<div class=\"item-cell item-exchange\">";
          rows += "<div>".concat(item.type ? item.type : '', "</div>");
          var exchange = item.exchange;
          if (exchange.toLowerCase() === 'physical currency') exchange = 'Aggregated';
          if (item.sources.length > 0) {
            var dropdownHtml = "<ul class=\"dropdown-menu\">";
            for (var i = 0; i < item.sources.length; i++) {
              if (item.sources[i].Source && item.sources[i].Source.toLowerCase() == 'physical currency') {
                item.sources[i].Source = 'Aggregated';
              }
              dropdownHtml += "<li><a href=\"javascript:void(0);\" data-ticker=\"".concat(item.sources[i].Ticker, "\">").concat(item.sources[i].Source, "</a></li>");
            }
            dropdownHtml += "</ul>";
            rows += "<div data-tog class=\"d-flex flex-column flex-md-row align-items-center\">".concat(exchange, "&nbsp;<button class=\"more-sources\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">+").concat(item.sources.length, " <i class=\"mdi mdi-chevron-down\"></i></button>").concat(dropdownHtml, "</div>");
          } else {
            rows += "<div>".concat(exchange, "</div>");
          }
          rows += "</div >";
          rows += '</div>';
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      if (isFirst) {
        $dialog.find('.modal-body .list-container .item-row').remove();
        settings.retrievedSymbols = [];
      } else {}
      $dialog.find('.modal-body .list-container').append(rows);
      settings.retrievedSymbols = settings.retrievedSymbols.concat(res);
      settings.loadingNextPage = false;
      if (res.length == settings.pageSize) {
        settings.hasNext = true;
      } else {
        settings.hasNext = false;
      }
      $(".tooltip").remove();
      $dialog.find(".modal-body .list-container .item-star.filled").tooltip('dispose').tooltip({
        boundary: 'window',
        title: 'Remove from watchlist'
      });
      $dialog.find(".modal-body .list-container .item-star:not(.filled)").tooltip('dispose').tooltip({
        boundary: 'window',
        title: 'Add to watchlist'
      });
      $dialog.find(".modal-body .list-container .item-cell .more-sources").tooltip('dispose').tooltip({
        trigger: 'hover',
        boundary: 'window',
        title: 'Select from multiple data sources'
      });
      ResizeSymbolColumn();
    });
  }
  function retrieveSymbolsFromApi(query, exchange, category, watchlistName, page, pageSize, abortController) {
    var searchUrl = dialogConfig.baseUri + "/search";
    if (window.CURRENT_LANG && window.CURRENT_LANG != 'en') {
      searchUrl = '/' + window.CURRENT_LANG + searchUrl;
    }
    var url = searchUrl + "?query=".concat(query) + "&exchange=".concat(exchange) + "&type=".concat(category) + "&page=".concat(page) + "&pageSize=".concat(pageSize) + "&lang=".concat(window.CURRENT_LANG);
    if (category.toLowerCase() == 'favorite') {
      url += '&watchlist=' + watchlistName;
    }
    if (category.toLowerCase() == "recent") {
      var recentList = window.WatchlistInstance.GetRecentSymbols();
      var symbols = '';
      if (recentList.length > 0) {
        var _iterator4 = _createForOfIteratorHelper(recentList),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var symbol = _step4.value;
            symbols += symbol.Symbol + ',';
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        symbols = symbols.substring(0, symbols.length - 1);
      }
      url += '&symbols=' + symbols;
    } else if (category.toLowerCase() == 'favorite') {
      /*
      const watchList = GetWatchList();
      var tickers = '';
      if (watchList.length > 0) {
          for (const symbol of watchList) {
              tickers += symbol.Ticker + ',';
          }
          tickers = tickers.substring(0, tickers.length - 1);
      }
      url += '&tickers=' + tickers;
      */
      var watchList = window.WatchlistInstance.GetWatchlistByName(watchlistName);
      if (watchList.Symbols.length > 0) {
        var symbols = '';
        var _iterator5 = _createForOfIteratorHelper(watchList.Symbols),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _symbol = _step5.value;
            symbols += _symbol.Symbol + ',';
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
        symbols = symbols.substring(0, symbols.length - 1);
        url += '&symbols=' + symbols;
      }
    }
    return fetch(url, {
      signal: abortController.signal
    }).then(function (res) {
      return res.json();
    }).then(function (json) {
      if (category.toLowerCase() == "recent") {
        var _recentList = window.WatchlistInstance.GetRecentSymbols();
        var list = json.filter(function (item) {
          return _recentList.findIndex(function (recentItem) {
            if (item.symbol.includes("/")) {
              // forex or crypto
              return recentItem.Symbol.toLowerCase() == item.symbol.toLowerCase();
            } else {
              if (recentItem.Ticker) return recentItem.Ticker.toLowerCase() == item.ticker.toLowerCase();else return recentItem.Symbol.toLowerCase() == item.symbol.toLowerCase();
            }
          }) != -1;
        });
        list.sort(function (a, b) {
          var aIndex = _recentList.findIndex(function (recentItem) {
            if (a.symbol.includes("/")) {
              // forex or crypto
              return recentItem.Symbol.toLowerCase() == a.symbol.toLowerCase();
            } else {
              if (recentItem.Ticker) return recentItem.Ticker.toLowerCase() == a.ticker.toLowerCase();else return recentItem.Symbol.toLowerCase() == a.symbol.toLowerCase();
            }
          });
          if (aIndex < 0) aIndex = 10000;
          var bIndex = _recentList.findIndex(function (recentItem) {
            if (b.symbol.includes("/")) {
              // forex or crypto
              return recentItem.Symbol.toLowerCase() == b.symbol.toLowerCase();
            } else {
              if (recentItem.Ticker) return recentItem.Ticker.toLowerCase() == b.ticker.toLowerCase();else return recentItem.Symbol.toLowerCase() == b.symbol.toLowerCase();
            }
          });
          if (bIndex < 0) bIndex = 10000;
          return aIndex - bIndex;
        });
        for (var i = 0; i < list.length; i++) {
          if (list[i].symbol.includes("/")) {
            var index = _recentList.findIndex(function (recentListItem) {
              return list[i].symbol == recentListItem.Symbol;
            });
            if (index != -1 && !!_recentList[index].Ticker && list[i].ticker != _recentList[index].Ticker && _recentList[index].Ticker.includes(":")) {
              if (list[i].sources.findIndex(function (sourceItem) {
                return sourceItem.Ticker == _recentList[index].Ticker;
              }) != -1) {
                var recentListItemExchange = _recentList[index].Ticker.split(":")[0];
                if (recentListItemExchange.toLowerCase() === 'physical currency') recentListItemExchange = 'Aggregated';
                if (list[i].exchange != recentListItemExchange) {
                  list[i].sources.push({
                    Ticker: list[i].ticker,
                    Source: list[i].exchange
                  });
                  list[i].exchange = recentListItemExchange;
                  list[i].ticker = _recentList[index].Ticker;
                  list[i].sources = list[i].sources.filter(function (item) {
                    return item.Ticker != list[i].ticker;
                  });
                }
              }
            }
          }
        }
        return list;
      } else if (category.toLowerCase() == 'favorite') {
        var watchlist = window.WatchlistInstance.GetWatchlistByName(watchlistName);
        json = json.filter(function (item) {
          return watchlist.Symbols.findIndex(function (watchListItem) {
            return item.symbol.includes("/") && watchListItem.Symbol.toLowerCase() == item.symbol.toLowerCase() || watchListItem.Ticker.toLowerCase() == item.ticker.toLowerCase();
          }) != -1;
        });
      }
      var filtered = json;

      /*
        const curWatchlist = window.WatchlistInstance.GetWatchlistByName(watchlistName);
      const curWatchlistSymbols = curWatchlist.Symbols || [];
      let hasRemovedWatchlist = false;
      for (var i = 0; i < filtered.length; i++) {
          if (filtered[i].symbol.includes("/")) {
              var index = curWatchlistSymbols.findIndex(function (watchListItem) { return filtered[i].symbol == watchListItem.Symbol; });
              if (index != -1 && filtered[i].ticker != curWatchlistSymbols[index].Ticker) {
                  if (filtered[i].exchange != curWatchlistSymbols[index].Exchange) {
                      if (filtered[i].sources.findIndex(function (sourceItem) { return sourceItem.Ticker == curWatchlistSymbols[index].Ticker }) != -1) {
                            filtered[i].sources.push({ Ticker: filtered[i].ticker, Source: filtered[i].exchange });
                          filtered[i].exchange = curWatchlistSymbols[index].Exchange;
                          filtered[i].ticker = curWatchlistSymbols[index].Ticker;
                          filtered[i].sources = filtered[i].sources.filter(function (item) { return item.Ticker != filtered[i].ticker; });
                      } else {
                          window.WatchlistInstance.RemoveSymbolFromWatchList(watchlist, curWatchlistSymbols[index].Ticker);
                          hasRemovedWatchlist = true;
                      }
                  }
              }
          }
      }
      if (hasRemovedWatchlist) {
          window.WatchlistInstance.RenderWatchlistComponents();
      }
      */
      return filtered;
    });
  }
  initializeEventHandlers();
})(jQuery);

},{}],12:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _CalcWidgetsStyle = _interopRequireDefault(require("./CalcWidgetsStyle.js"));
var _CalculatorHelper = _interopRequireDefault(require("./CalculatorHelper.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
require('./CustomChartSymbolSelectPlugin.js');
require("./InfiniteScrollSelectPlugin.js");
var PositionSizeCalculator = /*#__PURE__*/function () {
  function PositionSizeCalculator() {
    _classCallCheck(this, PositionSizeCalculator);
    this.calcWidgetStyleInstance = new _CalcWidgetsStyle["default"]();
    this.calculatorHelperInstance = new _CalculatorHelper["default"]();
    this.parameters = {
      ticker: 'EUR/USD',
      symbol: 'EUR/USD',
      exchange: '',
      depositCurrency: 'USD',
      balance: 100000,
      risk: 2,
      riskType: 0,
      stopLossPips: 200
    };
    this.symbolSearchControl = null;
    this.currencyControl = null;
    this.symbolInfo = null;
  }
  return _createClass(PositionSizeCalculator, [{
    key: "Initialize",
    value: function Initialize() {
      var myThis = this;
      myThis.InitCalculatorParams();
      myThis.InitializeComponents();
      myThis.calculatorHelperInstance.RetrieveToolSymbolInfo(myThis.parameters.ticker, function (info) {
        return myThis.OnSymbolInfoResolved(info, function () {
          return myThis.CalculateResult();
        }, true);
      });
    }
  }, {
    key: "InitCalculatorParams",
    value: function InitCalculatorParams() {
      var toolParams = this.calculatorHelperInstance.GetToolParamsFromUrlAndCache();
      this.parameters.symbol = toolParams.symbol;
      this.parameters.exchange = toolParams.exchange;
      this.parameters.ticker = toolParams.ticker;
      this.parameters.depositCurrency = toolParams.depositCurrency;
      var cookieBalance = parseFloat(this.calcWidgetStyleInstance.GetCalcCookieValue('psc-balance'));
      if (cookieBalance) {
        this.parameters.balance = cookieBalance;
      }
      var cookieRisk = parseFloat(this.calcWidgetStyleInstance.GetCalcCookieValue('psc-risk'));
      if (cookieRisk) {
        this.parameters.risk = cookieRisk;
      }
      var cookieRiskType = this.calcWidgetStyleInstance.GetCalcCookieValue('psc-risk-type');
      if (cookieRiskType != "") {
        this.parameters.riskType = cookieRiskType;
      }
      var stopLossPips = parseFloat(this.calcWidgetStyleInstance.GetCalcCookieValue('psc-stop-loss'));
      if (stopLossPips) this.parameters.stopLossPips = stopLossPips;
    }
  }, {
    key: "InitializeComponents",
    value: function InitializeComponents() {
      var myThis = this;
      var hideStarIcon = false;
      var hideFavorites = false;
      if (window.location.pathname.includes("/widgets/")) {
        if (!window.allowAuthFeatures || !window.userIsOnline) {
          hideStarIcon = true;
          hideFavorites = true;
        }
      } else {
        if (!window.userIsOnline) {
          hideFavorites = true;
        }
      }
      this.symbolSearchControl = $("#psc-symbol-select-control").chartSymbolSearch('init', '/api/live-chart/datafeed', {
        onChange: function onChange(ticker, symbolData) {
          myThis.OnSymbolChanged(ticker, symbolData);
        },
        ticker: this.parameters.ticker,
        symbol: this.parameters.symbol,
        hideFavorites: hideFavorites,
        hideStarIcon: hideStarIcon
      });
      this.currencyControl = $("#psc-deposit-currency-select").infiniteselect({
        types: [{
          option: 'all',
          text: 'All'
        }, {
          option: 'forex',
          text: 'Forex'
        }, {
          option: 'crypto',
          text: 'Crypto'
        }],
        url: '/api/widgets/currencies',
        placeholder: 'Select',
        "default": this.parameters.depositCurrency,
        showDescription: true,
        culture: window.CURRENT_LANG,
        btnClass: 'widget-input-override frn-override'
      });
      $("#PSCAccountBalance").val(this.parameters.balance);
      $("#PSCRisk").val(this.parameters.risk);
      $("#pscRiskTypeSelect").val(this.parameters.riskType);
      $("#PSCStopLoss").val(this.parameters.stopLossPips);
      document.getElementById("psc-risk-type-currency").innerHTML = this.parameters.depositCurrency;
      $(document).on('change', '#PSCStopLoss', function () {
        return myThis.RemoveResult();
      });
      $(document).on('change', '#PSCAccountBalance', function () {
        return myThis.RemoveResult();
      });
      $(document).on('change', '#PSCRisk', function () {
        return myThis.RemoveResult();
      });
      $(document).on('change', '#pscRiskTypeSelect', function () {
        return myThis.RemoveResult();
      });
      $(document).on('change', '#pscCurrentPrice', function () {
        return myThis.RemoveResult();
      });
      $(document).on('change', '#pscContractSize', function () {
        return myThis.RemoveResult();
      });
      $(document).on('click', "#psc-stop-loss-popover-link", function () {
        myThis.OnSwitchStopLossPopoverLink(this);
      });
      $("#psc-deposit-currency-select").on('change', function () {
        return myThis.OnCurrencyChanged();
      });
      $(document).on('click', '#psc-calculate-button', function () {
        return myThis.CalculateResult();
      });
      $(document).on('click', '#psc-contract-size-link', function () {
        return myThis.OnContractSizeEnable();
      });
    }
  }, {
    key: "UpdateCalculatorSymbol",
    value: function UpdateCalculatorSymbol(ticker, symbol) {
      var myThis = this;
      myThis.symbolSearchControl.chartSymbolSearch('setSymbol', ticker, symbol);
      myThis.parameters.ticker = ticker;
      myThis.parameters.symbol = symbol;
      myThis.calculatorHelperInstance.RetrieveToolSymbolInfo(myThis.parameters.ticker, function (info) {
        return myThis.OnSymbolInfoResolved(info, function () {
          return myThis.CalculateResult();
        });
      });
    }
  }, {
    key: "UpdatePopupLink",
    value: function UpdatePopupLink() {
      if ($("#psc-widget-top-pane a.calc-popup-icon").length > 0) {
        var link = "";
        if (window.CURRENT_LANG != "en") link += "/" + window.CURRENT_LANG;
        link += "/widgets/position-size-calculator?symbol=" + this.symbolInfo.symbol;
        for (var i = 0; i < $("#psc-widget-top-pane a.calc-popup-icon").length; i++) {
          $("#psc-widget-top-pane a.calc-popup-icon")[i].href = link;
        }
      }
    }
  }, {
    key: "OnLotsQuestionMarkClicked",
    value: function OnLotsQuestionMarkClicked() {
      this.OnContractSizeEnable();
      var input = $("#psc-contract-size-form-group input");
      if (!input.isInViewport()) {
        $('html, body').animate({
          scrollTop: input.offset().top - 50
        }, 200);
      }
      input.addClass("highlight");
      setTimeout(function () {
        return input.removeClass("highlight");
      }, 1000);
    }
  }, {
    key: "OnContractSizeEnable",
    value: function OnContractSizeEnable() {
      $("#psc-contract-size-form-group").addClass("active");
    }
  }, {
    key: "RemoveResult",
    value: function RemoveResult() {
      document.getElementById("psc-units").innerHTML = "--";
      document.getElementById("psc-lots").innerHTML = "--";
      document.getElementById("psc-moneyAtRisk").innerHTML = "--";
    }
  }, {
    key: "CalculateResult",
    value: function CalculateResult() {
      var myThis = this;
      var form = document.getElementById('psc-form');
      if (form.checkValidity() === false) {
        form.reportValidity();
        //form.classList.add('was-validated');
        return;
      }
      var stopLossPips = this.calculatorHelperInstance.ParseLocaleNumber(document.getElementById('PSCStopLoss').value);
      if (document.getElementById("psc-stop-loss-type").value == "price") {
        var onePipSize = myThis.symbolInfo.onePipSize;
        stopLossPips = (this.calculatorHelperInstance.ParseLocaleNumber(document.getElementById('psc-open-price').value) - stopLossPips) / onePipSize;
      } else {
        this.calcWidgetStyleInstance.SetCalcCookieValue('psc-stop-loss', stopLossPips);
        myThis.parameters.stopLossPips = stopLossPips;
      }
      var accountBalance = this.calculatorHelperInstance.ParseLocaleNumber(document.getElementById('PSCAccountBalance').value);
      var risk = this.calculatorHelperInstance.ParseLocaleNumber(document.getElementById('PSCRisk').value);
      var riskTypeControl = document.getElementById("pscRiskTypeSelect");
      var riskType = riskTypeControl.options[riskTypeControl.selectedIndex].value;
      this.calcWidgetStyleInstance.SetCalcCookieValue('psc-balance', accountBalance);
      this.calcWidgetStyleInstance.SetCalcCookieValue('psc-risk', risk);
      this.calcWidgetStyleInstance.SetCalcCookieValue('psc-risk-type', riskType);
      var moneyToRisk = 0;
      var displayMoneyOrRisk = 0;
      if (riskType == "0") {
        displayMoneyOrRisk = accountBalance * risk / 100;
        moneyToRisk = displayMoneyOrRisk;
      } else {
        displayMoneyOrRisk = risk / accountBalance * 100;
        moneyToRisk = risk;
      }
      var lotSize = this.calculatorHelperInstance.ParseLocaleNumber(document.getElementById("pscContractSize").value);
      var pipAtRisk = stopLossPips;
      var exchangeRate = this.calculatorHelperInstance.ParseLocaleNumber(document.getElementById("pscCurrentPrice").value);
      if (exchangeRate == "NaN") {
        return;
      }
      var onePipSize = this.calculatorHelperInstance.ParseLocaleNumber(document.getElementById("pscCurrentPairPipSize").value);
      if (document.getElementById("psc-stop-loss-type").value == "price") {
        onePipSize = myThis.symbolInfo.onePipSize;
      }
      $("#position-size-calc-form span.result-span").html('<img class="result-loading-img" src="/Content/dist/images/PageElements/ajax-loader.svg" />');
      $.ajax({
        type: "POST",
        cache: false,
        dataType: "json",
        url: "/widgets/calculation/position-size",
        data: {
          moneyToRisk: moneyToRisk,
          pipAtRisk: pipAtRisk,
          lotSize: lotSize,
          onePipSize: onePipSize,
          rate: exchangeRate
        },
        success: function success(data) {
          if (data.success === true) {
            document.getElementById("psc-units").innerHTML = myThis.calculatorHelperInstance.ToLocaleNumberForResult(data.units, "", 3, "");
            if (!$("#psc-contract-size-form-group").hasClass("active")) {
              $('#psc-lots-result-group #psc-lots').html('<a class="lots-question-mark" data-toggle="popover" data-trigger="hover toggle" data-placement="auto" data-html="true" data-content="' + window.lotsQuestionMarkPopover + '" style="lot-size-question-mark" href="javascript:void(0);" onclick="window.positionSizeCalculator.OnLotsQuestionMarkClicked()">?</a>');
              $('#psc-lots-result-group #psc-lots a').popover();
            } else {
              document.getElementById("psc-lots").innerHTML = myThis.calculatorHelperInstance.ToLocaleNumberForResult(data.lots, "", 3, "");
            }
            if (riskType == "0") {
              document.getElementById("psc-moneyAtRisk").innerHTML = myThis.calculatorHelperInstance.ToLocaleNumberForResult(displayMoneyOrRisk, 'currency', 2, myThis.parameters.depositCurrency);
            } else {
              document.getElementById("psc-moneyAtRisk").innerHTML = myThis.calculatorHelperInstance.ToLocaleNumberForResult(displayMoneyOrRisk, "", 2, "");
            }
          } else {
            document.getElementById("psc-units").innerHTML = "NaN";
            document.getElementById("psc-lots").innerHTML = "NaN";
            document.getElementById("psc-moneyAtRisk").innerHTML = "NaN";
          }
        },
        error: function error() {
          document.getElementById("psc-units").innerHTML = "NaN";
          document.getElementById("psc-lots").innerHTML = "NaN";
          document.getElementById("psc-moneyAtRisk").innerHTML = "NaN";
        }
      });
    }
  }, {
    key: "GetCurrency",
    value: function GetCurrency(currency) {
      if (currency == 'USD') return "&#36;";else if (currency == 'AUD') return "AUD &#36;";else if (currency == 'NZD') return "NZD &#36;";else if (currency == 'CAD') return "CAD &#36;";else if (currency == 'EUR') return "&#128;";else if (currency == 'GBP') return "&#163;";else if (currency == 'CHF') return "CHF";else if (currency == 'JPY') return "&#165;";else if (currency == 'SGD') return "S&#36;";
      return currency;
    }
  }, {
    key: "GenerateNewLink",
    value: function GenerateNewLink(oldUrl, exchange, symbol) {
      var slug = this.calculatorHelperInstance.GetToolSymbolSlugFromTicker(exchange, symbol);
      var urlPart = "tools/position-size-calculator";
      var baseUrl = oldUrl.substring(0, oldUrl.toLowerCase().indexOf(urlPart) + urlPart.length);
      return baseUrl + "/" + slug;
    }
  }, {
    key: "UpdateHrefAndTitle",
    value: function UpdateHrefAndTitle(atInitialize) {
      var urlPart = "/tools/position-size-calculator";
      if (!window.location.pathname.includes(urlPart) || window.location.hash == '#popout') return;
      if (!atInitialize || window.location.search.includes("?s=")) {
        this.calculatorHelperInstance.UpdateCalculatorTitle(this.symbolInfo);
        this.calculatorHelperInstance.UpdateCalculatorHrefs(urlPart, this.symbolInfo);
      } else {
        this.calculatorHelperInstance.UpdateCalculatorHrefs(urlPart, null);
      }
      if (!atInitialize) TriggerGoogleAnalytics();
    }
  }, {
    key: "UpdateStopLossPriceFields",
    value: function UpdateStopLossPriceFields() {
      var myThis = this;
      var currentStopLossType = document.getElementById("psc-stop-loss-type").value;
      if (currentStopLossType == 'price') {
        var currentPrice = myThis.symbolInfo.price;
        document.getElementById("psc-open-price").value = myThis.calculatorHelperInstance.ToLocaleNumberForInput(currentPrice, {
          minimumFractionDigits: 5
        });
        document.getElementById("PSCStopLoss").value = myThis.calculatorHelperInstance.ToLocaleNumberForInput(currentPrice * 0.98, {
          minimumFractionDigits: 5
        });
      } else {
        document.getElementById("PSCStopLoss").value = myThis.parameters.stopLossPips;
      }
    }
  }, {
    key: "OnSwitchStopLossPopoverLink",
    value: function OnSwitchStopLossPopoverLink(e) {
      var currentStopLossType = document.getElementById("psc-stop-loss-type").value;
      if (currentStopLossType == "pips") {
        $("#psc-stop-loss-type").val("price");
        $('label[for="PSCStopLoss"]').html('<i class="mdi mdi-settings font-12"></i>' + window.stopLossPriceLabel);
        $("#psc-open-price-price-field").css('display', 'block');
        $('#psc-stop-loss-popover-link').html(window.switchToStopLossPipsLabel);
        $('#psc-current-pair-pip-size-form-group').css('display', 'none');
        if (e != undefined) e.innerHTML = window.switchToStopLossPipsLabel;
      } else {
        $("#psc-stop-loss-type").val("pips");
        $('label[for="PSCStopLoss"]').html('<i class="mdi mdi-settings font-12"></i>' + window.stopLossPipsLabel);
        $("#psc-open-price-price-field").css('display', 'none');
        $('#psc-stop-loss-popover-link').html(window.switchToStopLossPriceLabel);
        $('#psc-current-pair-pip-size-form-group').css('display', 'block');
        if (e != undefined) e.innerHTML = window.switchToStopLossPriceLabel;
      }
      this.UpdateStopLossPriceFields();
    }
  }, {
    key: "OnSymbolInfoResolved",
    value: function OnSymbolInfoResolved(symbolInfo, callback, atInitialize) {
      var myThis = this;
      if (!symbolInfo) return;
      myThis.symbolInfo = symbolInfo;
      myThis.parameters.ticker = myThis.symbolInfo.ticker;
      myThis.parameters.symbol = myThis.symbolInfo.symbol;
      myThis.parameters.exchange = myThis.symbolInfo.exchange;
      myThis.calcWidgetStyleInstance.SetCalcCookieValue('ticker', myThis.parameters.ticker);
      myThis.calcWidgetStyleInstance.SetCalcCookieValue('symbol', myThis.symbolInfo.symbol.replace("/", "."));
      myThis.calcWidgetStyleInstance.SetCalcCookieValue('exchange', myThis.symbolInfo.exchange);
      UpdateCalcLiveChartPopoutLink('psc-livechart-links', myThis.symbolInfo.symbol, this.calculatorHelperInstance.GetToolSymbolSlugFromTicker(myThis.symbolInfo.exchange, myThis.symbolInfo.symbol));
      myThis.UpdateOnePipSizeLabel();
      myThis.UpdateOneLotSize();
      myThis.UpdateConversationPrice(callback);
      myThis.UpdatePopupLink();
      myThis.UpdateHrefAndTitle(atInitialize);
      if (myThis.symbolInfo.type.toLowerCase() !== "forex" && document.getElementById("psc-stop-loss-type").value == "pips") {
        myThis.OnSwitchStopLossPopoverLink();
      } else {
        myThis.UpdateStopLossPriceFields();
      }
      if (window.WatchlistInstance) {
        window.WatchlistInstance.VisitSymbol(myThis.symbolInfo);
      }
    }
  }, {
    key: "OnSymbolChanged",
    value: function OnSymbolChanged(ticker, symbolData) {
      var myThis = this;
      myThis.RemoveResult();
      myThis.parameters.ticker = ticker;
      myThis.parameters.symbol = symbolData.symbol;
      myThis.calculatorHelperInstance.RetrieveToolSymbolInfo(ticker, function (info) {
        return myThis.OnSymbolInfoResolved(info);
      });
    }
  }, {
    key: "UpdateOnePipSizeLabel",
    value: function UpdateOnePipSizeLabel() {
      var myThis = this;
      document.getElementById("pscCurrentPairPipSize").readOnly = false;
      $("#pscCurrentPairPipSize").attr('style', 'opacity: 1;');
      /*
      if (myThis.symbolInfo.type.toLowerCase() === "forex") {
          document.getElementById("pscCurrentPairPipSize").readOnly = true;
          //$("#pscCurrentPairPipSize").attr('style', 'background-color: #E9ECEF; color: #777 !important;');
          $("#pscCurrentPairPipSize").attr('style', 'opacity: .8;');
      } else {
            document.getElementById("pscCurrentPairPipSize").readOnly = false;
          // $("#pscCurrentPairPipSize").attr('style', 'background-color: white; color: black;');
          $("#pscCurrentPairPipSize").attr('style', 'opacity: 1;');
      }
      */
      document.getElementById("pscCurrentPairPipSize").value = myThis.calculatorHelperInstance.ToLocaleNumberForInput(myThis.symbolInfo.onePipSize, {
        maximumFractionDigits: 5
      });
      document.getElementById("pscCurrentPairPipSizeLabel").innerHTML = window._01PipSize.replace("{0}", myThis.symbolInfo.symbol);
    }
  }, {
    key: "UpdateOneLotSize",
    value: function UpdateOneLotSize() {
      var myThis = this;
      var lotSize = myThis.symbolInfo.lotSize;
      if (myThis.symbolInfo.type.toLowerCase() === "forex") {
        $("#psc-contract-size-form-group").addClass("active");
      } else {
        $("#psc-contract-size-form-group").removeClass("active");
      }
      document.getElementById("pscContractSize").value = this.calculatorHelperInstance.ToLocaleNumberForInput(lotSize);
    }
  }, {
    key: "UpdateConversationPrice",
    value: function UpdateConversationPrice(callback) {
      var myThis = this;
      var currency = myThis.parameters.depositCurrency;
      var quoteCurrency = myThis.symbolInfo.quoteCurrency;
      var showCurrency = currency + "/" + quoteCurrency;
      document.getElementById("pscCurrentPriceLabel").innerHTML = showCurrency;
      myThis.calculatorHelperInstance.GetExchangeRateAsync(currency, quoteCurrency).then(function (res) {
        var currentPrice = res.rate;
        if (currentPrice < 0) currentPrice = "NaN";
        document.getElementById("pscCurrentPrice").value = myThis.calculatorHelperInstance.ToLocaleNumberForInput(currentPrice, {
          minimumFractionDigits: 5
        });
        if (currentPrice == 1) {
          $("#psc-current-price-form-group").css("display", "none");
        } else {
          $("#psc-current-price-form-group").css("display", "block");
        }
        if (callback && typeof callback === 'function') callback();
      });
    }
  }, {
    key: "OnCurrencyChanged",
    value: function OnCurrencyChanged() {
      var myThis = this;
      myThis.RemoveResult();
      myThis.parameters.depositCurrency = $(myThis.currencyControl).infiniteselect('val');
      document.getElementById("psc-risk-type-currency").innerHTML = myThis.parameters.depositCurrency;
      myThis.UpdateConversationPrice();
    }
  }]);
}();
var _default = exports["default"] = PositionSizeCalculator;

},{"./CalcWidgetsStyle.js":4,"./CalculatorHelper.js":5,"./CustomChartSymbolSelectPlugin.js":7,"./InfiniteScrollSelectPlugin.js":8}],11:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _CalcWidgetsStyle = _interopRequireDefault(require("./CalcWidgetsStyle.js"));
var _CalculatorHelper = _interopRequireDefault(require("./CalculatorHelper.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
require('./CustomChartSymbolSelectPlugin.js');
require("./InfiniteScrollSelectPlugin.js");
var PipValueCalculator = /*#__PURE__*/function () {
  function PipValueCalculator() {
    _classCallCheck(this, PipValueCalculator);
    this.calcWidgetStyleInstance = new _CalcWidgetsStyle["default"]();
    this.calculatorHelperInstance = new _CalculatorHelper["default"]();
    this.parameters = {
      ticker: 'EUR/USD',
      symbol: 'EUR/USD',
      exchange: '',
      depositCurrency: 'USD',
      tradeSize: 1,
      tradeSizeType: 'lots',
      fromCookie: true
    };
    this.symbolSearchControl = null;
    this.currencyControl = null;
    this.symbolInfo = null;
  }
  return _createClass(PipValueCalculator, [{
    key: "Initialize",
    value: function Initialize() {
      var myThis = this;
      myThis.InitCalculatorParams();
      myThis.InitializeComponents();
      myThis.calculatorHelperInstance.RetrieveToolSymbolInfo(myThis.parameters.ticker, function (info) {
        return myThis.OnSymbolInfoResolved(info, function () {
          return myThis.CalculateResult();
        }, true);
      });
    }
  }, {
    key: "InitCalculatorParams",
    value: function InitCalculatorParams() {
      var toolParams = this.calculatorHelperInstance.GetToolParamsFromUrlAndCache();
      this.parameters.symbol = toolParams.symbol;
      this.parameters.exchange = toolParams.exchange;
      this.parameters.ticker = toolParams.ticker;
      this.parameters.depositCurrency = toolParams.depositCurrency;
      var tradeSizeParams = this.calcWidgetStyleInstance.GetTradeSize(this.parameters.symbol);
      if (tradeSizeParams != null) {
        this.parameters.tradeSize = tradeSizeParams.size;
        this.parameters.tradeSizeType = tradeSizeParams.type;
      }
    }
  }, {
    key: "InitializeComponents",
    value: function InitializeComponents() {
      var _this = this;
      var myThis = this;
      var hideStarIcon = false;
      var hideFavorites = false;
      if (window.location.pathname.includes("/widgets/")) {
        if (!window.allowAuthFeatures || !window.userIsOnline) {
          hideStarIcon = true;
          hideFavorites = true;
        }
      } else {
        if (!window.userIsOnline) {
          hideFavorites = true;
        }
      }
      this.symbolSearchControl = $("#pvc-symbol-select-control").chartSymbolSearch('init', '/api/live-chart/datafeed', {
        onChange: function onChange(ticker, symbolData) {
          myThis.OnSymbolChanged(ticker, symbolData);
        },
        ticker: this.parameters.ticker,
        symbol: this.parameters.symbol,
        hideFavorites: hideFavorites,
        hideStarIcon: hideStarIcon
      });
      this.currencyControl = $("#pvc-deposit-currency-select").infiniteselect({
        types: [{
          option: 'all',
          text: 'All'
        }, {
          option: 'forex',
          text: 'Forex'
        }, {
          option: 'crypto',
          text: 'Crypto'
        }],
        url: '/api/widgets/currencies',
        placeholder: 'Select',
        "default": this.parameters.depositCurrency,
        showDescription: true,
        culture: window.CURRENT_LANG,
        btnClass: 'widget-input-override frn-override'
      });
      document.getElementById("pvc-trade-size-type").value = this.parameters.tradeSizeType;
      document.getElementById("pvc-trade-size").value = this.parameters.tradeSize;
      if (this.parameters.tradeSizeType == "units") {
        $("label[for='pvc-trade-size']").html(window.TradeSizeUnitsLabel);
      } else {
        $("label[for='pvc-trade-size']").html(window.TradeSizeLotsLabel);
      }
      $(document).on('change', '#pvc-pip-amount', function () {
        return myThis.RemoveResult();
      });
      $(document).on('change', '#pvc-trade-size', function () {
        return myThis.RemoveResult();
      });
      $(document).on('change', '#pvcCurrentPrice', function () {
        return myThis.RemoveResult();
      });
      $("#pvc-deposit-currency-select").on('change', function () {
        return myThis.OnCurrencyChanged();
      });
      $(document).on('click', '#pvc-calculate-button', function () {
        return myThis.CalculateResult();
      });
      $(document).on('click', '#pvc-trade-size-popover-link', function () {
        return myThis.calculatorHelperInstance.SwitchUnitsLots(_this, "pvc", myThis.symbolInfo);
      });
    }
  }, {
    key: "UpdateCalculatorSymbol",
    value: function UpdateCalculatorSymbol(ticker, symbol) {
      var myThis = this;
      myThis.symbolSearchControl.chartSymbolSearch('setSymbol', ticker, symbol);
      myThis.parameters.ticker = ticker;
      myThis.parameters.symbol = symbol;
      myThis.calculatorHelperInstance.RetrieveToolSymbolInfo(myThis.parameters.ticker, function (info) {
        return myThis.OnSymbolInfoResolved(info, function () {
          return myThis.CalculateResult();
        });
      });
    }
  }, {
    key: "UpdatePopupLink",
    value: function UpdatePopupLink() {
      if ($("#pvc-widget-top-pane a.calc-popup-icon").length > 0) {
        var link = "";
        if (window.CURRENT_LANG != "en") link += "/" + window.CURRENT_LANG;
        link += "/widgets/pip-value-calculator?symbol=" + this.symbolInfo.symbol;
        for (var i = 0; i < $("#pvc-widget-top-pane a.calc-popup-icon").length; i++) {
          $("#pvc-widget-top-pane a.calc-popup-icon")[i].href = link;
        }
      }
    }
  }, {
    key: "RemoveResult",
    value: function RemoveResult() {
      document.getElementById('pvc-pip-value-result').innerHTML = "--";
    }
  }, {
    key: "CalculateResult",
    value: function CalculateResult() {
      var myThis = this;
      var form = document.getElementById('pvc-form');
      if (form === null) return;
      if (form.checkValidity() == false) {
        form.reportValidity();
        //form.classList.add('was-validated');
        return;
      }
      var depositCurrency = $(myThis.currencyControl).infiniteselect('val');
      var pipAmount = myThis.calculatorHelperInstance.ParseLocaleNumber(document.getElementById('pvc-pip-amount').value);
      var tradeSize = myThis.calculatorHelperInstance.ParseLocaleNumber(document.getElementById('pvc-trade-size').value);
      myThis.calcWidgetStyleInstance.AddTradeSizeHistory(myThis.symbolInfo.symbol, tradeSize, $("#pvc-trade-size-type").val());
      var onePipSize = myThis.calculatorHelperInstance.ParseLocaleNumber(document.getElementById("pvcCurrentPairPipSize").value);
      var oneLotSize = myThis.symbolInfo.lotSize;
      if ($("#pvc-trade-size-type").val() == "units") {
        oneLotSize = tradeSize;
        tradeSize = 1;
      }

      //var rate = window.CalculatorHelper.GetCalculatedExchangeRate(depositCurrency, quoteCurrency);
      var rate = myThis.calculatorHelperInstance.ParseLocaleNumber(document.getElementById("pvcCurrentPrice").value);
      if (rate == "NaN") {
        return;
      }
      $("#pip-value-calc-form span.result-span").html('<img class="result-loading-img" src="/Content/dist/images/PageElements/ajax-loader.svg" />');
      $.ajax({
        type: "POST",
        cache: false,
        dataType: "json",
        url: "/widgets/calculation/pip-value",
        data: {
          pipSize: onePipSize,
          lotSize: oneLotSize,
          rate: rate,
          pipAmount: pipAmount,
          tradeSize: tradeSize
        },
        success: function success(data) {
          if (data.success === true) {
            document.getElementById('pvc-pip-value-result').innerHTML = myThis.calculatorHelperInstance.ToLocaleNumberForResult(data.result, 'currency', 2, depositCurrency);
          } else {
            document.getElementById('pvc-pip-value-result').innerHTML = "NaN";
          }
        },
        error: function error() {
          document.getElementById('pvc-pip-value-result').innerHTML = "NaN";
        }
      });
    }
  }, {
    key: "OnSymbolInfoResolved",
    value: function OnSymbolInfoResolved(symbolInfo, callback, atInitialize) {
      var myThis = this;
      if (!symbolInfo) return;
      myThis.symbolInfo = symbolInfo;
      myThis.parameters.ticker = myThis.symbolInfo.ticker;
      myThis.parameters.symbol = myThis.symbolInfo.symbol;
      myThis.parameters.exchange = myThis.symbolInfo.exchange;
      myThis.calcWidgetStyleInstance.SetCalcCookieValue('ticker', myThis.parameters.ticker);
      myThis.calcWidgetStyleInstance.SetCalcCookieValue('symbol', myThis.symbolInfo.symbol.replace("/", "."));
      myThis.calcWidgetStyleInstance.SetCalcCookieValue('exchange', myThis.symbolInfo.exchange);
      UpdateCalcLiveChartPopoutLink('pvc-livechart-links', myThis.symbolInfo.symbol, this.calculatorHelperInstance.GetToolSymbolSlugFromTicker(myThis.symbolInfo.exchange, myThis.symbolInfo.symbol));
      myThis.calculatorHelperInstance.UpdateTradeSizeFields(myThis.symbolInfo, "pvc");
      myThis.UpdateOnePipSizeLabel();
      myThis.UpdateConversationPrice(callback);
      myThis.UpdatePopupLink();
      myThis.UpdateHrefAndTitle(atInitialize);
      myThis.UpdateOneLotPipValueLabel(window.CURRENT_CULTURE, myThis.symbolInfo);
      if (window.WatchlistInstance) {
        window.WatchlistInstance.VisitSymbol(myThis.symbolInfo);
      }
    }
  }, {
    key: "UpdateConversationPrice",
    value: function UpdateConversationPrice(callback) {
      var myThis = this;
      myThis.calculatorHelperInstance.UpdateConversationPriceFields(myThis.parameters.depositCurrency, myThis.symbolInfo.quoteCurrency, "pvc", callback);
    }
  }, {
    key: "UpdateOnePipSizeLabel",
    value: function UpdateOnePipSizeLabel() {
      var myThis = this;
      document.getElementById("pvcCurrentPairPipSize").readOnly = false;
      $("#pvcCurrentPairPipSize").attr('style', 'opacity: 1;');
      /*
      if (myThis.symbolInfo.type.toLowerCase() === "forex") {
          // $("#pcCurrentPairPipSize").attr('style', 'background-color: #E9ECEF; color: #777 !important;');
          $("#pvcCurrentPairPipSize").attr('style', 'opacity: .8;');
        } else {
          // $("#pcCurrentPairPipSize").attr('style', 'background-color: white; color: black;');
          $("#pvcCurrentPairPipSize").attr('style', 'opacity: 1;');
      }
      */

      document.getElementById("pvcCurrentPairPipSize").value = myThis.calculatorHelperInstance.ToLocaleNumberForInput(myThis.symbolInfo.onePipSize, {
        maximumFractionDigits: 5
      });
      document.getElementById("pvcCurrentPairPipSizeLabel").innerHTML = window._01PipSize.replace("{0}", myThis.symbolInfo.symbol);
    }
  }, {
    key: "UpdateHrefAndTitle",
    value: function UpdateHrefAndTitle(atInitialize) {
      var urlPart = "/tools/pip-calculator";
      if (!window.location.pathname.includes(urlPart) || window.location.hash == '#popout') return;
      if (!atInitialize || window.location.search.includes("?s=")) {
        this.calculatorHelperInstance.UpdateCalculatorTitle(this.symbolInfo);
        this.calculatorHelperInstance.UpdateCalculatorHrefs(urlPart, this.symbolInfo);
      } else {
        this.calculatorHelperInstance.UpdateCalculatorHrefs(urlPart, null);
      }
      if (!atInitialize) TriggerGoogleAnalytics();
    }
  }, {
    key: "OnCurrencyChanged",
    value: function OnCurrencyChanged() {
      var myThis = this;
      myThis.RemoveResult();
      myThis.parameters.depositCurrency = $(myThis.currencyControl).infiniteselect('val');
      myThis.UpdateConversationPrice();
    }
  }, {
    key: "OnSymbolChanged",
    value: function OnSymbolChanged(ticker, symbolData) {
      var myThis = this;
      myThis.RemoveResult();
      myThis.parameters.ticker = ticker;
      myThis.parameters.symbol = symbolData.symbol;
      var tradeSizeParams = myThis.calcWidgetStyleInstance.GetTradeSize(myThis.parameters.symbol);
      if (tradeSizeParams != null) {
        myThis.calculatorHelperInstance.SetTradeSizeFields('pvc', tradeSizeParams.size, tradeSizeParams.type);
      } else {
        if (symbolData.type && symbolData.type.toLowerCase() === 'forex') myThis.calculatorHelperInstance.SetTradeSizeFields('pvc', 1, 'lots');else myThis.calculatorHelperInstance.SetTradeSizeFields('pvc', 1, 'units');
      }
      myThis.calculatorHelperInstance.RetrieveToolSymbolInfo(ticker, function (info) {
        return myThis.OnSymbolInfoResolved(info);
      });
    }
  }, {
    key: "UpdateOneLotPipValueLabel",
    value: function UpdateOneLotPipValueLabel(localeCode, symbolInfo) {
      var queryParams = new URLSearchParams(window.location.search);
      if (!window.location.pathname.includes("tools/pip-calculator") || !queryParams.get('s') || $("#pip-calc-seo-paragraph").length == 0) return;
      if (localeCode.includes("ar") || localeCode.includes("fa")) localeCode = "en-GB";
      var html = '';
      html += '<h2>' + window.H2PipValueLabel.replaceAll("{0}", symbolInfo.symbol);
      if (symbolInfo.type.toLowerCase() !== "forex" && symbolInfo.description !== '') html += "- " + symbolInfo.description;
      html += "</h2>";
      if (symbolInfo.type.toLowerCase() === "forex") {
        html += '<p>' + window.ForexStandardLotPipValueText.replaceAll("{0}", symbolInfo.symbol).replaceAll("{1}", (symbolInfo.onePipSize * symbolInfo.lotSize).toLocaleString(localeCode, {
          style: "currency",
          maximumFractionDigits: 4,
          currency: symbolInfo.quoteCurrency
        })).replaceAll("{2}", 100000 .toLocaleString(localeCode)) + '</p>';
        html += '<p>' + window.ForexMiniLotPipValueText.replaceAll("{0}", symbolInfo.symbol).replaceAll("{1}", (symbolInfo.onePipSize * symbolInfo.lotSize / 10).toLocaleString(localeCode, {
          style: "currency",
          maximumFractionDigits: 4,
          currency: symbolInfo.quoteCurrency
        })).replaceAll("{2}", 10000 .toLocaleString(localeCode)) + '</p>';
        html += '<p>' + window.ForexMacroLotPipValueText.replaceAll("{0}", symbolInfo.symbol).replaceAll("{1}", (symbolInfo.onePipSize * symbolInfo.lotSize / 100).toLocaleString(localeCode, {
          style: "currency",
          maximumFractionDigits: 4,
          currency: symbolInfo.quoteCurrency
        })).replaceAll("{2}", 1000 .toLocaleString(localeCode)) + '</p>';
      } else {
        var val = 1;
        html += '<p>' + window.NonForexPipValueText.replaceAll("{0}", val.toLocaleString(localeCode, {
          maximumFractionDigits: 5
        })).replaceAll("{1}", symbolInfo.symbol).replaceAll("{2}", symbolInfo.onePipSize.toLocaleString(localeCode, {
          style: "currency",
          maximumFractionDigits: 4,
          currency: symbolInfo.quoteCurrency
        })) + '</p>';
      }
      var price = 1;
      var digit = 1;
      if (symbolInfo.onePipSize == 1) {
        price = 1;
        digit = 1;
      } else if (symbolInfo.onePipSize == 0.1) {
        price = 1.2;
        digit = 2;
      } else if (symbolInfo.onePipSize == 0.01) {
        price = 1.23;
        digit = 3;
      } else if (symbolInfo.onePipSize == 0.001) {
        price = 1.234;
        digit = 4;
      } else if (symbolInfo.onePipSize == 0.0001) {
        price = 1.2345;
        digit = 5;
      } else if (symbolInfo.onePipSize == 0.00001) {
        price = 1.23456;
        digit = 6;
      }
      html += '<p>' + window.PipSizeLabel.replaceAll("{0}", symbolInfo.symbol).replaceAll("{1}", symbolInfo.onePipSize.toLocaleString(localeCode, {
        maximumFractionDigits: 5
      })).replaceAll("{2}", price.toLocaleString(localeCode, {
        maximumFractionDigits: 5
      })).replaceAll("{3}", digit) + '</p>';
      document.getElementById('pip-calc-seo-paragraph').innerHTML = html;
    }
  }]);
}();
var _default = exports["default"] = PipValueCalculator;

},{"./CalcWidgetsStyle.js":4,"./CalculatorHelper.js":5,"./CustomChartSymbolSelectPlugin.js":7,"./InfiniteScrollSelectPlugin.js":8}],10:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _CalcWidgetsStyle = _interopRequireDefault(require("./CalcWidgetsStyle.js"));
var _CalculatorHelper = _interopRequireDefault(require("./CalculatorHelper.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
require('./CustomChartSymbolSelectPlugin.js');
require("./InfiniteScrollSelectPlugin.js");
var MarginCalculator = /*#__PURE__*/function () {
  function MarginCalculator() {
    _classCallCheck(this, MarginCalculator);
    this.calcWidgetStyleInstance = new _CalcWidgetsStyle["default"]();
    this.calculatorHelperInstance = new _CalculatorHelper["default"]();
    this.parameters = {
      ticker: 'EUR/USD',
      symbol: 'EUR/USD',
      exchange: '',
      depositCurrency: 'USD',
      tradeSize: 1,
      tradeSizeType: 'lots',
      leverage: 100
    };
    this.symbolSearchControl = null;
    this.currencyControl = null;
    this.symbolInfo = null;
  }
  return _createClass(MarginCalculator, [{
    key: "Initialize",
    value: function Initialize() {
      var myThis = this;
      myThis.InitCalculatorParams();
      myThis.InitializeComponents();
      myThis.calculatorHelperInstance.RetrieveToolSymbolInfo(myThis.parameters.ticker, function (info) {
        return myThis.OnSymbolInfoResolved(info, function () {
          return myThis.CalculateResult();
        }, true);
      });
    }
  }, {
    key: "InitCalculatorParams",
    value: function InitCalculatorParams() {
      var myThis = this;
      var toolParams = this.calculatorHelperInstance.GetToolParamsFromUrlAndCache();
      this.parameters.symbol = toolParams.symbol;
      this.parameters.exchange = toolParams.exchange;
      this.parameters.ticker = toolParams.ticker;
      this.parameters.depositCurrency = toolParams.depositCurrency;
      var tradeSizeParams = this.calcWidgetStyleInstance.GetTradeSize(this.parameters.symbol);
      if (tradeSizeParams != null) {
        this.parameters.tradeSize = tradeSizeParams.size;
        this.parameters.tradeSizeType = tradeSizeParams.type;
      }
      var cookieLeverage = myThis.calcWidgetStyleInstance.GetCalcCookieValue('mc-leverage');
      if (cookieLeverage != "") {
        this.parameters.leverage = cookieLeverage;
      }
    }
  }, {
    key: "InitializeComponents",
    value: function InitializeComponents() {
      var _this = this;
      var myThis = this;
      var hideStarIcon = false;
      var hideFavorites = false;
      if (window.location.pathname.includes("/widgets/")) {
        if (!window.allowAuthFeatures || !window.userIsOnline) {
          hideStarIcon = true;
          hideFavorites = true;
        }
      } else {
        if (!window.userIsOnline) {
          hideFavorites = true;
        }
      }
      this.symbolSearchControl = $("#mc-symbol-select-control").chartSymbolSearch('init', '/api/live-chart/datafeed', {
        onChange: function onChange(ticker, symbolData) {
          myThis.OnSymbolChanged(ticker, symbolData);
        },
        ticker: this.parameters.ticker,
        symbol: this.parameters.symbol,
        hideFavorites: hideFavorites,
        hideStarIcon: hideStarIcon
      });
      this.currencyControl = $("#mc-deposit-currency-select").infiniteselect({
        types: [{
          option: 'all',
          text: 'All'
        }, {
          option: 'forex',
          text: 'Forex'
        }, {
          option: 'crypto',
          text: 'Crypto'
        }],
        url: '/api/widgets/currencies',
        placeholder: 'Select',
        "default": this.parameters.depositCurrency,
        showDescription: true,
        culture: window.CURRENT_LANG,
        btnClass: 'widget-input-override frn-override'
      });
      document.getElementById("mc-trade-size-type").value = this.parameters.tradeSizeType;
      document.getElementById("mc-trade-size").value = this.parameters.tradeSize;
      if (this.parameters.tradeSizeType == "units") {
        $("label[for='mc-trade-size']").html(window.TradeSizeUnitsLabel);
      } else {
        $("label[for='mc-trade-size']").html(window.TradeSizeLotsLabel);
      }
      $("#mcMarginRatioSelect").val(parseInt(this.parameters.leverage) + ":1");
      $("#mcMarginRatioSelect").on('click', function (e) {
        $(this).select();
      });
      $(document).on('change', '#pvc-pip-amount', function () {
        return myThis.RemoveResult();
      });
      $(document).on('change', '#mc-trade-size', function () {
        return myThis.RemoveResult();
      });
      $(document).on('change', '#mcCurrentPrice', function () {
        return myThis.RemoveResult();
      });
      $(document).on('change', "#mcMarginRatioSelect", function () {
        return myThis.RemoveResult();
      });
      $("#mc-deposit-currency-select").on('change', function () {
        return myThis.OnCurrencyChanged();
      });
      $(document).on('click', '#mc-calculate-button', function () {
        return myThis.CalculateResult();
      });
      $(document).on('click', '#mc-trade-size-popover-link', function () {
        return myThis.calculatorHelperInstance.SwitchUnitsLots(_this, "mc", myThis.symbolInfo);
      });
    }
  }, {
    key: "UpdateCalculatorSymbol",
    value: function UpdateCalculatorSymbol(ticker, symbol) {
      var myThis = this;
      myThis.symbolSearchControl.chartSymbolSearch('setSymbol', ticker, symbol);
      myThis.parameters.ticker = ticker;
      myThis.parameters.symbol = symbol;
      myThis.calculatorHelperInstance.RetrieveToolSymbolInfo(myThis.parameters.ticker, function (info) {
        return myThis.OnSymbolInfoResolved(info, function () {
          return myThis.CalculateResult();
        });
      });
    }
  }, {
    key: "UpdatePopupLink",
    value: function UpdatePopupLink() {
      if ($("#margin-calc-widget-top-pane a.calc-popup-icon").length > 0) {
        var link = "";
        if (window.CURRENT_LANG != "en") link += "/" + window.CURRENT_LANG;
        link += "/widgets/margin-calculator?symbol=" + this.symbolInfo.symbol;
        for (var i = 0; i < $("#margin-calc-widget-top-pane a.calc-popup-icon").length; i++) {
          $("#margin-calc-widget-top-pane a.calc-popup-icon")[i].href = link;
        }
      }
    }
  }, {
    key: "RemoveResult",
    value: function RemoveResult() {
      document.getElementById('margin-result').innerHTML = "--";
      if (!parseInt($("#mcMarginRatioSelect").val())) $("#mcMarginRatioSelect").val("100:1");else $("#mcMarginRatioSelect").val(parseInt($("#mcMarginRatioSelect").val()) + ":1");
    }
  }, {
    key: "CalculateResult",
    value: function CalculateResult() {
      var myThis = this;
      var form = document.getElementById('margin-calc-form');
      if (form.checkValidity() == false) {
        form.reportValidity();
        //form.classList.add('was-validated');
        return;
      }
      var accountCurrency = myThis.parameters.depositCurrency;
      var lotSize = myThis.symbolInfo.lotSize;
      var lots = myThis.calculatorHelperInstance.ParseLocaleNumber(document.getElementById('mc-trade-size').value);
      myThis.calcWidgetStyleInstance.AddTradeSizeHistory(myThis.symbolInfo.symbol, lots, $("#mc-trade-size-type").val());
      if ($("#mc-trade-size-type").val() == "units") {
        lotSize = lots;
        lots = 1;
      }
      var tradeSize = lots * lotSize; // if trade-size-type == "units" --> tradeSize = units
      var leverage = parseInt($("#mcMarginRatioSelect").val());
      myThis.calcWidgetStyleInstance.SetCalcCookieValue('mc-leverage', leverage);
      var rate = myThis.calculatorHelperInstance.ParseLocaleNumber(document.getElementById('mcCurrentPrice').value);
      if (rate == "NaN") {
        return;
      }
      $("#margin-calc-form span.result-span").html('<img class="result-loading-img" src="/Content/dist/images/PageElements/ajax-loader.svg" />');
      $.ajax({
        type: "POST",
        cache: false,
        dataType: "json",
        url: "/widgets/calculation/margin",
        data: {
          tradeSize: tradeSize,
          leverage: leverage,
          rate: rate
        },
        success: function success(data) {
          if (data.success === true) {
            document.getElementById('margin-result').innerHTML = myThis.calculatorHelperInstance.ToLocaleNumberForResult(data.result, 'currency', 2, accountCurrency);
          } else {
            document.getElementById('margin-result').innerHTML = "NaN";
          }
        },
        error: function error() {
          document.getElementById('margin-result').innerHTML = "NaN";
        }
      });
    }
  }, {
    key: "OnSymbolInfoResolved",
    value: function OnSymbolInfoResolved(symbolInfo, callback, atInitialize) {
      var myThis = this;
      if (!symbolInfo) return;
      myThis.symbolInfo = symbolInfo;
      myThis.parameters.ticker = myThis.symbolInfo.ticker;
      myThis.parameters.symbol = myThis.symbolInfo.symbol;
      myThis.parameters.exchange = myThis.symbolInfo.exchange;
      myThis.calcWidgetStyleInstance.SetCalcCookieValue('ticker', myThis.parameters.ticker);
      myThis.calcWidgetStyleInstance.SetCalcCookieValue('symbol', myThis.symbolInfo.symbol.replace("/", "."));
      myThis.calcWidgetStyleInstance.SetCalcCookieValue('exchange', myThis.symbolInfo.exchange);
      UpdateCalcLiveChartPopoutLink('mc-livechart-links', myThis.symbolInfo.symbol, this.calculatorHelperInstance.GetToolSymbolSlugFromTicker(myThis.symbolInfo.exchange, myThis.symbolInfo.symbol));
      myThis.calculatorHelperInstance.UpdateTradeSizeFields(myThis.symbolInfo, "mc");
      myThis.UpdateConversationPrice(callback);
      myThis.UpdatePopupLink();
      myThis.UpdateHrefAndTitle(atInitialize);
      if (window.WatchlistInstance) {
        window.WatchlistInstance.VisitSymbol(myThis.symbolInfo);
      }
    }
  }, {
    key: "UpdateConversationPrice",
    value: function UpdateConversationPrice(callback) {
      var myThis = this;
      var showCurrency = myThis.symbolInfo.baseCurrency + "/" + myThis.parameters.depositCurrency;
      document.getElementById("mcCurrentPriceLabel").innerHTML = showCurrency;
      if (myThis.symbolInfo.baseCurrency == myThis.parameters.depositCurrency) {
        $("#mc-current-price-form-group").css("display", "none");
        document.getElementById("mcCurrentPrice").value = myThis.calculatorHelperInstance.ToLocaleNumberForInput(1, {
          minimumFractionDigits: 5
        });
        if (callback && typeof callback === 'function') callback();
      } else {
        myThis.calculatorHelperInstance.GetExchangeRateAsync(myThis.symbolInfo.quoteCurrency, myThis.parameters.depositCurrency).then(function (res) {
          var currentPrice = myThis.symbolInfo.price * res.rate;
          if (currentPrice < 0) currentPrice = "NaN";
          document.getElementById("mcCurrentPrice").value = myThis.calculatorHelperInstance.ToLocaleNumberForInput(currentPrice, {
            minimumFractionDigits: 5
          });
          $("#mc-current-price-form-group").css("display", "block");
          if (callback && typeof callback === 'function') callback();
        });
      }
    }
  }, {
    key: "UpdateHrefAndTitle",
    value: function UpdateHrefAndTitle(atInitialize) {
      var urlPart = "/tools/margin-calculator";
      if (!window.location.pathname.includes(urlPart) || window.location.hash == '#popout') return;
      if (!atInitialize || window.location.search.includes("?s=")) {
        this.calculatorHelperInstance.UpdateCalculatorTitle(this.symbolInfo);
        this.calculatorHelperInstance.UpdateCalculatorHrefs(urlPart, this.symbolInfo);
      } else {
        this.calculatorHelperInstance.UpdateCalculatorHrefs(urlPart, null);
      }
      if (!atInitialize) TriggerGoogleAnalytics();
    }
  }, {
    key: "OnCurrencyChanged",
    value: function OnCurrencyChanged() {
      var myThis = this;
      myThis.RemoveResult();
      myThis.parameters.depositCurrency = $(myThis.currencyControl).infiniteselect('val');
      myThis.UpdateConversationPrice();
    }
  }, {
    key: "OnSymbolChanged",
    value: function OnSymbolChanged(ticker, symbolData) {
      var myThis = this;
      myThis.RemoveResult();
      myThis.parameters.ticker = ticker;
      myThis.parameters.symbol = symbolData.symbol;
      var tradeSizeParams = myThis.calcWidgetStyleInstance.GetTradeSize(myThis.parameters.symbol);
      if (tradeSizeParams != null) {
        myThis.calculatorHelperInstance.SetTradeSizeFields('mc', tradeSizeParams.size, tradeSizeParams.type);
      } else {
        if (symbolData.type && symbolData.type.toLowerCase() === 'forex') myThis.calculatorHelperInstance.SetTradeSizeFields('mc', 1, 'lots');else myThis.calculatorHelperInstance.SetTradeSizeFields('mc', 1, 'units');
      }
      myThis.calculatorHelperInstance.RetrieveToolSymbolInfo(ticker, function (info) {
        return myThis.OnSymbolInfoResolved(info);
      });
    }
  }]);
}();
var _default = exports["default"] = MarginCalculator;

},{"./CalcWidgetsStyle.js":4,"./CalculatorHelper.js":5,"./CustomChartSymbolSelectPlugin.js":7,"./InfiniteScrollSelectPlugin.js":8}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _CalcWidgetsStyle = _interopRequireDefault(require("./CalcWidgetsStyle"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CalculatorHelper = exports["default"] = /*#__PURE__*/function () {
  function CalculatorHelper() {
    _classCallCheck(this, CalculatorHelper);
    this.calcWidgetStyleInstance = new _CalcWidgetsStyle["default"]();
    this.CurrencyPairs = new Object();
    this.StandardLotSize = 100000;
    this.ISOCurrencyList = ["AFN", "EUR", "ALL", "DZD", "USD", "EUR", "AOA", "XCD", "XCD", "ARS", "AMD", "AWG", "AUD", "EUR", "AZN", "BSD", "BHD", "BDT", "BBD", "BYN", "EUR", "BZD", "XOF", "BMD", "INR", "BTN", "BOB", "BOV", "USD", "BAM", "BWP", "NOK", "BRL", "USD", "BND", "BGN", "XOF", "BIF", "CVE", "KHR", "XAF", "CAD", "KYD", "XAF", "XAF", "CLP", "CLF", "CNY", "AUD", "AUD", "COP", "COU", "KMF", "CDF", "XAF", "NZD", "CRC", "XOF", "HRK", "CUP", "CUC", "ANG", "EUR", "CZK", "DKK", "DJF", "XCD", "DOP", "USD", "EGP", "SVC", "USD", "XAF", "ERN", "EUR", "SZL", "ETB", "EUR", "FKP", "DKK", "FJD", "EUR", "EUR", "EUR", "XPF", "EUR", "XAF", "GMD", "GEL", "EUR", "GHS", "GIP", "EUR", "DKK", "XCD", "EUR", "USD", "GTQ", "GBP", "GNF", "XOF", "GYD", "HTG", "USD", "AUD", "EUR", "HNL", "HKD", "HUF", "ISK", "INR", "IDR", "XDR", "IRR", "IQD", "EUR", "GBP", "ILS", "EUR", "JMD", "JPY", "GBP", "JOD", "KZT", "KES", "AUD", "KPW", "KRW", "KWD", "KGS", "LAK", "EUR", "LBP", "LSL", "ZAR", "LRD", "LYD", "CHF", "EUR", "EUR", "MOP", "MKD", "MGA", "MWK", "MYR", "MVR", "XOF", "EUR", "USD", "EUR", "MRU", "MUR", "EUR", "XUA", "MXN", "MXV", "USD", "MDL", "EUR", "MNT", "EUR", "XCD", "MAD", "MZN", "MMK", "NAD", "ZAR", "AUD", "NPR", "EUR", "XPF", "NZD", "NIO", "XOF", "NGN", "NZD", "AUD", "USD", "NOK", "OMR", "PKR", "USD", "PAB", "USD", "PGK", "PYG", "PEN", "PHP", "NZD", "PLN", "EUR", "USD", "QAR", "EUR", "RON", "RUB", "RWF", "EUR", "SHP", "XCD", "XCD", "EUR", "EUR", "XCD", "WST", "EUR", "STN", "SAR", "XOF", "RSD", "SCR", "SLL", "SGD", "ANG", "XSU", "EUR", "EUR", "SBD", "SOS", "ZAR", "SSP", "EUR", "LKR", "SDG", "SRD", "NOK", "SEK", "CHF", "CHE", "CHW", "SYP", "TWD", "TJS", "TZS", "THB", "USD", "XOF", "NZD", "TOP", "TTD", "TND", "TRY", "TMT", "USD", "AUD", "UGX", "UAH", "AED", "GBP", "USD", "USD", "USN", "UYU", "UYI", "UYW", "UZS", "VUV", "VES", "VND", "USD", "USD", "XPF", "MAD", "YER", "ZMW", "ZWL", "XBA", "XBB", "XBC", "XBD", "XTS", "XXX", "XAU", "XPD", "XPT", "XAG"];
    this.CryptoCurrencies = ["BTC", "ETH", "LTC", "XRP", "BCH", "DSH", "EOS", "XMR", "BSV", "BNB", "XLM"];
    this.Metals = ["XAU", "XAG"];
    this.CurrencyList = new Object();
    this.SymbolRates = new Object();
    this.icMarketsIndices = ['AUS200', 'CA60', 'CHINA50', 'CHINAH', 'DE30', 'DE40', 'ES35', 'F40', 'HK50', 'IT40', 'JP225', 'MidDE50', 'MidDE60', 'NETH25', 'NOR25', 'SA40', 'SE30', 'STOXX50', 'SWI2010037', 'TecDE30', 'UK100', 'US2000', 'US30', 'US500', 'USTEC'];
    this.oldSymbolMaps = {
      "AUDCAD": "AUD/CAD",
      "AUDCHF": "AUD/CHF",
      "AUDJPY": "AUD/JPY",
      "AUDNZD": "AUD/NZD",
      "AUDUSD": "AUD/USD",
      "CADCHF": "CAD/CHF",
      "CADJPY": "CAD/JPY",
      "CHFJPY": "CHF/JPY",
      "GBPAUD": "GBP/AUD",
      "GBPCAD": "GBP/CAD",
      "GBPCHF": "GBP/CHF",
      "GBPJPY": "GBP/JPY",
      "GBPNZD": "GBP/NZD",
      "GBPUSD": "GBP/USD",
      "EURAUD": "EUR/AUD",
      "EURCAD": "EUR/CAD",
      "EURCHF": "EUR/CHF",
      "EURGBP": "EUR/GBP",
      "EURJPY": "EUR/JPY",
      "EURNZD": "EUR/NZD",
      "EURUSD": "EUR/USD",
      "NZDCAD": "NZD/CAD",
      "NZDCHF": "NZD/CHF",
      "NZDJPY": "NZD/JPY",
      "NZDUSD": "NZD/USD",
      "USDCAD": "USD/CAD",
      "USDCHF": "USD/CHF",
      "USDCNH": "USD/CNH",
      "USDJPY": "USD/JPY",
      "USDMXN": "USD/MXN",
      "XAGUSD": "XAG/USD",
      "XAUUSD": "XAU/USD",
      "BTCUSD": "BTC/USD",
      "ETHUSD": "ETH/USD",
      "XRPUSD": "XRP/USD",
      "LTCUSD": "LTC/USD",
      "EOSUSD": "EOS/USD",
      "XLMUSD": "XLM/USD",
      "BCHUSD": "BCH/USD",
      "TRYJPY": "TRY/JPY",
      "USDSEK": "USD/SEK",
      "EURSEK": "EUR/SEK",
      "EURNOK": "EUR/NOK",
      "USDNOK": "USD/NOK",
      "USDZAR": "USD/ZAR",
      "USDHKD": "USD/HKD",
      "USDTRY": "USD/TRY",
      "EURTRY": "EUR/TRY",
      "USDILS": "USD/ILS",
      "XTIUSD": "WTI/USD",
      "XTI.USD": "WTI/USD",
      "US500": "[US500]",
      "NZDSGD": "NZD/SGD",
      "US30": "[US30]",
      "AUS200": "[AUS200]",
      "USDSGD": "USD/SGD",
      "SGDJPY": "SGD/JPY",
      "AUDSGD": "AUD/SGD",
      "EURSGD": "EUR/SGD",
      "BTCJPY": "BTC/JPY",
      "STOXX50": "[STOXX50]",
      "UK100": "[UK100]",
      "EURDKK": "EUR/DKK",
      "USDDKK": "USD/DKK",
      "EURMXN": "EUR/MXN",
      "NOKJPY": "NOK/JPY",
      "EURZAR": "EUR/ZAR",
      "EURHKD": "EUR/HKD",
      "CHFSGD": "CHF/SGD",
      "GBPSGD": "GBP/SGD",
      "USDRUB": "USD/RUB",
      "GBPNOK": "GBP/NOK",
      "CADSGD": "CAD/SGD",
      "EURRUB": "EUR/RUB",
      "CHINA50": "[CHINA50]",
      "USDPLN": "USD/PLN",
      "EURPLN": "EUR/PLN",
      "XBRUSD": "XBR/USD",
      "FRA40": "[F40]",
      "GER40": "[DE40]",
      "JPN225": "[JP225]",
      "US100": "[USTEC]",
      "US2000": "[US2000]",
      "GBPSEK": "GBP/SEK",
      "GBPMXN": "GBP/MXN",
      "ZARJPY": "ZAR/JPY",
      "USDHUF": "USD/HUF",
      "EURHUF": "EUR/HUF",
      "GBPTRY": "GBP/TRY",
      "SEKJPY": "SEK/JPY",
      "GBPDKK": "GBP/DKK",
      "USDTHB": "USD/THB",
      "GBPPLN": "GBP/PLN",
      "AUDPLN": "AUD/PLN",
      "AUDNOK": "AUD/NOK",
      "AUDSEK": "AUD/SEK",
      "GBPHUF": "GBP/HUF",
      "USDCZK": "USD/CZK",
      "EURCZK": "EUR/CZK",
      "GBPCZK": "GBP/CZK",
      "XNGUSD": "XNG/USD",
      "USDRON": "USD/RON",
      "EURRON": "EUR/RON",
      "HK50": "[HK50]",
      "USDCNY": "USD/CNY",
      "XAUEUR": "XAU/EUR",
      "XPTUSD": "XPT/USD",
      "ES35": "[ES35]",
      "GBPZAR": "GBP/ZAR",
      "XPDUSD": "XPD/USD",
      "DSHUSD": "DSH/USD",
      "USDINR": "USD/INR",
      "XCUUSD": "XG/USD",
      "XAUAUD": "XAU/AUD",
      "BTCEUR": "BTC/EUR",
      "IT40": "[IT40]",
      "GBPHKD": "GBP/HKD",
      "NOKSEK": "NOK/SEK",
      "USDBRL": "USD/BRL",
      "XAGEUR": "XAG/EUR",
      "XAUGBP": "XAU/GBP",
      "XAUJPY": "XAU/JPY",
      "CA60": "[CA60]",
      "NETH25": "[NETH25]",
      "SWI20": "SIX-SPI20",
      "CHINAH": "[CHINAH]",
      "XAGAUD": "XAG/AUD",
      "CHFSEK": "CHF/SEK",
      "XAUCHF": "XAU/CHF",
      "USDTUSD": "USDT/USD",
      "LINKUSD": "LINK/USD",
      "USDCUSD": "USDC/USD",
      "WBTCUSD": "WBTC/USD",
      "DOGEUSD": "DOGE/USD",
      "AAVEUSD": "AAVE/USD",
      "THETAUSD": "THETA/USD",
      "ATOMUSD": "ATOM/USD",
      "SUSHIUSD": "SUSHI/USD",
      "COMPUSD": "COMP/USD",
      "HTUSD": "HT/USD",
      "IOTAUSD": "IOTA/USD",
      "EGLDUSD": "EGLD/USD",
      "AVAXUSD": "AVAX/USD",
      "DOTUSD": "DOT/USD",
      "ADAUSD": "ADA/USD",
      "BNBUSD": "BNB/USD",
      "UNIUSD": "UNI/USD",
      "BSVUSD": "BSV/USD",
      "XMRUSD": "XMR/USD",
      "XEMUSD": "XEM/USD",
      "SNXUSD": "SNX/USD",
      "TRXUSD": "TRX/USD",
      "XTZUSD": "XTZ/USD",
      "VETUSD": "VET/USD",
      "CELUSD": "CEL/USD",
      "NEOUSD": "NEO/USD",
      "DAIUSD": "DAI/USD",
      "OKBUSD": "OKB/USD",
      "MKRUSD": "MKR/USD",
      "CROUSD": "CRO/USD",
      "LEOUSD": "LEO/USD",
      "SOLUSD": "SOL/USD",
      "FTTUSD": "FTT/USD",
      "FILUSD": "FIL/USD",
      "ZECUSD": "ZEC/USD",
      "LUNAUSD": "LUNA/USD",
      "SHIBUSD": "SHIB/USD"
    };
  }
  return _createClass(CalculatorHelper, [{
    key: "InitCurrencyPairData",
    value: function InitCurrencyPairData(callback) {
      var url = "/api/widgets/get-currency-pairs";
      if (window.GetCurrencyPairDataUrl != undefined) url = window.GetCurrencyPairDataUrl;
      var myThis = this;
      $.ajax({
        type: "GET",
        cache: false,
        dataType: "json",
        url: url,
        success: function success(data) {
          if (data.success === true) {
            for (var i = 0; i < data.currencyPairs.length; i++) {
              myThis.CurrencyPairs[data.currencyPairs[i].SymbolName] = data.currencyPairs[i];
              if (myThis.SymbolRates[data.currencyPairs[i].BaseCurrency] == undefined) myThis.SymbolRates[data.currencyPairs[i].BaseCurrency] = new Object();
              myThis.SymbolRates[data.currencyPairs[i].BaseCurrency][data.currencyPairs[i].QuoteCurrency] = data.currencyPairs[i].SymbolRate;
              if (myThis.SymbolRates[data.currencyPairs[i].QuoteCurrency] == undefined) myThis.SymbolRates[data.currencyPairs[i].QuoteCurrency] = new Object();
              myThis.SymbolRates[data.currencyPairs[i].QuoteCurrency][data.currencyPairs[i].BaseCurrency] = 1 / data.currencyPairs[i].SymbolRate;
            }
            myThis.CryptoCurrencies = data.cryptoCurrencies;
            myThis.Metals = data.metalCurrencies;
            for (var i = 0; i < data.currencyList.length; i++) {
              myThis.CurrencyList[data.currencyList[i].GlobalCurrencyName] = data.currencyList[i];
            }
            if (callback != undefined) callback();
          } else {
            //window.location.reload();
          }
        },
        error: function error() {
          //window.location.reload();
        }
      });
    }
  }, {
    key: "GetLotSize",
    value: function GetLotSize(symbol) {
      if (this.CurrencyPairs[symbol] != undefined) {
        return this.CurrencyPairs[symbol].LotSize;
      }
      return 100000;
    }
  }, {
    key: "GetCalculatedExchangeRate",
    value: function GetCalculatedExchangeRate(firstCur, secondCur) {
      var rate = this.GetCurrencyPairPrice(firstCur, secondCur);
      if (rate > 0) return rate;
      var currencies = Object.keys(this.CurrencyList);
      for (var i = 0; i < currencies.length; i++) {
        var first_usd = this.GetCurrencyPairPrice(firstCur, currencies[i]);
        var usd_sec = this.GetCurrencyPairPrice(currencies[i], secondCur);
        if (first_usd != -1 && usd_sec != -1) return first_usd * usd_sec;
      }
      return this.GetCalculatedExchangeRate(firstCur, "USD") * this.GetCalculatedExchangeRate("USD", secondCur);
    }
  }, {
    key: "GetCurrencyPairPrice",
    value: function GetCurrencyPairPrice(firstCurr, secondCurr) {
      if (firstCurr == secondCurr) return 1;
      if (this.SymbolRates.hasOwnProperty(firstCurr) && this.SymbolRates[firstCurr].hasOwnProperty(secondCurr)) {
        return this.SymbolRates[firstCurr][secondCurr];
      }
      return -1;
    }
  }, {
    key: "GetPipSize",
    value: function GetPipSize(symbol) {
      if (this.CurrencyPairs[symbol] != undefined) {
        return this.CurrencyPairs[symbol].PipSize;
      }
      return 0.0001;
    }
  }, {
    key: "GetQuoteCurrency",
    value: function GetQuoteCurrency(currencyPair) {
      if (this.CurrencyPairs[currencyPair] == undefined) return "NaN";
      return this.CurrencyPairs[currencyPair].QuoteCurrency;
    }
  }, {
    key: "GetBaseCurrency",
    value: function GetBaseCurrency(currencyPair) {
      if (this.CurrencyPairs[currencyPair] == undefined) return "NaN";
      return this.CurrencyPairs[currencyPair].BaseCurrency;
    }
  }, {
    key: "GetCurrencyFullName",
    value: function GetCurrencyFullName(currency) {
      if (this.CurrencyList[currency] == undefined) return currency;
      if (this.CurrencyList[currency].CurrencyFullName == undefined || this.CurrencyList[currency].CurrencyFullName == "") return currency;
      return this.CurrencyList[currency].CurrencyFullName;
    }
  }, {
    key: "GetCurrencyPairFullName",
    value: function GetCurrencyPairFullName(symbol) {
      if (!this.CurrencyPairs.hasOwnProperty(symbol) || this.CurrencyPairs[symbol].FullName == "") return symbol;
      if (this.IsCryptoSymbol(symbol) || this.IsMetalSymbol(symbol)) return this.CurrencyPairs[symbol].DisplaySymbolName + " " + this.CurrencyPairs[symbol].FullName;
      return this.CurrencyPairs[symbol].FullName;
    }
  }, {
    key: "GetCurrencyPairDisplayName",
    value: function GetCurrencyPairDisplayName(symbol) {
      if (!this.CurrencyPairs.hasOwnProperty(symbol) || this.CurrencyPairs[symbol].FullName == "") return symbol;
      return this.CurrencyPairs[symbol].DisplaySymbolName;
    }
  }, {
    key: "ParseLocaleNumber",
    value: function ParseLocaleNumber(stringNumber) {
      /*
      var localeCode = window.CURRENT_CULTURE;
      if (localeCode.includes("ar") || localeCode.includes("fa"))
          localeCode = window.DEFAULT_CULTURE;
      
      var thousandSeparator = (11111).toLocaleString(localeCode).replace(/1/g, '');
      var decimalSeparator = (1.1).toLocaleString(localeCode).replace(/1/g, '');
      if (thousandSeparator == "")
          thousandSeparator = 'g';
      return parseFloat(stringNumber
          .replace(new RegExp('\\' + thousandSeparator, 'g'), '')
          .replace(new RegExp('\\' + decimalSeparator), '.')
      );
      */
      var decimalSeparator = ',';
      return parseFloat(stringNumber.replace(new RegExp('\\' + decimalSeparator), '.'));
    }
  }, {
    key: "ToLocaleNumberForInput",
    value: function ToLocaleNumberForInput(number, options) {
      if (options === undefined) options = {};
      var localeCode = window.CURRENT_CULTURE;
      if (localeCode.includes("ar") || localeCode.includes("fa")) localeCode = window.DEFAULT_CULTURE;
      var thousandSeparator = 11111 .toLocaleString(localeCode).replace(/1/g, '');
      if (thousandSeparator == "") thousandSeparator = 'g';
      var decimalCount = 3;
      var t = Math.abs(number);
      if (t != 0) {
        while (t < 0.1) {
          t = t * 10;
          decimalCount = decimalCount + 1;
        }
      }
      if (options.maximumFractionDigits == undefined || options.maximumFractionDigits < decimalCount) {
        if (options.minimumFractionDigits != undefined) options.maximumFractionDigits = Math.max(options.minimumFractionDigits, decimalCount);else options.maximumFractionDigits = decimalCount;
      }
      return number.toLocaleString(localeCode, options).replace(new RegExp('\\' + thousandSeparator, 'g'), '');
    }
  }, {
    key: "ToLongDecimalNumberForInput",
    value: function ToLongDecimalNumberForInput(number) {
      var localeCode = window.CURRENT_CULTURE;
      if (localeCode.includes("ar") || localeCode.includes("fa")) localeCode = window.DEFAULT_CULTURE;
      var thousandSeparator = 11111 .toLocaleString(localeCode).replace(/1/g, '');
      if (thousandSeparator == "") thousandSeparator = 'g';
      number = parseFloat(number);
      if (!number) number = 0;
      var decimalCount = 3;
      var t = Math.abs(number);
      if (t != 0) {
        while (t < 0.1) {
          t = t * 10;
          decimalCount = decimalCount + 1;
        }
      }
      return number.toLocaleString(localeCode, {
        maximumFractionDigits: decimalCount
      }).replace(new RegExp('\\' + thousandSeparator, 'g'), '');
    }
  }, {
    key: "ToLongDecimalNumberForResult",
    value: function ToLongDecimalNumberForResult(number, toStandard) {
      number = parseFloat(number);
      var localeCode = window.CURRENT_CULTURE;
      if (localeCode.includes("ar") || localeCode.includes("fa")) localeCode = window.DEFAULT_CULTURE;
      if (toStandard === true) localeCode = 'en';
      if (!number) number = 0;
      var decimalCount = 3;
      var t = Math.abs(number);
      if (t != 0) {
        while (t < 0.1) {
          t = t * 10;
          decimalCount = decimalCount + 1;
        }
      }
      return number.toLocaleString(localeCode, {
        maximumFractionDigits: decimalCount
      });
    }
  }, {
    key: "ToLocaleNumberForResult",
    value: function ToLocaleNumberForResult(number, style, maximumDigit, currency) {
      number = parseFloat(number);
      var localeCode = window.CURRENT_CULTURE;
      if (localeCode.includes("ar") || localeCode.includes("fa")) localeCode = window.DEFAULT_CULTURE;
      var decimalCount = 3;
      var t = Math.abs(number);
      if (t != 0) {
        while (t < 0.1) {
          t = t * 10;
          decimalCount = decimalCount + 1;
        }
      }
      if (style != 'percent' && Math.abs(parseFloat(number)) < 1.0) maximumDigit = Math.max(decimalCount, maximumDigit);else if (style == 'percent' && Math.abs(parseFloat(number)) < 0.01) maximumDigit = Math.max(decimalCount, maximumDigit);
      if (style == "percent") {
        return number.toLocaleString(localeCode, {
          style: "percent",
          maximumFractionDigits: maximumDigit
        });
      } else if (style == "currency") {
        if (this.ISOCurrencyList.includes(currency)) return number.toLocaleString(localeCode, {
          style: "currency",
          maximumFractionDigits: maximumDigit,
          currency: currency
        });else return number.toLocaleString(localeCode, {
          maximumFractionDigits: maximumDigit
        }) + ' ' + currency;
      } else {
        return number.toLocaleString(localeCode, {
          maximumFractionDigits: maximumDigit
        });
      }
    }
  }, {
    key: "IsForexSymbol",
    value: function IsForexSymbol(currencyPair) {
      if (!this.CurrencyPairs.hasOwnProperty(currencyPair)) return undefined;
      return this.CurrencyPairs[currencyPair].SymbolType == 0 && !this.IsMetalSymbol(currencyPair) && !this.IsCryptoSymbol(currencyPair);
    }
  }, {
    key: "IsMetalSymbol",
    value: function IsMetalSymbol(currencyPair) {
      if (!this.CurrencyPairs.hasOwnProperty(currencyPair)) return false;
      var baseCurrency = this.CurrencyPairs[currencyPair].BaseCurrency;
      var qutoeCurrency = this.CurrencyPairs[currencyPair].QuoteCurrency;
      if (baseCurrency.includes(qutoeCurrency)) {
        baseCurrency = baseCurrency.replace(qutoeCurrency, "");
      }
      return this.Metals.includes(baseCurrency) || this.Metals.includes(qutoeCurrency);
    }
  }, {
    key: "IsCryptoSymbol",
    value: function IsCryptoSymbol(currencyPair) {
      if (!this.CurrencyPairs.hasOwnProperty(currencyPair)) return false;
      var baseCurrency = this.CurrencyPairs[currencyPair].BaseCurrency;
      var qutoeCurrency = this.CurrencyPairs[currencyPair].QuoteCurrency;
      if (baseCurrency.includes(qutoeCurrency)) {
        baseCurrency = baseCurrency.replace(qutoeCurrency, "");
      }
      return this.CryptoCurrencies.includes(baseCurrency) || this.CryptoCurrencies.includes(qutoeCurrency);
    }
  }, {
    key: "IsSpecialSymbol",
    value: function IsSpecialSymbol(currencyPair) {
      return this.CurrencyPairs[currencyPair].SymbolType != 0;
    }
  }, {
    key: "IsExisitSymbol",
    value: function IsExisitSymbol(currencyPair) {
      return this.CurrencyPairs.hasOwnProperty(currencyPair);
    }
  }, {
    key: "GetTVSymbol",
    value: function GetTVSymbol(currencyPair) {
      if (!this.CurrencyPairs.hasOwnProperty(currencyPair)) return "";
      if (this.CurrencyPairs[currencyPair].ExcludeFromLiveChart) return "";
      if (!!this.CurrencyPairs[currencyPair].TVSymbol) return this.CurrencyPairs[currencyPair].TVSymbol;
      return currencyPair;
    }
  }, {
    key: "GenerateCalcPreviewLink",
    value: function GenerateCalcPreviewLink(WidgetConfig, calculatorSlug) {
      if (WidgetConfig.Url == undefined) {
        WidgetConfig.Url = "https://www.cashbackforex.com";
      }

      // assign url

      var frameSrc = WidgetConfig.Url;
      if (WidgetConfig.Lang != undefined) {
        if (WidgetConfig.Lang == 'page') WidgetConfig.Lang = window.CURRENT_LANG;
        frameSrc += '/' + WidgetConfig.Lang;
      }
      frameSrc += '/widgets/' + calculatorSlug;
      if (WidgetConfig.IsDisplayTitle === true) {
        frameSrc += "?IsDisplayTitle=true";
      } else {
        frameSrc += "?IsDisplayTitle=false";
      }
      if (WidgetConfig.IsShowChartLinks == false) {
        frameSrc += "&ShowChartLinks=false";
      } else {
        frameSrc += "&ShowChartLinks=true";
      }
      if (WidgetConfig.TopPaneStyle != undefined) {
        frameSrc += "&TopPaneStyle=" + WidgetConfig.TopPaneStyle;
      }
      if (WidgetConfig.BottomPaneStyle != undefined) {
        frameSrc += "&BottomPaneStyle=" + WidgetConfig.BottomPaneStyle;
      }
      if (WidgetConfig.ButtonStyle != undefined) {
        frameSrc += "&ButtonStyle=" + WidgetConfig.ButtonStyle;
      }
      return frameSrc;
    }
  }, {
    key: "GetExchangeRateAsync",
    value: function GetExchangeRateAsync(fromCurrency, toCurrency) {
      return new Promise(function (resolve, reject) {
        $.ajax({
          url: '/api/widgets/currencies/exchange-rate',
          data: {
            from: fromCurrency,
            to: toCurrency
          },
          type: 'GET',
          success: function success(res) {
            resolve(res);
          },
          error: function error() {
            console.error("exchange rate retrieve error");
            reject('network error');
          }
        });
      });
    }
  }, {
    key: "GenerateCustomSelect",
    value: function GenerateCustomSelect(selector) {
      $(selector).selectpicker({
        style: "frn-override widget-input-override",
        styleBase: "form-control",
        noneSelectedText: ""
      });
      var pickers = $(selector);
      for (var i = 0; i < pickers.length; i++) {
        var initVal = $(pickers[i]).attr("value");
        for (var j = 0; j < pickers[i].options.length; j++) {
          if (pickers[i].options[j].value == initVal) {
            $(pickers[i]).selectpicker("val", initVal);
            break;
          }
        }
      }
    }
  }, {
    key: "RetrieveToolSymbolInfo",
    value: function RetrieveToolSymbolInfo(symbol, onSymbolResolvedCallback) {
      var url = "/api/live-chart/datafeed/tool-symbols" + "?symbol=".concat(symbol) + "&lang=".concat(window.CURRENT_LANG);
      fetch(url).then(function (res) {
        return res.json();
      }).then(function (json) {
        onSymbolResolvedCallback(json);
      })["catch"](function (err) {
        console.log("failed to resolve tools symbol", symbol, err);
      });
    }
  }, {
    key: "GetToolSymbolSlugFromTicker",
    value: function GetToolSymbolSlugFromTicker(exchange, symbol) {
      var myThis = this;
      if (symbol.includes('/')) exchange = '';
      symbol = symbol.replace("/", ".");
      if (myThis.icMarketsIndices.includes(symbol)) {
        exchange = '';
        symbol = '[' + symbol + ']';
      }
      if (exchange) return exchange + "-" + symbol;else return symbol;
    }
  }, {
    key: "GetToolParamsFromUrlAndCache",
    value: function GetToolParamsFromUrlAndCache() {
      var pathName = window.location.pathname;
      if (pathName.endsWith("/")) pathName = pathName.substring(0, pathName.length - 1);
      var defaultInstrument = 'EUR/USD';
      var defaultExchange = '';
      var defaultTicker = '';
      var defaultDepositCurrency = "USD";
      if (pathName.endsWith("-calculator") || pathName.endsWith("tools/widgets")) {
        var queryParams = new URLSearchParams(window.location.search);
        var querySymbol = '';
        if (queryParams.get('s')) {
          querySymbol = queryParams.get('s');
        } else if (queryParams.get('DefaultInstrument')) {
          querySymbol = queryParams.get('DefaultInstrument');
        } else if (queryParams.get('symbol')) {
          querySymbol = queryParams.get('symbol');
        }
        if (querySymbol) {
          if (this.oldSymbolMaps[querySymbol.replace("-", "").toUpperCase()]) {
            querySymbol = this.oldSymbolMaps[querySymbol.replace("-", "").toUpperCase()];
          }
          if (querySymbol.includes("-")) {
            defaultExchange = querySymbol.split("-")[0];
            defaultInstrument = querySymbol.split("-")[1];
          } else {
            defaultInstrument = querySymbol;
          }
        } else {
          var cookieSymbol = this.calcWidgetStyleInstance.GetCalcCookieValue('symbol');
          if (cookieSymbol && this.oldSymbolMaps[cookieSymbol.toUpperCase()]) {
            cookieSymbol = this.oldSymbolMaps[cookieSymbol.toUpperCase()];
          }
          if (cookieSymbol) defaultInstrument = cookieSymbol;
          var cookieExchange = this.calcWidgetStyleInstance.GetCalcCookieValue('exchange');
          if (cookieExchange) defaultExchange = cookieExchange;
          var cookieTicker = this.calcWidgetStyleInstance.GetCalcCookieValue("ticker");
          if (cookieTicker) defaultTicker = cookieTicker;
        }
      } else if (pathName.includes("-calculator/")) {
        var urlSymbol = pathName.split("-calculator/")[1];
        if (urlSymbol) {
          if (this.oldSymbolMaps[urlSymbol.toUpperCase()]) {
            querySymbol = this.oldSymbolMaps[urlSymbol.toUpperCase()];
          }
          if (urlSymbol.includes("-")) {
            defaultExchange = urlSymbol.split("-")[0];
            defaultInstrument = urlSymbol.split("-")[1];
          } else {
            defaultInstrument = urlSymbol;
          }
        }
      }
      if (!defaultInstrument.endsWith(".")) defaultInstrument = defaultInstrument.replace(".", "/").replace("[", "").replace("]", "");
      if (!defaultTicker) {
        if (defaultExchange) defaultTicker = defaultExchange + ":" + defaultInstrument;else defaultTicker = defaultInstrument;
      }
      var depositCurrency = this.calcWidgetStyleInstance.GetDepositCurrencyCookie();
      if (depositCurrency) defaultDepositCurrency = depositCurrency;
      return {
        symbol: defaultInstrument,
        exchange: defaultExchange,
        ticker: defaultTicker,
        depositCurrency: defaultDepositCurrency
      };
    }
  }, {
    key: "GetPrefix",
    value: function GetPrefix(symbolInfo) {
      var prefix = symbolInfo.symbol;
      if (symbolInfo.type.toLowerCase() == "crypto" || symbolInfo.type.toLowerCase() == "metal") {
        if (symbolInfo.quoteCurrency.toLowerCase() == "usd") {
          prefix = symbolInfo.description.split(" / ")[0];
        }
      }
      return prefix;
    }
  }, {
    key: "GetSuffix",
    value: function GetSuffix(symbolInfo) {
      if (symbolInfo.type.toLowerCase() == "forex") return '';
      var suffix = symbolInfo.description;
      if (symbolInfo.quoteCurrency.toLowerCase() == "usd" && (symbolInfo.type.toLowerCase() == "crypto" || symbolInfo.type.toLowerCase() == "metal")) {
        suffix = symbolInfo.symbol;
      }
      return suffix;
    }
  }, {
    key: "GetCalculatorH1Title",
    value: function GetCalculatorH1Title(symbolInfo) {
      if (!window.originArticleH1Title) return "";
      var prefix = this.GetPrefix(symbolInfo);
      var suffix = this.GetSuffix(symbolInfo);
      var newH1Title = prefix + " " + window.originArticleH1Title;
      if (suffix != undefined && suffix != '') {
        newH1Title += " - " + suffix;
      }
      return newH1Title;
    }
  }, {
    key: "GetCalculatorPageTitle",
    value: function GetCalculatorPageTitle(symbolInfo) {
      if (!window.originArticlePageTitle) return "";
      var prefix = this.GetPrefix(symbolInfo);
      var suffix = this.GetSuffix(symbolInfo);
      var newPageTitle = prefix + " " + window.originArticlePageTitle;
      if (suffix != undefined && suffix != '') {
        newPageTitle += " - " + suffix;
      }
      return newPageTitle;
    }
  }, {
    key: "GetCalculatorSEODescription",
    value: function GetCalculatorSEODescription(symbolInfo) {
      if (!window.originArticleSEODescription) return "";
      return symbolInfo.symbol + ": " + window.originArticleSEODescription;
    }
  }, {
    key: "UpdateCalculatorTitle",
    value: function UpdateCalculatorTitle(symbolInfo) {
      var newH1Title = this.GetCalculatorH1Title(symbolInfo);
      var newPageTitle = this.GetCalculatorPageTitle(symbolInfo);
      var newSEODesc = this.GetCalculatorSEODescription(symbolInfo);
      if (newH1Title) $("h1.article-title").html(newH1Title);
      if (newPageTitle) $("title").html(newPageTitle);
      if (newSEODesc) $('meta[name="description"]').attr("content", newSEODesc);
    }
  }, {
    key: "UpdateCalculatorHrefs",
    value: function UpdateCalculatorHrefs(urlPart, symbolInfo) {
      var newPathAndQuery = '';
      if (window.CURRENT_LANG != "en") newPathAndQuery = "/" + window.CURRENT_LANG;
      if (!urlPart.startsWith('/')) urlPart = "/" + urlPart;
      newPathAndQuery += urlPart;
      if (symbolInfo) {
        var slug = this.GetToolSymbolSlugFromTicker(symbolInfo.exchange, symbolInfo.symbol);
        newPathAndQuery += "?s=" + slug;

        // update curreng page url
        window.history.replaceState({
          path: newPathAndQuery
        }, '', newPathAndQuery);
      }

      // update canonical links

      $("link[rel='canonical']").attr('href', window.location.protocol + "//" + window.location.host + newPathAndQuery);
      if (symbolInfo) {
        // update href links
        var hreflangs = $("link[hreflang]");
        for (var i = 0; i < hreflangs.length; i++) {
          hreflangs[i].href = this.GenerateNewLink(urlPart, hreflangs[i].href, symbolInfo.exchange, symbolInfo.symbol);
        }
        var symbolSlug = this.GetToolSymbolSlugFromTicker(symbolInfo.exchange, symbolInfo.symbol);

        //update language switch links
        var langSelectors = $("#lang-select li a");
        for (var i = 0; i < langSelectors.length; i++) {
          var newLink = this.GenerateNewLink(urlPart, langSelectors[i].href, symbolInfo.exchange, symbolInfo.symbol);
          var langCode = $("#lang-select li a i")[i].getAttribute("data-id").split('-')[0];
          langSelectors[i].href = newLink;
          if (langCode == "en") $(langSelectors[i]).attr("onclick", "return window.Language.Select('" + urlPart + "?s=" + symbolSlug + "','" + langCode + "')");else $(langSelectors[i]).attr("onclick", "return window.Language.Select('/" + langCode + urlPart + "?s=" + symbolSlug + "','" + langCode + "')");
        }
      }
    }
  }, {
    key: "GenerateNewLink",
    value: function GenerateNewLink(urlPart, oldUrl, exchange, symbol) {
      var slug = this.GetToolSymbolSlugFromTicker(exchange, symbol);

      /*
      var baseUrl = oldUrl.substring(0, oldUrl.toLowerCase().indexOf(urlPart) + urlPart.length);
      return baseUrl + "?s=" + slug;
      */
      var newUrl = oldUrl.split('?')[0] + "?s=" + slug;
      return newUrl;
    }
  }, {
    key: "UpdateTradeSizeFields",
    value: function UpdateTradeSizeFields(symbolInfo, prefix) {
      if (symbolInfo.type.toLowerCase() === 'forex') {
        /*
        if ($("#" + prefix + "-trade-size-popover-link").css("display") == "none") { // when swtich non-forex to forex
            document.getElementById(prefix + "-trade-size-type").value = "lots";
            document.getElementById(prefix + "-trade-size").value = 1;
            $("label[for='" + prefix + "-trade-size']").html(window.TradeSizeLotsLabel);
        } */

        $("#" + prefix + "-trade-size-popover-link").css("display", "block");
      } else {
        if (document.getElementById(prefix + "-trade-size-type").value !== "units") {
          document.getElementById(prefix + "-trade-size-type").value = "units";
          document.getElementById(prefix + "-trade-size").value = symbolInfo.lotSize;
          $("label[for='" + prefix + "-trade-size']").html(window.TradeSizeUnitsLabel);
        }
        $("#" + prefix + "-trade-size-popover-link").css("display", "none");
      }
      if (document.getElementById(prefix + "-trade-size-type").value == 'units') {
        $("#" + prefix + "-trade-size-popover-link").text(window.SwitchToLotsLabel);
      } else {
        $("#" + prefix + "-trade-size-popover-link").text(window.SwitchToUnitsLabel);
      }
    }
  }, {
    key: "UpdateConversationPriceFields",
    value: function UpdateConversationPriceFields(baseCurrency, quoteCurrency, prefix, callback) {
      var myThis = this;
      var showCurrency = baseCurrency + "/" + quoteCurrency;
      document.getElementById(prefix + "CurrentPriceLabel").innerHTML = showCurrency;
      myThis.GetExchangeRateAsync(baseCurrency, quoteCurrency).then(function (res) {
        var currentPrice = res.rate;
        if (currentPrice < 0) currentPrice = "NaN";
        document.getElementById(prefix + "CurrentPrice").value = myThis.ToLocaleNumberForInput(currentPrice, {
          minimumFractionDigits: 5
        });
        if (currentPrice == 1) {
          $("#" + prefix + "-current-price-form-group").css("display", "none");
        } else {
          $("#" + prefix + "-current-price-form-group").css("display", "block");
        }
        if (callback && typeof callback === 'function') callback();
      });
    }
  }, {
    key: "SetTradeSizeFields",
    value: function SetTradeSizeFields(prefix, size, type) {
      document.getElementById(prefix + "-trade-size-type").value = type;
      document.getElementById(prefix + "-trade-size").value = size;
      if (type == "units") {
        $("label[for='" + prefix + "-trade-size']").html(window.TradeSizeUnitsLabel);
      } else {
        $("label[for='" + prefix + "-trade-size']").html(window.TradeSizeLotsLabel);
      }
    }
  }, {
    key: "SwitchUnitsLots",
    value: function SwitchUnitsLots(e, prefix, symbolInfo) {
      var lotSize = symbolInfo.lotSize;
      var currentTradeSizeType = document.getElementById(prefix + "-trade-size-type").value;
      if (currentTradeSizeType == "lots") {
        document.getElementById(prefix + "-trade-size-type").value = "units";
        document.getElementById(prefix + "-trade-size").value = window.CalculatorHelper.ToLocaleNumberForInput(window.CalculatorHelper.ParseLocaleNumber(document.getElementById(prefix + "-trade-size").value) * lotSize);
        $("label[for='" + prefix + "-trade-size']").html(window.TradeSizeUnitsLabel);
        $("#" + prefix + "-trade-size-popover-link").text(window.SwitchToLotsLabel);
        e.innerHTML = window.SwitchToLotsLabel;
      } else {
        document.getElementById(prefix + "-trade-size-type").value = "lots";
        document.getElementById(prefix + "-trade-size").value = window.CalculatorHelper.ToLocaleNumberForInput(window.CalculatorHelper.ParseLocaleNumber(document.getElementById(prefix + "-trade-size").value) / lotSize);
        $("label[for='" + prefix + "-trade-size']").html(window.TradeSizeLotsLabel);
        $("#" + prefix + "-trade-size-popover-link").text(window.SwitchToUnitsLabel);
        e.innerHTML = window.SwitchToUnitsLabel;
      }
    }
  }]);
}();

},{"./CalcWidgetsStyle":4}],13:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _CalcWidgetsStyle = _interopRequireDefault(require("./CalcWidgetsStyle"));
var _CalculatorHelper = _interopRequireDefault(require("./CalculatorHelper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
require('./CustomChartSymbolSelectPlugin');
require('./InfiniteScrollSelectPlugin');
var ProfitCalculator = /*#__PURE__*/function () {
  function ProfitCalculator() {
    _classCallCheck(this, ProfitCalculator);
    this.calcWidgetStyleInstance = new _CalcWidgetsStyle["default"]();
    this.calculatorHelperInstance = new _CalculatorHelper["default"]();
    this.parameters = {
      ticker: 'EUR/USD',
      symbol: 'EUR/USD',
      exchange: '',
      depositCurrency: 'USD',
      balance: 100000,
      tradeSize: 1,
      tradeSizeType: 'lots',
      buyOrSell: 'buy'
    };
    this.symbolSearchControl = null;
    this.currencyControl = null;
    this.symbolInfo = null;
  }
  return _createClass(ProfitCalculator, [{
    key: "Initialize",
    value: function Initialize() {
      var myThis = this;
      myThis.InitCalculatorParams();
      myThis.InitializeComponents();
      myThis.calculatorHelperInstance.RetrieveToolSymbolInfo(myThis.parameters.ticker, function (info) {
        return myThis.OnSymbolInfoResolved(info, function () {
          return myThis.CalculateResult();
        }, true);
      });
    }
  }, {
    key: "InitCalculatorParams",
    value: function InitCalculatorParams() {
      var toolParams = this.calculatorHelperInstance.GetToolParamsFromUrlAndCache();
      this.parameters.symbol = toolParams.symbol;
      this.parameters.exchange = toolParams.exchange;
      this.parameters.ticker = toolParams.ticker;
      this.parameters.depositCurrency = toolParams.depositCurrency;
      var tradeSizeParams = this.calcWidgetStyleInstance.GetTradeSize(this.parameters.symbol);
      if (tradeSizeParams != null) {
        this.parameters.tradeSize = tradeSizeParams.size;
        this.parameters.tradeSizeType = tradeSizeParams.type;
      }
      var cookieBuyOrSell = this.calcWidgetStyleInstance.GetCalcCookieValue('pc-buy-or-sell');
      if (cookieBuyOrSell != "") {
        this.parameters.buyOrSell = cookieBuyOrSell;
      }
    }
  }, {
    key: "InitializeComponents",
    value: function InitializeComponents() {
      var _this = this;
      var myThis = this;
      var hideStarIcon = false;
      var hideFavorites = false;
      if (window.location.pathname.includes("/widgets/")) {
        if (!window.allowAuthFeatures || !window.userIsOnline) {
          hideStarIcon = true;
          hideFavorites = true;
        }
      } else {
        if (!window.userIsOnline) {
          hideFavorites = true;
        }
      }
      myThis.symbolSearchControl = $("#pc-symbol-select-control").chartSymbolSearch('init', '/api/live-chart/datafeed', {
        onChange: function onChange(ticker, symbolData) {
          myThis.OnSymbolChanged(ticker, symbolData);
        },
        ticker: this.parameters.ticker,
        symbol: this.parameters.symbol,
        hideFavorites: hideFavorites,
        hideStarIcon: hideStarIcon
      });
      myThis.currencyControl = $("#pc-deposit-currency-select").infiniteselect({
        types: [{
          option: 'all',
          text: 'All'
        }, {
          option: 'forex',
          text: 'Forex'
        }, {
          option: 'crypto',
          text: 'Crypto'
        }],
        url: '/api/widgets/currencies',
        placeholder: 'Select',
        "default": this.parameters.depositCurrency,
        showDescription: true,
        culture: window.CURRENT_LANG,
        btnClass: 'widget-input-override frn-override'
      });
      $("#pc-calculate-button").on('click', function () {
        return myThis.CalculateResult();
      });
      $("#pc-deposit-currency-select").on('change', function () {
        return myThis.OnCurrencyChanged();
      });
      $("#pc-buy-or-sell").selectpicker('val', myThis.parameters.buyOrSell);
      $("#pc-trade-size-type").val(myThis.parameters.tradeSizeType);
      $("#pc-trade-size").val(myThis.parameters.tradeSize);
      if (myThis.parameters.tradeSizeType == "units") {
        $("label[for='pc-trade-size']").html(window.TradeSizeUnitsLabel);
      } else {
        $("label[for='pc-trade-size']").html(window.TradeSizeLotsLabel);
      }
      document.getElementById('pc-buy-or-sell').addEventListener('change', myThis.RemoveResult);
      document.getElementById('pc-trade-size').addEventListener('change', myThis.RemoveResult);
      document.getElementById('pc-open-price').addEventListener('change', myThis.RemoveResult);
      document.getElementById('pc-close-price').addEventListener('change', myThis.RemoveResult);
      document.getElementById('pcCurrentPrice').addEventListener('change', myThis.RemoveResult);
      $(document).on('click', '#pc-trade-size-popover-link', function () {
        return myThis.calculatorHelperInstance.SwitchUnitsLots(_this, "pc", myThis.symbolInfo);
      });
    }
  }, {
    key: "UpdateCalculatorSymbol",
    value: function UpdateCalculatorSymbol(ticker, symbol) {
      var myThis = this;
      myThis.symbolSearchControl.chartSymbolSearch('setSymbol', ticker, symbol);
      myThis.parameters.ticker = ticker;
      myThis.parameters.symbol = symbol;
      myThis.calculatorHelperInstance.RetrieveToolSymbolInfo(myThis.parameters.ticker, function (info) {
        return myThis.OnSymbolInfoResolved(info, function () {
          return myThis.CalculateResult();
        });
      });
    }
  }, {
    key: "UpdatePopupLink",
    value: function UpdatePopupLink() {
      if ($("#profit-calc-widget-top-pane a.calc-popup-icon").length > 0) {
        var link = "";
        if (window.CURRENT_LANG != "en") link += "/" + window.CURRENT_LANG;
        link += "/widgets/profit-calculator?symbol=" + this.symbolInfo.symbol;
        for (var i = 0; i < $("#profit-calc-widget-top-pane a.calc-popup-icon").length; i++) {
          $("#profit-calc-widget-top-pane a.calc-popup-icon")[i].href = link;
        }
      }
    }
  }, {
    key: "OnSymbolChanged",
    value: function OnSymbolChanged(ticker, symbolData) {
      var myThis = this;
      myThis.RemoveResult();
      myThis.parameters.ticker = ticker;
      myThis.parameters.symbol = symbolData.symbol;
      var tradeSizeParams = myThis.calcWidgetStyleInstance.GetTradeSize(myThis.parameters.symbol);
      if (tradeSizeParams != null) {
        myThis.calculatorHelperInstance.SetTradeSizeFields('pc', tradeSizeParams.size, tradeSizeParams.type);
      } else {
        if (symbolData.type && symbolData.type.toLowerCase() === 'forex') myThis.calculatorHelperInstance.SetTradeSizeFields('pc', 1, 'lots');else myThis.calculatorHelperInstance.SetTradeSizeFields('pc', 1, 'units');
      }
      myThis.calculatorHelperInstance.RetrieveToolSymbolInfo(ticker, function (info) {
        return myThis.OnSymbolInfoResolved(info);
      });
    }
  }, {
    key: "OnSymbolInfoResolved",
    value: function OnSymbolInfoResolved(symbolInfo, callback, atInitialize) {
      var myThis = this;
      if (!symbolInfo) return;
      myThis.symbolInfo = symbolInfo;
      myThis.parameters.ticker = myThis.symbolInfo.ticker;
      myThis.parameters.symbol = myThis.symbolInfo.symbol;
      myThis.parameters.exchange = myThis.symbolInfo.exchange;
      myThis.calcWidgetStyleInstance.SetCalcCookieValue('ticker', myThis.parameters.ticker);
      myThis.calcWidgetStyleInstance.SetCalcCookieValue('symbol', myThis.symbolInfo.symbol.replace("/", "."));
      myThis.calcWidgetStyleInstance.SetCalcCookieValue('exchange', myThis.symbolInfo.exchange);
      UpdateCalcLiveChartPopoutLink('pc-livechart-links', myThis.symbolInfo.symbol, this.calculatorHelperInstance.GetToolSymbolSlugFromTicker(myThis.symbolInfo.exchange, myThis.symbolInfo.symbol));
      myThis.UpdateOpenClosePrice();
      myThis.calculatorHelperInstance.UpdateTradeSizeFields(myThis.symbolInfo, "pc");
      myThis.ToggleOnePipFields();
      myThis.UpdateOnePipSizeLabel();
      myThis.UpdatePopupLink();
      myThis.UpdateHrefAndTitle(atInitialize);
      myThis.UpdateConversationPrice(callback);
      if (window.WatchlistInstance) {
        window.WatchlistInstance.VisitSymbol(myThis.symbolInfo);
      }
    }
  }, {
    key: "UpdateOpenClosePrice",
    value: function UpdateOpenClosePrice() {
      var myThis = this;
      myThis.symbolInfo.price;
      var closePrice;
      if (myThis.symbolInfo.type.toLowerCase() === "forex") {
        var closePrice = myThis.symbolInfo.price + 200 * myThis.symbolInfo.onePipSize;
      } else {
        var closePrice = myThis.symbolInfo.price * 1.02;
      }
      document.getElementById('pc-open-price').value = this.calculatorHelperInstance.ToLocaleNumberForInput(myThis.symbolInfo.price, {
        minimumFractionDigits: 5
      });
      document.getElementById('pc-close-price').value = this.calculatorHelperInstance.ToLocaleNumberForInput(closePrice, {
        minimumFractionDigits: 5
      });
    }
  }, {
    key: "ToggleOnePipFields",
    value: function ToggleOnePipFields() {
      var myThis = this;
      if (myThis.symbolInfo.type.toLowerCase() === "forex") {
        $("#pips-profit-result-group").removeAttr('style');
        $("#pc-current-pair-pip-size-form-group").removeAttr('style');
      } else {
        $("#pips-profit-result-group").attr('style', 'display: none !important;');
        $("#pc-current-pair-pip-size-form-group").attr('style', 'display: none !important;');
      }
    }
  }, {
    key: "UpdateOnePipSizeLabel",
    value: function UpdateOnePipSizeLabel() {
      var myThis = this;
      document.getElementById("pcCurrentPairPipSize").readOnly = false;
      $("#pcCurrentPairPipSize").attr('style', 'opacity: 1;');

      /*
      if (myThis.symbolInfo.type.toLowerCase() === "forex") {
          document.getElementById("pcCurrentPairPipSize").readOnly = true;
          // $("#pcCurrentPairPipSize").attr('style', 'background-color: #E9ECEF; color: #777 !important;');
          $("#pcCurrentPairPipSize").attr('style', 'opacity: .8;');
        } else {
            document.getElementById("pcCurrentPairPipSize").readOnly = false;
          // $("#pcCurrentPairPipSize").attr('style', 'background-color: white; color: black;');
          $("#pcCurrentPairPipSize").attr('style', 'opacity: 1;');
      }
      */

      document.getElementById("pcCurrentPairPipSize").value = myThis.calculatorHelperInstance.ToLocaleNumberForInput(myThis.symbolInfo.onePipSize, {
        maximumFractionDigits: 5
      });
      document.getElementById("pcCurrentPairPipSizeLabel").innerHTML = window._01PipSize.replace("{0}", myThis.symbolInfo.symbol);
    }
  }, {
    key: "UpdateConversationPrice",
    value: function UpdateConversationPrice(callback) {
      var myThis = this;
      myThis.calculatorHelperInstance.UpdateConversationPriceFields(myThis.parameters.depositCurrency, myThis.symbolInfo.quoteCurrency, "pc", callback);
    }
  }, {
    key: "RemoveResult",
    value: function RemoveResult() {
      document.getElementById('profit-in-money-result').innerHTML = "--";
      document.getElementById('profit-in-pips-result').innerHTML = "--";
    }
  }, {
    key: "CalculateResult",
    value: function CalculateResult() {
      var myThis = this;
      var form = document.getElementById('profit-calc-form');
      if (form.checkValidity() == false) {
        form.reportValidity();
        //form.classList.add('was-validated');
        return;
      }
      var accountCurrency = $(myThis.currencyControl).infiniteselect('val');
      var buyOrSell = $("#pc-buy-or-sell").val() == "buy" ? 1 : -1;
      var onePipSize = myThis.symbolInfo.onePipSize;
      var lots = this.calculatorHelperInstance.ParseLocaleNumber(document.getElementById('pc-trade-size').value);
      var pipAmount = (this.calculatorHelperInstance.ParseLocaleNumber(document.getElementById('pc-close-price').value) - this.calculatorHelperInstance.ParseLocaleNumber(document.getElementById('pc-open-price').value)) / onePipSize;
      myThis.calcWidgetStyleInstance.AddTradeSizeHistory(myThis.symbolInfo.symbol, lots, $("#pc-trade-size-type").val());
      this.calcWidgetStyleInstance.SetCalcCookieValue('pc-buy-or-sell', $("#pc-buy-or-sell").val());
      var lotSize;
      lotSize = myThis.symbolInfo.lotSize;
      if ($("#pc-trade-size-type").val() == "units") {
        //lotSize = lots;
        lots = lots / lotSize;
      }

      //var rate = this.calculatorHelperInstance.GetCalculatedExchangeRate(accountCurrency, quoteCurrency);
      var rate = this.calculatorHelperInstance.ParseLocaleNumber(document.getElementById("pcCurrentPrice").value);
      if (rate == "NaN") {
        return;
      }
      $("#profit-calc-form span.result-span").html('<img class="result-loading-img" src="/Content/dist/images/PageElements/ajax-loader.svg" />');
      $.ajax({
        type: "POST",
        cache: false,
        dataType: "json",
        url: "/widgets/calculation/profit",
        data: {
          buyOrSell: buyOrSell,
          lots: lots,
          pipAmount: pipAmount,
          onePipSize: onePipSize,
          lotSize: lotSize,
          rate: rate
        },
        success: function success(data) {
          if (data.success === true) {
            document.getElementById('profit-in-money-result').innerHTML = myThis.calculatorHelperInstance.ToLocaleNumberForResult(data.result, 'currency', 2, accountCurrency);
            document.getElementById('profit-in-pips-result').innerHTML = myThis.calculatorHelperInstance.ToLocaleNumberForResult(data.pipResult, '', 2, '');
          } else {
            document.getElementById('profit-in-money-result').innerHTML = "NaN";
            document.getElementById('profit-in-pips-result').innerHTML = "NaN";
          }
        },
        error: function error() {
          document.getElementById('profit-in-money-result').innerHTML = "NaN";
          document.getElementById('profit-in-pips-result').innerHTML = "NaN";
        }
      });
    }
  }, {
    key: "UpdateHrefAndTitle",
    value: function UpdateHrefAndTitle(atInitialize) {
      var urlPart = "/tools/profit-calculator";
      if (!window.location.pathname.includes(urlPart) || window.location.hash == '#popout') return;
      if (!atInitialize || window.location.search.includes("?s=")) {
        this.calculatorHelperInstance.UpdateCalculatorTitle(this.symbolInfo);
        this.calculatorHelperInstance.UpdateCalculatorHrefs(urlPart, this.symbolInfo);
      } else {
        this.calculatorHelperInstance.UpdateCalculatorHrefs(urlPart, null);
      }
      if (!atInitialize) TriggerGoogleAnalytics();
    }
  }, {
    key: "OnCurrencyChanged",
    value: function OnCurrencyChanged() {
      var myThis = this;
      myThis.RemoveResult();
      myThis.parameters.depositCurrency = $(myThis.currencyControl).infiniteselect('val');
      myThis.UpdateConversationPrice();
    }
  }]);
}();
var _default = exports["default"] = ProfitCalculator;

},{"./CalcWidgetsStyle":4,"./CalculatorHelper":5,"./CustomChartSymbolSelectPlugin":7,"./InfiniteScrollSelectPlugin":8}],14:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _CalcWidgetsStyle = _interopRequireDefault(require("./CalcWidgetsStyle"));
var _CalculatorHelper = _interopRequireDefault(require("./CalculatorHelper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
require('./CustomChartSymbolSelectPlugin');
require('./InfiniteScrollSelectPlugin');
var RebateCalculator = /*#__PURE__*/function () {
  function RebateCalculator() {
    _classCallCheck(this, RebateCalculator);
    this.calcWidgetStyleInstance = new _CalcWidgetsStyle["default"]();
    this.calculatorHelperInstance = new _CalculatorHelper["default"]();
    this.parameters = {
      ticker: 'EUR/USD',
      symbol: 'EUR/USD',
      exchange: '',
      depositCurrency: 'USD',
      tradeSize: 1,
      tradeSizeType: 'lots'
    };
    this.symbolSearchControl = null;
    this.currencyControl = null;
    this.symbolInfo = null;
  }
  return _createClass(RebateCalculator, [{
    key: "Initialize",
    value: function Initialize() {
      var myThis = this;
      myThis.InitCalculatorParams();
      myThis.InitializeComponents();
      myThis.calculatorHelperInstance.RetrieveToolSymbolInfo(myThis.parameters.ticker, function (info) {
        return myThis.OnSymbolInfoResolved(info, function () {
          return myThis.CalculateResult();
        }, true);
      });
    }
  }, {
    key: "InitCalculatorParams",
    value: function InitCalculatorParams() {
      var toolParams = this.calculatorHelperInstance.GetToolParamsFromUrlAndCache();
      this.parameters.symbol = toolParams.symbol;
      this.parameters.exchange = toolParams.exchange;
      this.parameters.ticker = toolParams.ticker;
      this.parameters.depositCurrency = toolParams.depositCurrency;
      var tradeSizeParams = this.calcWidgetStyleInstance.GetTradeSize(this.parameters.symbol);
      if (tradeSizeParams != null) {
        this.parameters.tradeSize = tradeSizeParams.size;
        this.parameters.tradeSizeType = tradeSizeParams.type;
      }
    }
  }, {
    key: "InitializeComponents",
    value: function InitializeComponents() {
      var _this = this;
      var myThis = this;
      var hideStarIcon = false;
      var hideFavorites = false;
      if (window.location.pathname.includes("/widgets/")) {
        if (!window.allowAuthFeatures || !window.userIsOnline) {
          hideStarIcon = true;
          hideFavorites = true;
        }
      } else {
        if (!window.userIsOnline) {
          hideFavorites = true;
        }
      }
      myThis.symbolSearchControl = $("#rc-symbol-select-control").chartSymbolSearch('init', '/api/live-chart/datafeed', {
        onChange: function onChange(ticker, symbolData) {
          myThis.OnSymbolChanged(ticker, symbolData);
        },
        ticker: this.parameters.ticker,
        symbol: this.parameters.symbol,
        hideFavorites: hideFavorites,
        hideStarIcon: hideStarIcon
      });
      myThis.currencyControl = $("#rc-deposit-currency-select").infiniteselect({
        types: [{
          option: 'all',
          text: 'All'
        }, {
          option: 'forex',
          text: 'Forex'
        }, {
          option: 'crypto',
          text: 'Crypto'
        }],
        url: '/api/widgets/currencies',
        placeholder: 'Select',
        "default": this.parameters.depositCurrency,
        showDescription: true,
        culture: window.CURRENT_LANG,
        btnClass: 'widget-input-override frn-override'
      });
      $("#rc-calculate-button").on('click', function () {
        return myThis.CalculateResult();
      });
      $("#rc-deposit-currency-select").on('change', function () {
        return myThis.OnCurrencyChanged();
      });
      $("#rc-type-select").on('change', function () {
        myThis.UpdateRCTradeSizeFields();
        myThis.RemoveResult();
        myThis.UpdateConversationPrice();
      });
      $("#rc-trade-size-type").val(myThis.parameters.tradeSizeType);
      $("#rc-trade-size").val(myThis.parameters.tradeSize);
      if (myThis.parameters.tradeSizeType == "units") {
        $("label[for='rc-trade-size']").html(window.TradeSizeUnitsLabel);
      } else {
        $("label[for='rc-trade-size']").html(window.TradeSizeLotsLabel);
      }
      document.getElementById('rc-trade-size').addEventListener('change', myThis.RemoveResult);
      document.getElementById('rcCurrentPrice').addEventListener('change', myThis.RemoveResult);
      document.getElementById('rc-amount-in').addEventListener('change', myThis.RemoveResult);
      $(document).on('click', '#rc-trade-size-popover-link', function () {
        return myThis.calculatorHelperInstance.SwitchUnitsLots(_this, "rc", myThis.symbolInfo);
      });
      myThis.UpdateRCTradeSizeFields();
    }
  }, {
    key: "UpdateCalculatorSymbol",
    value: function UpdateCalculatorSymbol(ticker, symbol) {
      var myThis = this;
      myThis.symbolSearchControl.chartSymbolSearch('setSymbol', ticker, symbol);
      myThis.parameters.ticker = ticker;
      myThis.parameters.symbol = symbol;
      myThis.calculatorHelperInstance.RetrieveToolSymbolInfo(myThis.parameters.ticker, function (info) {
        return myThis.OnSymbolInfoResolved(info, function () {
          return myThis.CalculateResult();
        });
      });
    }
  }, {
    key: "UpdateRCTradeSizeFields",
    value: function UpdateRCTradeSizeFields() {
      if ($("#rc-type-select").val() == "pips") {
        $("#rc-trade-size-popover-link").css("display", "block");
      } else {
        if (document.getElementById("rc-trade-size-type").value !== "lots") {
          document.getElementById("rc-trade-size-type").value = "lots";
          document.getElementById("rc-trade-size").value = 1;
          $("label[for='rc-trade-size']").html(window.TradeSizeLotsLabel);
        }
        $("#rc-trade-size-popover-link").css("display", "none");
      }
      if (document.getElementById("rc-trade-size-type").value == 'units') {
        $("#rc-trade-size-popover-link").text(window.SwitchToLotsLabel);
      } else {
        $("#rc-trade-size-popover-link").text(window.SwitchToUnitsLabel);
      }
    }
  }, {
    key: "UpdatePopupLink",
    value: function UpdatePopupLink() {
      if ($("#rbc-widget-top-pane a.calc-popup-icon").length > 0) {
        var link = "";
        if (window.CURRENT_LANG != "en") link += "/" + window.CURRENT_LANG;
        link += "/widgets/forex-rebate-calculator?symbol=" + this.symbolInfo.symbol;
        for (var i = 0; i < $("#rbc-widget-top-pane a.calc-popup-icon").length; i++) {
          $("#rbc-widget-top-pane a.calc-popup-icon")[i].href = link;
        }
      }
    }
  }, {
    key: "OnSymbolChanged",
    value: function OnSymbolChanged(ticker, symbolData) {
      var myThis = this;
      myThis.RemoveResult();
      myThis.parameters.ticker = ticker;
      myThis.parameters.symbol = symbolData.symbol;
      var tradeSizeParams = myThis.calcWidgetStyleInstance.GetTradeSize(myThis.parameters.symbol);
      if (tradeSizeParams != null) {
        myThis.calculatorHelperInstance.SetTradeSizeFields('rc', tradeSizeParams.size, tradeSizeParams.type);
      } else {
        if (symbolData.type && symbolData.type.toLowerCase() === 'forex') myThis.calculatorHelperInstance.SetTradeSizeFields('rc', 1, 'lots');else myThis.calculatorHelperInstance.SetTradeSizeFields('rc', 1, 'units');
      }
      myThis.UpdateRCTradeSizeFields();
      myThis.calculatorHelperInstance.RetrieveToolSymbolInfo(ticker, function (info) {
        return myThis.OnSymbolInfoResolved(info);
      });
    }
  }, {
    key: "OnSymbolInfoResolved",
    value: function OnSymbolInfoResolved(symbolInfo, callback, atInitialize) {
      var myThis = this;
      if (!symbolInfo) return;
      myThis.symbolInfo = symbolInfo;
      myThis.parameters.ticker = myThis.symbolInfo.ticker;
      myThis.parameters.symbol = myThis.symbolInfo.symbol;
      myThis.parameters.exchange = myThis.symbolInfo.exchange;
      myThis.calcWidgetStyleInstance.SetCalcCookieValue('ticker', myThis.parameters.ticker);
      myThis.calcWidgetStyleInstance.SetCalcCookieValue('symbol', myThis.symbolInfo.symbol.replace("/", "."));
      myThis.calcWidgetStyleInstance.SetCalcCookieValue('exchange', myThis.symbolInfo.exchange);
      UpdateCalcLiveChartPopoutLink('rc-livechart-links', myThis.symbolInfo.symbol, this.calculatorHelperInstance.GetToolSymbolSlugFromTicker(myThis.symbolInfo.exchange, myThis.symbolInfo.symbol));
      myThis.UpdateRCTradeSizeFields();
      // myThis.calculatorHelperInstance.UpdateTradeSizeFields(myThis.symbolInfo, "rc");

      myThis.UpdateConversationPrice(callback);
      myThis.UpdateOnePipSizeLabel();
      myThis.UpdatePopupLink();
      myThis.UpdateHrefAndTitle(atInitialize);
      if (window.WatchlistInstance) {
        window.WatchlistInstance.VisitSymbol(myThis.symbolInfo);
      }
    }
  }, {
    key: "UpdateConversationPrice",
    value: function UpdateConversationPrice(callback) {
      var myThis = this;
      var currency = myThis.parameters.depositCurrency;
      var secondCurrency;
      if ($("#rc-type-select").val() == "pips") {
        secondCurrency = myThis.symbolInfo.quoteCurrency;
      } else {
        var rebateTypeControl = document.getElementById('rc-type-select');
        secondCurrency = rebateTypeControl.value;
      }
      myThis.calculatorHelperInstance.UpdateConversationPriceFields(currency, secondCurrency, "rc", callback);
    }
  }, {
    key: "UpdateOnePipSizeLabel",
    value: function UpdateOnePipSizeLabel() {
      var myThis = this;
      document.getElementById("rcCurrentPairPipSize").readOnly = false;
      $("#rcCurrentPairPipSize").attr('style', 'opacity: 1;');
      /*
      if (myThis.symbolInfo.type.toLowerCase() === "forex") {
          document.getElementById("rcCurrentPairPipSize").readOnly = true;
          // $("#pcCurrentPairPipSize").attr('style', 'background-color: #E9ECEF; color: #777 !important;');
          $("#rcCurrentPairPipSize").attr('style', 'opacity: .8;');
        } else {
            document.getElementById("rcCurrentPairPipSize").readOnly = false;
          // $("#pcCurrentPairPipSize").attr('style', 'background-color: white; color: black;');
          $("#rcCurrentPairPipSize").attr('style', 'opacity: 1;');
      }
      */

      document.getElementById("rcCurrentPairPipSize").value = myThis.calculatorHelperInstance.ToLocaleNumberForInput(myThis.symbolInfo.onePipSize, {
        maximumFractionDigits: 5
      });
      document.getElementById("rcCurrentPairPipSizeLabel").innerHTML = window._01PipSize.replace("{0}", myThis.symbolInfo.symbol);
    }
  }, {
    key: "CalculateResult",
    value: function CalculateResult() {
      var myThis = this;
      var form = document.getElementById('rc-calc-form');
      if (form.checkValidity() == false) {
        form.reportValidity();
        //form.classList.add('was-validated');
        return;
      }
      var accountCurrency = myThis.parameters.depositCurrency;
      var rebateType = $("#rc-type-select").val();
      var rebateAmount = document.getElementById('rc-amount-in').value;
      var tradeSizeType = $("#rc-trade-size-type").val();
      var lots = myThis.calculatorHelperInstance.ParseLocaleNumber(document.getElementById('rc-trade-size').value);
      myThis.calcWidgetStyleInstance.AddTradeSizeHistory(myThis.symbolInfo.symbol, lots, tradeSizeType);
      var onePipSize = myThis.calculatorHelperInstance.ParseLocaleNumber(document.getElementById('rcCurrentPairPipSize').value);
      var oneLotSize = myThis.symbolInfo.lotSize;
      var rate = myThis.calculatorHelperInstance.ParseLocaleNumber(document.getElementById("rcCurrentPrice").value);
      if (rate == "NaN") {
        return;
      }
      $("#rc-calc-form span.result-span").html('<img class="result-loading-img" src="/Content/dist/images/PageElements/ajax-loader.svg" />');
      $.ajax({
        type: "POST",
        cache: false,
        dataType: "json",
        url: "/widgets/calculation/rc-value",
        data: {
          rebateType: rebateType,
          rebatePerLot: rebateAmount,
          tradeSizeType: tradeSizeType,
          tradeSize: lots,
          onePipSize: onePipSize,
          oneLotSize: oneLotSize,
          rate: rate
        },
        success: function success(data) {
          if (data.success === true) {
            document.getElementById('rc-result-value').innerHTML = myThis.calculatorHelperInstance.ToLocaleNumberForResult(data.result, 'currency', 2, accountCurrency);
          } else {
            document.getElementById('rc-result-value').innerHTML = "NaN";
          }
        },
        error: function error() {
          document.getElementById('rc-result-value').innerHTML = "NaN";
        }
      });
    }
  }, {
    key: "UpdateHrefAndTitle",
    value: function UpdateHrefAndTitle(atInitialize) {
      var urlPart = "/tools/forex-rebate-calculator";
      if (!window.location.pathname.includes(urlPart) || window.location.hash == '#popout') return;
      if (!atInitialize || window.location.search.includes("?s=")) {
        this.calculatorHelperInstance.UpdateCalculatorTitle(this.symbolInfo);
        this.calculatorHelperInstance.UpdateCalculatorHrefs(urlPart, this.symbolInfo);
      } else {
        this.calculatorHelperInstance.UpdateCalculatorHrefs(urlPart, null);
      }
      if (!atInitialize) TriggerGoogleAnalytics();
    }
  }, {
    key: "OnCurrencyChanged",
    value: function OnCurrencyChanged() {
      var myThis = this;
      myThis.RemoveResult();
      myThis.parameters.depositCurrency = $(myThis.currencyControl).infiniteselect('val');
      myThis.UpdateConversationPrice();
    }
  }, {
    key: "RemoveResult",
    value: function RemoveResult() {
      document.getElementById('rc-result-value').innerHTML = "--";
    }
  }]);
}();
var _default = exports["default"] = RebateCalculator;

},{"./CalcWidgetsStyle":4,"./CalculatorHelper":5,"./CustomChartSymbolSelectPlugin":7,"./InfiniteScrollSelectPlugin":8}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Cookie = _interopRequireDefault(require("./Cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CalcWidgetStyle = /*#__PURE__*/function () {
  // updated to use localStorage instead of cookie
  function CalcWidgetStyle() {
    _classCallCheck(this, CalcWidgetStyle);
    this.Cookie = new _Cookie["default"]();
  }
  return _createClass(CalcWidgetStyle, [{
    key: "SetWidgetStyleCookie",
    value: function SetWidgetStyleCookie(styleType, style) {
      window.localStorage.setItem(styleType, btoa(style));
    }
  }, {
    key: "ResetCalcWidgetsStyles",
    value: function ResetCalcWidgetsStyles() {
      $(".style-input-area[cbf-widget-style-input-id='top-pane-style-input']").val("background: white; border: solid 1px black; border-bottom: none; color: black;");
      $(".style-input-area[cbf-widget-style-input-id='bottom-pane-style-input']").val("background: white; border: solid 1px black; color: black;");
      $(".style-input-area[cbf-widget-style-input-id='button-style-input']").val("background: black; color: white; border-radius: 20px;");
      window.localStorage.removeItem("TopPaneStyle");
      window.localStorage.removeItem("BottomPaneStyle");
      window.localStorage.removeItem("ButtonStyle");
      this.InitialiseWidgetsStyleAndCookie();
    }
  }, {
    key: "GetTopPaneStyle",
    value: function GetTopPaneStyle() {
      if (window.localStorage.getItem("TopPaneStyle")) {
        return window.localStorage.getItem("TopPaneStyle");
      }
      return "";
    }
  }, {
    key: "GetCCTopPaneStyle",
    value: function GetCCTopPaneStyle() {
      if (window.localStorage.getItem("CCTopPaneStyle")) {
        return window.localStorage.getItem("CCTopPaneStyle");
      }
      return "";
    }
  }, {
    key: "SetCCTopPaneStyle",
    value: function SetCCTopPaneStyle(style) {
      this.SetWidgetStyleCookie("CCTopPaneStyle", style);
    }
  }, {
    key: "GetBottomPaneStyle",
    value: function GetBottomPaneStyle() {
      if (window.localStorage.getItem("BottomPaneStyle")) {
        return window.localStorage.getItem("BottomPaneStyle");
      }
      return "";
    }
  }, {
    key: "GetCCBottomPaneStyle",
    value: function GetCCBottomPaneStyle() {
      if (window.localStorage.getItem("CCBottomPaneStyle")) {
        return window.localStorage.getItem("CCBottomPaneStyle");
      }
      return "";
    }
  }, {
    key: "SetCCBottomPaneStyle",
    value: function SetCCBottomPaneStyle(style) {
      this.SetWidgetStyleCookie("CCBottomPaneStyle", style);
    }
  }, {
    key: "GetButtonStyle",
    value: function GetButtonStyle() {
      if (window.localStorage.getItem("ButtonStyle")) {
        return window.localStorage.getItem("ButtonStyle");
      }
      return "";
    }
  }, {
    key: "GetWidgetStyleTheme",
    value: function GetWidgetStyleTheme() {
      if (window.localStorage.getItem("WidgetTheme")) {
        return window.localStorage.getItem("WidgetTheme");
      }
      return "";
    }
  }, {
    key: "GetCCWidgetStyleTheme",
    value: function GetCCWidgetStyleTheme() {
      if (window.localStorage.getItem("CCWidgetTheme")) {
        return window.localStorage.getItem("CCWidgetTheme");
      }
      return "";
    }
  }, {
    key: "SetCCWidgetStyleTheme",
    value: function SetCCWidgetStyleTheme(style) {
      this.SetWidgetStyleCookie("CCWidgetTheme", style);
    }
  }, {
    key: "GetTitleStyle",
    value: function GetTitleStyle() {
      if (window.localStorage.getItem("TitleStyle")) {
        return window.localStorage.getItem("TitleStyle");
      }
      return "";
    }
  }, {
    key: "GetCCTitleStyle",
    value: function GetCCTitleStyle() {
      if (window.localStorage.getItem("CCTitleStyle")) {
        return window.localStorage.getItem("CCTitleStyle");
      }
      return "";
    }
  }, {
    key: "SetCCTitleStyle",
    value: function SetCCTitleStyle() {
      this.SetWidgetStyleCookie("CCTitleStyle", style);
    }
  }, {
    key: "GetTextboxStyle",
    value: function GetTextboxStyle() {
      if (window.localStorage.getItem("TextboxStyle")) {
        return window.localStorage.getItem("TextboxStyle");
      }
      return "";
    }
  }, {
    key: "GetContainerWidth",
    value: function GetContainerWidth() {
      if (window.localStorage.getItem("ContainerWidth")) {
        return window.localStorage.getItem("ContainerWidth");
      }
      return "";
    }
  }, {
    key: "GetSmallContainerWidth",
    value: function GetSmallContainerWidth() {
      if (window.localStorage.getItem("SmallContainerWidth")) {
        return window.localStorage.getItem("SmallContainerWidth");
      }
      return "";
    }
  }, {
    key: "GetCCContainerWidth",
    value: function GetCCContainerWidth() {
      if (window.localStorage.getItem("CCContainerWidth")) {
        return window.localStorage.getItem("CCContainerWidth");
      }
      return "";
    }
  }, {
    key: "SetCCContainerWidth",
    value: function SetCCContainerWidth(width) {
      this.SetWidgetStyleCookie("CCContainerWidth", width);
    }
  }, {
    key: "GetCCSmallContainerWidth",
    value: function GetCCSmallContainerWidth() {
      if (window.localStorage.getItem("CCSmallContainerWidth")) {
        return window.localStorage.getItem("CCSmallContainerWidth");
      }
      return "";
    }
  }, {
    key: "SetCCSmallContainerWidth",
    value: function SetCCSmallContainerWidth(width) {
      this.SetWidgetStyleCookie("CCSmallContainerWidth", width);
    }
  }, {
    key: "GetHighlightColor",
    value: function GetHighlightColor() {
      if (window.localStorage.getItem("HighlightColor")) {
        return window.localStorage.getItem("HighlightColor");
      }
      return "";
    }
  }, {
    key: "InitialiseWidgetsStyleAndCookie",
    value: function InitialiseWidgetsStyleAndCookie() {
      var topPaneStyle = this.GetTopPaneStyle();
      if (!!topPaneStyle) {
        // if cookie exist then initalize style

        $(".style-input-area[cbf-widget-style-input-id='top-pane-style-input']").val(atob(topPaneStyle));
      } else {
        // if cookie not exist then initalize cookie
        if ($(".style-input-area[cbf-widget-style-input-id='top-pane-style-input']").length > 0) this.SetWidgetStyleCookie("TopPaneStyle", $(".style-input-area[cbf-widget-style-input-id='top-pane-style-input']").val(), 365);else this.SetWidgetStyleCookie("TopPaneStyle", "background: white; border: solid 1px black; border-bottom: none; color: black;", 365);
      }
      var bottomPaneStyle = this.GetBottomPaneStyle();
      if (!!bottomPaneStyle) {
        // if cookie exist then initalize style

        $(".style-input-area[cbf-widget-style-input-id='bottom-pane-style-input']").val(atob(bottomPaneStyle));
      } else {
        // if cookie not exist then initalise cookie

        if ($(".style-input-area[cbf-widget-style-input-id='bottom-pane-style-input']").length > 0) this.SetWidgetStyleCookie("BottomPaneStyle", $(".style-input-area[cbf-widget-style-input-id='bottom-pane-style-input']").val(), 365);else this.SetWidgetStyleCookie("BottomPaneStyle", "background: white; border: solid 1px black; color: black;", 365);
      }
      var buttonStyle = this.GetButtonStyle();
      if (!!buttonStyle) {
        // if cookie exist then initalise style

        $(".style-input-area[cbf-widget-style-input-id='button-style-input']").val(atob(buttonStyle));
      } else {
        // if cookie not exist then initalise cookie

        if ($(".style-input-area[cbf-widget-style-input-id='bottom-pane-style-input']").length > 0) this.SetWidgetStyleCookie("ButtonStyle", $(".style-input-area[cbf-widget-style-input-id='button-style-input']").val(), 365);else this.SetWidgetStyleCookie("ButtonStyle", "background: black; color: white; border-radius: 20px;", 365);
      }
      var titleStyle = this.GetTitleStyle();
      if (!!titleStyle) {
        // if cookie exist then initalise style

        $(".style-input-area[cbf-widget-style-input-id='title-style-input']").val(atob(titleStyle));
      } else {
        // if cookie not exist then initalise cookie

        this.SetWidgetStyleCookie("TitleStyle", "text-align: left; font-size: 16px;font-weight: 500;", 365);
      }
      var containerWidth = this.GetContainerWidth();
      if (!!containerWidth) {
        $(".style-input-area[cbf-widget-style-input-id='container-width-input']").val(atob(containerWidth));
      } else {
        this.SetWidgetStyleCookie("ContainerWidth", "665", 365);
      }
    }
  }, {
    key: "GetCalcCookieValue",
    value: function GetCalcCookieValue(type) {
      var calcCookie = "";
      if (window.localStorage.getItem("calcs")) {
        calcCookie = window.localStorage.getItem("calcs");
      }
      if (calcCookie !== "") {
        try {
          var calcCookieValues = JSON.parse(calcCookie);
          if (calcCookieValues[type] == undefined || calcCookieValues[type] == null) return "";
          return calcCookieValues[type];
        } catch (e) {}
      }
      return "";
    }
  }, {
    key: "GetSymbolCookie",
    value: function GetSymbolCookie() {
      return this.GetCalcCookieValue("symbol");
    }
  }, {
    key: "GetTVIntervalCookie",
    value: function GetTVIntervalCookie() {
      return this.GetCalcCookieValue("tvInterval");
    }
  }, {
    key: "GetDepositCurrencyCookie",
    value: function GetDepositCurrencyCookie() {
      return this.GetCalcCookieValue("deposit");
    }
  }, {
    key: "GetTVThemeCookie",
    value: function GetTVThemeCookie() {
      return this.GetCalcCookieValue("tvTheme");
    }
  }, {
    key: "SetCalcCookieValue",
    value: function SetCalcCookieValue(type, value) {
      var calcCookie = "";
      if (window.localStorage.getItem("calcs")) {
        calcCookie = window.localStorage.getItem("calcs");
      }
      var calcCookieValues = {};
      try {
        calcCookieValues = JSON.parse(calcCookie);
      } catch (e) {}
      calcCookieValues[type] = value;
      window.localStorage.setItem("calcs", JSON.stringify(calcCookieValues));
    }
  }, {
    key: "SetSymbolCookie",
    value: function SetSymbolCookie(symbol) {
      this.SetCalcCookieValue("symbol", symbol);
    }
  }, {
    key: "SetTVIntervalCookie",
    value: function SetTVIntervalCookie(interval) {
      this.SetCalcCookieValue("tvInterval", interval);
    }
  }, {
    key: "SetDepositCurrencyCookie",
    value: function SetDepositCurrencyCookie(currency) {
      this.SetCalcCookieValue("deposit", currency);
    }
  }, {
    key: "SetTVThemeCookie",
    value: function SetTVThemeCookie(theme) {
      this.SetCalcCookieValue("tvTheme", theme);
    }
  }, {
    key: "IsLoggedInUser",
    value: function IsLoggedInUser() {
      var cook = this.Cookie.GetCookie("FrnHOST");
      var cookieValues = {};
      if (cook !== "") {
        cookieValues = JSON.parse(this.Cookie.GetValue("state", cook));
      }
      return cookieValues.logged == "1";
    }
  }, {
    key: "GetTradeSize",
    value: function GetTradeSize(symbol) {
      var historyStr = localStorage.getItem('calc-trade-size');
      if (!historyStr) historyStr = '[]';
      var history = [];
      try {
        history = JSON.parse(historyStr);
      } catch (e) {}
      for (var i = 0; i < history.length; i++) if (history[i].symbol == symbol) return history[i];
      return null;
    }
  }, {
    key: "AddTradeSizeHistory",
    value: function AddTradeSizeHistory(symbol, size, type) {
      var historyStr = localStorage.getItem('calc-trade-size');
      if (!historyStr) historyStr = '[]';
      var history = [];
      try {
        history = JSON.parse(historyStr);
      } catch (e) {}
      for (var i = 0; i < history.length; i++) if (history[i].symbol == symbol) break;
      if (i < history.length) history.splice(i, 1);
      history = [{
        symbol: symbol,
        size: size,
        type: type
      }].concat(history);
      if (history.length > 30) history = history.slice(0, 30);
      localStorage.setItem('calc-trade-size', JSON.stringify(history));
    }
  }]);
}();
var _default = exports["default"] = CalcWidgetStyle;

},{"./Cookie":6}],6:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Cookie = /*#__PURE__*/function () {
  function Cookie() {
    _classCallCheck(this, Cookie);
  }
  return _createClass(Cookie, [{
    key: "SetCookie",
    value: function SetCookie(CookieName, CookieValue, ExpiresInDays) {
      var d = new Date();
      d.setTime(d.getTime() + ExpiresInDays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      var cookieToSet = CookieName + "=" + encodeURIComponent(CookieValue) + ";" + expires + ";Secure;SameSite=Lax;path=/";
      document.cookie = cookieToSet;
    }
  }, {
    key: "SetCookieToExpireInHours",
    value: function SetCookieToExpireInHours(CookieName, CookieValue, ExpiresInHours) {
      var d = new Date();
      d.setTime(d.getTime() + ExpiresInHours * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      var cookieToSet = CookieName + "=" + encodeURIComponent(CookieValue) + ";" + expires + ";Secure;SameSite=Lax;path=/";
      document.cookie = cookieToSet;
    }
  }, {
    key: "SetCookieSameSiteNone",
    value: function SetCookieSameSiteNone(CookieName, CookieValue, ExpiresInDays) {
      var d = new Date();
      d.setTime(d.getTime() + ExpiresInDays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      var cookieToSet = CookieName + "=" + encodeURIComponent(CookieValue) + ";" + expires + ";Secure;SameSite=None;path=/";
      document.cookie = cookieToSet;
    }
  }, {
    key: "SetSessionCookie",
    value: function SetSessionCookie(cname, cvalue) {
      document.cookie = cname + "=" + cvalue + ";Secure;SameSite=Lax;expires=0;path=/";
    }
  }, {
    key: "GetCookie",
    value: function GetCookie(cname) {
      var name = cname + "=";
      var cookie = document.cookie;
      var ca = cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = decodeURIComponent(ca[i]);
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
  }, {
    key: "DeleteCookie",
    value: function DeleteCookie(name) {
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
    }
  }, {
    key: "GetValue",
    value: function GetValue(requestedValue, data) {
      var nameEQ = requestedValue + "=";
      var splits = data.split("&");
      for (var i = 0; i < splits.length; i++) {
        var c = splits[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
    }
  }]);
}();
var _default = exports["default"] = Cookie;

},{}]},{},[1]);


window.tvLang = new Object();

window.tvLang["cs"] = "cs";
window.tvLang["de"] = "de";
window.tvLang["en"] = "en";
window.tvLang["es"] = "es";
window.tvLang["fr"] = "fr";
window.tvLang["hr"] = "en";
window.tvLang["id"] = "id_ID";
window.tvLang["it"] = "it";
window.tvLang["hu"] = "hu_HU";
window.tvLang["pl"] = "pl";
window.tvLang["pt"] = "pt";
window.tvLang["ro"] = "ro";
window.tvLang["vi"] = "vi";
window.tvLang["tr"] = "tr";
window.tvLang["el"] = "el";
window.tvLang["bg"] = "en";
window.tvLang["ru"] = "ru";
window.tvLang["ar"] = "ar";
window.tvLang["fa"] = "fa";
window.tvLang["th"] = "th";
window.tvLang["zh"] = "zh";
window.tvLang["ko"] = "ko";
window.tvLang["ja"] = "ja";
window.tvLang["fil"] = "en";

window.tvIntervalParam = {};
window.tvIntervalParam['1'] = "1m";
window.tvIntervalParam['5'] = "5m";
window.tvIntervalParam['15'] = "15m";
window.tvIntervalParam['30'] = "30m";
window.tvIntervalParam['60'] = "1h";
window.tvIntervalParam['240'] = "4h";
window.tvIntervalParam['D'] = "1d";
window.tvIntervalParam['1D'] = "1d";
window.tvIntervalParam['1W'] = "1w";
window.tvIntervalParam['W'] = "1w";
window.tvIntervalParam['M'] = "monthly";
window.tvIntervalParam['1M'] = "monthly";

window.tvIntervalParam['1y'] = "1y";
window.tvIntervalParam['5y'] = "5y";
window.tvIntervalParam['all'] = "historical";

window.tvHrefTitleUpdateDisabled = false;
window.tvLivechartWidgetLoaded = false;

window.searchBoxControl = null;

function InitializeNewLiveChart(containerId, searchBoxControl) {
    var isChartWidget = false;
    if (window.location.pathname.includes("/widgets/")) isChartWidget = true;

    window.searchBoxControl = searchBoxControl;

    if (isChartWidget) {
        $("#lc-open-widget").hide();
        $("#lc-full-screen").hide();
        
        $.ajax({
            url: '/api/client/test-authentication-check',
            type: "GET",
            success: function (res) {
                if (res) {
                    if (res.authenticated) {
                        console.log('Live Chart Widget is calling CacheBuster.Refresh() method');
                        window.CacheBuster.Refresh();
                    }
                }
            }
        });
    }

    var defaultExchange = "";
    var defaultSymbol = "EUR/USD";
    var defaultInterval = '60';

    var pathName = window.location.pathname;
    if (pathName.endsWith("/")) pathName = pathName.substring(0, pathName.length - 1);

    var mobileAppWidget = false;

    var queryParams = new URLSearchParams(window.location.search);

    if (pathName.endsWith("chart") && queryParams.get('s')) {
        const urlParam = queryParams.get('s');
        var urlExchange, urlSymbol, urlInterval;

        const parts = urlParam.split('-');
        if (parts.length == 3) {
            urlExchange = parts[0];
            urlSymbol = parts[1].toUpperCase();
            urlInterval = parts[2];
        } else if (parts.length == 2) {
            urlSymbol = parts[0].toUpperCase();
            urlInterval = parts[1];

            if (!GetValidInterval(urlInterval)) {
                urlExchange = parts[0];
                urlSymbol = parts[1].toUpperCase();
                urlInterval = '1h';
            }
        } else if (parts.length == 1) {
            urlSymbol = urlParam.toUpperCase();
        }

        if (!!urlExchange) defaultExchange = urlExchange;
        if (!!urlSymbol) defaultSymbol = urlSymbol;
        if (!!urlInterval) {
            defaultInterval = GetValidInterval(urlInterval);
        }
    }
    else if (pathName.endsWith("chart") || pathName.endsWith("live-chart")) {

        const cookieExchange = window.CalcWidgetStyle.GetCalcCookieValue('ntvc-exchange');
        const cookieSymbol = window.CalcWidgetStyle.GetCalcCookieValue('ntvc-symbol');
        const cookieInterval = window.CalcWidgetStyle.GetCalcCookieValue('ntvc-interval');

        if (cookieExchange) defaultExchange = cookieExchange;
        if (cookieSymbol) defaultSymbol = cookieSymbol;
        if (cookieInterval) defaultInterval = cookieInterval;

    } else if (pathName.includes("chart/")) {

        const urlParam = pathName.split("chart/")[1].split('/')[0];
        var urlExchange, urlSymbol, urlInterval;

        const parts = urlParam.split('-');
        if (parts.length == 3) {
            urlExchange = parts[0];
            urlSymbol = parts[1].toUpperCase();
            urlInterval = parts[2];
        } else if (parts.length == 2) {
            urlSymbol = parts[0].toUpperCase();
            urlInterval = parts[1];

            if (!GetValidInterval(urlInterval)) {                
                urlExchange = parts[0];
                urlSymbol = parts[1].toUpperCase();
                urlInterval = '1h';
            }
        } else if (parts.length == 1) {
            urlSymbol = urlParam.toUpperCase();
        }

        if (!!urlExchange) defaultExchange = urlExchange;
        if (!!urlSymbol) defaultSymbol = urlSymbol;
        if (!!urlInterval) {
            defaultInterval = GetValidInterval(urlInterval);
        }
    }

    if (pathName.endsWith("chart") && queryParams.get('mobile')) {
        mobileAppWidget = true;
    }

    if (defaultSymbol && window.CalculatorHelper.oldSymbolMaps[defaultSymbol])
        defaultSymbol = window.CalculatorHelper.oldSymbolMaps[defaultSymbol];

    if (!!defaultExchange) {
        if (defaultExchange == 'Aggregated') defaultExchange = 'Physical currency';
        defaultSymbol = defaultExchange + ":" + defaultSymbol;
    }

    var theme = window.CalcWidgetStyle.GetCalcCookieValue('ntvc-theme');

    if (!theme) theme = 'dark';

    if (theme == 'light') {
        $("#lc-theme-switch").addClass('checked');
        $(".live-chart-content").removeClass("lc-dark-theme dark-theme-chart-widget");
    } else {
        $(".live-chart-content").addClass("lc-dark-theme dark-theme-chart-widget");
    }

    UpdateNewLiveChartLanguageHrefs();

    var loggedIn = window.CalcWidgetStyle.IsLoggedInUser();

    CreateNewLiveChart(containerId, loggedIn, defaultSymbol, defaultInterval, theme, searchBoxControl, mobileAppWidget);

    $(".chart-spinner").show();

    window.tvLivechartWidget.onChartReady(function () {

        window.tvLivechartWidget.activeChart().onDataLoaded().subscribe(null, OnChartDataLoaded);
        window.tvLivechartWidget.activeChart().onSymbolChanged().subscribe(null, OnSymbolChanged);
        window.tvLivechartWidget.activeChart().onIntervalChanged().subscribe(null, OnIntervalChanged);
        
        if (window.tvLivechartWidget.activeChart().symbolExt() == null && pathName.includes("chart/")) {
            console.log('failed to load symbol data');
        } else if (window.tvLivechartWidget.activeChart().symbolExt() == null && pathName.endsWith("/chart")) {
            window.CalcWidgetStyle.SetCalcCookieValue('ntvc-exchange', '');
            window.CalcWidgetStyle.SetCalcCookieValue('ntvc-symbol', '');
            window.CalcWidgetStyle.SetCalcCookieValue('ntvc-interval', '');
            console.log('failed to load symbol data');
        }
        else {
            window.tvLivechartWidgetLoaded = true;

            if (!isChartWidget) {
                UpdateIntervalSwitchLinks();

                if ($("#add-watch-list").length > 0) {
                    UpdateChartPageWatchlistIcon();
                }

                UpdateChartPageRecentWatchlistBar();
            }            
            
            if (window.searchBoxControl) {
                const symbolExt = window.tvLivechartWidget.activeChart().symbolExt();
                window.searchBoxControl.chartSymbolSearch('setSymbol', symbolExt.pro_name, symbolExt.symbol);
            }

            if (defaultInterval == 'all' || defaultInterval == '1y' || defaultInterval == '5y') {
                $(".interval-link-group a[range-code='" + defaultInterval + "']").click();
            }
            else if (defaultInterval != window.tvLivechartWidget.activeChart().resolution()) {

                window.tvHrefTitleUpdateDisabled = true;

                window.tvLivechartWidget.activeChart().setResolution(defaultInterval, function () {
                    window.tvHrefTitleUpdateDisabled = false;
                });
                
            }
            

            if (window.positionSizeCalculator) {
                const symbolExt = window.tvLivechartWidget.activeChart().symbolExt();
                window.positionSizeCalculator.UpdateCalculatorSymbol(symbolExt.pro_name, symbolExt.symbol);
            }
            if (window.profitCalculator) {
                const symbolExt = window.tvLivechartWidget.activeChart().symbolExt();
                window.profitCalculator.UpdateCalculatorSymbol(symbolExt.pro_name, symbolExt.symbol);
            }
        }
        if (window.matchMedia("(pointer:coarse)").matches) {
            if (window.tvLivechartWidget.activeChart().getCheckableActionState('drawingToolbarAction')) {
                window.tvLivechartWidget.activeChart().executeActionById('drawingToolbarAction');
            }
        }
    });


    InitializeNewLiveChartHandlers();
    DisableNewLiveChartInteract();
}



function OnChartDataLoaded() {

    if (window.tvLivechartWidgetPrevVisibleRange) {
        window.tvLivechartWidget.activeChart().setVisibleRange(window.tvLivechartWidgetPrevVisibleRange);
    }

    window.tvLivechartWidgetPrevVisibleRange = null;

    $(".chart-spinner").hide();

    if (!$("#ask-bid-section-div").is(':visible') && !$("#price-section-div").is(':visible') && window.tvLivechartWidgetLoaded) {
        const lastMsg = window.tvLivechartWidget.activeChart().getSeries().data().bars().last();

        OnNewStreamMessage({
            symbol: window.tvLivechartWidget.activeChart().symbolExt().pro_name,
            price: lastMsg.value[4]
        })
    }
    if (window.location.pathname.includes("/chart"))
        updatePriceHistoryTable();
}

function DisableNewLiveChartInteract() {
    $('#tv-chart-container').append('<div id="tv-chart-overlay"><span>' + window.lcEnableInteractiveTooltip + '</span></div>');
    $("#tv-chart-overlay").mousemove(function (e) {
        var left = e.pageX;
        var top = e.pageY;

        if ($("#tv-chart-overlay").offset().left < left
            && left < $("#tv-chart-overlay").offset().left + $("#tv-chart-overlay").width()
            && $("#tv-chart-overlay").offset().top < top
            && top < $("#tv-chart-overlay").offset().top + $("#tv-chart-overlay").height()) {

            $("#tv-chart-overlay span").css({ left: left - window.scrollX + 3, top: top - window.scrollY + 3 });
        }
    });

    $("#tv-chart-overlay").mousedown(function (e) {
        $("#tv-chart-overlay").remove();
    });
}


function InitializeNewLiveChartHandlers() {

    $(document).on('click', '.interval-link-group a[interval-code]', function (e) {

        e.preventDefault();

        const resolution = $(this).attr('interval-code');

        UpdateNewLiveChartPageTitleAndMeta(resolution);
        UpdateNewLiveChartHref(resolution);
        

        window.tvHrefTitleUpdateDisabled = true;

        window.tvLivechartWidget.activeChart().setResolution(resolution, function () {
            window.tvHrefTitleUpdateDisabled = false;
        });
    });

    $(document).on('click', '.interval-link-group a[range-code]', function (e) {
        e.preventDefault();

        $(".chart-spinner").show();

        var range = $(this).attr('range-code');
        var fromDate = new Date();
        var toDate = new Date();
        var resolution = '';
        var timeframeVal = '';
        if (range == '1y') {
            fromDate = toDate.setFullYear(fromDate.getFullYear() - 1);
            resolution = '1D';
            timeframeVal = '12M';
        } else if (range == '5y') {
            fromDate = toDate.setFullYear(fromDate.getFullYear() - 5);
            resolution = '1W';
            timeframeVal = '60M';
        } else if (range == 'all') {
            resolution = '1M';
            timeframeVal = '1200M';
            fromDate = toDate.setFullYear(fromDate.getFullYear() - 100);
        }

        UpdateNewLiveChartPageTitleAndMeta(range);
        UpdateNewLiveChartHref(range);

        window.tvLivechartWidget.setTimeFrame({ res: resolution, val: { type: 'period-back', value: timeframeVal } });

    });

    $(document).on('click', '.recent-bar-toggle', function (e) {
        e.preventDefault();
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(".chart-history-view").hide();
        } else {
            $(this).addClass('active');
            $(".chart-history-view").show();
        }
    })
}

function GetCurrentIntervalFromUrl() {

    var pathName = window.location.pathname;

    var urlParam = '';
    if (pathName && pathName.includes('/chart/')) {
        urlParam = pathName.split("/chart/")[1].split('/')[0];
        var urlInterval;

        var parts = urlParam.split('-');
        if (parts.length == 3) {
            urlInterval = parts[2];
        } else if (parts.length == 2) {
            urlInterval = parts[1];
        }
        return GetValidInterval(urlInterval);
    } else if (pathName && pathName.endsWith("/chart")) {
        var queryParams = new URLSearchParams(window.location.search);
        if (queryParams.get('s')) {
            const urlParam = queryParams.get('s');
            var urlInterval;

            var parts = urlParam.split('-');
            if (parts.length == 3) {
                urlInterval = parts[2];
            } else if (parts.length == 2) {
                urlInterval = parts[1];
            }
            const validInterval = GetValidInterval(urlInterval);
            if (validInterval) return validInterval;
        }
    }
    return window.CalcWidgetStyle.GetCalcCookieValue('ntvc-interval');
}

function GetValidInterval(intervalParam) {

    for (var i = 0; i < Object.keys(window.tvIntervalParam).length; i++) {
        const key = Object.keys(window.tvIntervalParam)[i];
        if (intervalParam && window.tvIntervalParam[key].toLowerCase() == intervalParam.toLowerCase()) {
            return key;
        }
    }
    
    return null;
}

function SetPriceSpan(selector, data, formattedData) {
    const orgVal = $(selector).data('value');
    $(selector).removeClass('price-up');
    $(selector).removeClass('price-down');

    if (orgVal != '' && parseFloat(orgVal) <= data) { $(selector).addClass('price-up'); }
    else if (orgVal != '' && parseFloat(orgVal) > data) { $(selector).addClass('price-down'); }

    $(selector).data('value', data);
    $(selector).html(formattedData);
}
function OnNewStreamMessage(msgData) {
    if (window.tvLivechartWidgetLoaded === true && window.tvLivechartWidget && msgData.symbol.toLowerCase() === window.tvLivechartWidget.activeChart().symbolExt().pro_name.toLowerCase()) {
        if (msgData.ask && msgData.bid) {
            $("#price-section-div").hide();
            SetPriceSpan("#ask-section>span:nth-child(2)", msgData.ask, window.tvLivechartWidget.activeChart().priceFormatter().format(msgData.ask));
            SetPriceSpan("#bid-section>span:nth-child(2)", msgData.bid, window.tvLivechartWidget.activeChart().priceFormatter().format(msgData.bid));
            $("#ask-bid-section-div").show();
        } else {
            $("#ask-bid-section-div").hide();
            SetPriceSpan("#price-section>span:nth-child(2)", msgData.price, window.tvLivechartWidget.activeChart().priceFormatter().format(msgData.price));
            $("#price-section-div").show();
        }
    }    
}

function CreateNewLiveChart(containerId, loggedIn, symbol, interval, theme, searchBoxControl, mobileAppWidget) {

    const langcode = window.tvLang[window.CURRENT_LANG];

    if (symbol == undefined) symbol = "EUR/USD";
    if (interval == undefined) interval = '60';

    const timeframes = [
        { text: "1d", resolution: "1", description: "1 day", title: "1D" },
        { text: "5d", resolution: "5", description: "5 days", title: "5D" },
        { text: "1m", resolution: "30", description: "1 Month", title: "1M" },
        { text: "3m", resolution: "60", description: "3 Months", title: "3M" },
        { text: "6m", resolution: "240", description: "6 Months", title: "6M" },
        { text: "1y", resolution: "1D", description: "1 Year", title: "1Y" },
        { text: "5y", resolution: "1W", description: "5 Year", title: "5Y" },
        { text: "100y", resolution: "1M", description: "All", title: "All" }
    ];
    if (symbol.includes('[')) symbol = symbol.replace('[', '');
    if (symbol.includes(']')) symbol = symbol.replace(']', '');
    if (!symbol.endsWith(".")) symbol = symbol.replace(".", "/");

    const widgetConfig = {
        debug: false, // uncomment this line to see Library errors and warnings in the console
        autosize: true,
        symbol: symbol,
        container: containerId,
        //	BEWARE: no trailing slash is expected in feed URL
        //datafeed: new Datafeeds.UDFCompatibleDatafeed("/live-chart/datafeed"),
        datafeed: new window.TwelveDatafeed({ host: "/api/live-chart/datafeed", debug: false, streamCallback: OnNewStreamMessage, symbolResolvedCallback: OnSymbolResolved, liveChartConnection: window.liveChartConnection }),
        library_path: "/Content/dist/js/charting_library/charting_library/",
        locale: langcode,
        //	Regression Trend-related functionality is not implemented yet, so it's hidden for a while
        drawings_access: { type: 'black', tools: [{ name: "Regression Trend" }] },
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        time_frames: timeframes,
        theme: theme,
        symbol_search_request_delay: 300,
        overrides: {
            "mainSeriesProperties.highLowAvgPrice.highLowPriceLabelsVisible": true,
            "mainSeriesProperties.showCountdown": true,
            "paneProperties.topMargin": 10,

        }
    };

    if (interval == '1y') {
        widgetConfig['interval'] = '1D';
        widgetConfig['timefrme'] = '1y';
    } else if (interval == '5y') {
        widgetConfig['interval'] = '1W';
        widgetConfig['timefrme'] = '5y';
    } else if (interval == 'all') {
        widgetConfig['interval'] = '1M';
        widgetConfig['timefrme'] = '100y';
    } else {
        widgetConfig['interval'] = interval;
    }

    if (!loggedIn) {
        widgetConfig['disabled_features'] = ["use_localstorage_for_settings", "header_saveload", "header_resolutions", "header_fullscreen_button", "display_market_status"];
        widgetConfig['enabled_features'] = [];        
    } else {
        widgetConfig['disabled_features'] = ["header_resolutions", "header_fullscreen_button", "display_market_status"];
        widgetConfig['enabled_features'] = ["study_templates", "use_localstorage_for_settings", "save_chart_properties_to_local_storage"];
       
        widgetConfig['save_load_adapter'] = new window.LiveChartSaveLoadAdapter();

        if (window.location.pathname.endsWith("/chart") && !window.location.search)
            widgetConfig['load_last_chart'] = true;
    }

    if (mobileAppWidget) {
        var customCSS = 'div[data-name="open-image-in-new-tab"],div[data-name="tweet-chart-image"],div[data-name="copy-link-to-the-chart-image"] { display: none; } ';

        const cssBlob = new Blob([customCSS], {
            type: "text/css",
        });
        const cssBlobUrl = URL.createObjectURL(cssBlob);
        widgetConfig['custom_css_url'] = cssBlobUrl;
    }

    if (window.matchMedia("(pointer:coarse)").matches) {
        $(".recent-bar-toggle").removeClass('active');
        widgetConfig['enabled_features'].push('hide_left_toolbar_by_default')
    }
    if (searchBoxControl) {
        widgetConfig['disabled_features'].push('header_symbol_search');

        var displaySymbol = symbol;
        if (symbol.includes(":")) displaySymbol = symbol.split(":")[1];

        searchBoxControl.chartSymbolSearch('setSymbol', symbol, displaySymbol);
    }

    widgetConfig['enabled_features'].push('chart_style_hilo_last_price');
    widgetConfig['enabled_features'].push('chart_style_hilo');
    widgetConfig['enabled_features'].push('countdown');
    // widgetConfig['enabled_features'].push('request_only_visible_range_on_reset');

    window.tvLivechartWidget = new TradingView.widget(widgetConfig);
}

function OnSymbolChanged(symbol) {

    $("#ask-bid-section-div").hide();
    $("#price-section-div").hide();

    $(".chart-spinner").show();

    if ($("#add-watch-list").length > 0) {
        UpdateChartPageWatchlistIcon();
    }
    
    if (window.searchBoxControl) {
        window.searchBoxControl.chartSymbolSearch('setSymbol', symbol.ticker, symbol.name);
    }

    if (window.tvHrefTitleUpdateDisabled === true)
        return;

    const interval = GetCurrentIntervalFromUrl();

    UpdateNewLiveChartPageTitleAndMeta(interval);
    UpdateNewLiveChartHref(interval);
    UpdateIntervalSwitchLinks();

    if (interval == 'all' || '1y' || '5y') {
        $(".interval-link-group a[range-code='" + interval + "']").click();
    }
}
function OnIntervalChanged(resolution, timeframeObj) {

    if (window.tvHrefTitleUpdateDisabled === true) {
        if (!!window.resolutionPendingTimeframe) {
            timeframeObj.timeframe = window.resolutionPendingTimeframe;
        }
        return;
    }

    var interval = resolution;
    if (timeframeObj && timeframeObj.timeframe) {
        if (timeframeObj.timeframe.value == '12M') {
            interval = '1y';
        } else if (timeframeObj.timeframe.value == '60M') {
            interval = '5y';
        } else if (timeframeObj.timeframe.value == '1200M') {
            interval = 'all';
        }
    }

    UpdateNewLiveChartPageTitleAndMeta(interval);
    UpdateNewLiveChartHref(interval);
}
function UpdateNewLiveChartLanguageHrefs() {
    var pathName = window.location.pathname;
    if (!pathName.includes("/chart"))
        return;

    var url = window.location.href;

    var queryString = '';
    if (window.location.search && window.location.search.includes('s=')) {
        queryString = window.location.search;
    }
    if ($("link[rel='canonical']").length > 0) {
        $("link[rel='canonical']").attr('href', window.location.protocol + "//" + window.location.host + pathName + queryString);
    }
    var hreflangs = $("link[hreflang]");
    for (var i = 0; i < hreflangs.length; i++) {
        hreflangs[i].href = GenerateNewLiveChartUrl(hreflangs[i].href, queryString);
    }

    var basePath = window.location.pathname;
    if (basePath.includes("/" + window.CURRENT_LANG)) {
        basePath = basePath.replace("/" + window.CURRENT_LANG, "");
    }

    var langSelectors = $("#lang-select li a")
    for (var i = 0; i < langSelectors.length; i++) {

        var newLink = GenerateNewLiveChartUrl(langSelectors[i].href, queryString);

        var langCode = $("#lang-select li a i")[i].getAttribute("data-id").split('-')[0];

        langSelectors[i].href = newLink;
        if (langCode == "en")
            $(langSelectors[i]).attr("onclick", "return window.Language.Select('" + GenerateNewLiveChartUrl(basePath, queryString) + "','" + langCode + "')");
        else
            $(langSelectors[i]).attr("onclick", "return window.Language.Select('/" + langCode + GenerateNewLiveChartUrl(basePath, queryString) + "','" + langCode + "')");
    }
}
function UpdateNewLiveChartHref(interval) {

    var pathName = window.location.pathname;
    if (!pathName.includes("/chart"))
        return;

    var symbolExt = window.tvLivechartWidget.activeChart().symbolExt();

    if (!interval) interval = '60';

    if (!symbolExt || !interval)
        return;

    var queryString = GenerateNewLiveChartUrlParam(symbolExt.exchange, symbolExt.symbol, interval);

    var newUrl = GenerateNewLiveChartUrl(window.location.href, queryString);
    window.history.replaceState({ path: newUrl }, '', newUrl);

    UpdateAllLCHrefs(interval);
    UpdateChartBreadcrumb(queryString);
    setTimeout(function() {
        TriggerGoogleAnalytics();
    }, 200);
    
}

function UpdateChartBreadcrumb(queryString) {

    if (!window.location.pathname.includes("/chart"))
        return;
    if (!queryString) queryString = window.location.search;

    var queryParms = new URLSearchParams(queryString);
    if (!queryParms.get('s')) return;

    var title = $("h1").text(); 

    var langSlug = "/";
    if (window.CURRENT_LANG != 'en') langSlug = "/" + window.CURRENT_LANG + "/";
    $("#site-breadcrumb>.breadcrumb-item:nth-child(2)").replaceWith('<a class="breadcrumb-item" href="' + langSlug + 'chart' + '">' + $("#site-breadcrumb>.breadcrumb-item:nth-child(2)").text() + '</a>');

    var lastItem = '<span class="breadcrumb-item">';
    lastItem += title;
    lastItem += '</span>';
    if ($("#site-breadcrumb>.breadcrumb-item:nth-child(3)").length > 0) {
        $("#site-breadcrumb>.breadcrumb-item:nth-child(3)").replaceWith(lastItem);
    } else {
        $("#site-breadcrumb").append(lastItem);
    }

    if ($('script[type="application/ld+json"]').length == 0) return;

    var breadcrumbSchema = JSON.parse($('script[type="application/ld+json"]').html());

    if (breadcrumbSchema['itemListElement'] && Array.isArray(breadcrumbSchema['itemListElement'])) {

        const items = breadcrumbSchema['itemListElement'];
        if (items.length == 2) {
            items.push({ '@type': 'ListItem', position: 3, name: title, item: window.location.href });
        } else if (items.length > 2) {
            items[2] = { '@type': 'ListItem', position: 3, name: title, item: window.location.href };
        }

        breadcrumbSchema['name'] = title;
        breadcrumbSchema['numberOfItems'] = 3;
        $('script[type="application/ld+json"]').html(JSON.stringify(breadcrumbSchema));
    }
}

function UpdateAllLCHrefs(interval) {

    var pathName = window.location.pathname;
    if (!pathName.includes("/chart"))
        return;

    var symbolExt = window.tvLivechartWidget.activeChart().symbolExt();

    if (!interval) interval = '60';

    if (!symbolExt || !interval)
        return;

    var queryString = GenerateNewLiveChartUrlParam(symbolExt.exchange, symbolExt.symbol, interval);

    if ($("link[rel='canonical']").length > 0) {
        var baseCanonical = $("link[rel='canonical']").attr('href');
        baseCanonical = GenerateNewLiveChartUrl(baseCanonical, queryString);
        $("link[rel='canonical']").attr('href', baseCanonical);
    }
    var hreflangs = $("link[hreflang]");
    for (var i = 0; i < hreflangs.length; i++) {
        hreflangs[i].href = GenerateNewLiveChartUrl(hreflangs[i].href, queryString);
    }

    var basePath = window.location.pathname;
    if (basePath.includes("/" + window.CURRENT_LANG)) {
        basePath = basePath.replace("/" + window.CURRENT_LANG, "");
    }

    var langSelectors = $("#lang-select li a")
    for (var i = 0; i < langSelectors.length; i++) {

        var newLink = GenerateNewLiveChartUrl(langSelectors[i].href, queryString);

        var langCode = $("#lang-select li a i")[i].getAttribute("data-id").split('-')[0];

        langSelectors[i].href = newLink;
        if (langCode == "en")
            $(langSelectors[i]).attr("onclick", "return window.Language.Select('" + GenerateNewLiveChartUrl(basePath, queryString) + "','" + langCode + "')");
        else
            $(langSelectors[i]).attr("onclick", "return window.Language.Select('/" + langCode + GenerateNewLiveChartUrl(basePath, queryString) + "','" + langCode + "')");
    }
}

function UpdateIntervalSwitchLinks() {

    var pathName = window.location.pathname;
    if (!pathName.includes("/chart"))
        return;

    var symbolExt = window.tvLivechartWidget.activeChart().symbolExt();

    if (!symbolExt)
        return;

    var baseQuery = GenerateNewLiveChartUrlParam(symbolExt.exchange, symbolExt.symbol);
    var baseUrl = GenerateNewLiveChartUrl(window.location.href, baseQuery);
    $(".interval-link-group [interval-param]").each(function () {
        var intervalParam = $(this).attr('interval-param');
        if (intervalParam != '1h') {
            $(this).attr('href', baseUrl + "-" + intervalParam);
        } else {
            $(this).attr('href', baseUrl);
        }
    })
}
function GenerateNewLiveChartUrl(oldUrl, queryParam) {
    var baseUrl = oldUrl.substring(0, oldUrl.toLowerCase().indexOf("chart") + 5);
    var result = baseUrl + queryParam;
    return result;
}
const icMarketsIndices = ['AUS200', 'CA60', 'CHINA50', 'CHINAH', 'DE30', 'DE40', 'ES35', 'F40', 'HK50', 'IT40', 'JP225', 'MidDE50', 'MidDE60', 'NETH25', 'NOR25', 'SA40', 'SE30', 'STOXX50', 'SWI2010037', 'TecDE30', 'UK100', 'US2000', 'US30', 'US500', 'USTEC'];
function GenerateNewLiveChartUrlParam(exchange, symbol, interval) {

    // if (symbol.includes('/')) exchange = '';

    symbol = symbol.replace("/", ".");

    if (icMarketsIndices.includes(symbol)) {
        exchange = '';
        symbol = '[' + symbol + ']';
    }

    if (exchange == "IC Markets") exchange = '';
    else if (exchange.toLowerCase() == "physical currency") exchange = 'Aggregated';

    var urlParam = '';
    if (interval != "60" && window.tvIntervalParam[interval])
        urlParam = symbol + "-" + window.tvIntervalParam[interval];
    else
        urlParam = symbol;
    
    if (!!exchange)
        urlParam = exchange + "-" + urlParam;
    return "?s=" + urlParam;
}
function UpdateNewLiveChartPageTitleAndMeta(interval, symbolInfo) {

    var exchange = '';
    var symbol;
    var type;
    var description;

    if (symbolInfo) {
        symbol = symbolInfo.name;
        exchange = symbolInfo.exchange;
        description = symbolInfo.description;
        type = symbolInfo.type;
    } else if (window.tvLivechartWidgetLoaded) {
        const symbolExt = window.tvLivechartWidget.activeChart().symbolExt();
        if (!!symbolExt) {
            symbol = symbolExt.symbol;
            exchange = symbolExt.exchange;
            type = symbolExt.type;
            description = symbolExt.description;
        }
    } else return;
   
    if (!interval) interval = '60';

    if (!symbol || !interval)
        return;

    var additional = '';
    if (type != 'Forex' && type != 'Crypto' && exchange && exchange.toLowerCase() != 'physical currency') {
        var stockDesc = '';
        additional += exchange;
        if (description.includes(' - ')) {
            additional += " / " + description.split(' - ')[1];
            stockDesc += description.split(' - ')[1] + " / ";
        }
        stockDesc += exchange + " exchange";

        $("#stock-exchange-description").html(stockDesc);
        $("#stock-exchange-description").show();
    } else if (exchange && exchange.toLowerCase() === 'physical currency') {
        //$("#stock-exchange-description").html('Live price updates from <a href="/brokers/395/ic-markets">IC Markets</a>');
        $("#stock-exchange-description").html('');
        $("#stock-exchange-description").hide();
    } else {
        $("#stock-exchange-description").html('');
        $("#stock-exchange-description").hide();
    }

    window.CalcWidgetStyle.SetCalcCookieValue('ntvc-exchange', exchange);
    window.CalcWidgetStyle.SetCalcCookieValue('ntvc-symbol', symbol.replace("/", "."));
    window.CalcWidgetStyle.SetCalcCookieValue('ntvc-interval', interval);

    var intervalParam = window.tvIntervalParam[interval];

    if (window.tvIntervalParam.hasOwnProperty(interval)) {
        $(".interval-link-group a").attr('selected', false);
        $(".interval-link-group a[interval-param='" + window.tvIntervalParam[interval] + "']").attr('selected', true);
    }

    var pathName = window.location.pathname;
    if (!pathName.includes("/chart"))
        return;

    var pageTitle = "";
    var h1Title = "";
    var additionalTitle = "";
    var pageText = "";
    var metaDesc = "";

    if (symbol && symbol.includes("/")) {

        var baseCurrency = symbol.split('/')[0];
        var localisedbaseCurrencyName = baseCurrency;

        var quoteCurrency = symbol.split('/')[1];
        var localisedQuoteCurrencyName = quoteCurrency

        pageText = window.lcPageText.replace(/\{1\}/g, localisedbaseCurrencyName)
            .replace(/\{2\}/g, localisedQuoteCurrencyName)
            .replace(/\{3\}/g, baseCurrency)
            .replace(/\{4\}/g, quoteCurrency);
        metaDesc = window.lcMetaText.replace("{1}", localisedbaseCurrencyName)
            .replace("{2}", localisedQuoteCurrencyName)
            .replace("{3}", baseCurrency)
            .replace("{4}", quoteCurrency);

        if (type != "Physical Currency") {
            pageTitle = window.textObj[intervalParam]["nonFxPageTitle"];
            h1Title = window.textObj[intervalParam]["fxH1Title"];
        } else {
            pageTitle = window.textObj[intervalParam]["fxPageTitle"];
            h1Title = window.textObj[intervalParam]["fxH1Title"];
        }

        if (intervalParam != "30m") {
            pageTitle = pageTitle.replace("{0}", baseCurrency).replace("{1}", quoteCurrency)
                .replace("{2}", localisedbaseCurrencyName).replace("{3}", localisedQuoteCurrencyName);
        } else {
            pageTitle = pageTitle.replace("{0}", localisedbaseCurrencyName).replace("{1}", localisedQuoteCurrencyName);
        }
        h1Title = h1Title.replace("{0}", localisedbaseCurrencyName).replace("{1}", localisedQuoteCurrencyName);

        if (description && description.includes(" / ")) {

            var baseCurrency = symbol.split('/')[0];
            var localisedbaseCurrencyName = description.split(' / ')[0];
            
            var quoteCurrency = symbol.split('/')[1];
            var localisedQuoteCurrencyName = description.split(' / ')[1]

            pageText = window.lcPageText.replace(/\{1\}/g, localisedbaseCurrencyName)
                .replace(/\{2\}/g, localisedQuoteCurrencyName)
                .replace(/\{3\}/g, baseCurrency)
                .replace(/\{4\}/g, quoteCurrency);
            metaDesc = window.lcMetaText.replace("{1}", localisedbaseCurrencyName)
                .replace("{2}", localisedQuoteCurrencyName)
                .replace("{3}", baseCurrency)
                .replace("{4}", quoteCurrency);

            if (type != "Physical Currency") {
                pageTitle = window.textObj[intervalParam]["nonFxPageTitle"];
                h1Title = window.textObj[intervalParam]["fxH1Title"];
            } else {
                pageTitle = window.textObj[intervalParam]["fxPageTitle"];
                h1Title = window.textObj[intervalParam]["fxH1Title"];
            }

            if (intervalParam != "30m") {
                pageTitle = pageTitle.replace("{0}", baseCurrency).replace("{1}", quoteCurrency)
                    .replace("{2}", localisedbaseCurrencyName).replace("{3}", localisedQuoteCurrencyName);
            } else {
                pageTitle = pageTitle.replace("{0}", localisedbaseCurrencyName).replace("{1}", localisedQuoteCurrencyName);
            }
            h1Title = h1Title.replace("{0}", localisedbaseCurrencyName).replace("{1}", localisedQuoteCurrencyName);

            metaDesc = metaDesc.replace("{0}", window.textObj[intervalParam]["textParam"]);
            pageText = pageText.replace("{0}", window.textObj[intervalParam]["textParam"]);

            $("title").html(pageTitle);
            $("h1.article-title").html(h1Title);
            $('meta[name="description"]').attr("content", metaDesc);
            $("#live-chart-page-text").html(pageText);

        } else {

            $.ajax({
                url: '/' + window.CURRENT_LANG + '/api/live-chart/meta-info',
                data: { baseSymbol: baseCurrency, quoteSymbol: quoteCurrency },
                type: "POST",
                dataType: "json",
                success: function (res) {

                    var baseCurrency = symbol.split('/')[0];
                    var localisedbaseCurrencyName = baseCurrency;
                    if (res.baseSymbolName)
                        localisedbaseCurrencyName = res.baseSymbolName;

                    var quoteCurrency = symbol.split('/')[1];
                    var localisedQuoteCurrencyName = quoteCurrency
                    if (res.quoteSymbolName)
                        localisedQuoteCurrencyName = res.quoteSymbolName;

                    pageText = window.lcPageText.replace(/\{1\}/g, localisedbaseCurrencyName)
                        .replace(/\{2\}/g, localisedQuoteCurrencyName)
                        .replace(/\{3\}/g, baseCurrency)
                        .replace(/\{4\}/g, quoteCurrency);
                    metaDesc = window.lcMetaText.replace("{1}", localisedbaseCurrencyName)
                        .replace("{2}", localisedQuoteCurrencyName)
                        .replace("{3}", baseCurrency)
                        .replace("{4}", quoteCurrency);

                    if (type != "Physical Currency") {
                        pageTitle = window.textObj[intervalParam]["nonFxPageTitle"];
                        h1Title = window.textObj[intervalParam]["fxH1Title"];
                    } else {
                        pageTitle = window.textObj[intervalParam]["fxPageTitle"];
                        h1Title = window.textObj[intervalParam]["fxH1Title"];
                    }

                    if (intervalParam != "30m") {
                        pageTitle = pageTitle.replace("{0}", baseCurrency).replace("{1}", quoteCurrency)
                            .replace("{2}", localisedbaseCurrencyName).replace("{3}", localisedQuoteCurrencyName);
                    } else {
                        pageTitle = pageTitle.replace("{0}", localisedbaseCurrencyName).replace("{1}", localisedQuoteCurrencyName);
                    }
                    h1Title = h1Title.replace("{0}", localisedbaseCurrencyName).replace("{1}", localisedQuoteCurrencyName);

                    metaDesc = metaDesc.replace("{0}", window.textObj[intervalParam]["textParam"]);
                    pageText = pageText.replace("{0}", window.textObj[intervalParam]["textParam"]);

                    $("title").html(pageTitle);
                    $("h1.article-title").html(h1Title);
                    $('meta[name="description"]').attr("content", metaDesc);
                    $("#live-chart-page-text").html(pageText);

                }
            });
        }
    } else {

        var symbolShortName = symbol;
        var symbolLongName = description.split(' - ')[0].trimEnd(' ');

        if (additional) {
            pageText = window.lcPageText_extra.replace(/\{1\}/g, symbolLongName + " (" + additional + ")")
                .replace(/\{2\}/g, symbolShortName)
                .replace(/\{3\}/g, symbolLongName + " (" + additional + ")");
        } else {
            pageText = window.lcPageText_extra.replace(/\{1\}/g, symbolLongName)
                .replace(/\{2\}/g, symbolShortName)
                .replace(/\{3\}/g, symbolLongName);
        }

        

        metaDesc = window.lcMetaText_extra.replace("{1}", symbolLongName)
            .replace("{2}", symbolShortName);

        pageTitle = window.textObj[intervalParam]["fxPageTitle_extra"];
        h1Title = window.textObj[intervalParam]["fxH1Title_extra"];

        pageTitle = pageTitle.replace("{0}", symbolShortName)
            .replace("{1}", symbolLongName);
        h1Title = h1Title.replace("{0}", symbolShortName + " | " + symbolLongName);
    }


    additionalTitle = window.textObj[intervalParam]["additionalTitle"];
    pageText = pageText.replace("{0}", window.textObj[intervalParam]["textParam"]);
    metaDesc = metaDesc.replace("{0}", window.textObj[intervalParam]["textParam"]);

    if (additional) {
        pageTitle += " (" + additional + ")";
        metaDesc += "(" + additional + ")";
    }

    $("title").html(pageTitle);
    $('meta[name="description"]').attr("content", metaDesc);
    $("h1.article-title").html(h1Title);
    $("#live-chart-additional-title").html(additionalTitle);
    $("#live-chart-page-text").html(pageText);
}
function OnNewLiveChartThemeChanged() {
    if ($("#lc-theme-switch").hasClass("checked")) {

        $("#lc-theme-switch").removeClass("checked");
        $(".live-chart-content").addClass("lc-dark-theme dark-theme-chart-widget");
        window.tvLivechartWidget.changeTheme('dark');
        window.CalcWidgetStyle.SetCalcCookieValue('ntvc-theme', 'dark');
    }
    else {

        $("#lc-theme-switch").addClass("checked");
        $(".live-chart-content").removeClass("lc-dark-theme dark-theme-chart-widget");        
        window.tvLivechartWidget.changeTheme('light');
        window.CalcWidgetStyle.SetCalcCookieValue('ntvc-theme', 'light');
    }
}
function OnNewLiveChartFullScreen() {

    if ($('div.tv-chart').hasClass("full-screen")) {

        window.scrollTo(0, 0);
        $("body").css("overflow", "auto");

        $('div.tv-chart').removeClass("full-screen");
        $("#lc-full-screen").html('<i class="mdi mdi-arrow-expand-all"></i>');
    }
    else {
        $("body").css("overflow", "hidden");

        $('div.tv-chart').addClass("full-screen");
        $("#lc-full-screen").html('<i class="mdi mdi-arrow-collapse-all"></i>');
    }
}




function NewLiveChartSwitchSymbol(ticker, symbol) {
    if (window.tvLivechartWidgetLoaded === true && window.tvLivechartWidget) {
        window.tvLivechartWidget.activeChart().setSymbol(ticker);

        if (window.positionSizeCalculator) {
            window.positionSizeCalculator.UpdateCalculatorSymbol(ticker, symbol);
        }

        if (window.profitCalculator) {
            window.profitCalculator.UpdateCalculatorSymbol(ticker, symbol);
        }

        return false;
    }
    return true;
}


function OnAddToWatchList() {

    const symbolExt = window.tvLivechartWidget.activeChart().symbolExt();

    window.WatchlistInstance.AddToWatchList(symbolExt.pro_name, symbolExt.symbol, symbolExt.exchange);

}

function CountWatchListItem(watchList, symbol) {
    var count = 0;
    for (var i = 0; i < watchList.length; i++) {
        if (watchList[i].Symbol == symbol)
            count++;
    }
    return count;
}
function OnNewLiveChartOpenNew() {

    var cookieExchange = window.CalcWidgetStyle.GetCalcCookieValue('ntvc-exchange');
    var cookieSymbol = window.CalcWidgetStyle.GetCalcCookieValue('ntvc-symbol');
    var cookieInterval = window.CalcWidgetStyle.GetCalcCookieValue('ntvc-interval');

    var urlParam = GenerateNewLiveChartUrlParam(cookieExchange, cookieSymbol, cookieInterval);
    if (window.CURRENT_LANG == "en")
        window.open("/widgets/live-chart" + urlParam, "", "width=800, height=600");
    else
        window.open("/" + window.CURRENT_LANG + "/widgets/live-chart" + urlParam, "", "width=800, height=600");
}


function GetHistoryItemDivStr(href, symbol, ticker) {
    if (!ticker) ticker = symbol;
    return '<div class="history-item"><a class="symbol-link" href="' + href + '" data-ticker="' + ticker + '" data-symbol="' + symbol + '" onclick="return NewLiveChartSwitchSymbol(' + "'" + ticker + "', '" + symbol + "'" + ');">' + symbol + '</a></div>';
}

function AppendWithDefaultSymbols(historyList) {

    const defaultList = ['EUR/USD', 'GBP/USD', 'USD/JPY', 'GBP/JPY', 'AUD/USD', 'BTC/USD', 'ETH/USD', 'XAU/USD', 'WTI/USD', 'XBR/USD', 'US30', 'US500', 'USTEC', 'US2000', 'UK100', 'JP225', 'ES35', 'F40', 'DE40', 'HK50', 'IT40', 'AUS200', 'CA60', 'CHINA50', 'DXY', 'AMZN', 'AAPL', 'GOOGL']

    var cnt = 28 - historyList.length;
    for (var j = 0; j < defaultList.length; j++) {
        if (cnt <= 0) break;
        for (var k = 0; k < historyList.length; k++)
            if (historyList[k].Symbol.includes(defaultList[j])) break;
        if (k == historyList.length) {
            historyList.push({
                Symbol: defaultList[j],
                Timeframe: '1h'
            });
            cnt--;
        }
    }
    return historyList;
}

function ResizeSymbolColumn() {
    const firstColumns = $(".list-container .item-info");

    // Find the maximum content width among all first columns
    var maxWidth = 0;
    firstColumns.each(function () {
        const width = $(this).outerWidth();
        maxWidth = Math.max(maxWidth, width);
    });

    // Set the width of all first columns to the maximum width
    firstColumns.outerWidth(maxWidth);

    const rows = $(".list-container .item-row");
    rows.each(function () {
        const columns = $(this).find('.item-cell');
        var maxHeight = 0;
        columns.each(function () {
            const height = $(this).outerHeight();
            maxHeight = Math.max(maxHeight, height);
        })
        columns.outerHeight(maxHeight);
    })
}

function OnSymbolResolved(symbolInfo) {

    const interval = GetCurrentIntervalFromUrl();

    UpdateNewLiveChartPageTitleAndMeta(interval, symbolInfo);

    UpdateChartBreadcrumb();

    if ($("#add-watch-list").length > 0) {
        UpdateChartPageWatchlistIcon();
    }

    UpdateChartPageRecentWatchlistSymbol(symbolInfo);
}

function UpdateChartPageRecentWatchlistBar() {

    if ($(".chart-history-view").length == 0) return;

    // DEBUG: Log current URL context
    var canonicalLink = $("link[rel='canonical']");

    var watchlistItems = [];
    if (window.WatchlistInstance.IsRecentSymbolsMode()) {
        watchlistItems = window.WatchlistInstance.GetRecentSymbols();
    } else {
        const watchlist = window.WatchlistInstance.GetActiveWatchlist();
        watchlistItems = watchlist.Symbols;

        watchlistItems.sort(function (a, b) { return window.WatchlistInstance.CompareWatchlistItemBySortMethod(a, b); });
    }

    const interval = GetCurrentIntervalFromUrl();

    var content = '';
    for (var i = 0; i < watchlistItems.length; i++) {
        const item = watchlistItems[i];
        var exchange = item.Exchange;
        if (!item.Exchange && item.Ticker && item.Ticker.includes(":"))
            exchange = item.Ticker.split(":")[0];

        const symbolHref = GetHrefOfChartHistory(exchange, item.Symbol, interval);
        var symbol = item.Symbol;
        if (symbol.includes(':'))
            symbol = symbol.split(':')[1];

        content += GetHistoryItemDivStr(symbolHref, symbol, item.Ticker);
    }

    if (!window.WatchlistInstance.IsRecentSymbolsMode()) {
        content += '<div class="history-item"><a class="symbol-link" href="javascript:void(0);" onclick="window.WatchlistInstance.OpenWatchListMngDialog(' + window.WatchlistInstance.GetActiveWatchlistId() + ');">+</a></div>';
    }

    $(".chart-history-view").html(content);
}
function GetHrefOfChartHistory(exchange, symbol, interval) {
    if (symbol && symbol.includes(':')) {
        symbol = symbol.split(':')[1];
    }

    const urlParam = GenerateNewLiveChartUrlParam(exchange, symbol, interval);
    const href = GenerateNewLiveChartUrl(location.href, urlParam);
    return href;
}
function UpdateChartPageRecentWatchlistSymbol(symbolInfo) {

    if (!symbolInfo) return;

    window.WatchlistInstance.VisitSymbol(symbolInfo);

    UpdateChartPageRecentWatchlistBar();
}

function ToggleChartTools() {
    window.tvLivechartWidget.activeChart().executeActionById('drawingToolbarAction');
}


function InitializePivotPointCalcParamsFromCookie() {

    var pathName = window.location.pathname;
    if (pathName.endsWith("/")) pathName = pathName.substring(0, pathName.length - 1);

    if (pathName.endsWith("calculator") || pathName.endsWith("tools/widgets")) {
        var cookieType = window.CalcWidgetStyle.GetCalcCookieValue('ppc-type');
        if (cookieType != "") {
            $("#ppc-type-select").selectpicker('val', cookieType);

            if (cookieType == 'demark') {
                $('#ppc-open-price-group').css("display", "block");
                $('#ppc-open-price').attr("required", true);
            } else {
                $('#ppc-open-price-group').css("display", "none");
                $('#ppc-open-price').removeAttr("required");
            }
        }
    }

    var cookieHigh = window.CalcWidgetStyle.GetCalcCookieValue('ppc-high-value');
    if (cookieHigh != "") {
        $("#ppc-high-price").val(cookieHigh);
    }

    var cookieLow = window.CalcWidgetStyle.GetCalcCookieValue('ppc-low');
    if (cookieLow != "") {
        $("#ppc-low-price").val(cookieLow);
    }
    var cookieClose = window.CalcWidgetStyle.GetCalcCookieValue('ppc-close');
    if (cookieClose != "") {
        $("#ppc-close-price").val(cookieClose);
    }
    var cookieOpen = window.CalcWidgetStyle.GetCalcCookieValue('ppc-open');
    if (cookieOpen != "") {
        $("#ppc-open-price").val(cookieOpen);
    }
}

function InitPivotPointCalcWidget() {
    if ($("#ppc-type-select").length <= 0)
        return;
    InitializePivotPointCalcParamsFromCookie();

    document.getElementById('ppc-type-select').addEventListener('change', OnPPCChangeInput);
    document.getElementById('ppc-high-price').addEventListener('change', OnPPCChangeInput);
    document.getElementById('ppc-low-price').addEventListener('change', OnPPCChangeInput);
    document.getElementById('ppc-close-price').addEventListener('change', OnPPCChangeInput);
    document.getElementById('ppc-open-price').addEventListener('change', OnPPCChangeInput);

    UpdatePPCParamLinks();
    CalculatePivotPoint();
}

function OnPPCStyleUpdated(e, styleType) {

    window.CalcWidgetStyle.SetWidgetStyleCookie(styleType, e.value);

    GeneratePivotPointCalculatorRemoteScript();
}
function OnPPCTypeChanged() {

    var type = document.getElementById('ppc-type-select').value;

    if (type == 'demark') {
        $('#ppc-open-price-group').css("display", "block");
        $('#ppc-open-price').attr("required", true);
    } else {
        $('#ppc-open-price-group').css("display", "none");
        $('#ppc-open-price').removeAttr("required");
    }

    UpdatePPCHrefAndTitle();
    UpdatePPCParamLinks();  
}

function UpdatePPCHrefAndTitle() {

    var urlPart = "/tools/pivot-point-calculator";

    if (!window.location.pathname.includes(urlPart) || window.location.hash == '#popout')
        return;

    var e = document.getElementById('ppc-type-select');
    var prefix = e.options[e.selectedIndex].text;
    var slug = e.options[e.selectedIndex].value;

    var newH1Title = prefix + " " + window.originArticleH1Title;
    var newPageTitle = prefix + " " + window.originArticlePageTitle;

    if (window.originArticleH1Title != "")
        $("h1.article-title").html(newH1Title);
    if (window.originArticlePageTitle != "")
        $("title").html(newPageTitle);

    // update current page link
    var newUrl = GeneratePPCNewLink(window.location.href, slug);
    window.history.replaceState({ path: newUrl }, '', newUrl);

    // update canonical links
    var baseCanonical = $("link[rel='canonical']").attr('href');
    $("link[rel='canonical']").attr('href', GeneratePPCNewLink(baseCanonical, slug));

    // update href links
    var hreflangs = $("link[hreflang]");
    for (var i = 0; i < hreflangs.length; i++) {
        hreflangs[i].href = GeneratePPCNewLink(hreflangs[i].href, slug);
    }

    //update language switch links
    var langSelectors = $("#lang-select li a")
    for (var i = 0; i < langSelectors.length; i++) {

        var newLink = GeneratePPCNewLink(langSelectors[i].href, slug);

        var langCode = $("#lang-select li a i")[i].getAttribute("data-id").split('-')[0];

        langSelectors[i].href = newLink;
        if (langCode == "en")
            $(langSelectors[i]).attr("onclick", "return window.Language.Select('" + urlPart + "?s=" + slug + "','" + langCode + "')");
        else
            $(langSelectors[i]).attr("onclick", "return window.Language.Select('/" + langCode + urlPart + "?s=" + slug + "','" + langCode + "')");
    }

    TriggerGoogleAnalytics();
}

function GeneratePPCNewLink(oldUrl, type) {

    var urlPart = "tools/pivot-point-calculator";
    var baseUrl = oldUrl.substring(0, oldUrl.toLowerCase().indexOf(urlPart) + urlPart.length);
    return baseUrl + "/" + type;
}

function UpdatePPCParamLinks() {

    var urlPart = "/tools/pivot-point-calculator";

    if (!window.location.pathname.includes(urlPart))
        return;

    if ($('#ppc-type-select-group .dropdown-menu a[role="option"]').length == 0)
        $("#ppc-type-select").selectpicker("refresh");
    var symbolLinks = $('#ppc-type-select-group .dropdown-menu a[role="option"]');

    for (var i = 0; i < symbolLinks.length; i++) {

        var curType = document.getElementById("ppc-type-select").options[i].value;

        symbolLinks[i].href = GeneratePPCNewLink(window.location.pathname, curType);
    }
}

function OpenPPCEmbedOverlay() {
    var prefix = 'pivot-point-calculator';
    var currentLocation = window.location.pathname;
    if (currentLocation.includes('/widgets/' + prefix + '-widget')) {
        var url = '/widgets/' + prefix + '-widget-maker';
        if (window.CurrentLang !== '') {
            url = '/' + window.CurrentLang + url;
            var width = 398;
            window.open(url, "", "width=" + width);
        }
    } else if (currentLocation.includes('/widgets/' + prefix)) {
        var url = '/widgets/' + prefix + '-widget';
        if (window.CurrentLang !== '') {
            url = '/' + window.CurrentLang + url;
        }
        window.open(url, '_blank').focus();
    } else if (currentLocation.includes('/tools/' + prefix)) {
        var url = '/tools/' + prefix + '-widget';
        if (window.CurrentLang !== '') {
            url = '/' + window.CurrentLang + url;
        }
        window.location.href = url;
    }
}

function ClosePPCEmbedOverlay() {
    $("#ppc-embed-script-overlay").css("display", "none");
}

function ClearPivotPointCalcWdigetStyles() {

    window.CalcWidgetStyle.ResetCalcWidgetsStyles();

    GeneratePivotPointCalculatorRemoteScript();
}

function OnCopyPPCEmbedScript() {
    document.getElementById('ppc-embed-script-preview-output').select();
    document.execCommand("copy");

    GeneratePivotPointCalculatorRemoteScript();
}

function GeneratePivotPointCalculatorRemoteScript() {

    PivotPointWidgetConfig = new Object();

    PivotPointWidgetConfig.TopPaneStyle = window.CalcWidgetStyle.GetTopPaneStyle();
    PivotPointWidgetConfig.BottomPaneStyle = window.CalcWidgetStyle.GetBottomPaneStyle();
    PivotPointWidgetConfig.ButtonStyle = window.CalcWidgetStyle.GetButtonStyle();

    PivotPointWidgetConfig.IsDisplayTitle = document.getElementById('ppc-display-tool-title-input').checked;

    var language = document.getElementById('ppc-widget-language-select').value;
    if (language != "browser") {
        PivotPointWidgetConfig.Lang = language;
    }

    var hostUrl = window.location.protocol + "//" + window.location.hostname;
    if (window.location.port !== "")
        hostUrl += ":" + window.location.port;

    PivotPointWidgetConfig.Url = hostUrl;
    PivotPointWidgetConfig.Calculator = "pivot-point-calculator";

    document.getElementById('ppc-embed-script-preview-output').value = GenerateCalcWidgetScript(PivotPointWidgetConfig);

    document.getElementById('pivot-point-preview-link').href = window.CalculatorHelper.GenerateCalcPreviewLink(PivotPointWidgetConfig, "pivot-point-calculator");
}

function OnPPCChangeInput() {
    var tableResultHtml = '<table class="calc-table pivot-point-table"><thead><tr><th>' + window.LevelLabel + '</th>' + '<th>' + window.PriceLabel + '</th></tr></thead>';
   
    tableResultHtml += '<tr>';

    tableResultHtml += "<td>--</td>";
    tableResultHtml += "<td>--</td>";

    tableResultHtml += '</tr>';
  
    document.getElementById('pivot-point-table-result').innerHTML = tableResultHtml;
}

function PPCResultLoading() {

    var tableResultHtml = '<table class="calc-table pivot-point-table"><thead><tr><th>' + window.LevelLabel + '</th>' + '<th>' + window.PriceLabel + '</th></tr></thead>';

    tableResultHtml += '<tr>';

    tableResultHtml += '<td><img class="result-loading-img" src="/Content/dist/images/PageElements/ajax-loader.svg" /></td>';
    tableResultHtml += '<td><img class="result-loading-img" src="/Content/dist/images/PageElements/ajax-loader.svg" /></td>';

    tableResultHtml += '</tr>';

    document.getElementById('pivot-point-table-result').innerHTML = tableResultHtml;
}

function CalculatePivotPoint() {

    var form = document.getElementById('pivot-point-calc-form');
    if (form.checkValidity() == false) {
        form.reportValidity();
        //form.classList.add('was-validated');
        return;
    }


    var type = document.getElementById('ppc-type-select').value;
    var highPrice = window.CalculatorHelper.ParseLocaleNumber(document.getElementById('ppc-high-price').value);
    var lowPrice = window.CalculatorHelper.ParseLocaleNumber(document.getElementById('ppc-low-price').value);
    var closePrice = window.CalculatorHelper.ParseLocaleNumber(document.getElementById('ppc-close-price').value);
    var openPrice = closePrice;

    if (type == "demark") {
        openPrice = window.CalculatorHelper.ParseLocaleNumber(document.getElementById('ppc-open-price').value);
    }

    window.CalcWidgetStyle.SetCalcCookieValue('ppc-type', type);
    window.CalcWidgetStyle.SetCalcCookieValue('ppc-high-value', highPrice);
    window.CalcWidgetStyle.SetCalcCookieValue('ppc-low', lowPrice);
    window.CalcWidgetStyle.SetCalcCookieValue('ppc-close', closePrice);
    window.CalcWidgetStyle.SetCalcCookieValue('ppc-open', openPrice);
    
    var isValid = true;
    if (highPrice < lowPrice) {
        $("#invalid-high-low-price").css("display", "block");
        isValid = false;
    } else {
        $("#invalid-high-low-price").css("display", "none");
    }
    if (highPrice < closePrice || closePrice < lowPrice || highPrice < openPrice || openPrice < lowPrice) {
        $("#invalid-open-close-price").css("display", "block");
        isValid = false;
    } else {
        $("#invalid-open-close-price").css("display", "none");
    }
    if (isValid == false)
        return;
    
    PPCResultLoading();

    $.ajax({
        type: "POST",
        cache: false,
        dataType: "json",
        url: "/widgets/calculation/pivot-point",
        data: { type: type, highPrice: highPrice, lowPrice: lowPrice, openPrice: openPrice, closePrice: closePrice },
        success: function (data) {
            if (data.success === true) {                

                var tableResultHtml = '<table class="calc-table pivot-point-table"><thead><tr><th>' + window.LevelLabel + '</th>' + '<th>' + window.PriceLabel + '</th></tr></thead>';
                for (var i = 0; i < data.tableResult.length; i++) {
                    if (data.tableResult[i] != undefined) {
                        tableResultHtml += '<tr>';

                        tableResultHtml += "<td>" + data.tableResult[i].Label + "</td>";
                        tableResultHtml += "<td>" + window.CalculatorHelper.ToLocaleNumberForResult(data.tableResult[i].Price, "", 4, "") + "</td>";

                        tableResultHtml += '</tr>';
                    }
                }

                document.getElementById('pivot-point-table-result').innerHTML = tableResultHtml;

            } else {
                
            }
        },
        error: function () {            
        }
    });
}



function InitializeRiskOfRuinCalcParamsFromCookie() {

    var cookieWinRate = window.CalcWidgetStyle.GetCalcCookieValue('ror-winrate');
    if (cookieWinRate != "") {
        $("#rorc-win-rate").val(cookieWinRate);
    }

    var cookieAvgWinLoss = window.CalcWidgetStyle.GetCalcCookieValue('ror-avgwinloss');
    if (cookieAvgWinLoss != "") {
        $("#rorc-avg-win-avg-loss").val(cookieAvgWinLoss);
    }

    var cookieRiskPerTrade = window.CalcWidgetStyle.GetCalcCookieValue('ror-riskpertrade');
    if (cookieRiskPerTrade != "") {
        $("#rorc-risk-per-trade").val(cookieRiskPerTrade);
    }

    var cookieTradesNum = window.CalcWidgetStyle.GetCalcCookieValue('ror-tradesnum');
    if (cookieTradesNum != "") {
        $("#rorc-number-of-trades").val(cookieTradesNum);
    }

    var cookieMaxDrawdown = window.CalcWidgetStyle.GetCalcCookieValue('ror-maxdrawdown');
    if (cookieMaxDrawdown != "") {
        $("#rorc-max-drawdown").val(cookieMaxDrawdown);
    }
}

function InitRiskOfRuinCalcWidget() {

    if ($("#rorc-win-rate").length <= 0)
        return;

    InitializeRiskOfRuinCalcParamsFromCookie();

    CalculateRiskOfRuin();

    document.getElementById('rorc-win-rate').addEventListener('change', OnRORCChangeInput);
    document.getElementById('rorc-avg-win-avg-loss').addEventListener('change', OnRORCChangeInput);
    document.getElementById('rorc-risk-per-trade').addEventListener('change', OnRORCChangeInput);
    document.getElementById('rorc-number-of-trades').addEventListener('change', OnRORCChangeInput);
    document.getElementById('rorc-max-drawdown').addEventListener('change', OnRORCChangeInput);
    document.getElementById('rorc-max-drawdown').addEventListener('change', OnRORCChangeMaxDrawdownInput);


}

function OnRORCStyleUpdated(e, styleType) {

    window.CalcWidgetStyle.SetWidgetStyleCookie(styleType, e.value);

    GenerateRiskOfRuinCalculatorRemoteScript();
}

function OpenRORCEmbedOverlay() {
    var prefix = 'risk-of-ruin-calculator';
    var currentLocation = window.location.pathname;
    if (currentLocation.includes('/widgets/' + prefix + '-widget')) {
        var url = '/widgets/' + prefix + '-widget-maker';
        if (window.CurrentLang !== '') {
            url = '/' + window.CurrentLang + url;
            var width = 398;
            window.open(url, "", "width=" + width);
        }
    } else if (currentLocation.includes('/widgets/' + prefix)) {
        var url = '/widgets/' + prefix + '-widget';
        if (window.CurrentLang !== '') {
            url = '/' + window.CurrentLang + url;
        }
        window.open(url, '_blank').focus();
    } else if (currentLocation.includes('/tools/' + prefix)) {
        var url = '/tools/' + prefix + '-widget';
        if (window.CurrentLang !== '') {
            url = '/' + window.CurrentLang + url;
        }
        window.location.href = url;
    }
}

function CloseRORCEmbedOverlay() {
    $("#rorc-embed-script-overlay").css("display", "none");
}

function ClearRiskOfRuinCalcWdigetStyles() {

    window.CalcWidgetStyle.ResetCalcWidgetsStyles();

    GenerateRiskOfRuinCalculatorRemoteScript();
}

function OnCopyRORCEmbedScript() {
    document.getElementById('rorc-embed-script-preview-output').select();
    document.execCommand("copy");
}

function GenerateRiskOfRuinCalculatorRemoteScript() {

    RiskOfRuinWidgetConfig = new Object();

    RiskOfRuinWidgetConfig.TopPaneStyle = window.CalcWidgetStyle.GetTopPaneStyle();
    RiskOfRuinWidgetConfig.BottomPaneStyle = window.CalcWidgetStyle.GetBottomPaneStyle();
    RiskOfRuinWidgetConfig.ButtonStyle = window.CalcWidgetStyle.GetButtonStyle();

    RiskOfRuinWidgetConfig.IsDisplayTitle = document.getElementById('rorc-display-tool-title-input').checked;

    var language = document.getElementById('rorc-widget-language-select').value;
    if (language != "browser") {
        RiskOfRuinWidgetConfig.Lang = language;
    }

    var hostUrl = window.location.protocol + "//" + window.location.hostname;
    if (window.location.port !== "")
        hostUrl += ":" + window.location.port;

    RiskOfRuinWidgetConfig.Url = hostUrl;
    RiskOfRuinWidgetConfig.Calculator = "risk-of-ruin-calculator";
    
    document.getElementById('rorc-embed-script-preview-output').value = GenerateCalcWidgetScript(RiskOfRuinWidgetConfig);

    document.getElementById('risk-of-ruin-preview-link').href = window.CalculatorHelper.GenerateCalcPreviewLink(RiskOfRuinWidgetConfig, "risk-of-ruin-calculator");
}

function OnRORCChangeInput() {
    document.getElementById('risk-of-drawdown-result').innerHTML = "--";
    document.getElementById('risk-of-ruin-result').innerHTML = "--";
}
function OnRORCChangeMaxDrawdownInput() {

    $('#risk-of-dradown-title')[0].title = window.RiskOfDrawdownTooltipLabel.replace("{0}", document.getElementById('rorc-max-drawdown').value).replace("{1}", 100000);
    $('#risk-of-ruin-title')[0].title = window.RiskOfRuinResultTooltipLabel.replace("{0}", document.getElementById('rorc-max-drawdown').value).replace("{1}", 100000);    

    $('#risk-of-dradown-title').tooltip('dispose').tooltip({ boundary: 'window' });
    $('#risk-of-ruin-title').tooltip('dispose').tooltip({ boundary: 'window' });
}
function CalculateRiskOfRuin() {

    var form = document.getElementById('risk-of-ruin-calc-form');
    if (form.checkValidity() == false) {
        form.reportValidity();
        //form.classList.add('was-validated');
        return;
    }

    var winRate = window.CalculatorHelper.ParseLocaleNumber(document.getElementById('rorc-win-rate').value);
    var avgWinAvgLoss = window.CalculatorHelper.ParseLocaleNumber(document.getElementById('rorc-avg-win-avg-loss').value);
    var riskPerTrade = window.CalculatorHelper.ParseLocaleNumber(document.getElementById('rorc-risk-per-trade').value);
    var numberOfTrades = window.CalculatorHelper.ParseLocaleNumber(document.getElementById('rorc-number-of-trades').value);
    var maxDrawdown = window.CalculatorHelper.ParseLocaleNumber(document.getElementById('rorc-max-drawdown').value);

    window.CalcWidgetStyle.SetCalcCookieValue('ror-winrate', winRate);
    window.CalcWidgetStyle.SetCalcCookieValue('ror-avgwinloss', avgWinAvgLoss);
    window.CalcWidgetStyle.SetCalcCookieValue('ror-riskpertrade', riskPerTrade);
    window.CalcWidgetStyle.SetCalcCookieValue('ror-tradesnum', numberOfTrades);
    window.CalcWidgetStyle.SetCalcCookieValue('ror-maxdrawdown', maxDrawdown);
    
    $("#risk-of-ruin-calc-form span.result-span").html('<img class="result-loading-img" src="/Content/dist/images/PageElements/ajax-loader.svg" />');
    
    $.ajax({
        type: "POST",
        cache: false,
        dataType: "json",
        url: "/widgets/calculation/risk-of-ruin",
        data: { winRate: winRate, avgWinAvgLoss: avgWinAvgLoss, riskPerTrade: riskPerTrade, numberOfTrades: numberOfTrades, maxDrawdown: maxDrawdown },
        success: function (data) {
            if (data.success === true) {
                document.getElementById('risk-of-drawdown-result').innerHTML = window.CalculatorHelper.ToLocaleNumberForResult(data.drawdown, 'percent', 1, "");
                document.getElementById('risk-of-ruin-result').innerHTML = window.CalculatorHelper.ToLocaleNumberForResult(data.ruin, 'percent', 1);
            } else {
                document.getElementById('risk-of-drawdown-result').innerHTML = "NaN";
                document.getElementById('risk-of-ruin-result').innerHTML = "NaN";
            }

        },
        error: function () {
            document.getElementById('risk-of-drawdown-result').innerHTML = "NaN";
            document.getElementById('risk-of-ruin-result').innerHTML = "NaN";
        }
    });
}

/*! Sortable 1.15.6 - MIT | git://github.com/SortableJS/Sortable.git */
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(t=t||self).Sortable=e()}(this,function(){"use strict";function e(e,t){var n,o=Object.keys(e);return Object.getOwnPropertySymbols&&(n=Object.getOwnPropertySymbols(e),t&&(n=n.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),o.push.apply(o,n)),o}function I(o){for(var t=1;t<arguments.length;t++){var i=null!=arguments[t]?arguments[t]:{};t%2?e(Object(i),!0).forEach(function(t){var e,n;e=o,t=i[n=t],n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t}):Object.getOwnPropertyDescriptors?Object.defineProperties(o,Object.getOwnPropertyDescriptors(i)):e(Object(i)).forEach(function(t){Object.defineProperty(o,t,Object.getOwnPropertyDescriptor(i,t))})}return o}function o(t){return(o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function a(){return(a=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n,o=arguments[e];for(n in o)Object.prototype.hasOwnProperty.call(o,n)&&(t[n]=o[n])}return t}).apply(this,arguments)}function i(t,e){if(null==t)return{};var n,o=function(t,e){if(null==t)return{};for(var n,o={},i=Object.keys(t),r=0;r<i.length;r++)n=i[r],0<=e.indexOf(n)||(o[n]=t[n]);return o}(t,e);if(Object.getOwnPropertySymbols)for(var i=Object.getOwnPropertySymbols(t),r=0;r<i.length;r++)n=i[r],0<=e.indexOf(n)||Object.prototype.propertyIsEnumerable.call(t,n)&&(o[n]=t[n]);return o}function r(t){return function(t){if(Array.isArray(t))return l(t)}(t)||function(t){if("undefined"!=typeof Symbol&&null!=t[Symbol.iterator]||null!=t["@@iterator"])return Array.from(t)}(t)||function(t,e){if(t){if("string"==typeof t)return l(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);return"Map"===(n="Object"===n&&t.constructor?t.constructor.name:n)||"Set"===n?Array.from(t):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?l(t,e):void 0}}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function l(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,o=new Array(e);n<e;n++)o[n]=t[n];return o}function t(t){if("undefined"!=typeof window&&window.navigator)return!!navigator.userAgent.match(t)}var y=t(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i),w=t(/Edge/i),s=t(/firefox/i),u=t(/safari/i)&&!t(/chrome/i)&&!t(/android/i),c=t(/iP(ad|od|hone)/i),n=t(/chrome/i)&&t(/android/i),d={capture:!1,passive:!1};function h(t,e,n){t.addEventListener(e,n,!y&&d)}function p(t,e,n){t.removeEventListener(e,n,!y&&d)}function f(t,e){if(e&&(">"===e[0]&&(e=e.substring(1)),t))try{if(t.matches)return t.matches(e);if(t.msMatchesSelector)return t.msMatchesSelector(e);if(t.webkitMatchesSelector)return t.webkitMatchesSelector(e)}catch(t){return}}function g(t){return t.host&&t!==document&&t.host.nodeType?t.host:t.parentNode}function P(t,e,n,o){if(t){n=n||document;do{if(null!=e&&(">"!==e[0]||t.parentNode===n)&&f(t,e)||o&&t===n)return t}while(t!==n&&(t=g(t)))}return null}var m,v=/\s+/g;function k(t,e,n){var o;t&&e&&(t.classList?t.classList[n?"add":"remove"](e):(o=(" "+t.className+" ").replace(v," ").replace(" "+e+" "," "),t.className=(o+(n?" "+e:"")).replace(v," ")))}function R(t,e,n){var o=t&&t.style;if(o){if(void 0===n)return document.defaultView&&document.defaultView.getComputedStyle?n=document.defaultView.getComputedStyle(t,""):t.currentStyle&&(n=t.currentStyle),void 0===e?n:n[e];o[e=!(e in o||-1!==e.indexOf("webkit"))?"-webkit-"+e:e]=n+("string"==typeof n?"":"px")}}function b(t,e){var n="";if("string"==typeof t)n=t;else do{var o=R(t,"transform")}while(o&&"none"!==o&&(n=o+" "+n),!e&&(t=t.parentNode));var i=window.DOMMatrix||window.WebKitCSSMatrix||window.CSSMatrix||window.MSCSSMatrix;return i&&new i(n)}function D(t,e,n){if(t){var o=t.getElementsByTagName(e),i=0,r=o.length;if(n)for(;i<r;i++)n(o[i],i);return o}return[]}function O(){var t=document.scrollingElement;return t||document.documentElement}function X(t,e,n,o,i){if(t.getBoundingClientRect||t===window){var r,a,l,s,c,u,d=t!==window&&t.parentNode&&t!==O()?(a=(r=t.getBoundingClientRect()).top,l=r.left,s=r.bottom,c=r.right,u=r.height,r.width):(l=a=0,s=window.innerHeight,c=window.innerWidth,u=window.innerHeight,window.innerWidth);if((e||n)&&t!==window&&(i=i||t.parentNode,!y))do{if(i&&i.getBoundingClientRect&&("none"!==R(i,"transform")||n&&"static"!==R(i,"position"))){var h=i.getBoundingClientRect();a-=h.top+parseInt(R(i,"border-top-width")),l-=h.left+parseInt(R(i,"border-left-width")),s=a+r.height,c=l+r.width;break}}while(i=i.parentNode);return o&&t!==window&&(o=(e=b(i||t))&&e.a,t=e&&e.d,e&&(s=(a/=t)+(u/=t),c=(l/=o)+(d/=o))),{top:a,left:l,bottom:s,right:c,width:d,height:u}}}function Y(t,e,n){for(var o=M(t,!0),i=X(t)[e];o;){var r=X(o)[n];if(!("top"===n||"left"===n?r<=i:i<=r))return o;if(o===O())break;o=M(o,!1)}return!1}function B(t,e,n,o){for(var i=0,r=0,a=t.children;r<a.length;){if("none"!==a[r].style.display&&a[r]!==jt.ghost&&(o||a[r]!==jt.dragged)&&P(a[r],n.draggable,t,!1)){if(i===e)return a[r];i++}r++}return null}function F(t,e){for(var n=t.lastElementChild;n&&(n===jt.ghost||"none"===R(n,"display")||e&&!f(n,e));)n=n.previousElementSibling;return n||null}function j(t,e){var n=0;if(!t||!t.parentNode)return-1;for(;t=t.previousElementSibling;)"TEMPLATE"===t.nodeName.toUpperCase()||t===jt.clone||e&&!f(t,e)||n++;return n}function E(t){var e=0,n=0,o=O();if(t)do{var i=b(t),r=i.a,i=i.d}while(e+=t.scrollLeft*r,n+=t.scrollTop*i,t!==o&&(t=t.parentNode));return[e,n]}function M(t,e){if(!t||!t.getBoundingClientRect)return O();var n=t,o=!1;do{if(n.clientWidth<n.scrollWidth||n.clientHeight<n.scrollHeight){var i=R(n);if(n.clientWidth<n.scrollWidth&&("auto"==i.overflowX||"scroll"==i.overflowX)||n.clientHeight<n.scrollHeight&&("auto"==i.overflowY||"scroll"==i.overflowY)){if(!n.getBoundingClientRect||n===document.body)return O();if(o||e)return n;o=!0}}}while(n=n.parentNode);return O()}function S(t,e){return Math.round(t.top)===Math.round(e.top)&&Math.round(t.left)===Math.round(e.left)&&Math.round(t.height)===Math.round(e.height)&&Math.round(t.width)===Math.round(e.width)}function _(e,n){return function(){var t;m||(1===(t=arguments).length?e.call(this,t[0]):e.apply(this,t),m=setTimeout(function(){m=void 0},n))}}function H(t,e,n){t.scrollLeft+=e,t.scrollTop+=n}function C(t){var e=window.Polymer,n=window.jQuery||window.Zepto;return e&&e.dom?e.dom(t).cloneNode(!0):n?n(t).clone(!0)[0]:t.cloneNode(!0)}function T(t,e){R(t,"position","absolute"),R(t,"top",e.top),R(t,"left",e.left),R(t,"width",e.width),R(t,"height",e.height)}function x(t){R(t,"position",""),R(t,"top",""),R(t,"left",""),R(t,"width",""),R(t,"height","")}function L(n,o,i){var r={};return Array.from(n.children).forEach(function(t){var e;P(t,o.draggable,n,!1)&&!t.animated&&t!==i&&(e=X(t),r.left=Math.min(null!==(t=r.left)&&void 0!==t?t:1/0,e.left),r.top=Math.min(null!==(t=r.top)&&void 0!==t?t:1/0,e.top),r.right=Math.max(null!==(t=r.right)&&void 0!==t?t:-1/0,e.right),r.bottom=Math.max(null!==(t=r.bottom)&&void 0!==t?t:-1/0,e.bottom))}),r.width=r.right-r.left,r.height=r.bottom-r.top,r.x=r.left,r.y=r.top,r}var K="Sortable"+(new Date).getTime();function A(){var e,o=[];return{captureAnimationState:function(){o=[],this.options.animation&&[].slice.call(this.el.children).forEach(function(t){var e,n;"none"!==R(t,"display")&&t!==jt.ghost&&(o.push({target:t,rect:X(t)}),e=I({},o[o.length-1].rect),!t.thisAnimationDuration||(n=b(t,!0))&&(e.top-=n.f,e.left-=n.e),t.fromRect=e)})},addAnimationState:function(t){o.push(t)},removeAnimationState:function(t){o.splice(function(t,e){for(var n in t)if(t.hasOwnProperty(n))for(var o in e)if(e.hasOwnProperty(o)&&e[o]===t[n][o])return Number(n);return-1}(o,{target:t}),1)},animateAll:function(t){var c=this;if(!this.options.animation)return clearTimeout(e),void("function"==typeof t&&t());var u=!1,d=0;o.forEach(function(t){var e=0,n=t.target,o=n.fromRect,i=X(n),r=n.prevFromRect,a=n.prevToRect,l=t.rect,s=b(n,!0);s&&(i.top-=s.f,i.left-=s.e),n.toRect=i,n.thisAnimationDuration&&S(r,i)&&!S(o,i)&&(l.top-i.top)/(l.left-i.left)==(o.top-i.top)/(o.left-i.left)&&(t=l,s=r,r=a,a=c.options,e=Math.sqrt(Math.pow(s.top-t.top,2)+Math.pow(s.left-t.left,2))/Math.sqrt(Math.pow(s.top-r.top,2)+Math.pow(s.left-r.left,2))*a.animation),S(i,o)||(n.prevFromRect=o,n.prevToRect=i,e=e||c.options.animation,c.animate(n,l,i,e)),e&&(u=!0,d=Math.max(d,e),clearTimeout(n.animationResetTimer),n.animationResetTimer=setTimeout(function(){n.animationTime=0,n.prevFromRect=null,n.fromRect=null,n.prevToRect=null,n.thisAnimationDuration=null},e),n.thisAnimationDuration=e)}),clearTimeout(e),u?e=setTimeout(function(){"function"==typeof t&&t()},d):"function"==typeof t&&t(),o=[]},animate:function(t,e,n,o){var i,r;o&&(R(t,"transition",""),R(t,"transform",""),i=(r=b(this.el))&&r.a,r=r&&r.d,i=(e.left-n.left)/(i||1),r=(e.top-n.top)/(r||1),t.animatingX=!!i,t.animatingY=!!r,R(t,"transform","translate3d("+i+"px,"+r+"px,0)"),this.forRepaintDummy=t.offsetWidth,R(t,"transition","transform "+o+"ms"+(this.options.easing?" "+this.options.easing:"")),R(t,"transform","translate3d(0,0,0)"),"number"==typeof t.animated&&clearTimeout(t.animated),t.animated=setTimeout(function(){R(t,"transition",""),R(t,"transform",""),t.animated=!1,t.animatingX=!1,t.animatingY=!1},o))}}}var N=[],W={initializeByDefault:!0},z={mount:function(e){for(var t in W)!W.hasOwnProperty(t)||t in e||(e[t]=W[t]);N.forEach(function(t){if(t.pluginName===e.pluginName)throw"Sortable: Cannot mount plugin ".concat(e.pluginName," more than once")}),N.push(e)},pluginEvent:function(e,n,o){var t=this;this.eventCanceled=!1,o.cancel=function(){t.eventCanceled=!0};var i=e+"Global";N.forEach(function(t){n[t.pluginName]&&(n[t.pluginName][i]&&n[t.pluginName][i](I({sortable:n},o)),n.options[t.pluginName]&&n[t.pluginName][e]&&n[t.pluginName][e](I({sortable:n},o)))})},initializePlugins:function(n,o,i,t){for(var e in N.forEach(function(t){var e=t.pluginName;(n.options[e]||t.initializeByDefault)&&((t=new t(n,o,n.options)).sortable=n,t.options=n.options,n[e]=t,a(i,t.defaults))}),n.options){var r;n.options.hasOwnProperty(e)&&(void 0!==(r=this.modifyOption(n,e,n.options[e]))&&(n.options[e]=r))}},getEventProperties:function(e,n){var o={};return N.forEach(function(t){"function"==typeof t.eventProperties&&a(o,t.eventProperties.call(n[t.pluginName],e))}),o},modifyOption:function(e,n,o){var i;return N.forEach(function(t){e[t.pluginName]&&t.optionListeners&&"function"==typeof t.optionListeners[n]&&(i=t.optionListeners[n].call(e[t.pluginName],o))}),i}};function G(t){var e=t.sortable,n=t.rootEl,o=t.name,i=t.targetEl,r=t.cloneEl,a=t.toEl,l=t.fromEl,s=t.oldIndex,c=t.newIndex,u=t.oldDraggableIndex,d=t.newDraggableIndex,h=t.originalEvent,p=t.putSortable,f=t.extraEventProperties;if(e=e||n&&n[K]){var g,m=e.options,t="on"+o.charAt(0).toUpperCase()+o.substr(1);!window.CustomEvent||y||w?(g=document.createEvent("Event")).initEvent(o,!0,!0):g=new CustomEvent(o,{bubbles:!0,cancelable:!0}),g.to=a||n,g.from=l||n,g.item=i||n,g.clone=r,g.oldIndex=s,g.newIndex=c,g.oldDraggableIndex=u,g.newDraggableIndex=d,g.originalEvent=h,g.pullMode=p?p.lastPutMode:void 0;var v,b=I(I({},f),z.getEventProperties(o,e));for(v in b)g[v]=b[v];n&&n.dispatchEvent(g),m[t]&&m[t].call(e,g)}}function U(t,e){var n=(o=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{}).evt,o=i(o,q);z.pluginEvent.bind(jt)(t,e,I({dragEl:Z,parentEl:$,ghostEl:Q,rootEl:J,nextEl:tt,lastDownEl:et,cloneEl:nt,cloneHidden:ot,dragStarted:mt,putSortable:ct,activeSortable:jt.active,originalEvent:n,oldIndex:it,oldDraggableIndex:at,newIndex:rt,newDraggableIndex:lt,hideGhostForTarget:Xt,unhideGhostForTarget:Yt,cloneNowHidden:function(){ot=!0},cloneNowShown:function(){ot=!1},dispatchSortableEvent:function(t){V({sortable:e,name:t,originalEvent:n})}},o))}var q=["evt"];function V(t){G(I({putSortable:ct,cloneEl:nt,targetEl:Z,rootEl:J,oldIndex:it,oldDraggableIndex:at,newIndex:rt,newDraggableIndex:lt},t))}var Z,$,Q,J,tt,et,nt,ot,it,rt,at,lt,st,ct,ut,dt,ht,pt,ft,gt,mt,vt,bt,yt,wt,Dt=!1,Et=!1,St=[],_t=!1,Ct=!1,Tt=[],xt=!1,Ot=[],Mt="undefined"!=typeof document,At=c,Nt=w||y?"cssFloat":"float",It=Mt&&!n&&!c&&"draggable"in document.createElement("div"),Pt=function(){if(Mt){if(y)return!1;var t=document.createElement("x");return t.style.cssText="pointer-events:auto","auto"===t.style.pointerEvents}}(),kt=function(t,e){var n=R(t),o=parseInt(n.width)-parseInt(n.paddingLeft)-parseInt(n.paddingRight)-parseInt(n.borderLeftWidth)-parseInt(n.borderRightWidth),i=B(t,0,e),r=B(t,1,e),a=i&&R(i),l=r&&R(r),s=a&&parseInt(a.marginLeft)+parseInt(a.marginRight)+X(i).width,t=l&&parseInt(l.marginLeft)+parseInt(l.marginRight)+X(r).width;if("flex"===n.display)return"column"===n.flexDirection||"column-reverse"===n.flexDirection?"vertical":"horizontal";if("grid"===n.display)return n.gridTemplateColumns.split(" ").length<=1?"vertical":"horizontal";if(i&&a.float&&"none"!==a.float){e="left"===a.float?"left":"right";return!r||"both"!==l.clear&&l.clear!==e?"horizontal":"vertical"}return i&&("block"===a.display||"flex"===a.display||"table"===a.display||"grid"===a.display||o<=s&&"none"===n[Nt]||r&&"none"===n[Nt]&&o<s+t)?"vertical":"horizontal"},Rt=function(t){function l(r,a){return function(t,e,n,o){var i=t.options.group.name&&e.options.group.name&&t.options.group.name===e.options.group.name;if(null==r&&(a||i))return!0;if(null==r||!1===r)return!1;if(a&&"clone"===r)return r;if("function"==typeof r)return l(r(t,e,n,o),a)(t,e,n,o);e=(a?t:e).options.group.name;return!0===r||"string"==typeof r&&r===e||r.join&&-1<r.indexOf(e)}}var e={},n=t.group;n&&"object"==o(n)||(n={name:n}),e.name=n.name,e.checkPull=l(n.pull,!0),e.checkPut=l(n.put),e.revertClone=n.revertClone,t.group=e},Xt=function(){!Pt&&Q&&R(Q,"display","none")},Yt=function(){!Pt&&Q&&R(Q,"display","")};Mt&&!n&&document.addEventListener("click",function(t){if(Et)return t.preventDefault(),t.stopPropagation&&t.stopPropagation(),t.stopImmediatePropagation&&t.stopImmediatePropagation(),Et=!1},!0);function Bt(t){if(Z){t=t.touches?t.touches[0]:t;var e=(i=t.clientX,r=t.clientY,St.some(function(t){var e=t[K].options.emptyInsertThreshold;if(e&&!F(t)){var n=X(t),o=i>=n.left-e&&i<=n.right+e,e=r>=n.top-e&&r<=n.bottom+e;return o&&e?a=t:void 0}}),a);if(e){var n,o={};for(n in t)t.hasOwnProperty(n)&&(o[n]=t[n]);o.target=o.rootEl=e,o.preventDefault=void 0,o.stopPropagation=void 0,e[K]._onDragOver(o)}}var i,r,a}function Ft(t){Z&&Z.parentNode[K]._isOutsideThisEl(t.target)}function jt(t,e){if(!t||!t.nodeType||1!==t.nodeType)throw"Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(t));this.el=t,this.options=e=a({},e),t[K]=this;var n,o,i={group:null,sort:!0,disabled:!1,store:null,handle:null,draggable:/^[uo]l$/i.test(t.nodeName)?">li":">*",swapThreshold:1,invertSwap:!1,invertedSwapThreshold:null,removeCloneOnHide:!0,direction:function(){return kt(t,this.options)},ghostClass:"sortable-ghost",chosenClass:"sortable-chosen",dragClass:"sortable-drag",ignore:"a, img",filter:null,preventOnFilter:!0,animation:0,easing:null,setData:function(t,e){t.setData("Text",e.textContent)},dropBubble:!1,dragoverBubble:!1,dataIdAttr:"data-id",delay:0,delayOnTouchOnly:!1,touchStartThreshold:(Number.parseInt?Number:window).parseInt(window.devicePixelRatio,10)||1,forceFallback:!1,fallbackClass:"sortable-fallback",fallbackOnBody:!1,fallbackTolerance:0,fallbackOffset:{x:0,y:0},supportPointer:!1!==jt.supportPointer&&"PointerEvent"in window&&(!u||c),emptyInsertThreshold:5};for(n in z.initializePlugins(this,t,i),i)n in e||(e[n]=i[n]);for(o in Rt(e),this)"_"===o.charAt(0)&&"function"==typeof this[o]&&(this[o]=this[o].bind(this));this.nativeDraggable=!e.forceFallback&&It,this.nativeDraggable&&(this.options.touchStartThreshold=1),e.supportPointer?h(t,"pointerdown",this._onTapStart):(h(t,"mousedown",this._onTapStart),h(t,"touchstart",this._onTapStart)),this.nativeDraggable&&(h(t,"dragover",this),h(t,"dragenter",this)),St.push(this.el),e.store&&e.store.get&&this.sort(e.store.get(this)||[]),a(this,A())}function Ht(t,e,n,o,i,r,a,l){var s,c,u=t[K],d=u.options.onMove;return!window.CustomEvent||y||w?(s=document.createEvent("Event")).initEvent("move",!0,!0):s=new CustomEvent("move",{bubbles:!0,cancelable:!0}),s.to=e,s.from=t,s.dragged=n,s.draggedRect=o,s.related=i||e,s.relatedRect=r||X(e),s.willInsertAfter=l,s.originalEvent=a,t.dispatchEvent(s),c=d?d.call(u,s,a):c}function Lt(t){t.draggable=!1}function Kt(){xt=!1}function Wt(t){return setTimeout(t,0)}function zt(t){return clearTimeout(t)}jt.prototype={constructor:jt,_isOutsideThisEl:function(t){this.el.contains(t)||t===this.el||(vt=null)},_getDirection:function(t,e){return"function"==typeof this.options.direction?this.options.direction.call(this,t,e,Z):this.options.direction},_onTapStart:function(e){if(e.cancelable){var n=this,o=this.el,t=this.options,i=t.preventOnFilter,r=e.type,a=e.touches&&e.touches[0]||e.pointerType&&"touch"===e.pointerType&&e,l=(a||e).target,s=e.target.shadowRoot&&(e.path&&e.path[0]||e.composedPath&&e.composedPath()[0])||l,c=t.filter;if(!function(t){Ot.length=0;var e=t.getElementsByTagName("input"),n=e.length;for(;n--;){var o=e[n];o.checked&&Ot.push(o)}}(o),!Z&&!(/mousedown|pointerdown/.test(r)&&0!==e.button||t.disabled)&&!s.isContentEditable&&(this.nativeDraggable||!u||!l||"SELECT"!==l.tagName.toUpperCase())&&!((l=P(l,t.draggable,o,!1))&&l.animated||et===l)){if(it=j(l),at=j(l,t.draggable),"function"==typeof c){if(c.call(this,e,l,this))return V({sortable:n,rootEl:s,name:"filter",targetEl:l,toEl:o,fromEl:o}),U("filter",n,{evt:e}),void(i&&e.preventDefault())}else if(c=c&&c.split(",").some(function(t){if(t=P(s,t.trim(),o,!1))return V({sortable:n,rootEl:t,name:"filter",targetEl:l,fromEl:o,toEl:o}),U("filter",n,{evt:e}),!0}))return void(i&&e.preventDefault());t.handle&&!P(s,t.handle,o,!1)||this._prepareDragStart(e,a,l)}}},_prepareDragStart:function(t,e,n){var o,i=this,r=i.el,a=i.options,l=r.ownerDocument;n&&!Z&&n.parentNode===r&&(o=X(n),J=r,$=(Z=n).parentNode,tt=Z.nextSibling,et=n,st=a.group,ut={target:jt.dragged=Z,clientX:(e||t).clientX,clientY:(e||t).clientY},ft=ut.clientX-o.left,gt=ut.clientY-o.top,this._lastX=(e||t).clientX,this._lastY=(e||t).clientY,Z.style["will-change"]="all",o=function(){U("delayEnded",i,{evt:t}),jt.eventCanceled?i._onDrop():(i._disableDelayedDragEvents(),!s&&i.nativeDraggable&&(Z.draggable=!0),i._triggerDragStart(t,e),V({sortable:i,name:"choose",originalEvent:t}),k(Z,a.chosenClass,!0))},a.ignore.split(",").forEach(function(t){D(Z,t.trim(),Lt)}),h(l,"dragover",Bt),h(l,"mousemove",Bt),h(l,"touchmove",Bt),a.supportPointer?(h(l,"pointerup",i._onDrop),this.nativeDraggable||h(l,"pointercancel",i._onDrop)):(h(l,"mouseup",i._onDrop),h(l,"touchend",i._onDrop),h(l,"touchcancel",i._onDrop)),s&&this.nativeDraggable&&(this.options.touchStartThreshold=4,Z.draggable=!0),U("delayStart",this,{evt:t}),!a.delay||a.delayOnTouchOnly&&!e||this.nativeDraggable&&(w||y)?o():jt.eventCanceled?this._onDrop():(a.supportPointer?(h(l,"pointerup",i._disableDelayedDrag),h(l,"pointercancel",i._disableDelayedDrag)):(h(l,"mouseup",i._disableDelayedDrag),h(l,"touchend",i._disableDelayedDrag),h(l,"touchcancel",i._disableDelayedDrag)),h(l,"mousemove",i._delayedDragTouchMoveHandler),h(l,"touchmove",i._delayedDragTouchMoveHandler),a.supportPointer&&h(l,"pointermove",i._delayedDragTouchMoveHandler),i._dragStartTimer=setTimeout(o,a.delay)))},_delayedDragTouchMoveHandler:function(t){t=t.touches?t.touches[0]:t;Math.max(Math.abs(t.clientX-this._lastX),Math.abs(t.clientY-this._lastY))>=Math.floor(this.options.touchStartThreshold/(this.nativeDraggable&&window.devicePixelRatio||1))&&this._disableDelayedDrag()},_disableDelayedDrag:function(){Z&&Lt(Z),clearTimeout(this._dragStartTimer),this._disableDelayedDragEvents()},_disableDelayedDragEvents:function(){var t=this.el.ownerDocument;p(t,"mouseup",this._disableDelayedDrag),p(t,"touchend",this._disableDelayedDrag),p(t,"touchcancel",this._disableDelayedDrag),p(t,"pointerup",this._disableDelayedDrag),p(t,"pointercancel",this._disableDelayedDrag),p(t,"mousemove",this._delayedDragTouchMoveHandler),p(t,"touchmove",this._delayedDragTouchMoveHandler),p(t,"pointermove",this._delayedDragTouchMoveHandler)},_triggerDragStart:function(t,e){e=e||"touch"==t.pointerType&&t,!this.nativeDraggable||e?this.options.supportPointer?h(document,"pointermove",this._onTouchMove):h(document,e?"touchmove":"mousemove",this._onTouchMove):(h(Z,"dragend",this),h(J,"dragstart",this._onDragStart));try{document.selection?Wt(function(){document.selection.empty()}):window.getSelection().removeAllRanges()}catch(t){}},_dragStarted:function(t,e){var n;Dt=!1,J&&Z?(U("dragStarted",this,{evt:e}),this.nativeDraggable&&h(document,"dragover",Ft),n=this.options,t||k(Z,n.dragClass,!1),k(Z,n.ghostClass,!0),jt.active=this,t&&this._appendGhost(),V({sortable:this,name:"start",originalEvent:e})):this._nulling()},_emulateDragOver:function(){if(dt){this._lastX=dt.clientX,this._lastY=dt.clientY,Xt();for(var t=document.elementFromPoint(dt.clientX,dt.clientY),e=t;t&&t.shadowRoot&&(t=t.shadowRoot.elementFromPoint(dt.clientX,dt.clientY))!==e;)e=t;if(Z.parentNode[K]._isOutsideThisEl(t),e)do{if(e[K])if(e[K]._onDragOver({clientX:dt.clientX,clientY:dt.clientY,target:t,rootEl:e})&&!this.options.dragoverBubble)break}while(e=g(t=e));Yt()}},_onTouchMove:function(t){if(ut){var e=this.options,n=e.fallbackTolerance,o=e.fallbackOffset,i=t.touches?t.touches[0]:t,r=Q&&b(Q,!0),a=Q&&r&&r.a,l=Q&&r&&r.d,e=At&&wt&&E(wt),a=(i.clientX-ut.clientX+o.x)/(a||1)+(e?e[0]-Tt[0]:0)/(a||1),l=(i.clientY-ut.clientY+o.y)/(l||1)+(e?e[1]-Tt[1]:0)/(l||1);if(!jt.active&&!Dt){if(n&&Math.max(Math.abs(i.clientX-this._lastX),Math.abs(i.clientY-this._lastY))<n)return;this._onDragStart(t,!0)}Q&&(r?(r.e+=a-(ht||0),r.f+=l-(pt||0)):r={a:1,b:0,c:0,d:1,e:a,f:l},r="matrix(".concat(r.a,",").concat(r.b,",").concat(r.c,",").concat(r.d,",").concat(r.e,",").concat(r.f,")"),R(Q,"webkitTransform",r),R(Q,"mozTransform",r),R(Q,"msTransform",r),R(Q,"transform",r),ht=a,pt=l,dt=i),t.cancelable&&t.preventDefault()}},_appendGhost:function(){if(!Q){var t=this.options.fallbackOnBody?document.body:J,e=X(Z,!0,At,!0,t),n=this.options;if(At){for(wt=t;"static"===R(wt,"position")&&"none"===R(wt,"transform")&&wt!==document;)wt=wt.parentNode;wt!==document.body&&wt!==document.documentElement?(wt===document&&(wt=O()),e.top+=wt.scrollTop,e.left+=wt.scrollLeft):wt=O(),Tt=E(wt)}k(Q=Z.cloneNode(!0),n.ghostClass,!1),k(Q,n.fallbackClass,!0),k(Q,n.dragClass,!0),R(Q,"transition",""),R(Q,"transform",""),R(Q,"box-sizing","border-box"),R(Q,"margin",0),R(Q,"top",e.top),R(Q,"left",e.left),R(Q,"width",e.width),R(Q,"height",e.height),R(Q,"opacity","0.8"),R(Q,"position",At?"absolute":"fixed"),R(Q,"zIndex","100000"),R(Q,"pointerEvents","none"),jt.ghost=Q,t.appendChild(Q),R(Q,"transform-origin",ft/parseInt(Q.style.width)*100+"% "+gt/parseInt(Q.style.height)*100+"%")}},_onDragStart:function(t,e){var n=this,o=t.dataTransfer,i=n.options;U("dragStart",this,{evt:t}),jt.eventCanceled?this._onDrop():(U("setupClone",this),jt.eventCanceled||((nt=C(Z)).removeAttribute("id"),nt.draggable=!1,nt.style["will-change"]="",this._hideClone(),k(nt,this.options.chosenClass,!1),jt.clone=nt),n.cloneId=Wt(function(){U("clone",n),jt.eventCanceled||(n.options.removeCloneOnHide||J.insertBefore(nt,Z),n._hideClone(),V({sortable:n,name:"clone"}))}),e||k(Z,i.dragClass,!0),e?(Et=!0,n._loopId=setInterval(n._emulateDragOver,50)):(p(document,"mouseup",n._onDrop),p(document,"touchend",n._onDrop),p(document,"touchcancel",n._onDrop),o&&(o.effectAllowed="move",i.setData&&i.setData.call(n,o,Z)),h(document,"drop",n),R(Z,"transform","translateZ(0)")),Dt=!0,n._dragStartId=Wt(n._dragStarted.bind(n,e,t)),h(document,"selectstart",n),mt=!0,window.getSelection().removeAllRanges(),u&&R(document.body,"user-select","none"))},_onDragOver:function(n){var o,i,r,t,e,a=this.el,l=n.target,s=this.options,c=s.group,u=jt.active,d=st===c,h=s.sort,p=ct||u,f=this,g=!1;if(!xt){if(void 0!==n.preventDefault&&n.cancelable&&n.preventDefault(),l=P(l,s.draggable,a,!0),O("dragOver"),jt.eventCanceled)return g;if(Z.contains(n.target)||l.animated&&l.animatingX&&l.animatingY||f._ignoreWhileAnimating===l)return A(!1);if(Et=!1,u&&!s.disabled&&(d?h||(i=$!==J):ct===this||(this.lastPutMode=st.checkPull(this,u,Z,n))&&c.checkPut(this,u,Z,n))){if(r="vertical"===this._getDirection(n,l),o=X(Z),O("dragOverValid"),jt.eventCanceled)return g;if(i)return $=J,M(),this._hideClone(),O("revert"),jt.eventCanceled||(tt?J.insertBefore(Z,tt):J.appendChild(Z)),A(!0);var m=F(a,s.draggable);if(m&&(S=n,c=r,x=X(F((E=this).el,E.options.draggable)),E=L(E.el,E.options,Q),!(c?S.clientX>E.right+10||S.clientY>x.bottom&&S.clientX>x.left:S.clientY>E.bottom+10||S.clientX>x.right&&S.clientY>x.top)||m.animated)){if(m&&(t=n,e=r,C=X(B((_=this).el,0,_.options,!0)),_=L(_.el,_.options,Q),e?t.clientX<_.left-10||t.clientY<C.top&&t.clientX<C.right:t.clientY<_.top-10||t.clientY<C.bottom&&t.clientX<C.left)){var v=B(a,0,s,!0);if(v===Z)return A(!1);if(D=X(l=v),!1!==Ht(J,a,Z,o,l,D,n,!1))return M(),a.insertBefore(Z,v),$=a,N(),A(!0)}else if(l.parentNode===a){var b,y,w,D=X(l),E=Z.parentNode!==a,S=(S=Z.animated&&Z.toRect||o,x=l.animated&&l.toRect||D,_=(e=r)?S.left:S.top,t=e?S.right:S.bottom,C=e?S.width:S.height,v=e?x.left:x.top,S=e?x.right:x.bottom,x=e?x.width:x.height,!(_===v||t===S||_+C/2===v+x/2)),_=r?"top":"left",C=Y(l,"top","top")||Y(Z,"top","top"),v=C?C.scrollTop:void 0;if(vt!==l&&(y=D[_],_t=!1,Ct=!S&&s.invertSwap||E),0!==(b=function(t,e,n,o,i,r,a,l){var s=o?t.clientY:t.clientX,c=o?n.height:n.width,t=o?n.top:n.left,o=o?n.bottom:n.right,n=!1;if(!a)if(l&&yt<c*i){if(_t=!_t&&(1===bt?t+c*r/2<s:s<o-c*r/2)?!0:_t)n=!0;else if(1===bt?s<t+yt:o-yt<s)return-bt}else if(t+c*(1-i)/2<s&&s<o-c*(1-i)/2)return function(t){return j(Z)<j(t)?1:-1}(e);if((n=n||a)&&(s<t+c*r/2||o-c*r/2<s))return t+c/2<s?1:-1;return 0}(n,l,D,r,S?1:s.swapThreshold,null==s.invertedSwapThreshold?s.swapThreshold:s.invertedSwapThreshold,Ct,vt===l)))for(var T=j(Z);(w=$.children[T-=b])&&("none"===R(w,"display")||w===Q););if(0===b||w===l)return A(!1);bt=b;var x=(vt=l).nextElementSibling,E=!1,S=Ht(J,a,Z,o,l,D,n,E=1===b);if(!1!==S)return 1!==S&&-1!==S||(E=1===S),xt=!0,setTimeout(Kt,30),M(),E&&!x?a.appendChild(Z):l.parentNode.insertBefore(Z,E?x:l),C&&H(C,0,v-C.scrollTop),$=Z.parentNode,void 0===y||Ct||(yt=Math.abs(y-X(l)[_])),N(),A(!0)}}else{if(m===Z)return A(!1);if((l=m&&a===n.target?m:l)&&(D=X(l)),!1!==Ht(J,a,Z,o,l,D,n,!!l))return M(),m&&m.nextSibling?a.insertBefore(Z,m.nextSibling):a.appendChild(Z),$=a,N(),A(!0)}if(a.contains(Z))return A(!1)}return!1}function O(t,e){U(t,f,I({evt:n,isOwner:d,axis:r?"vertical":"horizontal",revert:i,dragRect:o,targetRect:D,canSort:h,fromSortable:p,target:l,completed:A,onMove:function(t,e){return Ht(J,a,Z,o,t,X(t),n,e)},changed:N},e))}function M(){O("dragOverAnimationCapture"),f.captureAnimationState(),f!==p&&p.captureAnimationState()}function A(t){return O("dragOverCompleted",{insertion:t}),t&&(d?u._hideClone():u._showClone(f),f!==p&&(k(Z,(ct||u).options.ghostClass,!1),k(Z,s.ghostClass,!0)),ct!==f&&f!==jt.active?ct=f:f===jt.active&&ct&&(ct=null),p===f&&(f._ignoreWhileAnimating=l),f.animateAll(function(){O("dragOverAnimationComplete"),f._ignoreWhileAnimating=null}),f!==p&&(p.animateAll(),p._ignoreWhileAnimating=null)),(l===Z&&!Z.animated||l===a&&!l.animated)&&(vt=null),s.dragoverBubble||n.rootEl||l===document||(Z.parentNode[K]._isOutsideThisEl(n.target),t||Bt(n)),!s.dragoverBubble&&n.stopPropagation&&n.stopPropagation(),g=!0}function N(){rt=j(Z),lt=j(Z,s.draggable),V({sortable:f,name:"change",toEl:a,newIndex:rt,newDraggableIndex:lt,originalEvent:n})}},_ignoreWhileAnimating:null,_offMoveEvents:function(){p(document,"mousemove",this._onTouchMove),p(document,"touchmove",this._onTouchMove),p(document,"pointermove",this._onTouchMove),p(document,"dragover",Bt),p(document,"mousemove",Bt),p(document,"touchmove",Bt)},_offUpEvents:function(){var t=this.el.ownerDocument;p(t,"mouseup",this._onDrop),p(t,"touchend",this._onDrop),p(t,"pointerup",this._onDrop),p(t,"pointercancel",this._onDrop),p(t,"touchcancel",this._onDrop),p(document,"selectstart",this)},_onDrop:function(t){var e=this.el,n=this.options;rt=j(Z),lt=j(Z,n.draggable),U("drop",this,{evt:t}),$=Z&&Z.parentNode,rt=j(Z),lt=j(Z,n.draggable),jt.eventCanceled||(_t=Ct=Dt=!1,clearInterval(this._loopId),clearTimeout(this._dragStartTimer),zt(this.cloneId),zt(this._dragStartId),this.nativeDraggable&&(p(document,"drop",this),p(e,"dragstart",this._onDragStart)),this._offMoveEvents(),this._offUpEvents(),u&&R(document.body,"user-select",""),R(Z,"transform",""),t&&(mt&&(t.cancelable&&t.preventDefault(),n.dropBubble||t.stopPropagation()),Q&&Q.parentNode&&Q.parentNode.removeChild(Q),(J===$||ct&&"clone"!==ct.lastPutMode)&&nt&&nt.parentNode&&nt.parentNode.removeChild(nt),Z&&(this.nativeDraggable&&p(Z,"dragend",this),Lt(Z),Z.style["will-change"]="",mt&&!Dt&&k(Z,(ct||this).options.ghostClass,!1),k(Z,this.options.chosenClass,!1),V({sortable:this,name:"unchoose",toEl:$,newIndex:null,newDraggableIndex:null,originalEvent:t}),J!==$?(0<=rt&&(V({rootEl:$,name:"add",toEl:$,fromEl:J,originalEvent:t}),V({sortable:this,name:"remove",toEl:$,originalEvent:t}),V({rootEl:$,name:"sort",toEl:$,fromEl:J,originalEvent:t}),V({sortable:this,name:"sort",toEl:$,originalEvent:t})),ct&&ct.save()):rt!==it&&0<=rt&&(V({sortable:this,name:"update",toEl:$,originalEvent:t}),V({sortable:this,name:"sort",toEl:$,originalEvent:t})),jt.active&&(null!=rt&&-1!==rt||(rt=it,lt=at),V({sortable:this,name:"end",toEl:$,originalEvent:t}),this.save())))),this._nulling()},_nulling:function(){U("nulling",this),J=Z=$=Q=tt=nt=et=ot=ut=dt=mt=rt=lt=it=at=vt=bt=ct=st=jt.dragged=jt.ghost=jt.clone=jt.active=null,Ot.forEach(function(t){t.checked=!0}),Ot.length=ht=pt=0},handleEvent:function(t){switch(t.type){case"drop":case"dragend":this._onDrop(t);break;case"dragenter":case"dragover":Z&&(this._onDragOver(t),function(t){t.dataTransfer&&(t.dataTransfer.dropEffect="move");t.cancelable&&t.preventDefault()}(t));break;case"selectstart":t.preventDefault()}},toArray:function(){for(var t,e=[],n=this.el.children,o=0,i=n.length,r=this.options;o<i;o++)P(t=n[o],r.draggable,this.el,!1)&&e.push(t.getAttribute(r.dataIdAttr)||function(t){var e=t.tagName+t.className+t.src+t.href+t.textContent,n=e.length,o=0;for(;n--;)o+=e.charCodeAt(n);return o.toString(36)}(t));return e},sort:function(t,e){var n={},o=this.el;this.toArray().forEach(function(t,e){e=o.children[e];P(e,this.options.draggable,o,!1)&&(n[t]=e)},this),e&&this.captureAnimationState(),t.forEach(function(t){n[t]&&(o.removeChild(n[t]),o.appendChild(n[t]))}),e&&this.animateAll()},save:function(){var t=this.options.store;t&&t.set&&t.set(this)},closest:function(t,e){return P(t,e||this.options.draggable,this.el,!1)},option:function(t,e){var n=this.options;if(void 0===e)return n[t];var o=z.modifyOption(this,t,e);n[t]=void 0!==o?o:e,"group"===t&&Rt(n)},destroy:function(){U("destroy",this);var t=this.el;t[K]=null,p(t,"mousedown",this._onTapStart),p(t,"touchstart",this._onTapStart),p(t,"pointerdown",this._onTapStart),this.nativeDraggable&&(p(t,"dragover",this),p(t,"dragenter",this)),Array.prototype.forEach.call(t.querySelectorAll("[draggable]"),function(t){t.removeAttribute("draggable")}),this._onDrop(),this._disableDelayedDragEvents(),St.splice(St.indexOf(this.el),1),this.el=t=null},_hideClone:function(){ot||(U("hideClone",this),jt.eventCanceled||(R(nt,"display","none"),this.options.removeCloneOnHide&&nt.parentNode&&nt.parentNode.removeChild(nt),ot=!0))},_showClone:function(t){"clone"===t.lastPutMode?ot&&(U("showClone",this),jt.eventCanceled||(Z.parentNode!=J||this.options.group.revertClone?tt?J.insertBefore(nt,tt):J.appendChild(nt):J.insertBefore(nt,Z),this.options.group.revertClone&&this.animate(Z,nt),R(nt,"display",""),ot=!1)):this._hideClone()}},Mt&&h(document,"touchmove",function(t){(jt.active||Dt)&&t.cancelable&&t.preventDefault()}),jt.utils={on:h,off:p,css:R,find:D,is:function(t,e){return!!P(t,e,t,!1)},extend:function(t,e){if(t&&e)for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n]);return t},throttle:_,closest:P,toggleClass:k,clone:C,index:j,nextTick:Wt,cancelNextTick:zt,detectDirection:kt,getChild:B,expando:K},jt.get=function(t){return t[K]},jt.mount=function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];(e=e[0].constructor===Array?e[0]:e).forEach(function(t){if(!t.prototype||!t.prototype.constructor)throw"Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(t));t.utils&&(jt.utils=I(I({},jt.utils),t.utils)),z.mount(t)})},jt.create=function(t,e){return new jt(t,e)};var Gt,Ut,qt,Vt,Zt,$t,Qt=[],Jt=!(jt.version="1.15.6");function te(){Qt.forEach(function(t){clearInterval(t.pid)}),Qt=[]}function ee(){clearInterval($t)}var ne,oe=_(function(n,t,e,o){if(t.scroll){var i,r=(n.touches?n.touches[0]:n).clientX,a=(n.touches?n.touches[0]:n).clientY,l=t.scrollSensitivity,s=t.scrollSpeed,c=O(),u=!1;Ut!==e&&(Ut=e,te(),Gt=t.scroll,i=t.scrollFn,!0===Gt&&(Gt=M(e,!0)));var d=0,h=Gt;do{var p=h,f=X(p),g=f.top,m=f.bottom,v=f.left,b=f.right,y=f.width,w=f.height,D=void 0,E=void 0,S=p.scrollWidth,_=p.scrollHeight,C=R(p),T=p.scrollLeft,f=p.scrollTop,E=p===c?(D=y<S&&("auto"===C.overflowX||"scroll"===C.overflowX||"visible"===C.overflowX),w<_&&("auto"===C.overflowY||"scroll"===C.overflowY||"visible"===C.overflowY)):(D=y<S&&("auto"===C.overflowX||"scroll"===C.overflowX),w<_&&("auto"===C.overflowY||"scroll"===C.overflowY)),T=D&&(Math.abs(b-r)<=l&&T+y<S)-(Math.abs(v-r)<=l&&!!T),f=E&&(Math.abs(m-a)<=l&&f+w<_)-(Math.abs(g-a)<=l&&!!f);if(!Qt[d])for(var x=0;x<=d;x++)Qt[x]||(Qt[x]={});Qt[d].vx==T&&Qt[d].vy==f&&Qt[d].el===p||(Qt[d].el=p,Qt[d].vx=T,Qt[d].vy=f,clearInterval(Qt[d].pid),0==T&&0==f||(u=!0,Qt[d].pid=setInterval(function(){o&&0===this.layer&&jt.active._onTouchMove(Zt);var t=Qt[this.layer].vy?Qt[this.layer].vy*s:0,e=Qt[this.layer].vx?Qt[this.layer].vx*s:0;"function"==typeof i&&"continue"!==i.call(jt.dragged.parentNode[K],e,t,n,Zt,Qt[this.layer].el)||H(Qt[this.layer].el,e,t)}.bind({layer:d}),24))),d++}while(t.bubbleScroll&&h!==c&&(h=M(h,!1)));Jt=u}},30),n=function(t){var e=t.originalEvent,n=t.putSortable,o=t.dragEl,i=t.activeSortable,r=t.dispatchSortableEvent,a=t.hideGhostForTarget,t=t.unhideGhostForTarget;e&&(i=n||i,a(),e=e.changedTouches&&e.changedTouches.length?e.changedTouches[0]:e,e=document.elementFromPoint(e.clientX,e.clientY),t(),i&&!i.el.contains(e)&&(r("spill"),this.onSpill({dragEl:o,putSortable:n})))};function ie(){}function re(){}ie.prototype={startIndex:null,dragStart:function(t){t=t.oldDraggableIndex;this.startIndex=t},onSpill:function(t){var e=t.dragEl,n=t.putSortable;this.sortable.captureAnimationState(),n&&n.captureAnimationState();t=B(this.sortable.el,this.startIndex,this.options);t?this.sortable.el.insertBefore(e,t):this.sortable.el.appendChild(e),this.sortable.animateAll(),n&&n.animateAll()},drop:n},a(ie,{pluginName:"revertOnSpill"}),re.prototype={onSpill:function(t){var e=t.dragEl,t=t.putSortable||this.sortable;t.captureAnimationState(),e.parentNode&&e.parentNode.removeChild(e),t.animateAll()},drop:n},a(re,{pluginName:"removeOnSpill"});var ae,le,se,ce,ue,de=[],he=[],pe=!1,fe=!1,ge=!1;function me(n,o){he.forEach(function(t,e){e=o.children[t.sortableIndex+(n?Number(e):0)];e?o.insertBefore(t,e):o.appendChild(t)})}function ve(){de.forEach(function(t){t!==se&&t.parentNode&&t.parentNode.removeChild(t)})}return jt.mount(new function(){function t(){for(var t in this.defaults={scroll:!0,forceAutoScrollFallback:!1,scrollSensitivity:30,scrollSpeed:10,bubbleScroll:!0},this)"_"===t.charAt(0)&&"function"==typeof this[t]&&(this[t]=this[t].bind(this))}return t.prototype={dragStarted:function(t){t=t.originalEvent;this.sortable.nativeDraggable?h(document,"dragover",this._handleAutoScroll):this.options.supportPointer?h(document,"pointermove",this._handleFallbackAutoScroll):t.touches?h(document,"touchmove",this._handleFallbackAutoScroll):h(document,"mousemove",this._handleFallbackAutoScroll)},dragOverCompleted:function(t){t=t.originalEvent;this.options.dragOverBubble||t.rootEl||this._handleAutoScroll(t)},drop:function(){this.sortable.nativeDraggable?p(document,"dragover",this._handleAutoScroll):(p(document,"pointermove",this._handleFallbackAutoScroll),p(document,"touchmove",this._handleFallbackAutoScroll),p(document,"mousemove",this._handleFallbackAutoScroll)),ee(),te(),clearTimeout(m),m=void 0},nulling:function(){Zt=Ut=Gt=Jt=$t=qt=Vt=null,Qt.length=0},_handleFallbackAutoScroll:function(t){this._handleAutoScroll(t,!0)},_handleAutoScroll:function(e,n){var o,i=this,r=(e.touches?e.touches[0]:e).clientX,a=(e.touches?e.touches[0]:e).clientY,t=document.elementFromPoint(r,a);Zt=e,n||this.options.forceAutoScrollFallback||w||y||u?(oe(e,this.options,t,n),o=M(t,!0),!Jt||$t&&r===qt&&a===Vt||($t&&ee(),$t=setInterval(function(){var t=M(document.elementFromPoint(r,a),!0);t!==o&&(o=t,te()),oe(e,i.options,t,n)},10),qt=r,Vt=a)):this.options.bubbleScroll&&M(t,!0)!==O()?oe(e,this.options,M(t,!1),!1):te()}},a(t,{pluginName:"scroll",initializeByDefault:!0})}),jt.mount(re,ie),jt.mount(new function(){function t(){this.defaults={swapClass:"sortable-swap-highlight"}}return t.prototype={dragStart:function(t){t=t.dragEl;ne=t},dragOverValid:function(t){var e=t.completed,n=t.target,o=t.onMove,i=t.activeSortable,r=t.changed,a=t.cancel;i.options.swap&&(t=this.sortable.el,i=this.options,n&&n!==t&&(t=ne,ne=!1!==o(n)?(k(n,i.swapClass,!0),n):null,t&&t!==ne&&k(t,i.swapClass,!1)),r(),e(!0),a())},drop:function(t){var e,n,o=t.activeSortable,i=t.putSortable,r=t.dragEl,a=i||this.sortable,l=this.options;ne&&k(ne,l.swapClass,!1),ne&&(l.swap||i&&i.options.swap)&&r!==ne&&(a.captureAnimationState(),a!==o&&o.captureAnimationState(),n=ne,t=(e=r).parentNode,l=n.parentNode,t&&l&&!t.isEqualNode(n)&&!l.isEqualNode(e)&&(i=j(e),r=j(n),t.isEqualNode(l)&&i<r&&r++,t.insertBefore(n,t.children[i]),l.insertBefore(e,l.children[r])),a.animateAll(),a!==o&&o.animateAll())},nulling:function(){ne=null}},a(t,{pluginName:"swap",eventProperties:function(){return{swapItem:ne}}})}),jt.mount(new function(){function t(o){for(var t in this)"_"===t.charAt(0)&&"function"==typeof this[t]&&(this[t]=this[t].bind(this));o.options.avoidImplicitDeselect||(o.options.supportPointer?h(document,"pointerup",this._deselectMultiDrag):(h(document,"mouseup",this._deselectMultiDrag),h(document,"touchend",this._deselectMultiDrag))),h(document,"keydown",this._checkKeyDown),h(document,"keyup",this._checkKeyUp),this.defaults={selectedClass:"sortable-selected",multiDragKey:null,avoidImplicitDeselect:!1,setData:function(t,e){var n="";de.length&&le===o?de.forEach(function(t,e){n+=(e?", ":"")+t.textContent}):n=e.textContent,t.setData("Text",n)}}}return t.prototype={multiDragKeyDown:!1,isMultiDrag:!1,delayStartGlobal:function(t){t=t.dragEl;se=t},delayEnded:function(){this.isMultiDrag=~de.indexOf(se)},setupClone:function(t){var e=t.sortable,t=t.cancel;if(this.isMultiDrag){for(var n=0;n<de.length;n++)he.push(C(de[n])),he[n].sortableIndex=de[n].sortableIndex,he[n].draggable=!1,he[n].style["will-change"]="",k(he[n],this.options.selectedClass,!1),de[n]===se&&k(he[n],this.options.chosenClass,!1);e._hideClone(),t()}},clone:function(t){var e=t.sortable,n=t.rootEl,o=t.dispatchSortableEvent,t=t.cancel;this.isMultiDrag&&(this.options.removeCloneOnHide||de.length&&le===e&&(me(!0,n),o("clone"),t()))},showClone:function(t){var e=t.cloneNowShown,n=t.rootEl,t=t.cancel;this.isMultiDrag&&(me(!1,n),he.forEach(function(t){R(t,"display","")}),e(),ue=!1,t())},hideClone:function(t){var e=this,n=(t.sortable,t.cloneNowHidden),t=t.cancel;this.isMultiDrag&&(he.forEach(function(t){R(t,"display","none"),e.options.removeCloneOnHide&&t.parentNode&&t.parentNode.removeChild(t)}),n(),ue=!0,t())},dragStartGlobal:function(t){t.sortable;!this.isMultiDrag&&le&&le.multiDrag._deselectMultiDrag(),de.forEach(function(t){t.sortableIndex=j(t)}),de=de.sort(function(t,e){return t.sortableIndex-e.sortableIndex}),ge=!0},dragStarted:function(t){var e,n=this,t=t.sortable;this.isMultiDrag&&(this.options.sort&&(t.captureAnimationState(),this.options.animation&&(de.forEach(function(t){t!==se&&R(t,"position","absolute")}),e=X(se,!1,!0,!0),de.forEach(function(t){t!==se&&T(t,e)}),pe=fe=!0)),t.animateAll(function(){pe=fe=!1,n.options.animation&&de.forEach(function(t){x(t)}),n.options.sort&&ve()}))},dragOver:function(t){var e=t.target,n=t.completed,t=t.cancel;fe&&~de.indexOf(e)&&(n(!1),t())},revert:function(t){var n,o,e=t.fromSortable,i=t.rootEl,r=t.sortable,a=t.dragRect;1<de.length&&(de.forEach(function(t){r.addAnimationState({target:t,rect:fe?X(t):a}),x(t),t.fromRect=a,e.removeAnimationState(t)}),fe=!1,n=!this.options.removeCloneOnHide,o=i,de.forEach(function(t,e){e=o.children[t.sortableIndex+(n?Number(e):0)];e?o.insertBefore(t,e):o.appendChild(t)}))},dragOverCompleted:function(t){var e,n=t.sortable,o=t.isOwner,i=t.insertion,r=t.activeSortable,a=t.parentEl,l=t.putSortable,t=this.options;i&&(o&&r._hideClone(),pe=!1,t.animation&&1<de.length&&(fe||!o&&!r.options.sort&&!l)&&(e=X(se,!1,!0,!0),de.forEach(function(t){t!==se&&(T(t,e),a.appendChild(t))}),fe=!0),o||(fe||ve(),1<de.length?(o=ue,r._showClone(n),r.options.animation&&!ue&&o&&he.forEach(function(t){r.addAnimationState({target:t,rect:ce}),t.fromRect=ce,t.thisAnimationDuration=null})):r._showClone(n)))},dragOverAnimationCapture:function(t){var e=t.dragRect,n=t.isOwner,t=t.activeSortable;de.forEach(function(t){t.thisAnimationDuration=null}),t.options.animation&&!n&&t.multiDrag.isMultiDrag&&(ce=a({},e),e=b(se,!0),ce.top-=e.f,ce.left-=e.e)},dragOverAnimationComplete:function(){fe&&(fe=!1,ve())},drop:function(t){var o,i,r,a,n,e,l,s=t.originalEvent,c=t.rootEl,u=t.parentEl,d=t.sortable,h=t.dispatchSortableEvent,p=t.oldIndex,t=t.putSortable,f=t||this.sortable;s&&(o=this.options,i=u.children,ge||(o.multiDragKey&&!this.multiDragKeyDown&&this._deselectMultiDrag(),k(se,o.selectedClass,!~de.indexOf(se)),~de.indexOf(se)?(de.splice(de.indexOf(se),1),ae=null,G({sortable:d,rootEl:c,name:"deselect",targetEl:se,originalEvent:s})):(de.push(se),G({sortable:d,rootEl:c,name:"select",targetEl:se,originalEvent:s}),s.shiftKey&&ae&&d.el.contains(ae)?(r=j(ae),a=j(se),~r&&~a&&r!==a&&function(){for(var e,t=r<a?(e=r,a):(e=a,r+1),n=o.filter;e<t;e++)~de.indexOf(i[e])||P(i[e],o.draggable,u,!1)&&(n&&("function"==typeof n?n.call(d,s,i[e],d):n.split(",").some(function(t){return P(i[e],t.trim(),u,!1)}))||(k(i[e],o.selectedClass,!0),de.push(i[e]),G({sortable:d,rootEl:c,name:"select",targetEl:i[e],originalEvent:s})))}()):ae=se,le=f)),ge&&this.isMultiDrag&&(fe=!1,(u[K].options.sort||u!==c)&&1<de.length&&(n=X(se),e=j(se,":not(."+this.options.selectedClass+")"),!pe&&o.animation&&(se.thisAnimationDuration=null),f.captureAnimationState(),pe||(o.animation&&(se.fromRect=n,de.forEach(function(t){var e;t.thisAnimationDuration=null,t!==se&&(e=fe?X(t):n,t.fromRect=e,f.addAnimationState({target:t,rect:e}))})),ve(),de.forEach(function(t){i[e]?u.insertBefore(t,i[e]):u.appendChild(t),e++}),p===j(se)&&(l=!1,de.forEach(function(t){t.sortableIndex!==j(t)&&(l=!0)}),l&&(h("update"),h("sort")))),de.forEach(function(t){x(t)}),f.animateAll()),le=f),(c===u||t&&"clone"!==t.lastPutMode)&&he.forEach(function(t){t.parentNode&&t.parentNode.removeChild(t)}))},nullingGlobal:function(){this.isMultiDrag=ge=!1,he.length=0},destroyGlobal:function(){this._deselectMultiDrag(),p(document,"pointerup",this._deselectMultiDrag),p(document,"mouseup",this._deselectMultiDrag),p(document,"touchend",this._deselectMultiDrag),p(document,"keydown",this._checkKeyDown),p(document,"keyup",this._checkKeyUp)},_deselectMultiDrag:function(t){if(!(void 0!==ge&&ge||le!==this.sortable||t&&P(t.target,this.options.draggable,this.sortable.el,!1)||t&&0!==t.button))for(;de.length;){var e=de[0];k(e,this.options.selectedClass,!1),de.shift(),G({sortable:this.sortable,rootEl:this.sortable.el,name:"deselect",targetEl:e,originalEvent:t})}},_checkKeyDown:function(t){t.key===this.options.multiDragKey&&(this.multiDragKeyDown=!0)},_checkKeyUp:function(t){t.key===this.options.multiDragKey&&(this.multiDragKeyDown=!1)}},a(t,{pluginName:"multiDrag",utils:{select:function(t){var e=t.parentNode[K];e&&e.options.multiDrag&&!~de.indexOf(t)&&(le&&le!==e&&(le.multiDrag._deselectMultiDrag(),le=e),k(t,e.options.selectedClass,!0),de.push(t))},deselect:function(t){var e=t.parentNode[K],n=de.indexOf(t);e&&e.options.multiDrag&&~n&&(k(t,e.options.selectedClass,!1),de.splice(n,1))}},eventProperties:function(){var n=this,o=[],i=[];return de.forEach(function(t){var e;o.push({multiDragElement:t,index:t.sortableIndex}),e=fe&&t!==se?-1:fe?j(t,":not(."+n.options.selectedClass+")"):j(t),i.push({multiDragElement:t,index:e})}),{items:r(de),clones:[].concat(he),oldIndicies:o,newIndicies:i}},optionListeners:{multiDragKey:function(t){return"ctrl"===(t=t.toLowerCase())?t="Control":1<t.length&&(t=t.charAt(0).toUpperCase()+t.substr(1)),t}}})}),jt});
function InitializeStatsWidget(aisRoot) {

    var accountId;
    var urlParam = new URLSearchParams(location.search);
    if (urlParam.get('said')) accountId = urlParam.get('said');
    else return;

    if (location.pathname.includes("/widgets/trading-account-statistics")) {
        $("a[data-id=embed-script-copy]").remove();

    } else {
        $("a[data-id=embed-script-copy]").on('click', function () {
            var widgetElem = $(this).closest('.statistics-widget');
            var width = widgetElem.innerWidth();
            CopyStatsWidgetRemoteScriptToClipboard(accountId, width);
        });
    }

    window.APIHelper.SafeServiceAPICall({
        url: aisRoot + "/api/v1/mt/statistics/embed-widgets/" + accountId,
        type: "GET",
        traditional: true,
        success: function (res) {
            InitData(res);
        },
        error: function (xhr, statusText) {
            if (xhr.status == 423) {

            }
        },
        complete: function () {
            setTimeout(function () {
                ResizeCalcWidgetFrame('.stats-widget-body');
            }, 100);
        }
    });

    if ($("[data-id=stats-widgets-chart-box]").length > 1
        || $("[data-id=stats-widgets-chart-box]").length == 1 && $("[data-id=stats-widgets-chart-box]").is(':visible')) {

        try {
            InitStatsWidgetChart(aisRoot, accountId);
        } catch (error) {
            console.error("InitStatsWidgetChart failed:", aisRoot, accountId);
        }
    }
    var langSlug = "";
    if (window.CURRENT_LANG != 'en')
        langSlug += '/' + window.CURRENT_LANG;
    $(".widget-logo a").attr('href', 'https://' + window.location.host + langSlug + '/trading-account?said=' + accountId);
}

function GetDefaultChartOption(chartType, xaxisType, res) {       // chartType: line, area, bar | res: data | xaxisType: category, datetime

    if (!res.series || res.series.length == 0 || !res.series[0].data || res.series[0].data.length == 0)
        return null;

    var options = {
        chart: {
            type: chartType,
            height: '100%',
            foreColor: 'rgba(255, 255, 255, 0.7)',
            background: 'transparent',
            toolbar: {
                show: true
            },
            zoom: {
                enabled: true,
            }
        },
        colors: ['#44a2f8', '#26E7A6', '#FEBC3B'],
        theme: {
            mode: 'dark'
        },

        dataLabels: {
            enabled: false
        },
        series: res.series,
        xaxis: {
            categories: res.categories,
            type: xaxisType,
            axisTicks: {
                show: true
            },
        },
        stroke: {
            width: 2,
            curve: 'smooth'
        },
        markers: {
            size: 0
        },

        grid: {
            show: true,
            borderColor: 'rgba(255, 255, 255, 0.22)',
            strokeDashArray: 0,
            xaxis: {
                lines: {
                    show: true
                }
            },
            yaxis: {
                lines: {
                    show: true
                }
            },
            row: {
                opacity: 0.3
            },
            column: {
                opacity: 0.3
            }
        },
    };
    if (chartType == "area") {
        options.fill = {
            type: ['gradient', 'solid'],
            colors: ['#44a2f8', '#343540'],
            gradient: {
                shadeIntensity: .4,
                opacityFrom: .6,
                opacityTo: 0,
                stops: [0, 100]
            },
            opacity: 1,
        };
    }
    if (!!res.categories && res.categories.length > 20) {
        options.xaxis.tickAmount = 20;
    }

    if (xaxisType == 'datetime') {
        options.xaxis.labels = { datetimeUTC: false };
    }

    for (var i = 0; i < options.series.length; i++) {

        var twr = false;
        if (options.series[i].name.includes("-twr")) {
            options.series[i].name = options.series[i].name.replace("-twr", "");
            twr = true;
        }
        if (!!window.statsStrings[options.series[i].name])
            options.series[i].name = window.statsStrings[options.series[i].name];
        if (twr) {
            options.series[i].name += ',<i class="mdi mdi-clock"></i>';
        }
    }

    return options;
}

function InitData(data) {
    var aisHelper = new AISHelper();

    var duration = aisHelper.GetDuraction(data.lastUpdated, new Date());
    $(".statistics-widget [data-id]").each(function (index, e) {
        var dataId = $(e).data("id");
        switch (dataId) {
            case "name":
                $(e).html(data.name);
                break;
            case "last-sync":
                $(e).html(window.statsStrings["LastSync0Ago"].replace("{0}", duration));
                break;
            case "profit-percent":
                $(e).html(aisHelper.ToPercent(data.profitPercent));
                break;
            case "equity":
                $(e).html(aisHelper.ToDecimal(data.equity));
                break;
            case "balance":
                $(e).html(aisHelper.ToDecimal(data.balance));
                break;
            case "open-profit":
                $(e).html(aisHelper.ToDecimal(data.openProfit));
                break;
            case "open-profit-percent":
                $(e).html(aisHelper.ToPercent(data.openProfitPercent));
                break;
            case "profit":
                $(e).html(aisHelper.ToDecimal(data.profit));
                break;
            case "monthly-profit-percent":
                $(e).html(aisHelper.ToPercent(data.monthlyProfit));
                break;
            case "peak-drawdown":
                $(e).html(aisHelper.ToPercent(data.peakDrawdown));
                break;
        }
    });
}
function InitStatsWidgetChart(aisRoot, aisAccountId) {
    var aisHelper = new AISHelper();

    window.APIHelper.SafeServiceAPICall({
        url: aisRoot + "/api/v1/mt/statistics/chart/profit-percent" + '?AisAccountId=' + aisAccountId + "&ProfitType=equity",
        type: "GET",
        traditional: true,
        success: function (res) {

            var selector = '[data-id=stats-widgets-chart-box]';
            if ($(selector).length > 1)
                selector = '.medium-widget ' + selector;

            var options = GetDefaultChartOption('line', 'datetime', res);
            if (options == null) {
                $(selector).html('<span class="no-data-display">' + window.statsStrings['NoData'] + '</span>');
            } else {
                options.yaxis = {
                    forceNiceScale: false,
                    labels: {
                        formatter: function (value) {
                            return aisHelper.ToPercent(value);
                        }
                    }
                }
                var chart = new ApexCharts(document.querySelector(selector), options);
                chart.render();
            }
        },
        error: function (xhr, statusText) {
            console.log(statusText);
            if (xhr.status == 423) {
                if ($('#stats-widgets-chart-box').length > 0) {
                    $("#stats-widgets-chart-box").html('<span class="no-data-display"><i class="mdi mdi-lock"></span>');
                }
            }
        }
    });
}

function GenerateStatsWidgetModel(said, width) {
    CalcWidgetConfig = new Object();

    var hostUrl = window.location.protocol + "//" + window.location.hostname;
    if (window.location.port !== "")
        hostUrl += ":" + window.location.port;

    CalcWidgetConfig.Url = hostUrl;
    CalcWidgetConfig.Calculator = "trading-account-statistics";

    CalcWidgetConfig.SAID = said;
    CalcWidgetConfig.ContainerWidth = width + 'px';

    return CalcWidgetConfig;
}
function CopyStatsWidgetRemoteScriptToClipboard(said, width) {

    var CalcWidgetConfig = GenerateStatsWidgetModel(said, width);
    var script = GenerateCalcWidgetScript(CalcWidgetConfig);

    $("#stats-widget-embed-script-preview-output").val(script);
    $("#stats-widget-embed-script-dialog").modal('show');

}
function OnCopyStatsWidgetEmbedScript() {
    var script = $("#stats-widget-embed-script-preview-output").val();
    navigator.clipboard.writeText(script).then(function () {
        $("#stats-widget-embed-copy-notification-panel").show();
        setTimeout(function () {
            $("#stats-widget-embed-copy-notification-panel").hide();
        }, 3000)
    });
}